(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("PowerMap", [], factory);
	else if(typeof exports === 'object')
		exports["PowerMap"] = factory();
	else
		root["PowerMap"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 106);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:frutiger-light;src:url(\"./fonts/frutiger/frutiger_ce_45_light-webfont.eot\");src:url(\"./fonts/frutiger/frutiger_ce_45_light-webfont.eot?#iefix\") format(\"embedded-opentype\"),url(\"./fonts/frutiger/frutiger_ce_45_light-webfont.woff2\") format(\"woff2\"),url(\"./fonts/frutiger/frutiger_ce_45_light-webfont.woff\") format(\"woff\"),url(\"./fonts/frutiger/frutiger_ce_45_light-webfont.ttf\") format(\"truetype\"),url(\"./fonts/frutiger/frutiger_ce_45_light-webfont.svg#frutiger_ce_45_lightregular\") format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:frutiger-medium;src:url(\"./fonts/frutiger/frutiger_ce_55_roman-webfont.eot\");src:url(\"./fonts/frutiger/frutiger_ce_55_roman-webfont.eot?#iefix\") format(\"embedded-opentype\"),url(\"./fonts/frutiger/frutiger_ce_55_roman-webfont.woff2\") format(\"woff2\"),url(\"./fonts/frutiger/frutiger_ce_55_roman-webfont.woff\") format(\"woff\"),url(\"./fonts/frutiger/frutiger_ce_55_roman-webfont.ttf\") format(\"truetype\"),url(\"./fonts/frutiger/frutiger_ce_55_roman-webfont.svg#frutiger_ce_55_romanregular\") format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:frutiger-bold;src:url(\"./fonts/frutiger/frutiger-75-black.eot\");src:url(\"./fonts/frutiger/frutiger-75-black.eot?#iefix\") format(\"embedded-opentype\"),url(\"./fonts/frutiger/frutiger-75-black.woff2\") format(\"woff2\"),url(\"./fonts/frutiger/frutiger-75-black.woff\") format(\"woff\"),url(\"./fonts/frutiger/frutiger-75-black.ttf\") format(\"truetype\"),url(\"./fonts/frutiger/frutiger-75-black.svg#frutiger-75-black\") format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:digital;src:url(\"./fonts/digital/digital-7.ttf\");font-weight:400;font-style:normal}.Fonts__light-font___3KKc6{font-family:frutiger-light,arial,sans-serif}.Fonts__medium-font___3yYd3{font-family:frutiger-medium,arial,sans-serif}.Fonts__bold-font___3iFek{font-family:frutiger-bold,arial,sans-serif}.Fonts__calculator-font___2Vr8r{font-family:digital,arial,sans-serif}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/common/Fonts.scss"],"names":[],"mappings":"AAAA,WAAW,2BAA6B,6DAA6D,maAAma,gBAAmB,iBAAiB,CAAC,WAAW,4BAA8B,6DAA6D,maAAma,gBAAmB,iBAAiB,CAAC,WAAW,0BAA4B,kDAAkD,kWAAkW,gBAAmB,iBAAiB,CAAC,WAAW,oBAAsB,yCAAyC,gBAAmB,iBAAiB,CAAC,2BAAY,2CAA+C,CAAC,4BAAa,4CAAgD,CAAC,0BAAW,0CAA8C,CAAC,gCAAiB,oCAAwC,CAAC","file":"Fonts.scss","sourcesContent":["@font-face{font-family:'frutiger-light';src:url(\"./fonts/frutiger/frutiger_ce_45_light-webfont.eot\");src:url(\"./fonts/frutiger/frutiger_ce_45_light-webfont.eot?#iefix\") format(\"embedded-opentype\"),url(\"./fonts/frutiger/frutiger_ce_45_light-webfont.woff2\") format(\"woff2\"),url(\"./fonts/frutiger/frutiger_ce_45_light-webfont.woff\") format(\"woff\"),url(\"./fonts/frutiger/frutiger_ce_45_light-webfont.ttf\") format(\"truetype\"),url(\"./fonts/frutiger/frutiger_ce_45_light-webfont.svg#frutiger_ce_45_lightregular\") format(\"svg\");font-weight:normal;font-style:normal}@font-face{font-family:'frutiger-medium';src:url(\"./fonts/frutiger/frutiger_ce_55_roman-webfont.eot\");src:url(\"./fonts/frutiger/frutiger_ce_55_roman-webfont.eot?#iefix\") format(\"embedded-opentype\"),url(\"./fonts/frutiger/frutiger_ce_55_roman-webfont.woff2\") format(\"woff2\"),url(\"./fonts/frutiger/frutiger_ce_55_roman-webfont.woff\") format(\"woff\"),url(\"./fonts/frutiger/frutiger_ce_55_roman-webfont.ttf\") format(\"truetype\"),url(\"./fonts/frutiger/frutiger_ce_55_roman-webfont.svg#frutiger_ce_55_romanregular\") format(\"svg\");font-weight:normal;font-style:normal}@font-face{font-family:'frutiger-bold';src:url(\"./fonts/frutiger/frutiger-75-black.eot\");src:url(\"./fonts/frutiger/frutiger-75-black.eot?#iefix\") format(\"embedded-opentype\"),url(\"./fonts/frutiger/frutiger-75-black.woff2\") format(\"woff2\"),url(\"./fonts/frutiger/frutiger-75-black.woff\") format(\"woff\"),url(\"./fonts/frutiger/frutiger-75-black.ttf\") format(\"truetype\"),url(\"./fonts/frutiger/frutiger-75-black.svg#frutiger-75-black\") format(\"svg\");font-weight:normal;font-style:normal}@font-face{font-family:'digital';src:url(\"./fonts/digital/digital-7.ttf\");font-weight:normal;font-style:normal}.light-font{font-family:'frutiger-light', arial, sans-serif}.medium-font{font-family:'frutiger-medium', arial, sans-serif}.bold-font{font-family:'frutiger-bold', arial, sans-serif}.calculator-font{font-family:'digital', arial, sans-serif}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"light-font": "Fonts__light-font___3KKc6",
	"lightFont": "Fonts__light-font___3KKc6",
	"medium-font": "Fonts__medium-font___3yYd3",
	"mediumFont": "Fonts__medium-font___3yYd3",
	"bold-font": "Fonts__bold-font___3iFek",
	"boldFont": "Fonts__bold-font___3iFek",
	"calculator-font": "Fonts__calculator-font___2Vr8r",
	"calculatorFont": "Fonts__calculator-font___2Vr8r"
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports


// module
exports.push([module.i, ".Colour__blue___3JCwq{background-color:#246ab6}.Colour__green___2SHEH{background-color:#5ca327}.Colour__yellow___2xL7_{background-color:#fcd300;color:#000}.Colour__red___3L8_4{background-color:#e04c00}.Colour__blue-hoverable___1p95h:hover{background-color:#3683d7}.Colour__green-hoverable___272xi:hover{background-color:#508e22}.Colour__yellow-hoverable___GgWcF:hover{background-color:#ffdd30}.Colour__red-hoverable___1-IDU:hover{background-color:#ff6414}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/common/Colour.scss"],"names":[],"mappings":"AAAA,sBAAM,wBAAwB,CAAC,uBAAO,wBAAwB,CAAC,wBAAQ,yBAAyB,UAAW,CAAC,qBAAK,wBAAwB,CAAC,AAA8B,sCAAsB,wBAAwB,CAAC,AAAgC,uCAAuB,wBAAwB,CAAC,AAAkC,wCAAwB,wBAAwB,CAAC,AAA4B,qCAAqB,wBAAwB,CAAC","file":"Colour.scss","sourcesContent":[".blue{background-color:#246AB6}.green{background-color:#5ca327}.yellow{background-color:#FCD300;color:black}.red{background-color:#E04C00}.blue-hoverable{composes:blue}.blue-hoverable:hover{background-color:#3683d7}.green-hoverable{composes:green}.green-hoverable:hover{background-color:#508e22}.yellow-hoverable{composes:yellow}.yellow-hoverable:hover{background-color:#ffdd30}.red-hoverable{composes:red}.red-hoverable:hover{background-color:#ff6414}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"blue": "Colour__blue___3JCwq",
	"green": "Colour__green___2SHEH",
	"yellow": "Colour__yellow___2xL7_",
	"red": "Colour__red___3L8_4",
	"blue-hoverable": "Colour__blue-hoverable___1p95h Colour__blue___3JCwq",
	"blueHoverable": "Colour__blue-hoverable___1p95h Colour__blue___3JCwq",
	"green-hoverable": "Colour__green-hoverable___272xi Colour__green___2SHEH",
	"greenHoverable": "Colour__green-hoverable___272xi Colour__green___2SHEH",
	"yellow-hoverable": "Colour__yellow-hoverable___GgWcF Colour__yellow___2xL7_",
	"yellowHoverable": "Colour__yellow-hoverable___GgWcF Colour__yellow___2xL7_",
	"red-hoverable": "Colour__red-hoverable___1-IDU Colour__red___3L8_4",
	"redHoverable": "Colour__red-hoverable___1-IDU Colour__red___3L8_4"
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.action = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var SET_SCREEN = exports.SET_SCREEN = 'SET_SCREEN';
  var SET_MODAL = exports.SET_MODAL = 'SET_MODAL';
  var SET_POPUP = exports.SET_POPUP = 'SET_POPUP';
  var HIDE_POPUP = exports.HIDE_POPUP = 'HIDE_POPUP';
  var SET_TOOLTIP = exports.SET_TOOLTIP = 'SET_TOOLTIP';
  var SHOW_GAME_INTRO = exports.SHOW_GAME_INTRO = 'SHOW_GAME_INTRO';
  var START_GAME = exports.START_GAME = 'START_GAME';
  var RESUME_GAME = exports.RESUME_GAME = 'RESUME_GAME';
  var SET_SELECTED_LOCATION = exports.SET_SELECTED_LOCATION = 'SET_SELECTED_LOCATION';
  var SET_HIGHLIGHT_LOCATION = exports.SET_HIGHLIGHT_LOCATION = 'SET_HIGHLIGHT_LOCATION';
  var CLEAR_SELECTED_LOCATION = exports.CLEAR_SELECTED_LOCATION = 'CLEAR_SELECTED_LOCATION';
  var SET_MAP_OFFSET = exports.SET_MAP_OFFSET = 'SET_MAP_OFFSET';
  var SET_MAP_BOUNDS = exports.SET_MAP_BOUNDS = 'SET_MAP_BOUNDS';
  var SET_SELECTED_POWER_SOURCE = exports.SET_SELECTED_POWER_SOURCE = 'SET_SELECTED_POWER_SOURCE';
  var ADD_POWER_SOURCE_AT_LOCATION = exports.ADD_POWER_SOURCE_AT_LOCATION = 'ADD_POWER_SOURCE_AT_LOCATION';
  var SET_DRAGGING_POWER_SOURCE = exports.SET_DRAGGING_POWER_SOURCE = 'SET_DRAGGING_POWER_SOURCE';
  var PLACE_POWER_SOURCE = exports.PLACE_POWER_SOURCE = 'PLACE_POWER_SOURCE';
  var REMOVE_POWER_SOURCE = exports.REMOVE_POWER_SOURCE = 'REMOVE_POWER_SOURCE';
  var REMOVE_ALL_POWER_SOURCES = exports.REMOVE_ALL_POWER_SOURCES = 'REMOVE_ALL_POWER_SOURCES';
  var RESET_ALL_POWER_SOURCES = exports.RESET_ALL_POWER_SOURCES = 'RESET_ALL_POWER_SOURCES';
  var BREAK_POWER_SOURCE_TYPE = exports.BREAK_POWER_SOURCE_TYPE = 'BREAK_POWER_SOURCE_TYPE';
  var REMOVE_ALL_POWER_SOURCE_TYPE = exports.REMOVE_ALL_POWER_SOURCE_TYPE = 'REMOVE_ALL_POWER_SOURCE_TYPE';
  var SAVE_POWER_SOURCE_COUNTS = exports.SAVE_POWER_SOURCE_COUNTS = 'SAVE_POWER_SOURCE_COUNTS_BY_TYPE';
  var DAMAGE_SOURCE_TYPE = exports.DAMAGE_SOURCE_TYPE = 'DAMAGE_SOURCE_TYPE';
  var CLEAR_ALL_DAMAGE = exports.CLEAR_ALL_DAMAGE = 'CLEAR_ALL_DAMAGE';
  var SET_INITIAL_DAMAGE = exports.SET_INITIAL_DAMAGE = 'SET_INITIAL_DAMAGE';
  var REPAIR_STATION_AT_LOCATION = exports.REPAIR_STATION_AT_LOCATION = 'REPAIR_STATION_AT_LOCATION';
  var DEPRECATE_SOURCE_TYPE = exports.DEPRECATE_SOURCE_TYPE = 'DEPRECATE_SOURCE_TYPE';
  var CLEAR_ALL_DEPRECATIONS = exports.CLEAR_ALL_DEPRECATIONS = 'CLEAR_ALL_DEPRECATIONS';
  var REMOVE_ALL_DEPRECATED_STATIONS = exports.REMOVE_ALL_DEPRECATED_STATIONS = 'REMOVE_ALL_DEPRECATED_STATIONS';
  var REMOVE_STATIONS = exports.REMOVE_STATIONS = 'REMOVE_STATIONS';
  var SET_INITIAL_DEPRECATIONS = exports.SET_INITIAL_DEPRECATIONS = 'SET_INITIAL_DEPRECATIONS';
  var START_TIMER = exports.START_TIMER = 'START_TIMER';
  var TICK_TIMER = exports.TICK_TIMER = 'TICK_TIMER';
  var STOP_TIMER = exports.STOP_TIMER = 'STOP_TIMER';
  var PAUSE_TIMER = exports.PAUSE_TIMER = 'PAUSE_TIMER';
  var RESUME_TIMER = exports.RESUME_TIMER = 'RESUME_TIMER';
  var RESET_TIMER = exports.RESET_TIMER = 'RESET_TIMER';
  var TIMER_HAS_EXPIRED = exports.TIMER_HAS_EXPIRED = 'TIMER_HAS_EXPIRED';
  var SKIP_TIMER = exports.SKIP_TIMER = 'SKIP_TIMER';
  var CHOOSE_GENERAL_HINT = exports.CHOOSE_GENERAL_HINT = 'CHOOSE_SUITABLE_HINT';
  var CHOOSE_INCREASE_POWER_SOURCE_HINT = exports.CHOOSE_INCREASE_POWER_SOURCE_HINT = 'CHOOSE_INCREASE_POWER_SOURCE_HINT';
  var CHOOSE_DECREASE_POWER_SOURCE_HINT = exports.CHOOSE_DECREASE_POWER_SOURCE_HINT = 'CHOOSE_DECREASE_POWER_SOURCE_HINT';
  var CHOOSE_SUITABLE_OUTAGE = exports.CHOOSE_SUITABLE_OUTAGE = 'CHOOSE_SUITABLE_OUTAGE';
  var CHOOSE_SUITABLE_EVENT = exports.CHOOSE_SUITABLE_EVENT = 'CHOOSE_SUITABLE_EVENT';
  var SET_ENERGY_DEMAND = exports.SET_ENERGY_DEMAND = 'SET_ENERGY_DEMAND';
  var SET_CARBON_TARGET = exports.SET_CARBON_TARGET = 'SET_CARBON_TARGET';
  var SET_CARBON_OUTPUT = exports.SET_CARBON_OUTPUT = 'SET_CARBON_OUTPUT';
  var SHOW_HINT = exports.SHOW_HINT = 'SHOW_HINT';
  var SET_OUTAGE_ID = exports.SET_OUTAGE_ID = 'SET_OUTAGE_ID';
  var SET_DEPRECATE_TYPE = exports.SET_DEPRECATE_TYPE = 'SET_DEPRECATE_TYPE';
  var SHOW_QUESTION = exports.SHOW_QUESTION = 'SHOW_QUESTION';
  var SHOW_NEXT_OUTAGE_QUESTION = exports.SHOW_NEXT_OUTAGE_QUESTION = 'SHOW_NEXT_OUTAGE_QUESTION';
  var SHOW_NEXT_YEAR_END_QUESTION = exports.SHOW_NEXT_YEAR_END_QUESTION = 'SHOW_NEXT_YEAR_END_QUESTION';
  var CHOOSE_ANSWER = exports.CHOOSE_ANSWER = 'CHOOSE_ANSWER';
  var SET_EVENT_ID = exports.SET_EVENT_ID = 'SET_EVENT_ID';
  var SHOW_POWER_SOURCE_DETAILS = exports.SHOW_POWER_SOURCE_DETAILS = 'SHOW_POWER_SOURCE_DETAILS';
  var SET_MINI_GAME_ID = exports.SET_MINI_GAME_ID = 'SET_MINI_GAME_ID';
  var CLEAR_MINI_GAME_ID = exports.CLEAR_MINI_GAME_ID = 'CLEAR_MINI_GAME_ID';
  var ACTIVATE_MINI_GAME = exports.ACTIVATE_MINI_GAME = 'ACTIVATE_MINI_GAME';
  var START_DRAGGING = exports.START_DRAGGING = 'START_DRAGGING';
  var STOP_DRAGGING = exports.STOP_DRAGGING = 'STOP_DRAGGING';
  var TOGGLE_DEBUG_CONSOLE = exports.TOGGLE_DEBUG_CONSOLE = 'TOGGLE_DEBUG_CONSOLE';
  var SET_SCORE = exports.SET_SCORE = 'SET_SCORE';
  var UPDATE_SCORE = exports.UPDATE_SCORE = 'UPDATE_SCORE';
  var ADD_SCORE = exports.ADD_SCORE = 'ADD_SCORE';
  var RECORD_CORRECT_ANSWER = exports.RECORD_CORRECT_ANSWER = 'RECORD_CORRECT_ANSWER';
  var RESET_CORRECT_ANSWERS_COUNT = exports.RESET_CORRECT_ANSWERS_COUNT = 'RESET_CORRECT_ANSWERS_COUNT';
  var RECORD_ENERGY_GENERATED = exports.RECORD_ENERGY_GENERATED = 'RECORD_ENERGY_GENERATED';
  var RESET_ENERGY_GENERATED = exports.RESET_ENERGY_GENERATED = 'RESET_ENERGY_GENERATED';
  var SET_SEASON = exports.SET_SEASON = 'SET_SEASON';
  var RESET_SEASON = exports.RESET_SEASON = 'RESET_SEASON';
  var NEXT_SEASON = exports.NEXT_SEASON = 'NEXT_SEASON';
  var TRIGGER_SEASONAL_CONTENT = exports.TRIGGER_SEASONAL_CONTENT = 'TRIGGER_SEASONAL_CONTENT';
  var TEST_ANNUAL_TARGETS = exports.TEST_ANNUAL_TARGETS = 'TEST_ANNUAL_TARGETS';
  var SET_YEAR = exports.SET_YEAR = 'SET_YEAR';
  var INCREMENT_YEAR = exports.INCREMENT_YEAR = 'INCREMENT_YEAR';
  var START_YEAR = exports.START_YEAR = 'START_YEAR';
  var END_YEAR = exports.END_YEAR = 'END_YEAR';
  var OPEN_RESULTS_PANEL = exports.OPEN_RESULTS_PANEL = 'OPEN_RESULTS_PANEL';
  var CLOSE_RESULTS_PANEL = exports.CLOSE_RESULTS_PANEL = 'CLOSE_RESULTS_PANEL';
  var RESET_RESULTS_PANEL = exports.RESET_RESULTS_PANEL = 'RESET_RESULTS_PANEL';
});

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(107);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { if (o[n]) i[n] = function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; }; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator];
    return m ? m.call(o) : typeof __values === "function" ? __values(o) : o[Symbol.iterator]();
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(175);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var DEFAULT_HANDLE_MISSING_STYLENAME_OPTION = 'throw';

var isNamespacedStyleName = function isNamespacedStyleName(styleName) {
  return styleName.indexOf('.') !== -1;
};

var getClassNameForNamespacedStyleName = function getClassNameForNamespacedStyleName(styleName, styleModuleImportMap, handleMissingStyleNameOption) {
  // Note:
  // Do not use the desctructing syntax with Babel.
  // Desctructing adds _slicedToArray helper.
  var styleNameParts = styleName.split('.');
  var importName = styleNameParts[0];
  var moduleName = styleNameParts[1];
  var handleMissingStyleName = handleMissingStyleNameOption || DEFAULT_HANDLE_MISSING_STYLENAME_OPTION;

  if (!moduleName) {
    if (handleMissingStyleName === 'throw') {
      throw new Error('Invalid style name.');
    } else if (handleMissingStyleName === 'warn') {
      // eslint-disable-next-line no-console
      console.warn('Invalid style name.');
    } else {
      return null;
    }
  }

  if (!styleModuleImportMap[importName]) {
    if (handleMissingStyleName === 'throw') {
      throw new Error('CSS module import does not exist.');
    } else if (handleMissingStyleName === 'warn') {
      // eslint-disable-next-line no-console
      console.warn('CSS module import does not exist.');
    } else {
      return null;
    }
  }

  if (!styleModuleImportMap[importName][moduleName]) {
    if (handleMissingStyleName === 'throw') {
      throw new Error('CSS module does not exist.');
    } else if (handleMissingStyleName === 'warn') {
      // eslint-disable-next-line no-console
      console.warn('CSS module does not exist.');
    } else {
      return null;
    }
  }

  return styleModuleImportMap[importName][moduleName];
};

exports.default = function (styleNameValue, styleModuleImportMap, options) {
  var styleModuleImportMapKeys = Object.keys(styleModuleImportMap);

  var handleMissingStyleName = options && options.handleMissingStyleName || DEFAULT_HANDLE_MISSING_STYLENAME_OPTION;

  return styleNameValue.split(' ').filter(function (styleName) {
    return styleName;
  }).map(function (styleName) {
    if (isNamespacedStyleName(styleName)) {
      return getClassNameForNamespacedStyleName(styleName, styleModuleImportMap, handleMissingStyleName);
    }

    if (styleModuleImportMapKeys.length === 0) {
      throw new Error('Cannot use styleName attribute without importing at least one stylesheet.');
    }

    if (styleModuleImportMapKeys.length > 1) {
      throw new Error('Cannot use anonymous style name with more than one stylesheet import.');
    }

    var styleModuleMap = styleModuleImportMap[styleModuleImportMapKeys[0]];

    if (!styleModuleMap[styleName]) {
      if (handleMissingStyleName === 'throw') {
        throw new Error('Could not resolve the styleName \'' + styleName + '\'.');
      }
      if (handleMissingStyleName === 'warn') {
        // eslint-disable-next-line no-console
        console.warn('Could not resolve the styleName \'' + styleName + '\'.');
      }
    }

    return styleModuleMap[styleName];
  }).filter(function (className) {
    // Remove any styles which could not be found (if handleMissingStyleName === 'ignore')
    return className;
  }).join(' ');
};

//# sourceMappingURL=getClassName.js.map

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.4';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      reLeadingDot = /^\./,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * Adds the key-value `pair` to `map`.
   *
   * @private
   * @param {Object} map The map to modify.
   * @param {Array} pair The key-value pair to add.
   * @returns {Object} Returns `map`.
   */
  function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
  }

  /**
   * Adds `value` to `set`.
   *
   * @private
   * @param {Object} set The set to modify.
   * @param {*} value The value to add.
   * @returns {Object} Returns `set`.
   */
  function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
  }

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, baseClone, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = object[key],
          srcValue = source[key],
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `map`.
     *
     * @private
     * @param {Object} map The map to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned map.
     */
    function cloneMap(map, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
      return arrayReduce(array, addMapEntry, new map.constructor);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of `set`.
     *
     * @private
     * @param {Object} set The set to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned set.
     */
    function cloneSet(set, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
      return arrayReduce(array, addSetEntry, new set.constructor);
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, cloneFunc, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return cloneMap(object, isDeep, cloneFunc);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return cloneSet(object, isDeep, cloneFunc);

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length &&
        (typeof value == 'number' || reIsUint.test(value)) &&
        (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (reLeadingDot.test(string)) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            result = wait - timeSinceLastCall;

        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(args) {
      args.push(undefined, customDefaultsAssignIn);
      return apply(assignInWith, undefined, args);
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46), __webpack_require__(47)(module)))

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(124);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(8), __webpack_require__(152)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('lodash'), require('../../data/power-map.yaml'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.lodash, global.powerMap);
        global.data = mod.exports;
    }
})(this, function (exports, _lodash, data) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getAllPowerSourcesData = getAllPowerSourcesData;
    exports.getPowerSourcesData = getPowerSourcesData;
    exports.getPowerSourceDataByID = getPowerSourceDataByID;
    exports.getPowerSourceLocationsData = getPowerSourceLocationsData;
    exports.getDefaultPowerSourcesData = getDefaultPowerSourcesData;
    exports.getYearsData = getYearsData;
    exports.getSeasonsData = getSeasonsData;
    exports.getEnergyMixData = getEnergyMixData;
    exports.getPowerSourceLocationData = getPowerSourceLocationData;
    exports.getOutages = getOutages;
    exports.getHints = getHints;
    exports.getMiniGames = getMiniGames;
    exports.getQuestions = getQuestions;
    exports.getContent = getContent;
    exports.getGameOverHint = getGameOverHint;
    exports.getGameOverResults = getGameOverResults;
    exports.getQuestionResults = getQuestionResults;

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function getAllPowerSourcesData() {
        return data['power-sources'];
    }
    function getPowerSourcesData() {
        var power_sources = data['power-sources'];
        return _.filter(power_sources, function (power_source) {
            return power_source.include !== false;
        });
    }
    function getPowerSourceDataByID(power_source_id) {
        var power_sources = data['power-sources'];
        return _.find(power_sources, ['id', power_source_id]);
    }
    function getPowerSourceLocationsData() {
        return data['power-source-locations'];
    }
    function getDefaultPowerSourcesData() {
        var default_sources = data['default-power-sources'];
        var power_sources = getAllPowerSourcesData();
        return _.map(default_sources, function (source_id, position_id) {
            return _.find(power_sources, { id: source_id });
        });
    }
    function getYearsData() {
        return data['years'];
    }
    function getSeasonsData() {
        return data['seasons'];
    }
    function getEnergyMixData() {
        return data['energy-mix'];
    }
    function getPowerSourceLocationData(location_id) {
        return getPowerSourceLocationsData()[location_id];
    }
    function getOutages() {
        return data['outages'];
    }
    function getHints() {
        return data['hints'];
    }
    function getMiniGames() {
        return data['mini-games'];
    }
    function getQuestions() {
        return data['questions'];
    }
    function getContent(id) {
        return data['content'][id];
    }
    function getGameOverHint(area_id, score) {
        return data['game-over-hints'][area_id][score];
    }
    function getGameOverResults() {
        return data['game-over-results'];
    }
    function getQuestionResults() {
        return data['question-results'];
    }
});

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2), __webpack_require__(8), __webpack_require__(11), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("../actions/action"), require("lodash"), require("reselect"), require("../../data/data"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action, global.lodash, global.reselect, global.data);
        global.year = mod.exports;
    }
})(this, function (exports, _action, _lodash, _reselect, _data) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getPreviousYearData = exports.getYearData = exports.getYearIndex = undefined;
    exports.year = year;

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    var getYearIndex = exports.getYearIndex = function getYearIndex(state) {
        return state.year;
    };
    var getYearData = exports.getYearData = (0, _reselect.createSelector)([getYearIndex], function (season_id) {
        var year = (0, _data.getYearsData)();
        return _.get(year, season_id);
    });
    var getPreviousYearData = exports.getPreviousYearData = (0, _reselect.createSelector)([getYearIndex], function (season_id) {
        var year = (0, _data.getYearsData)();
        return _.get(year, season_id - 1);
    });
    function year(state, action) {
        if (state === void 0) {
            state = 0;
        }
        switch (action.type) {
            case _action.SET_YEAR:
                {
                    var payload = action.payload;
                    var year_1 = payload.year;
                    return year_1;
                }
            case _action.INCREMENT_YEAR:
                {
                    return state + 1;
                }
            default:
                return state;
        }
    }
});

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(8), __webpack_require__(2), __webpack_require__(10), __webpack_require__(11), __webpack_require__(37), __webpack_require__(28), __webpack_require__(12)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("lodash"), require("../actions/action"), require("../../data/data"), require("reselect"), require("./location"), require("./power-sources/deprecate"), require("./year"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.lodash, global.action, global.data, global.reselect, global.location, global.deprecate, global.year);
        global.powerSources = mod.exports;
    }
})(this, function (exports, _lodash, _action, _data, _reselect, _location, _deprecate, _year) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.isPowerSourceLastOfType = exports.getPowerSourceAtSelectedLocation = exports.isPowerSourceEligible = exports.getPowerSourceAtLocation = exports.countPowerSourcesByID = exports.countPowerSourcesByType = exports.countPowerSources = exports.getLocationID = exports.getPopulatedPowerSources = exports.getPowerSources = exports.getPowerSourceRequirements = exports.getPowerSourceID = undefined;
    exports.powerSources = powerSources;

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    var getPowerSourceID = exports.getPowerSourceID = function getPowerSourceID(state, props) {
        return props.id;
    };
    var getPowerSourceRequirements = exports.getPowerSourceRequirements = function getPowerSourceRequirements(state, props) {
        return props.power_source.requirements;
    };
    var getPowerSources = exports.getPowerSources = function getPowerSources(state) {
        return state.powerSources;
    };
    var getPopulatedPowerSources = exports.getPopulatedPowerSources = function getPopulatedPowerSources(state) {
        return _.compact(state.powerSources);
    };
    var getLocationID = exports.getLocationID = function getLocationID(state, props) {
        return props.location_id;
    };
    var countPowerSources = exports.countPowerSources = (0, _reselect.createSelector)([getPowerSources], function (power_sources) {
        return _.size(_.compact(power_sources));
    });
    var countPowerSourcesByType = exports.countPowerSourcesByType = (0, _reselect.createSelector)([getPowerSources, _year.getYearData, _deprecate.getDeprecations], function (power_sources, year, deprecations) {
        var counts = _.countBy(_.compact(power_sources), 'id');
        counts['wind-land'] += counts['wind-sea'];
        var deprecate_id = year.deprecate;
        if (deprecate_id) {
            var deprecated_count = _.filter(deprecations, function (value) {
                return value;
            }).length;
            counts[deprecate_id] -= deprecated_count;
        }
        return counts;
    });
    var countPowerSourcesByID = exports.countPowerSourcesByID = (0, _reselect.createSelector)([countPowerSourcesByType, getPowerSourceID], function (counts, power_source_id) {
        return counts[power_source_id];
    });
    var getPowerSourceAtLocation = exports.getPowerSourceAtLocation = (0, _reselect.createSelector)([getPowerSources, getLocationID], function (power_sources, location_id) {
        return power_sources[location_id];
    });
    var isPowerSourceEligible = exports.isPowerSourceEligible = (0, _reselect.createSelector)([getPowerSourceRequirements, _location.getSelectedLocationData], function (requirements, location) {
        return _.isEmpty(requirements) || _.includes(requirements, location.type);
    });
    var getPowerSourceAtSelectedLocation = exports.getPowerSourceAtSelectedLocation = (0, _reselect.createSelector)([getPowerSources, _location.getSelectedLocation], function (power_sources, location_id) {
        return power_sources[location_id];
    });
    var isPowerSourceLastOfType = exports.isPowerSourceLastOfType = (0, _reselect.createSelector)([countPowerSourcesByType, getPowerSourceAtLocation], function (counts, power_source) {
        if (!power_source) return false;
        if (power_source.id === 'coal' || power_source.id === 'gas') return false;
        var wind_land = counts['wind-land'] - counts['wind-sea'];
        if (power_source.id === 'wind-land') return power_source && wind_land <= 1;
        return power_source && counts[power_source.id] <= 1;
    });
    var initialState = _.fill(Array(160), undefined);
    function powerSources(state, action) {
        if (state === void 0) {
            state = initialState;
        }
        switch (action.type) {
            case _action.ADD_POWER_SOURCE_AT_LOCATION:
                {
                    var payload = action.payload;
                    var power_source = payload.power_source,
                        location_id = payload.location_id;
                    return state.slice(0, location_id).concat([power_source], state.slice(location_id + 1));
                }
            case _action.REMOVE_POWER_SOURCE:
                {
                    var payload = action.payload;
                    var location_id = payload.location_id;
                    return state.slice(0, location_id).concat([null], state.slice(location_id + 1));
                }
            case _action.REMOVE_ALL_POWER_SOURCES:
                {
                    return _.fill(Array(50), undefined);
                }
            case _action.REMOVE_ALL_POWER_SOURCE_TYPE:
                {
                    var payload = action.payload;
                    var source_type_1 = payload.source_type;
                    return _.map(state, function (power_source) {
                        return power_source && power_source.id === source_type_1 ? undefined : power_source;
                    });
                }
            case _action.RESET_ALL_POWER_SOURCES:
                {
                    var base_state = initialState.slice(0);
                    return _.merge(base_state, (0, _data.getDefaultPowerSourcesData)());
                }
            case _action.REMOVE_STATIONS:
                {
                    var payload = action.payload;
                    var stations_1 = payload.stations;
                    return state.map(function (power_source, id) {
                        return stations_1[id] ? undefined : power_source;
                    });
                }
            default:
                return state;
        }
    }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export konst */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return kTrue; });
/* unused harmony export kFalse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return identity; });
/* unused harmony export check */
/* unused harmony export hasOwn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return is; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return object; });
/* harmony export (immutable) */ __webpack_exports__["p"] = remove;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return array; });
/* harmony export (immutable) */ __webpack_exports__["o"] = once;
/* harmony export (immutable) */ __webpack_exports__["e"] = deferred;
/* harmony export (immutable) */ __webpack_exports__["b"] = arrayOfDeferred;
/* harmony export (immutable) */ __webpack_exports__["f"] = delay;
/* harmony export (immutable) */ __webpack_exports__["d"] = createMockTask;
/* unused harmony export autoInc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return uid; });
/* harmony export (immutable) */ __webpack_exports__["l"] = makeIterator;
/* harmony export (immutable) */ __webpack_exports__["k"] = log;
/* unused harmony export deprecate */
/* unused harmony export updateIncentive */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return internalErr; });
/* unused harmony export createSetContextWarning */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return wrapSagaDispatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cloneableGenerator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__symbols__ = __webpack_require__(27);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


var konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue =
/*#__PURE__*/
konst(true);
var kFalse =
/*#__PURE__*/
konst(false);
var noop = function noop() {};
var identity = function identity(v) {
  return v;
};
function check(value, predicate, error) {
  if (!predicate(value)) {
    throw new Error(error);
  }
}
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(object, property) {
  return is.notUndef(object) && hasOwnProperty.call(object, property);
}
var is = {
  undef: function undef(v) {
    return v === null || v === undefined;
  },
  notUndef: function notUndef(v) {
    return v !== null && v !== undefined;
  },
  func: function func(f) {
    return typeof f === 'function';
  },
  number: function number(n) {
    return typeof n === 'number';
  },
  string: function string(s) {
    return typeof s === 'string';
  },
  array: Array.isArray,
  object: function object(obj) {
    return obj && !is.array(obj) && _typeof(obj) === 'object';
  },
  promise: function promise(p) {
    return p && is.func(p.then);
  },
  iterator: function iterator(it) {
    return it && is.func(it.next) && is.func(it.throw);
  },
  iterable: function iterable(it) {
    return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
  },
  task: function task(t) {
    return t && t[__WEBPACK_IMPORTED_MODULE_0__symbols__["i" /* TASK */]];
  },
  observable: function observable(ob) {
    return ob && is.func(ob.subscribe);
  },
  buffer: function buffer(buf) {
    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
  },
  pattern: function pattern(pat) {
    return pat && (is.string(pat) || is.symbol(pat) || is.func(pat) || is.array(pat));
  },
  channel: function channel(ch) {
    return ch && is.func(ch.take) && is.func(ch.close);
  },
  stringableFunc: function stringableFunc(f) {
    return is.func(f) && hasOwn(f, 'toString');
  },
  symbol: function symbol(sym) {
    return _typeof(sym) === 'symbol';
  },
  multicast: function multicast(ch) {
    return is.channel(ch) && ch[__WEBPACK_IMPORTED_MODULE_0__symbols__["f" /* MULTICAST */]];
  }
};
var object = {
  assign: function assign(target, source) {
    for (var i in source) {
      if (hasOwn(source, i)) {
        target[i] = source[i];
      }
    }
  }
};
function remove(array, item) {
  var index = array.indexOf(item);

  if (index >= 0) {
    array.splice(index, 1);
  }
}
var array = {
  from: function from(obj) {
    var arr = Array(obj.length);

    for (var i in obj) {
      if (hasOwn(obj, i)) {
        arr[i] = obj[i];
      }
    }

    return arr;
  }
};
function once(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }

    called = true;
    fn();
  };
}
function deferred(props) {
  if (props === void 0) {
    props = {};
  }

  var def = _extends({}, props);

  var promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  def.promise = promise;
  return def;
}
function arrayOfDeferred(length) {
  var arr = [];

  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }

  return arr;
}
function delay(ms, val) {
  if (val === void 0) {
    val = true;
  }

  var timeoutId;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(function () {
      return resolve(val);
    }, ms);
  });

  promise[__WEBPACK_IMPORTED_MODULE_0__symbols__["a" /* CANCEL */]] = function () {
    return clearTimeout(timeoutId);
  };

  return promise;
}
function createMockTask() {
  var _ref;

  var running = true;

  var _result, _error;

  return _ref = {}, _ref[__WEBPACK_IMPORTED_MODULE_0__symbols__["i" /* TASK */]] = true, _ref.isRunning = function isRunning() {
    return running;
  }, _ref.result = function result() {
    return _result;
  }, _ref.error = function error() {
    return _error;
  }, _ref.setRunning = function setRunning(b) {
    return running = b;
  }, _ref.setResult = function setResult(r) {
    return _result = r;
  }, _ref.setError = function setError(e) {
    return _error = e;
  }, _ref;
}
function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}
var uid =
/*#__PURE__*/
autoInc();

var kThrow = function kThrow(err) {
  throw err;
};

var kReturn = function kReturn(value) {
  return {
    value: value,
    done: true
  };
};

function makeIterator(next, thro, name) {
  if (thro === void 0) {
    thro = kThrow;
  }

  if (name === void 0) {
    name = 'iterator';
  }

  var iterator = {
    name: name,
    next: next,
    throw: thro,
    return: kReturn
  };

  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }

  return iterator;
}
/**
  Print error in a useful way whether in a browser environment
  (with expandable error stack traces), or in a node.js environment
  (text-only log output)
 **/

function log(level, message, error) {
  if (error === void 0) {
    error = '';
  }

  /*eslint-disable no-console*/
  if (typeof window === 'undefined') {
    console.log("redux-saga " + level + ": " + message + "\n" + (error && error.stack || error));
  } else {
    console[level](message, error);
  }
}
function deprecate(fn, deprecationWarning) {
  return function () {
    if (false) log('warn', deprecationWarning);
    return fn.apply(void 0, arguments);
  };
}
var updateIncentive = function updateIncentive(deprecated, preferred) {
  return deprecated + " has been deprecated in favor of " + preferred + ", please update your code";
};
var internalErr = function internalErr(err) {
  return new Error("\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project's github repo.\n  Error: " + err + "\n");
};
var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + "setContext(props): argument " + props + " is not a plain object";
};
var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    return dispatch(Object.defineProperty(action, __WEBPACK_IMPORTED_MODULE_0__symbols__["g" /* SAGA_ACTION */], {
      value: true
    }));
  };
};

var cloneableGenerator = function cloneableGenerator(generatorFunc) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var history = [];
    var gen = generatorFunc.apply(void 0, args);
    return {
      next: function next(arg) {
        history.push(arg);
        return gen.next(arg);
      },
      clone: function clone() {
        var clonedGen = cloneableGenerator(generatorFunc).apply(void 0, args);
        history.forEach(function (arg) {
          return clonedGen.next(arg);
        });
        return clonedGen;
      },
      return: function _return(value) {
        return gen.return(value);
      },
      throw: function _throw(exception) {
        return gen.throw(exception);
      }
    };
  };
};



/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2), __webpack_require__(16)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("./action"), require("../reducers/screen"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action, global.screen);
        global.screens = mod.exports;
    }
})(this, function (exports, _action, _screen) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.setScreen = setScreen;
    exports.showLeaderboard = showLeaderboard;
    exports.showHowToPlay = showHowToPlay;
    exports.showMainMenu = showMainMenu;
    function setScreen(screen) {
        return { type: _action.SET_SCREEN, payload: { screen: screen } };
    }
    function showLeaderboard() {
        return { type: _action.SET_SCREEN, payload: { screen: _screen.SCREENS.LEADERBOARD } };
    }
    function showHowToPlay() {
        return { type: _action.SET_SCREEN, payload: { screen: _screen.SCREENS.HOW_TO_PLAY } };
    }
    function showMainMenu() {
        return { type: _action.SET_SCREEN, payload: { screen: _screen.SCREENS.MAIN_MENU } };
    }
});

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('../actions/action'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.screen = mod.exports;
    }
})(this, function (exports, _action) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getScreen = exports.SCREENS = undefined;
    exports.screen = screen;
    var SCREENS = exports.SCREENS = {
        PRELOADER: 'PRELOADER',
        INTRO: 'INTRO',
        HOW_TO_PLAY: 'HOW_TO_PLAY',
        LEADERBOARD: 'LEADERBOARD',
        MAIN_MENU: 'MAIN_MENU',
        GAME_INTRO: 'GAME_INTRO',
        GAME: 'GAME',
        MINI_GAME: 'MINI_GAME',
        GAME_OVER: 'GAME_OVER',
        HIGH_SCORES: 'HIGH_SCORES'
    };
    var getScreen = exports.getScreen = function getScreen(state) {
        return state.screen;
    };
    var initialState = SCREENS.MAIN_MENU;
    function screen(state, action) {
        if (state === void 0) {
            state = initialState;
        }
        switch (action.type) {
            case _action.SET_SCREEN:
                {
                    var payload = action.payload;
                    var screen_1 = payload.screen;
                    return screen_1;
                }
            default:
                return state;
        }
    }
});

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('../actions/action'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.modal = mod.exports;
    }
})(this, function (exports, _action) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getActiveModal = exports.MODALS = undefined;
    exports.modal = modal;
    var MODALS = exports.MODALS = {
        TIMER_START: 'TIMER_START',
        POWER_SOURCE_DETAILS: 'POWER_SOURCE_DETAILS',
        EVENT: 'EVENT_DETAILS',
        MINI_GAME_INTRO: 'MINI_GAME_INTRO',
        MINI_GAME_OUTRO: 'MINI_GAME_OUTRO',
        OUTAGE: 'OUTAGE',
        YEAR: 'YEAR',
        SEASON: 'SEASON',
        HINT: 'HINT',
        OUTAGE_QUESTION: 'OUTAGE_QUESTION',
        YEAR_END_STATUS: 'YEAR_END_STATUS',
        YEAR_END_QUESTION: 'YEAR_END_QUESTION',
        MINI_GAME_END_QUESTION: 'MINI_GAME_END_QUESTION',
        GAME_OVER: 'GAME_OVER'
    };
    var getActiveModal = exports.getActiveModal = function getActiveModal(state) {
        return state.modal;
    };
    var initialState = null;
    function modal(state, action) {
        if (state === void 0) {
            state = initialState;
        }
        switch (action.type) {
            case _action.SET_MODAL:
                {
                    var payload = action.payload;
                    var modal_id = payload.modal_id;
                    return modal_id;
                }
            default:
                return state;
        }
    }
});

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2), __webpack_require__(17)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("./action"), require("../reducers/modal"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action, global.modal);
        global.modals = mod.exports;
    }
})(this, function (exports, _action, _modal) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.showModal = showModal;
    exports.hideModal = hideModal;
    exports.showTimerStartModal = showTimerStartModal;
    exports.showPowerSourceDetailsModal = showPowerSourceDetailsModal;
    exports.showGameOverModal = showGameOverModal;
    exports.showHintsModal = showHintsModal;
    function showModal(modal_id) {
        return { type: _action.SET_MODAL, payload: { modal_id: modal_id } };
    }
    function hideModal() {
        return { type: _action.SET_MODAL, payload: { modal_id: null } };
    }
    function showTimerStartModal() {
        return { type: _action.SET_MODAL, payload: { modal_id: _modal.MODALS.TIMER_START } };
    }
    function showPowerSourceDetailsModal() {
        return { type: _action.SET_MODAL, payload: { modal_id: _modal.MODALS.POWER_SOURCE_DETAILS } };
    }
    function showGameOverModal() {
        return { type: _action.SET_MODAL, payload: { modal_id: _modal.MODALS.GAME_OVER } };
    }
    function showHintsModal() {
        return { type: _action.SET_MODAL, payload: { modal_id: _modal.MODALS.HINT } };
    }
});

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(177)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("./Button.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.Button);
        global.Button = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./Button.scss": {
            "button": "Button__button___wCHGy Fonts__bold-font___3iFek",
            "icon": "Button__icon___3m-TG",
            "padded-icon": "Button__padded-icon___2A2-D Button__icon___3m-TG",
            "blue-button": "Button__blue-button___3oNWY Button__button___wCHGy Fonts__bold-font___3iFek Colour__blue-hoverable___1p95h Colour__blue___3JCwq",
            "yellow-button": "Button__yellow-button___2fo4W Button__button___wCHGy Fonts__bold-font___3iFek Colour__yellow-hoverable___GgWcF Colour__yellow___2xL7_",
            "green-button": "Button__green-button___1rQ5K Button__button___wCHGy Fonts__bold-font___3iFek Colour__green-hoverable___272xi Colour__green___2SHEH",
            "red-button": "Button__red-button___13_B8 Button__button___wCHGy Fonts__bold-font___3iFek Colour__red-hoverable___1-IDU Colour__red___3L8_4",
            "basic": "Button__basic___3BXRg Button__green-button___1rQ5K Button__button___wCHGy Fonts__bold-font___3iFek Colour__green-hoverable___272xi Colour__green___2SHEH",
            "show-leaderboard": "Button__show-leaderboard___2Skw9 Button__blue-button___3oNWY Button__button___wCHGy Fonts__bold-font___3iFek Colour__blue-hoverable___1p95h Colour__blue___3JCwq",
            "play-game": "Button__play-game___3y39L Button__green-button___1rQ5K Button__button___wCHGy Fonts__bold-font___3iFek Colour__green-hoverable___272xi Colour__green___2SHEH",
            "show-how-to-play": "Button__show-how-to-play___3-9kE Button__red-button___13_B8 Button__button___wCHGy Fonts__bold-font___3iFek Colour__red-hoverable___1-IDU Colour__red___3L8_4",
            "file-download": "Button__file-download___2a0mB Button__red-button___13_B8 Button__button___wCHGy Fonts__bold-font___3iFek Colour__red-hoverable___1-IDU Colour__red___3L8_4",
            "skip-year": "Button__skip-year___wg_7D Button__green-button___1rQ5K Button__button___wCHGy Fonts__bold-font___3iFek Colour__green-hoverable___272xi Colour__green___2SHEH",
            "slideshow-cancel": "Button__slideshow-cancel___2cCIY Button__red-button___13_B8 Button__button___wCHGy Fonts__bold-font___3iFek Colour__red-hoverable___1-IDU Colour__red___3L8_4",
            "slideshow-previous": "Button__slideshow-previous___SMlEA Button__blue-button___3oNWY Button__button___wCHGy Fonts__bold-font___3iFek Colour__blue-hoverable___1p95h Colour__blue___3JCwq",
            "slideshow-next": "Button__slideshow-next___1_hc0 Button__blue-button___3oNWY Button__button___wCHGy Fonts__bold-font___3iFek Colour__blue-hoverable___1p95h Colour__blue___3JCwq",
            "slideshow-skip": "Button__slideshow-skip___1t1Xc Button__blue-button___3oNWY Button__button___wCHGy Fonts__bold-font___3iFek Colour__blue-hoverable___1p95h Colour__blue___3JCwq",
            "slideshow-complete": "Button__slideshow-complete___2IUJd Button__green-button___1rQ5K Button__button___wCHGy Fonts__bold-font___3iFek Colour__green-hoverable___272xi Colour__green___2SHEH",
            "remove-power-source": "Button__remove-power-source___1AVpJ Button__red-button___13_B8 Button__button___wCHGy Fonts__bold-font___3iFek Colour__red-hoverable___1-IDU Colour__red___3L8_4",
            "submit-score": "Button__submit-score___3DhKm Button__blue-button___3oNWY Button__button___wCHGy Fonts__bold-font___3iFek Colour__blue-hoverable___1p95h Colour__blue___3JCwq",
            "show-detailed-results": "Button__show-detailed-results___2YZxn Button__green-button___1rQ5K Button__button___wCHGy Fonts__bold-font___3iFek Colour__green-hoverable___272xi Colour__green___2SHEH",
            "quit-game": "Button__quit-game___18JFJ Button__blue-button___3oNWY Button__button___wCHGy Fonts__bold-font___3iFek Colour__blue-hoverable___1p95h Colour__blue___3JCwq Button__blue-button___3oNWY Button__button___wCHGy Fonts__bold-font___3iFek Colour__blue-hoverable___1p95h Colour__blue___3JCwq",
            "close": "Button__close___D73X- Button__green-button___1rQ5K Button__button___wCHGy Fonts__bold-font___3iFek Colour__green-hoverable___272xi Colour__green___2SHEH",
            "play-again": "Button__play-again___2xmW_ Button__green-button___1rQ5K Button__button___wCHGy Fonts__bold-font___3iFek Colour__green-hoverable___272xi Colour__green___2SHEH",
            "main-menu": "Button__main-menu___2ZEOD Button__blue-button___3oNWY Button__button___wCHGy Fonts__bold-font___3iFek Colour__blue-hoverable___1p95h Colour__blue___3JCwq",
            "more-info": "Button__more-info___2XDfA Button__yellow-button___2fo4W Button__button___wCHGy Fonts__bold-font___3iFek Colour__yellow-hoverable___GgWcF Colour__yellow___2xL7_",
            "back": "Button__back___2eCDW",
            "show-hints": "Button__show-hints___33h97 Button__blue-button___3oNWY Button__button___wCHGy Fonts__bold-font___3iFek Colour__blue-hoverable___1p95h Colour__blue___3JCwq",
            "ok": "Button__ok___Cq5ty Button__green-button___1rQ5K Button__button___wCHGy Fonts__bold-font___3iFek Colour__green-hoverable___272xi Colour__green___2SHEH",
            "outage-answer": "Button__outage-answer___10K4Q",
            "right-answer": "Button__right-answer___2rCIj Button__green-button___1rQ5K Button__button___wCHGy Fonts__bold-font___3iFek Colour__green-hoverable___272xi Colour__green___2SHEH",
            "wrong-answer": "Button__wrong-answer___2phMW Button__red-button___13_B8 Button__button___wCHGy Fonts__bold-font___3iFek Colour__red-hoverable___1-IDU Colour__red___3L8_4",
            "event-start": "Button__event-start___1CCdR"
        }
    };

    var Button = function (_super) {
        tslib_1.__extends(Button, _super);
        function Button(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.getIcon = function () {
                var type = _this.props.type;
                switch (type) {
                    case 'show-leaderboard':
                        return React.createElement("i", { className: "fas fa-trophy" });
                    case 'play-game':
                    case 'play-again':
                        return React.createElement("i", { className: "fas fa-play" });
                    case 'skip-year':
                        return React.createElement("i", { className: "fas fa-fast-forward" });
                    case 'show-how-to-play':
                        return React.createElement("i", { className: "fas fa-gamepad" });
                    case 'file-download':
                        return React.createElement("i", { className: "fas fa-download" });
                    case 'slideshow-cancel':
                        return React.createElement("i", { className: "fas fa-arrow-left" });
                    case 'slideshow-previous':
                        return React.createElement("i", { className: "fas fa-chevron-left" });
                    case 'slideshow-next':
                        return React.createElement("i", { className: "fas fa-chevron-right" });
                    case 'slideshow-skip':
                        return React.createElement("i", { className: "fas fa-fast-forward" });
                    case 'ok':
                        return React.createElement("i", { className: "fas fa-check" });
                    case 'close':
                        return React.createElement("i", { className: "fas fa-times" });
                    case 'remove-power-source':
                        return React.createElement("i", { className: "fas fa-trash-alt" });
                    case 'wrong-answer':
                        return React.createElement("i", { className: "fas fa-times" });
                    case 'main-menu':
                        return React.createElement("i", { className: "fas fa-chevron-left" });
                    case 'more-info':
                        return React.createElement("i", { className: "fas fa-trophy" });
                    default:
                        return null;
                }
            };
            return _this;
        }
        Button.prototype.render = function () {
            var _a = this.props,
                type = _a.type,
                onClick = _a.onClick,
                children = _a.children;
            var style_name = type ? type : 'basic';
            return React.createElement(
                "button",
                { onClick: onClick, className: (0, _getClassName3.default)(style_name, _styleModuleImportMap)
                },
                !!this.getIcon() && React.createElement(
                    "span",
                    {
                        className: (0, _getClassName3.default)(children ? 'padded-icon' : 'icon', _styleModuleImportMap)
                    },
                    this.getIcon()
                ),
                children
            );
        };
        return Button;
    }(React.Component);
    exports.default = Button;
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(67);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_io__ = __webpack_require__(24);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "take", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["t"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takeMaybe", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["w"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "put", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "putResolve", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["o"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "all", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "race", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["p"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "call", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "apply", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cps", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fork", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "spawn", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["s"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "join", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cancel", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "select", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["q"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "actionChannel", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cancelled", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "flush", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getContext", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setContext", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["r"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takeEvery", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["u"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takeLatest", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["v"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["x"]; });


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("../action"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.year = mod.exports;
    }
})(this, function (exports, _action) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.setSeason = setSeason;
    exports.setYear = setYear;
    exports.resetYear = resetYear;
    exports.incrementYear = incrementYear;
    exports.startYear = startYear;
    exports.completeYear = completeYear;
    exports.completeYearEarly = completeYearEarly;
    exports.endYear = endYear;
    exports.triggerSeasonalContent = triggerSeasonalContent;
    exports.testAnnualTargets = testAnnualTargets;
    function setSeason(season_id) {
        return { type: _action.SET_SEASON, payload: { season_id: season_id } };
    }
    function setYear(year) {
        return { type: _action.SET_YEAR, payload: { year: year } };
    }
    function resetYear() {
        return { type: _action.SET_YEAR, payload: { year: 0 } };
    }
    function incrementYear() {
        return { type: _action.INCREMENT_YEAR, payload: {} };
    }
    function startYear() {
        return { type: _action.START_YEAR, payload: {} };
    }
    function completeYear() {
        return { type: _action.START_YEAR, payload: {} };
    }
    function completeYearEarly() {
        return { type: _action.START_YEAR, payload: {} };
    }
    function endYear() {
        return { type: _action.END_YEAR, payload: {} };
    }
    function triggerSeasonalContent() {
        return { type: _action.TRIGGER_SEASONAL_CONTENT, payload: {} };
    }
    function testAnnualTargets() {
        return { type: _action.TEST_ANNUAL_TARGETS, payload: {} };
    }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isEnd; });
/* harmony export (immutable) */ __webpack_exports__["b"] = channel;
/* harmony export (immutable) */ __webpack_exports__["c"] = eventChannel;
/* harmony export (immutable) */ __webpack_exports__["e"] = multicastChannel;
/* harmony export (immutable) */ __webpack_exports__["f"] = stdChannel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__symbols__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__buffers__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scheduler__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matcher__ = __webpack_require__(72);





var END = {
  type: __WEBPACK_IMPORTED_MODULE_0__symbols__["c" /* CHANNEL_END_TYPE */]
};
var isEnd = function isEnd(a) {
  return a && a.type === __WEBPACK_IMPORTED_MODULE_0__symbols__["c" /* CHANNEL_END_TYPE */];
};
var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = "Saga or channel was provided with an undefined action\nHints:\n  - check that your Action Creator returns a non-undefined value\n  - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners";
function channel(buffer) {
  if (buffer === void 0) {
    buffer = __WEBPACK_IMPORTED_MODULE_2__buffers__["expanding"]();
  }

  var closed = false;
  var takers = [];

  if (false) {
    check(buffer, is.buffer, INVALID_BUFFER);
  }

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw Object(__WEBPACK_IMPORTED_MODULE_1__utils__["h" /* internalErr */])('Cannot have a closed channel with pending takers');
    }

    if (takers.length && !buffer.isEmpty()) {
      throw Object(__WEBPACK_IMPORTED_MODULE_1__utils__["h" /* internalErr */])('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    checkForbiddenStates();

    if (false) {
      check(input, is.notUndef, UNDEFINED_INPUT_ERROR);
    }

    if (closed) {
      return;
    }

    if (!takers.length) {
      return buffer.put(input);
    }

    var cb = takers[0];
    takers.splice(0, 1);
    cb(input);
  }

  function take(cb) {
    checkForbiddenStates();

    if (false) {
      check(cb, is.func, "channel.take's callback must be a function");
    }

    if (closed && buffer.isEmpty()) {
      cb(END);
    } else if (!buffer.isEmpty()) {
      cb(buffer.take());
    } else {
      takers.push(cb);

      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["p" /* remove */])(takers, cb);
      };
    }
  }

  function flush(cb) {
    checkForbiddenStates(); // TODO: check if some new state should be forbidden now

    if (false) {
      check(cb, is.func, "channel.flush' callback must be a function");
    }

    if (closed && buffer.isEmpty()) {
      cb(END);
      return;
    }

    cb(buffer.flush());
  }

  function close() {
    checkForbiddenStates();

    if (!closed) {
      closed = true;

      if (takers.length) {
        var arr = takers;
        takers = [];

        for (var i = 0, len = arr.length; i < len; i++) {
          var taker = arr[i];
          taker(END);
        }
      }
    }
  }

  return {
    take: take,
    put: put,
    flush: flush,
    close: close
  };
}
function eventChannel(subscribe, buffer) {
  if (buffer === void 0) {
    buffer = __WEBPACK_IMPORTED_MODULE_2__buffers__["none"]();
  }

  var closed = false;
  var unsubscribe;
  var chan = channel(buffer);

  var close = function close() {
    if (__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* is */].func(unsubscribe)) {
      unsubscribe();
    }

    chan.close();
  };

  unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      close();
      closed = true;
      return;
    }

    chan.put(input);
  });

  if (!__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* is */].func(unsubscribe)) {
    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
  }

  unsubscribe = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["o" /* once */])(unsubscribe);

  if (closed) {
    unsubscribe();
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: close
  };
}
function multicastChannel() {
  var _ref;

  var closed = false;
  var currentTakers = [];
  var nextTakers = currentTakers;

  var ensureCanMutateNextTakers = function ensureCanMutateNextTakers() {
    if (nextTakers !== currentTakers) {
      return;
    }

    nextTakers = currentTakers.slice();
  }; // TODO: check if its possible to extract closing function and reuse it in both unicasts and multicasts


  var close = function close() {
    closed = true;
    var takers = currentTakers = nextTakers;

    for (var i = 0; i < takers.length; i++) {
      var taker = takers[i];
      taker(END);
    }

    nextTakers = [];
  };

  return _ref = {}, _ref[__WEBPACK_IMPORTED_MODULE_0__symbols__["f" /* MULTICAST */]] = true, _ref.put = function put(input) {
    // TODO: should I check forbidden state here? 1 of them is even impossible
    // as we do not possibility of buffer here
    if (false) {
      check(input, is.notUndef, UNDEFINED_INPUT_ERROR);
    }

    if (closed) {
      return;
    }

    if (isEnd(input)) {
      close();
      return;
    }

    var takers = currentTakers = nextTakers;

    for (var i = 0; i < takers.length; i++) {
      var taker = takers[i];

      if (taker[__WEBPACK_IMPORTED_MODULE_0__symbols__["e" /* MATCH */]](input)) {
        taker.cancel();
        taker(input);
      }
    }
  }, _ref.take = function take(cb, matcher) {
    if (matcher === void 0) {
      matcher = __WEBPACK_IMPORTED_MODULE_4__matcher__["b" /* wildcard */];
    }

    if (closed) {
      cb(END);
      return;
    }

    cb[__WEBPACK_IMPORTED_MODULE_0__symbols__["e" /* MATCH */]] = matcher;
    ensureCanMutateNextTakers();
    nextTakers.push(cb);
    cb.cancel = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["o" /* once */])(function () {
      ensureCanMutateNextTakers();
      Object(__WEBPACK_IMPORTED_MODULE_1__utils__["p" /* remove */])(nextTakers, cb);
    });
  }, _ref.close = close, _ref;
}
function stdChannel() {
  var chan = multicastChannel();
  var put = chan.put;

  chan.put = function (input) {
    if (input[__WEBPACK_IMPORTED_MODULE_0__symbols__["g" /* SAGA_ACTION */]]) {
      put(input);
      return;
    }

    Object(__WEBPACK_IMPORTED_MODULE_3__scheduler__["a" /* asap */])(function () {
      return put(input);
    });
  };

  return chan;
}

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return detach; });
/* harmony export (immutable) */ __webpack_exports__["t"] = take;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return takeMaybe; });
/* harmony export (immutable) */ __webpack_exports__["n"] = put;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return putResolve; });
/* harmony export (immutable) */ __webpack_exports__["b"] = all;
/* harmony export (immutable) */ __webpack_exports__["p"] = race;
/* harmony export (immutable) */ __webpack_exports__["e"] = call;
/* harmony export (immutable) */ __webpack_exports__["c"] = apply;
/* harmony export (immutable) */ __webpack_exports__["h"] = cps;
/* harmony export (immutable) */ __webpack_exports__["k"] = fork;
/* harmony export (immutable) */ __webpack_exports__["s"] = spawn;
/* harmony export (immutable) */ __webpack_exports__["m"] = join;
/* harmony export (immutable) */ __webpack_exports__["f"] = cancel;
/* harmony export (immutable) */ __webpack_exports__["q"] = select;
/* harmony export (immutable) */ __webpack_exports__["a"] = actionChannel;
/* harmony export (immutable) */ __webpack_exports__["g"] = cancelled;
/* harmony export (immutable) */ __webpack_exports__["j"] = flush;
/* harmony export (immutable) */ __webpack_exports__["l"] = getContext;
/* harmony export (immutable) */ __webpack_exports__["r"] = setContext;
/* harmony export (immutable) */ __webpack_exports__["u"] = takeEvery;
/* harmony export (immutable) */ __webpack_exports__["v"] = takeLatest;
/* harmony export (immutable) */ __webpack_exports__["x"] = throttle;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return asEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__symbols__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sagaHelpers__ = __webpack_require__(147);



var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';
var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';

var effect = function effect(type, payload) {
  var _ref;

  return _ref = {}, _ref[__WEBPACK_IMPORTED_MODULE_0__symbols__["d" /* IO */]] = true, _ref[type] = payload, _ref;
};

var detach = function detach(eff) {
  if (false) {
    check(asEffect.fork(eff), is.object, 'detach(eff): argument must be a fork effect');
  }

  eff[FORK].detached = true;
  return eff;
};
function take(patternOrChannel, multicastPattern) {
  if (patternOrChannel === void 0) {
    patternOrChannel = '*';
  }

  if (false) {
    check(arguments[0], is.notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }

  if (__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* is */].pattern(patternOrChannel)) {
    return effect(TAKE, {
      pattern: patternOrChannel
    });
  }

  if (__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* is */].multicast(patternOrChannel) && __WEBPACK_IMPORTED_MODULE_1__utils__["i" /* is */].notUndef(multicastPattern) && __WEBPACK_IMPORTED_MODULE_1__utils__["i" /* is */].pattern(multicastPattern)) {
    return effect(TAKE, {
      channel: patternOrChannel,
      pattern: multicastPattern
    });
  }

  if (__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* is */].channel(patternOrChannel)) {
    return effect(TAKE, {
      channel: patternOrChannel
    });
  }

  throw new Error("take(patternOrChannel): argument " + patternOrChannel + " is not valid channel or a valid pattern");
}

var takeMaybe = function takeMaybe() {
  var eff = take.apply(void 0, arguments);
  eff[TAKE].maybe = true;
  return eff;
};


function put(channel, action) {
  if (false) {
    if (arguments.length > 1) {
      check(channel, is.notUndef, 'put(channel, action): argument channel is undefined');
      check(channel, is.channel, "put(channel, action): argument " + channel + " is not a valid channel");
      check(action, is.notUndef, 'put(channel, action): argument action is undefined');
    } else {
      check(channel, is.notUndef, 'put(action): argument action is undefined');
    }
  }

  if (__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* is */].undef(action)) {
    action = channel;
    channel = null;
  }

  return effect(PUT, {
    channel: channel,
    action: action
  });
}

var putResolve = function putResolve() {
  var eff = put.apply(void 0, arguments);
  eff[PUT].resolve = true;
  return eff;
};


function all(effects) {
  return effect(ALL, effects);
}
function race(effects) {
  return effect(RACE, effects);
}

function getFnCallDesc(meth, fn, args) {
  if (false) {
    check(fn, is.notUndef, meth + ": argument fn is undefined");
  }

  var context = null;

  if (__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* is */].array(fn)) {
    var _fn = fn;
    context = _fn[0];
    fn = _fn[1];
  } else if (fn.fn) {
    var _fn2 = fn;
    context = _fn2.context;
    fn = _fn2.fn;
  }

  if (context && __WEBPACK_IMPORTED_MODULE_1__utils__["i" /* is */].string(fn) && __WEBPACK_IMPORTED_MODULE_1__utils__["i" /* is */].func(context[fn])) {
    fn = context[fn];
  }

  if (false) {
    check(fn, is.func, meth + ": argument " + fn + " is not a function");
  }

  return {
    context: context,
    fn: fn,
    args: args
  };
}

function call(fn) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return effect(CALL, getFnCallDesc('call', fn, args));
}
function apply(context, fn, args) {
  if (args === void 0) {
    args = [];
  }

  return effect(CALL, getFnCallDesc('apply', {
    context: context,
    fn: fn
  }, args));
}
function cps(fn) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return effect(CPS, getFnCallDesc('cps', fn, args));
}
function fork(fn) {
  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return effect(FORK, getFnCallDesc('fork', fn, args));
}
function spawn(fn) {
  for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  return detach(fork.apply(void 0, [fn].concat(args)));
}
function join() {
  for (var _len5 = arguments.length, tasks = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    tasks[_key5] = arguments[_key5];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return join(t);
    }));
  }

  var task = tasks[0];

  if (false) {
    check(task, is.notUndef, 'join(task): argument task is undefined');
    check(task, is.task, "join(task): argument " + task + " is not a valid Task object " + TEST_HINT);
  }

  return effect(JOIN, task);
}
function cancel() {
  for (var _len6 = arguments.length, tasks = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    tasks[_key6] = arguments[_key6];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return cancel(t);
    }));
  }

  var task = tasks[0];

  if (false) {
    check(task, is.notUndef, 'cancel(task): argument task is undefined');
    check(task, is.task, "cancel(task): argument " + task + " is not a valid Task object " + TEST_HINT);
  }

  return effect(CANCEL, task || __WEBPACK_IMPORTED_MODULE_0__symbols__["h" /* SELF_CANCELLATION */]);
}
function select(selector) {
  if (selector === void 0) {
    selector = __WEBPACK_IMPORTED_MODULE_1__utils__["g" /* identity */];
  }

  for (var _len7 = arguments.length, args = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    args[_key7 - 1] = arguments[_key7];
  }

  if (false) {
    check(arguments[0], is.notUndef, 'select(selector, [...]): argument selector is undefined');
    check(selector, is.func, "select(selector, [...]): argument " + selector + " is not a function");
  }

  return effect(SELECT, {
    selector: selector,
    args: args
  });
}
/**
  channel(pattern, [buffer])    => creates a proxy channel for store actions
**/

function actionChannel(pattern, buffer) {
  if (false) {
    check(pattern, is.notUndef, 'actionChannel(pattern,...): argument pattern is undefined');

    if (arguments.length > 1) {
      check(buffer, is.notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
      check(buffer, is.buffer, "actionChannel(pattern, buffer): argument " + buffer + " is not a valid buffer");
    }
  }

  return effect(ACTION_CHANNEL, {
    pattern: pattern,
    buffer: buffer
  });
}
function cancelled() {
  return effect(CANCELLED, {});
}
function flush(channel) {
  if (false) {
    check(channel, is.channel, "flush(channel): argument " + channel + " is not valid channel");
  }

  return effect(FLUSH, channel);
}
function getContext(prop) {
  if (false) {
    check(prop, is.string, "getContext(prop): argument " + prop + " is not a string");
  }

  return effect(GET_CONTEXT, prop);
}
function setContext(props) {
  if (false) {
    check(props, is.object, createSetContextWarning(null, props));
  }

  return effect(SET_CONTEXT, props);
}
function takeEvery(patternOrChannel, worker) {
  for (var _len8 = arguments.length, args = new Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
    args[_key8 - 2] = arguments[_key8];
  }

  return fork.apply(void 0, [__WEBPACK_IMPORTED_MODULE_2__sagaHelpers__["a" /* takeEveryHelper */], patternOrChannel, worker].concat(args));
}
function takeLatest(patternOrChannel, worker) {
  for (var _len9 = arguments.length, args = new Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
    args[_key9 - 2] = arguments[_key9];
  }

  return fork.apply(void 0, [__WEBPACK_IMPORTED_MODULE_2__sagaHelpers__["b" /* takeLatestHelper */], patternOrChannel, worker].concat(args));
}
function throttle(ms, pattern, worker) {
  for (var _len10 = arguments.length, args = new Array(_len10 > 3 ? _len10 - 3 : 0), _key10 = 3; _key10 < _len10; _key10++) {
    args[_key10 - 3] = arguments[_key10];
  }

  return fork.apply(void 0, [__WEBPACK_IMPORTED_MODULE_2__sagaHelpers__["c" /* throttleHelper */], ms, pattern, worker].concat(args));
}

var createAsEffectType = function createAsEffectType(type) {
  return function (effect) {
    return effect && effect[__WEBPACK_IMPORTED_MODULE_0__symbols__["d" /* IO */]] && effect[type];
  };
};

var asEffect = {
  take:
  /*#__PURE__*/
  createAsEffectType(TAKE),
  put:
  /*#__PURE__*/
  createAsEffectType(PUT),
  all:
  /*#__PURE__*/
  createAsEffectType(ALL),
  race:
  /*#__PURE__*/
  createAsEffectType(RACE),
  call:
  /*#__PURE__*/
  createAsEffectType(CALL),
  cps:
  /*#__PURE__*/
  createAsEffectType(CPS),
  fork:
  /*#__PURE__*/
  createAsEffectType(FORK),
  join:
  /*#__PURE__*/
  createAsEffectType(JOIN),
  cancel:
  /*#__PURE__*/
  createAsEffectType(CANCEL),
  select:
  /*#__PURE__*/
  createAsEffectType(SELECT),
  actionChannel:
  /*#__PURE__*/
  createAsEffectType(ACTION_CHANNEL),
  cancelled:
  /*#__PURE__*/
  createAsEffectType(CANCELLED),
  flush:
  /*#__PURE__*/
  createAsEffectType(FLUSH),
  getContext:
  /*#__PURE__*/
  createAsEffectType(GET_CONTEXT),
  setContext:
  /*#__PURE__*/
  createAsEffectType(SET_CONTEXT)
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("../action"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.questions = mod.exports;
    }
})(this, function (exports, _action) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.showNextOutageQuestion = showNextOutageQuestion;
    exports.showNextYearEndQuestion = showNextYearEndQuestion;
    exports.recordCorrectAnswer = recordCorrectAnswer;
    exports.resetCorrectAnswerCount = resetCorrectAnswerCount;
    function showNextOutageQuestion(question_id) {
        return { type: _action.SHOW_NEXT_OUTAGE_QUESTION, payload: { question_id: question_id } };
    }
    function showNextYearEndQuestion(question_id) {
        return { type: _action.SHOW_NEXT_YEAR_END_QUESTION, payload: { question_id: question_id } };
    }
    function recordCorrectAnswer() {
        return { type: _action.RECORD_CORRECT_ANSWER, payload: {} };
    }
    function resetCorrectAnswerCount() {
        return { type: _action.RESET_CORRECT_ANSWERS_COUNT, payload: {} };
    }
});

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(16)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("tslib"), require("react"), require("react-redux"), require("../../store/reducers/screen"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.tslib, global.react, global.reactRedux, global.screen);
        global.screenComponent = mod.exports;
    }
})(this, function (exports, _tslib, _react, _reactRedux, _screen) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.screenComponent = undefined;

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }

        return target;
    };

    var screenComponent = exports.screenComponent = function screenComponent() {
        return function (Component) {
            var ScreenComponent = function (_super) {
                tslib_1.__extends(ScreenComponent, _super);
                function ScreenComponent(props) {
                    var _this = _super.call(this, props) || this;
                    _this.props = props;
                    return _this;
                }
                ScreenComponent.prototype.render = function () {
                    return React.createElement(Component, _extends({ active: this.props.screen === this.props.active_screen }, this.props));
                };
                return ScreenComponent;
            }(React.Component);
            function mapStateToProps(state) {
                return {
                    active_screen: (0, _screen.getScreen)(state)
                };
            }
            function mapDispatchToProps(dispatch) {
                return {};
            }
            return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ScreenComponent);
        };
    };
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANNEL_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANNEL_END_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MULTICAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SAGA_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SELF_CANCELLATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TASK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return TASK_CANCEL; });
var sym = function sym(id) {
  id = "@@redux-saga/" + id;
  return typeof Symbol === 'function' ? Symbol(id) : id;
};

var CANCEL =
/*#__PURE__*/
sym('CANCEL_PROMISE');
var CHANNEL_END =
/*#__PURE__*/
sym('CHANNEL_END');
var CHANNEL_END_TYPE =
/*#__PURE__*/
sym('CHANNEL_END');
var IO =
/*#__PURE__*/
sym('IO');
var MATCH =
/*#__PURE__*/
sym('MATCH');
var MULTICAST =
/*#__PURE__*/
sym('MULTICAST');
var SAGA_ACTION =
/*#__PURE__*/
sym('SAGA_ACTION');
var SELF_CANCELLATION =
/*#__PURE__*/
sym('SELF_CANCELLATION');
var TASK =
/*#__PURE__*/
sym('TASK');
var TASK_CANCEL =
/*#__PURE__*/
sym('TASK_CANCEL');

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(8), __webpack_require__(2), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('lodash'), require('../../actions/action'), require('reselect'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.lodash, global.action, global.reselect);
        global.deprecate = mod.exports;
    }
})(this, function (exports, _lodash, _action, _reselect) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getDeprecations = exports.isPowerSourceDeprecated = exports.getDeprecate = undefined;
    exports.deprecate = deprecate;

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    var getDeprecate = exports.getDeprecate = function getDeprecate(state) {
        return state.deprecate;
    };
    var getLocationID = function getLocationID(state, props) {
        return props.location_id;
    };
    var isPowerSourceDeprecated = exports.isPowerSourceDeprecated = (0, _reselect.createSelector)([getDeprecate, getLocationID], function (deprecate, location_id) {
        return deprecate[location_id] === true;
    });
    var getDeprecations = exports.getDeprecations = function getDeprecations(state) {
        return state.deprecate;
    };
    var initial_state = _.fill(Array(50), undefined);
    function deprecate(state, action) {
        if (state === void 0) {
            state = initial_state;
        }
        switch (action.type) {
            case _action.CLEAR_ALL_DEPRECATIONS:
                {
                    return initial_state.slice(0);
                }
            case _action.SET_INITIAL_DEPRECATIONS:
                {
                    var payload = action.payload;
                    var deprecations = payload.deprecations;
                    return deprecations;
                }
            case _action.REMOVE_POWER_SOURCE:
                {
                    var payload = action.payload;
                    var location_id = payload.location_id;
                    return state.slice(0, location_id).concat([false], state.slice(location_id + 1));
                }
            default:
                return state;
        }
    }
});

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(11), __webpack_require__(8), __webpack_require__(10), __webpack_require__(13), __webpack_require__(52), __webpack_require__(30), __webpack_require__(28)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("reselect"), require("lodash"), require("../../../data/data"), require("../powerSources"), require("../energy/energyDemand"), require("../power-sources/damage"), require("../power-sources/deprecate"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.reselect, global.lodash, global.data, global.powerSources, global.energyDemand, global.damage, global.deprecate);
        global.energyOutput = mod.exports;
    }
})(this, function (exports, _reselect, _lodash, _data, _powerSources, _energyDemand, _damage, _deprecate) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getEnergyOutputRatio = exports.getEnergyOutput = undefined;
    exports.getTargetEnergyOutput = getTargetEnergyOutput;
    exports.energyOutput = energyOutput;

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function getTargetEnergyOutput() {
        var locations = (0, _data.getPowerSourceLocationsData)();
        var power_sources = (0, _data.getAllPowerSourcesData)();
        var ratios = (0, _data.getEnergyMixData)();
        var energy_output_sum = _.reduce(power_sources, function (sum, power_source) {
            var source_output_data = power_source['energy-output'];
            return sum + ratios[power_source.id] * 0.01 * locations.length * source_output_data;
        }, 0);
        return energy_output_sum;
    }
    var getEnergyOutput = exports.getEnergyOutput = (0, _reselect.createSelector)([_powerSources.getPowerSources, _damage.getDamage, _deprecate.getDeprecate], function (power_sources, damage, deprecate) {
        if (!power_sources.length) return 0;
        var output_sum = _.reduce(power_sources, function (total, power_source, i) {
            if (!power_source || deprecate[i] === true) return total;
            return total + power_source['energy-output'];
        }, 0);
        return Math.round(output_sum);
    });
    var getEnergyOutputRatio = exports.getEnergyOutputRatio = (0, _reselect.createSelector)([getEnergyOutput, _energyDemand.getEnergyDemand], function (actual, demand) {
        if (!actual) return 0;
        var demand_min = Math.max(demand - 50, 0);
        var demand_max = demand + 50;
        var pc = (actual - demand_min) / (demand_max - demand_min);
        var ratio = _.clamp(pc, 0, 1);
        console.group('getEnergyOutputRatio');
        console.log('actual', actual);
        console.log('demand', demand);
        console.log('demand_min', demand_min);
        console.log('demand_max', demand_max);
        console.log('pc', pc);
        console.log('ratio', ratio);
        console.groupEnd();
        return parseFloat(ratio.toFixed(2));
    });
    var initialState = 30;
    function energyOutput(state, action) {
        if (state === void 0) {
            state = initialState;
        }
        switch (action.type) {
            default:
                return state;
        }
    }
});

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(8), __webpack_require__(2), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('lodash'), require('../../actions/action'), require('reselect'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.lodash, global.action, global.reselect);
        global.damage = mod.exports;
    }
})(this, function (exports, _lodash, _action, _reselect) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.isPowerSourceDamaged = exports.getDamage = undefined;
    exports.damage = damage;

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    var getDamage = exports.getDamage = function getDamage(state) {
        return state.damage;
    };
    var getLocationID = function getLocationID(state, props) {
        return props.location_id;
    };
    var isPowerSourceDamaged = exports.isPowerSourceDamaged = (0, _reselect.createSelector)([getDamage, getLocationID], function (damage, location_id) {
        return damage[location_id] === true;
    });
    var initial_state = _.fill(Array(50), undefined);
    function damage(state, action) {
        if (state === void 0) {
            state = initial_state;
        }
        switch (action.type) {
            case _action.CLEAR_ALL_DAMAGE:
                {
                    return initial_state.slice(0);
                }
            case _action.SET_INITIAL_DAMAGE:
                {
                    var payload = action.payload;
                    var damaged = payload.damaged;
                    return damaged;
                }
            case _action.REPAIR_STATION_AT_LOCATION:
                {
                    var payload = action.payload;
                    var location_id = payload.location_id;
                    return state.slice(0, location_id).concat([false], state.slice(location_id + 1));
                }
            default:
                return state;
        }
    }
});

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("./action"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.powerSources = mod.exports;
    }
})(this, function (exports, _action) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.selectPowerSource = selectPowerSource;
    exports.setDraggingPowerSource = setDraggingPowerSource;
    exports.placePowerSource = placePowerSource;
    exports.addPowerSourceAtLocation = addPowerSourceAtLocation;
    exports.removePowerSourceAtLocation = removePowerSourceAtLocation;
    exports.removeAllPowerSources = removeAllPowerSources;
    exports.resetAllPowerSources = resetAllPowerSources;
    function selectPowerSource(power_source) {
        return { type: _action.SET_SELECTED_POWER_SOURCE, payload: { power_source: power_source } };
    }
    function setDraggingPowerSource(power_source, ox, oy) {
        if (power_source === void 0) {
            power_source = null;
        }
        if (ox === void 0) {
            ox = null;
        }
        if (oy === void 0) {
            oy = null;
        }
        return { type: _action.SET_DRAGGING_POWER_SOURCE, payload: { power_source: power_source, ox: ox, oy: oy } };
    }
    function placePowerSource() {
        return { type: _action.PLACE_POWER_SOURCE };
    }
    function addPowerSourceAtLocation(power_source, location_id) {
        return { type: _action.ADD_POWER_SOURCE_AT_LOCATION, payload: { power_source: power_source, location_id: location_id } };
    }
    function removePowerSourceAtLocation(location_id) {
        return { type: _action.REMOVE_POWER_SOURCE, payload: { location_id: location_id } };
    }
    function removeAllPowerSources() {
        return { type: _action.REMOVE_ALL_POWER_SOURCES, payload: {} };
    }
    function resetAllPowerSources() {
        return { type: _action.RESET_ALL_POWER_SOURCES, payload: {} };
    }
});

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(8), __webpack_require__(11), __webpack_require__(13), __webpack_require__(12)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("lodash"), require("reselect"), require("../powerSources"), require("../year"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.lodash, global.reselect, global.powerSources, global.year);
        global.carbonOutput = mod.exports;
    }
})(this, function (exports, _lodash, _reselect, _powerSources, _year) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getCarbonOutputTarget = exports.getCarbonOutputPercentage = exports.getCarbonOutput = undefined;

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    var getCarbonOutput = exports.getCarbonOutput = (0, _reselect.createSelector)([_powerSources.getPopulatedPowerSources], function (power_sources) {
        if (!power_sources.length) return 0;
        return _.sumBy(power_sources, 'carbon-output');
    });
    var getCarbonOutputPercentage = exports.getCarbonOutputPercentage = (0, _reselect.createSelector)([getCarbonOutput, _powerSources.countPowerSources], function (carbon_output, power_source_count) {
        if (!carbon_output || !power_source_count) return 0;
        return Math.round(100 - carbon_output / power_source_count / 0.01);
    });
    var getCarbonOutputTarget = exports.getCarbonOutputTarget = (0, _reselect.createSelector)([_year.getYearData], function (year_data) {
        if (!year_data) return 8.5;
        return year_data['carbon-target'];
    });
    var initialState = 0;
});

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("./action"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.timer = mod.exports;
    }
})(this, function (exports, _action) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.startTimer = startTimer;
    exports.tickTimer = tickTimer;
    exports.stopTimer = stopTimer;
    exports.pauseTimer = pauseTimer;
    exports.resumeTimer = resumeTimer;
    exports.timerHasExpired = timerHasExpired;
    exports.resetTimer = resetTimer;
    function startTimer() {
        return { type: _action.START_TIMER, payload: {} };
    }
    function tickTimer() {
        return { type: _action.TICK_TIMER, payload: {} };
    }
    function stopTimer() {
        return { type: _action.STOP_TIMER, payload: {} };
    }
    function pauseTimer() {
        return { type: _action.PAUSE_TIMER, payload: {} };
    }
    function resumeTimer() {
        return { type: _action.RESUME_TIMER, payload: {} };
    }
    function timerHasExpired() {
        return { type: _action.TIMER_HAS_EXPIRED, payload: {} };
    }
    function resetTimer() {
        return { type: _action.RESET_TIMER, payload: {} };
    }
});

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("./action"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.game = mod.exports;
    }
})(this, function (exports, _action) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.showGameIntro = showGameIntro;
    exports.startGame = startGame;
    exports.resumeGame = resumeGame;
    function showGameIntro() {
        return { type: _action.SHOW_GAME_INTRO };
    }
    function startGame() {
        return { type: _action.START_GAME };
    }
    function resumeGame() {
        return { type: _action.RESUME_GAME };
    }
});

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(209)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("./HighlightText.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.HighlightText);
        global.HighlightText = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./HighlightText.scss": {
            "highlight-text": "HighlightText__highlight-text___28uI7 undefined",
            "blue": "HighlightText__blue___3qtGF HighlightText__highlight-text___28uI7 undefined Colour__blue___3JCwq",
            "green": "HighlightText__green___3oMeU HighlightText__highlight-text___28uI7 undefined Colour__green___2SHEH",
            "yellow": "HighlightText__yellow___2eXiL HighlightText__highlight-text___28uI7 undefined Colour__yellow___2xL7_",
            "red": "HighlightText__red___1nODN HighlightText__highlight-text___28uI7 undefined Colour__red___3L8_4"
        }
    };

    var HighlightText = function (_super) {
        tslib_1.__extends(HighlightText, _super);
        function HighlightText(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            return _this;
        }
        HighlightText.prototype.render = function () {
            var _a = this.props,
                type = _a.type,
                children = _a.children;
            return React.createElement(
                "h3",
                {
                    className: (0, _getClassName3.default)(type, _styleModuleImportMap)
                },
                children
            );
        };
        return HighlightText;
    }(React.Component);
    exports.default = HighlightText;
});

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(8), __webpack_require__(2), __webpack_require__(10), __webpack_require__(11), __webpack_require__(38)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("lodash"), require("../actions/action"), require("../../data/data"), require("reselect"), require("./draggingPowerSource"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.lodash, global.action, global.data, global.reselect, global.draggingPowerSource);
        global.location = mod.exports;
    }
})(this, function (exports, _lodash, _action, _data, _reselect, _draggingPowerSource) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.isLocationValidForDraggingPowerSource = exports.getSelectedLocationData = exports.getLocationID = exports.getSelectedLocation = undefined;
    exports.location = location;

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    var getSelectedLocation = exports.getSelectedLocation = function getSelectedLocation(state) {
        return state.location;
    };
    var getLocationID = exports.getLocationID = function getLocationID(state, props) {
        return _.isNumber(props) ? props : _.get(props, 'location_id');
    };
    var getSelectedLocationData = exports.getSelectedLocationData = (0, _reselect.createSelector)([getSelectedLocation], function (location_id) {
        var locations = (0, _data.getPowerSourceLocationsData)();
        return locations[location_id];
    });
    var isLocationValidForDraggingPowerSource = exports.isLocationValidForDraggingPowerSource = (0, _reselect.createSelector)([_draggingPowerSource.getDraggingPowerSource, getLocationID], function (power_source, location_id) {
        if (!_.isFinite(location_id) || location_id === -1) return false;
        var locations = (0, _data.getPowerSourceLocationsData)();
        var location = locations[location_id];
        var type = location.type;
        if (!power_source || !power_source.requirements) return true;
        return _.includes(power_source.requirements, type);
    });
    var initialState = 0;
    function location(state, action) {
        if (state === void 0) {
            state = initialState;
        }
        switch (action.type) {
            case _action.SET_SELECTED_LOCATION:
                {
                    var payload = action.payload;
                    var location_id = payload.location_id;
                    return location_id;
                }
            case _action.CLEAR_SELECTED_LOCATION:
                {
                    return null;
                }
            default:
                return state;
        }
    }
});

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("../actions/action"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.draggingPowerSource = mod.exports;
    }
})(this, function (exports, _action) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getDraggingOrigin = exports.getDraggingPowerSource = undefined;
    exports.draggingPowerSource = draggingPowerSource;
    exports.draggingOrigin = draggingOrigin;
    var getDraggingPowerSource = exports.getDraggingPowerSource = function getDraggingPowerSource(state) {
        return state.draggingPowerSource;
    };
    var getDraggingOrigin = exports.getDraggingOrigin = function getDraggingOrigin(state) {
        return state.draggingOrigin;
    };
    function draggingPowerSource(state, action) {
        if (state === void 0) {
            state = null;
        }
        switch (action.type) {
            case _action.SET_DRAGGING_POWER_SOURCE:
                {
                    var payload = action.payload;
                    var power_source = payload.power_source;
                    return power_source;
                }
            default:
                return state;
        }
    }
    function draggingOrigin(state, action) {
        if (state === void 0) {
            state = null;
        }
        switch (action.type) {
            case _action.SET_DRAGGING_POWER_SOURCE:
                {
                    var payload = action.payload;
                    var x = payload.ox,
                        y = payload.oy;
                    return { x: x, y: y };
                }
            default:
                return state;
        }
    }
});

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(8), __webpack_require__(11), __webpack_require__(12), __webpack_require__(32), __webpack_require__(29), __webpack_require__(13), __webpack_require__(28), __webpack_require__(30)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('lodash'), require('reselect'), require('../year'), require('../outputs/carbonOutput'), require('../outputs/energyOutput'), require('../powerSources'), require('../power-sources/deprecate'), require('../power-sources/damage'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.lodash, global.reselect, global.year, global.carbonOutput, global.energyOutput, global.powerSources, global.deprecate, global.damage);
        global.isYearAlreadyComplete = mod.exports;
    }
})(this, function (exports, _lodash, _reselect, _year, _carbonOutput, _energyOutput, _powerSources, _deprecate, _damage) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.allDamagedStationsRepaired = exports.isYearComplete = exports.isYearAlreadyComplete = undefined;

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    var isYearAlreadyComplete = exports.isYearAlreadyComplete = (0, _reselect.createSelector)([_year.getYearData, _powerSources.countPowerSourcesByType, _carbonOutput.getCarbonOutputPercentage, _energyOutput.getEnergyOutputRatio], function (year_data, sources_by_type, carbon_output_percentage, energy_output_ratio) {
        var outage = year_data.outage,
            mini_game = year_data["mini-game"],
            demand = year_data.demand,
            carbon_target = year_data["carbon-target"],
            remove = year_data.remove;
        console.group('isYearAlreadyComplete');
        console.log('year_data', year_data);
        console.log('sources_by_type', sources_by_type);
        console.log('carbon_output_percentage', carbon_output_percentage);
        console.log('energy_output_ratio', energy_output_ratio);
        console.log('remove', remove);
        console.groupEnd();
        if (outage || mini_game) return false;
        if (remove) {
            console.log('removed all targets', sources_by_type[remove]);
            return sources_by_type[remove] <= 1;
        }
        console.log('meeting demand', _.inRange(energy_output_ratio, 0.4, 0.6));
        console.log('meeting carbon target', carbon_output_percentage, carbon_target, carbon_output_percentage >= carbon_target * 10);
        return carbon_output_percentage >= carbon_target * 10 && _.inRange(energy_output_ratio, 0.45, 0.55);
    });
    var isYearComplete = exports.isYearComplete = (0, _reselect.createSelector)([_year.getYearData, _powerSources.countPowerSourcesByType, _carbonOutput.getCarbonOutputPercentage, _energyOutput.getEnergyOutputRatio], function (year_data, sources_by_type, carbon_output_percentage, energy_output_ratio) {
        var outage = year_data.outage,
            mini_game = year_data["mini-game"],
            demand = year_data.demand,
            carbon_target = year_data["carbon-target"],
            remove = year_data.remove;
        console.group('isYearComplete');
        console.log('year_data', year_data);
        console.log('sources_by_type', sources_by_type);
        console.log('carbon_output_percentage', carbon_output_percentage);
        console.log('energy_output_ratio', energy_output_ratio);
        console.log('remove', remove);
        console.groupEnd();
        if (outage || mini_game) return false;
        if (remove) {
            console.log('removed all targets', sources_by_type[remove]);
            return sources_by_type[remove] <= 1;
        }
        console.log('meeting demand', _.inRange(energy_output_ratio, 0.4, 0.6));
        console.log('meeting carbon target', carbon_output_percentage, carbon_target, carbon_output_percentage >= carbon_target * 10);
        var _a = year_data.ignore,
            ignore = _a === void 0 ? {} : _a;
        return (ignore.carbon === true || carbon_output_percentage >= carbon_target * 10) && (ignore.energy === true || _.inRange(energy_output_ratio, 0.45, 0.55));
    });
    var allDamagedStationsRepaired = exports.allDamagedStationsRepaired = (0, _reselect.createSelector)([_year.getYearData, _deprecate.getDeprecate, _damage.getDamage], function (year, deprecated, damage) {
        if (!year.deprecate && !year.outage) return false;
        return _.compact(deprecated).length === 0 && _.compact(damage).length === 0;
    });
});

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(185)();
}


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_middleware__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_runSaga__ = __webpack_require__(73);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "runSaga", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_runSaga__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_channel__ = __webpack_require__(23);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "END", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_channel__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "eventChannel", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_channel__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "channel", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_channel__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "multicastChannel", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_channel__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stdChannel", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_channel__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_symbols__ = __webpack_require__(27);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CANCEL", function() { return __WEBPACK_IMPORTED_MODULE_3__internal_symbols__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_utils__ = __webpack_require__(14);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "delay", function() { return __WEBPACK_IMPORTED_MODULE_4__internal_utils__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_io__ = __webpack_require__(24);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "detach", function() { return __WEBPACK_IMPORTED_MODULE_5__internal_io__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__effects__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__internal_buffers__ = __webpack_require__(48);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "effects", function() { return __WEBPACK_IMPORTED_MODULE_6__effects__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "utils", function() { return __WEBPACK_IMPORTED_MODULE_7__utils__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "buffers", function() { return __WEBPACK_IMPORTED_MODULE_8__internal_buffers__; });

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__internal_middleware__["a" /* default */]);










/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(8), __webpack_require__(2), __webpack_require__(11), __webpack_require__(10), __webpack_require__(12)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('lodash'), require('../../actions/action'), require('reselect'), require('../../../data/data'), require('../year'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.lodash, global.action, global.reselect, global.data, global.year);
        global.miniGame = mod.exports;
    }
})(this, function (exports, _lodash, _action, _reselect, _data, _year) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getMiniGameData = exports.hasMiniGameData = exports.getMiniGameID = undefined;
    exports.miniGame = miniGame;

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    var getMiniGameID = exports.getMiniGameID = function getMiniGameID(state) {
        return state.miniGame;
    };
    var hasMiniGameData = exports.hasMiniGameData = (0, _reselect.createSelector)([_year.getYearData], function (year) {
        var mini_games = (0, _data.getMiniGames)();
        return !!year['mini-game'];
    });
    var getMiniGameData = exports.getMiniGameData = (0, _reselect.createSelector)([getMiniGameID], function (mini_game_id) {
        var mini_games = (0, _data.getMiniGames)();
        return _.find(mini_games, { id: mini_game_id });
    });
    var initialState = null;
    function miniGame(state, action) {
        if (state === void 0) {
            state = initialState;
        }
        switch (action.type) {
            case _action.SET_MINI_GAME_ID:
                {
                    var payload = action.payload;
                    var mini_game_id = payload.mini_game_id;
                    return mini_game_id;
                }
            default:
                return state;
        }
    }
});

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(108);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(134);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 46 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "none", function() { return none; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fixed", function() { return fixed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dropping", function() { return dropping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sliding", function() { return sliding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "expanding", function() { return expanding; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(14);

var BUFFER_OVERFLOW = "Channel's Buffer overflow!";
var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;
var zeroBuffer = {
  isEmpty: __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* kTrue */],
  put: __WEBPACK_IMPORTED_MODULE_0__utils__["m" /* noop */],
  take: __WEBPACK_IMPORTED_MODULE_0__utils__["m" /* noop */]
};

function ringBuffer(limit, overflowAction) {
  if (limit === void 0) {
    limit = 10;
  }

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];

    while (length) {
      items.push(take());
    }

    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit;

        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);

          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;

          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;
            arr = flush();
            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;
            arr.length = doubledLimit;
            limit = doubledLimit;
            push(it);
            break;

          default: // DROP

        }
      }
    },
    take: take,
    flush: flush
  };
}

var none = function none() {
  return zeroBuffer;
};
var fixed = function fixed(limit) {
  return ringBuffer(limit, ON_OVERFLOW_THROW);
};
var dropping = function dropping(limit) {
  return ringBuffer(limit, ON_OVERFLOW_DROP);
};
var sliding = function sliding(limit) {
  return ringBuffer(limit, ON_OVERFLOW_SLIDE);
};
var expanding = function expanding(initialSize) {
  return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
};

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return qEnd; });
/* harmony export (immutable) */ __webpack_exports__["c"] = safeName;
/* harmony export (immutable) */ __webpack_exports__["a"] = fsmIterator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(14);

var done = {
  done: true,
  value: undefined
};
var qEnd = {};
function safeName(patternOrChannel) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* is */].channel(patternOrChannel)) {
    return 'channel';
  }

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* is */].stringableFunc(patternOrChannel)) {
    return String(patternOrChannel);
  }

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* is */].func(patternOrChannel)) {
    return patternOrChannel.name;
  }

  return String(patternOrChannel);
}
function fsmIterator(fsm, q0, name) {
  var updateState,
      qNext = q0;

  function next(arg, error) {
    if (qNext === qEnd) {
      return done;
    }

    if (error) {
      qNext = qEnd;
      throw error;
    } else {
      updateState && updateState(arg);

      var _fsm$qNext = fsm[qNext](),
          q = _fsm$qNext[0],
          output = _fsm$qNext[1],
          _updateState = _fsm$qNext[2];

      qNext = q;
      updateState = _updateState;
      return qNext === qEnd ? done : output;
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["l" /* makeIterator */])(next, function (error) {
    return next(null, error);
  }, name);
}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(20), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("redux"), require("../actions/action"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.redux, global.action);
        global.popup = mod.exports;
    }
})(this, function (exports, _redux, _action) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.popup = exports.getPopupY = exports.getPopupX = exports.getActivePopup = exports.POPUPS = undefined;
    var POPUPS = exports.POPUPS = {
        ADD_POWER_SOURCE: 'ADD_POWER_SOURCE'
    };
    var getActivePopup = exports.getActivePopup = function getActivePopup(state) {
        return state.popup.popupID;
    };
    var getPopupX = exports.getPopupX = function getPopupX(state) {
        return state.popup.x;
    };
    var getPopupY = exports.getPopupY = function getPopupY(state) {
        return state.popup.y;
    };
    function popupID(state, action) {
        if (state === void 0) {
            state = null;
        }
        switch (action.type) {
            case _action.SET_POPUP:
                {
                    var payload = action.payload;
                    var popup_id = payload.popup_id;
                    return popup_id;
                }
            case _action.HIDE_POPUP:
                {
                    return null;
                }
            default:
                return state;
        }
    }
    function x(state, action) {
        if (state === void 0) {
            state = 0;
        }
        switch (action.type) {
            case _action.SET_POPUP:
                {
                    var payload = action.payload;
                    var x_1 = payload.x;
                    return x_1;
                }
            default:
                return state;
        }
    }
    function y(state, action) {
        if (state === void 0) {
            state = 0;
        }
        switch (action.type) {
            case _action.SET_POPUP:
                {
                    var payload = action.payload;
                    var y_1 = payload.y;
                    return y_1;
                }
            default:
                return state;
        }
    }
    var popup = exports.popup = (0, _redux.combineReducers)({
        popupID: popupID,
        x: x,
        y: y
    });
});

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(8), __webpack_require__(10), __webpack_require__(13), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("lodash"), require("../../../data/data"), require("../powerSources"), require("reselect"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.lodash, global.data, global.powerSources, global.reselect);
        global.costPerMw = mod.exports;
    }
})(this, function (exports, _lodash, _data, _powerSources, _reselect) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getTargetCostPerMw = exports.getCostPerMw = undefined;
    exports.costPerMw = costPerMw;

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    var getCostPerMw = exports.getCostPerMw = (0, _reselect.createSelector)([_powerSources.countPowerSources, _powerSources.getPopulatedPowerSources], function (count, power_sources) {
        if (!power_sources.length) return 0;
        return _.sumBy(power_sources, 'cost-per-mw') / count;
    });
    var getTargetCostPerMw = exports.getTargetCostPerMw = (0, _reselect.createSelector)([_data.getAllPowerSourcesData], function (power_sources) {
        if (!power_sources.length) return 0;
        return _.max(_.map(power_sources, 'cost-per-mw'));
    });
    var initialState = 0;
    function costPerMw(state, action) {
        if (state === void 0) {
            state = initialState;
        }
        switch (action.type) {
            default:
                return state;
        }
    }
});

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('../../actions/action'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.energyDemand = mod.exports;
    }
})(this, function (exports, _action) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getEnergyDemand = undefined;
    exports.energyDemand = energyDemand;
    var getEnergyDemand = exports.getEnergyDemand = function getEnergyDemand(state) {
        return state.energyDemand;
    };
    function energyDemand(state, action) {
        if (state === void 0) {
            state = 150;
        }
        switch (action.type) {
            case _action.SET_ENERGY_DEMAND:
                {
                    var payload = action.payload;
                    var demand = payload.demand;
                    return demand || state;
                }
            default:
                return state;
        }
    }
});

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports);
        global.results = mod.exports;
    }
})(this, function (exports) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.resultsPanelOpen = resultsPanelOpen;
    var isResultsPanelOpen = exports.isResultsPanelOpen = function isResultsPanelOpen(state) {
        return state.resultsPanelOpen;
    };
    function resultsPanelOpen(state, action) {
        if (state === void 0) {
            state = false;
        }
        switch (action.type) {
            default:
                return state;
        }
    }
});

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("./action"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.locations = mod.exports;
    }
})(this, function (exports, _action) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.setSelectedLocation = setSelectedLocation;
    exports.setHighlightLocation = setHighlightLocation;
    exports.clearSelectedLocation = clearSelectedLocation;
    function setSelectedLocation(location_id) {
        return { type: _action.SET_SELECTED_LOCATION, payload: { location_id: location_id } };
    }
    function setHighlightLocation(location_id) {
        if (location_id === void 0) {
            location_id = null;
        }
        return { type: _action.SET_HIGHLIGHT_LOCATION, payload: { location_id: location_id } };
    }
    function clearSelectedLocation() {
        return { type: _action.CLEAR_SELECTED_LOCATION };
    }
});

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2), __webpack_require__(10), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("../actions/action"), require("../../data/data"), require("reselect"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action, global.data, global.reselect);
        global.highlightLocation = mod.exports;
    }
})(this, function (exports, _action, _data, _reselect) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getHighlightLocationData = exports.isLocationHighlighted = exports.getHighlightLocation = undefined;
    exports.highlightLocation = highlightLocation;
    var getHighlightLocation = exports.getHighlightLocation = function getHighlightLocation(state) {
        return state.highlightLocation;
    };
    var isLocationHighlighted = exports.isLocationHighlighted = function isLocationHighlighted(state, props) {
        return state.highlightLocation === props.location_id;
    };
    var getHighlightLocationData = exports.getHighlightLocationData = (0, _reselect.createSelector)([getHighlightLocation], function (location_id) {
        var locations = (0, _data.getPowerSourceLocationsData)();
        return locations[location_id];
    });
    var initialState = null;
    function highlightLocation(state, action) {
        if (state === void 0) {
            state = initialState;
        }
        switch (action.type) {
            case _action.SET_HIGHLIGHT_LOCATION:
                {
                    var payload = action.payload;
                    var location_id = payload.location_id;
                    return location_id;
                }
            default:
                return state;
        }
    }
});

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("./action"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.outages = mod.exports;
    }
})(this, function (exports, _action) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.chooseRelevantOutage = chooseRelevantOutage;
    exports.setOutageID = setOutageID;
    exports.clearOutageID = clearOutageID;
    function chooseRelevantOutage() {
        return { type: _action.CHOOSE_SUITABLE_OUTAGE };
    }
    function setOutageID(outage_id) {
        return { type: _action.SET_OUTAGE_ID, payload: { outage_id: outage_id } };
    }
    function clearOutageID() {
        return { type: _action.SET_OUTAGE_ID, payload: { outage_id: null } };
    }
});

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("../actions/action"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.score = mod.exports;
    }
})(this, function (exports, _action) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getScore = undefined;
    exports.score = score;
    var getScore = exports.getScore = function getScore(state) {
        return state.score;
    };
    var initial_state = 0;
    function score(state, action) {
        if (state === void 0) {
            state = initial_state;
        }
        switch (action.type) {
            case _action.SET_SCORE:
                {
                    var payload = action.payload;
                    var score_1 = payload.score;
                    return score_1;
                }
            case _action.ADD_SCORE:
                {
                    var payload = action.payload;
                    var score_2 = payload.score;
                    return state + score_2;
                }
            default:
                return state;
        }
    }
});

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(249)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("./CloseButton.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.CloseButton);
        global.CloseButton = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./CloseButton.scss": {
            "close-button": "CloseButton__close-button___aYlNU"
        }
    };

    var CloseButton = function (_super) {
        tslib_1.__extends(CloseButton, _super);
        function CloseButton(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            return _this;
        }
        CloseButton.prototype.render = function () {
            var onClose = this.props.onClose;
            return React.createElement(
                "button",
                { onClick: onClose, className: (0, _getClassName3.default)('close-button', _styleModuleImportMap)
                },
                React.createElement("i", { className: "fas fa-times" })
            );
        };
        return CloseButton;
    }(React.Component);
    exports.default = CloseButton;
});

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(119)();
}


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(63);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(128);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(70);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(44);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = asap;
/* harmony export (immutable) */ __webpack_exports__["c"] = suspend;
/* harmony export (immutable) */ __webpack_exports__["b"] = flush;
var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/

var semaphore = 0;
/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/

function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release();
  }
}
/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/


function asap(task) {
  queue.push(task);

  if (!semaphore) {
    suspend();
    flush();
  }
}
/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/

function suspend() {
  semaphore++;
}
/**
  Puts the scheduler in a `released` state.
**/

function release() {
  semaphore--;
}
/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/


function flush() {
  release();
  var task;

  while (!semaphore && (task = queue.shift()) !== undefined) {
    exec(task);
  }
}

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export array */
/* unused harmony export predicate */
/* unused harmony export string */
/* unused harmony export symbol */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return wildcard; });
/* harmony export (immutable) */ __webpack_exports__["a"] = matcher;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(14);

var array = function array(patterns) {
  return function (input) {
    return patterns.some(function (p) {
      return matcher(p)(input);
    });
  };
};
var predicate = function predicate(_predicate) {
  return function (input) {
    return _predicate(input);
  };
};
var string = function string(pattern) {
  return function (input) {
    return input.type === String(pattern);
  };
};
var symbol = function symbol(pattern) {
  return function (input) {
    return input.type === pattern;
  };
};
var wildcard = function wildcard() {
  return __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* kTrue */];
};
function matcher(pattern) {
  // prettier-ignore
  var matcherCreator = pattern === '*' ? wildcard : __WEBPACK_IMPORTED_MODULE_0__utils__["i" /* is */].string(pattern) ? string : __WEBPACK_IMPORTED_MODULE_0__utils__["i" /* is */].array(pattern) ? array : __WEBPACK_IMPORTED_MODULE_0__utils__["i" /* is */].stringableFunc(pattern) ? string : __WEBPACK_IMPORTED_MODULE_0__utils__["i" /* is */].func(pattern) ? predicate : __WEBPACK_IMPORTED_MODULE_0__utils__["i" /* is */].symbol(pattern) ? symbol : null;

  if (matcherCreator === null) {
    throw new Error("invalid pattern: " + pattern);
  }

  return matcherCreator(pattern);
}

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = runSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__proc__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__channel__ = __webpack_require__(23);




var RUN_SAGA_SIGNATURE = 'runSaga(options, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ": saga argument must be a Generator function!";
function runSaga(options, saga) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  if (false) {
    check(saga, is.func, NON_GENERATOR_ERR);
  }

  var iterator = saga.apply(void 0, args);

  if (false) {
    check(iterator, is.iterator, NON_GENERATOR_ERR);
  }

  var _options$channel = options.channel,
      channel = _options$channel === void 0 ? Object(__WEBPACK_IMPORTED_MODULE_3__channel__["f" /* stdChannel */])() : _options$channel,
      dispatch = options.dispatch,
      getState = options.getState,
      context = options.context,
      sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      effectMiddlewares = options.effectMiddlewares,
      onError = options.onError;
  var effectId = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["q" /* uid */])();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || __WEBPACK_IMPORTED_MODULE_1__utils__["m" /* noop */];
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || __WEBPACK_IMPORTED_MODULE_1__utils__["m" /* noop */];
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || __WEBPACK_IMPORTED_MODULE_1__utils__["m" /* noop */];
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || __WEBPACK_IMPORTED_MODULE_1__utils__["m" /* noop */];
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || __WEBPACK_IMPORTED_MODULE_1__utils__["m" /* noop */];
    sagaMonitor.effectTriggered({
      effectId: effectId,
      root: true,
      parentEffectId: 0,
      effect: {
        root: true,
        saga: saga,
        args: args
      }
    });
  }

  if (false) {
    var MIDDLEWARE_TYPE_ERROR = 'effectMiddlewares must be an array of functions';
    check(effectMiddlewares, is.array, MIDDLEWARE_TYPE_ERROR);
    effectMiddlewares.forEach(function (effectMiddleware) {
      return check(effectMiddleware, is.func, MIDDLEWARE_TYPE_ERROR);
    });
  }

  var middleware = effectMiddlewares && __WEBPACK_IMPORTED_MODULE_0_redux__["compose"].apply(void 0, effectMiddlewares);
  var task = Object(__WEBPACK_IMPORTED_MODULE_2__proc__["b" /* default */])(iterator, channel, Object(__WEBPACK_IMPORTED_MODULE_1__utils__["r" /* wrapSagaDispatch */])(dispatch), getState, context, {
    sagaMonitor: sagaMonitor,
    logger: logger,
    onError: onError,
    middleware: middleware
  }, effectId, saga.name);

  if (sagaMonitor) {
    sagaMonitor.effectResolved(effectId, task);
  }

  return task;
}

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANNEL_END; });
/* unused harmony export TASK_CANCEL */
/* harmony export (immutable) */ __webpack_exports__["b"] = proc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__symbols__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__io__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__channel__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matcher__ = __webpack_require__(72);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }






 // TODO: check if this hacky toString stuff is needed
// also check again whats the difference between CHANNEL_END and CHANNEL_END_TYPE
// maybe this could become MAYBE_END
// I guess this gets exported so takeMaybe result can be checked

var CHANNEL_END = {
  toString: function toString() {
    return __WEBPACK_IMPORTED_MODULE_0__symbols__["b" /* CHANNEL_END */];
  }
};
var TASK_CANCEL = {
  toString: function toString() {
    return __WEBPACK_IMPORTED_MODULE_0__symbols__["j" /* TASK_CANCEL */];
  }
};
/**
  Used to track a parent task and its forks
  In the new fork model, forked tasks are attached by default to their parent
  We model this using the concept of Parent task && main Task
  main task is the main flow of the current Generator, the parent tasks is the
  aggregation of the main tasks + all its forked tasks.
  Thus the whole model represents an execution tree with multiple branches (vs the
  linear execution tree in sequential (non parallel) programming)

  A parent tasks has the following semantics
  - It completes if all its forks either complete or all cancelled
  - If it's cancelled, all forks are cancelled as well
  - It aborts if any uncaught error bubbles up from forks
  - If it completes, the return value is the one returned by the main task
**/

function forkQueue(name, mainTask, cb) {
  var tasks = [],
      result,
      completed = false;
  addTask(mainTask);

  function abort(err) {
    cancelAll();
    cb(err, true);
  }

  function addTask(task) {
    tasks.push(task);

    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_1__utils__["p" /* remove */])(tasks, task);
      task.cont = __WEBPACK_IMPORTED_MODULE_1__utils__["m" /* noop */];

      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }

        if (!tasks.length) {
          completed = true;
          cb(result);
        }
      }
    }; // task.cont.cancel = task.cancel

  }

  function cancelAll() {
    if (completed) {
      return;
    }

    completed = true;
    tasks.forEach(function (t) {
      t.cont = __WEBPACK_IMPORTED_MODULE_1__utils__["m" /* noop */];
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: function getTasks() {
      return tasks;
    },
    taskNames: function taskNames() {
      return tasks.map(function (t) {
        return t.name;
      });
    }
  };
}

function createTaskIterator(_ref) {
  var context = _ref.context,
      fn = _ref.fn,
      args = _ref.args;

  if (__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* is */].iterator(fn)) {
    return fn;
  } // catch synchronous failures; see #152 and #441


  var result, error;

  try {
    result = fn.apply(context, args);
  } catch (err) {
    error = err;
  } // i.e. a generator function returns an iterator


  if (__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* is */].iterator(result)) {
    return result;
  } // do not bubble up synchronous failures for detached forks
  // instead create a failed task. See #152 and #441


  return error ? Object(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* makeIterator */])(function () {
    throw error;
  }) : Object(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* makeIterator */])(function () {
    var pc;
    var eff = {
      done: false,
      value: result
    };

    var ret = function ret(value) {
      return {
        done: true,
        value: value
      };
    };

    return function (arg) {
      if (!pc) {
        pc = true;
        return eff;
      } else {
        return ret(arg);
      }
    };
  }());
}

function proc(iterator, stdChannel, dispatch, getState, parentContext, options, parentEffectId, name, cont) {
  if (dispatch === void 0) {
    dispatch = __WEBPACK_IMPORTED_MODULE_1__utils__["m" /* noop */];
  }

  if (getState === void 0) {
    getState = __WEBPACK_IMPORTED_MODULE_1__utils__["m" /* noop */];
  }

  if (parentContext === void 0) {
    parentContext = {};
  }

  if (options === void 0) {
    options = {};
  }

  if (parentEffectId === void 0) {
    parentEffectId = 0;
  }

  if (name === void 0) {
    name = 'anonymous';
  }

  var _options = options,
      sagaMonitor = _options.sagaMonitor,
      logger = _options.logger,
      onError = _options.onError,
      middleware = _options.middleware;
  var log = logger || __WEBPACK_IMPORTED_MODULE_1__utils__["k" /* log */];

  var logError = function logError(err) {
    var message = err.sagaStack;

    if (!message && err.stack) {
      message = err.stack.split('\n')[0].indexOf(err.message) !== -1 ? err.stack : "Error: " + err.message + "\n" + err.stack;
    }

    log('error', "uncaught at " + name, message || err.message || err);
  };

  var taskContext = Object.create(parentContext);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/

  next.cancel = __WEBPACK_IMPORTED_MODULE_1__utils__["m" /* noop */];
  /**
    Creates a new task descriptor for this generator, We'll also create a main task
    to track the main flow (besides other forked tasks)
  **/

  var task = newTask(parentEffectId, name, iterator, cont);
  var mainTask = {
    name: name,
    cancel: cancelMain,
    isRunning: true
  };
  var taskQueue = forkQueue(name, mainTask, end);
  /**
    cancellation of the main task. We'll simply resume the Generator with a Cancel
  **/

  function cancelMain() {
    if (mainTask.isRunning && !mainTask.isCancelled) {
      mainTask.isCancelled = true;
      next(TASK_CANCEL);
    }
  }
  /**
    This may be called by a parent generator to trigger/propagate cancellation
    cancel all pending tasks (including the main task), then end the current task.
     Cancellation propagates down to the whole execution tree holded by this Parent task
    It's also propagated to all joiners of this task and their execution tree/joiners
     Cancellation is noop for terminated/Cancelled tasks tasks
  **/


  function cancel() {
    /**
      We need to check both Running and Cancelled status
      Tasks can be Cancelled but still Running
    **/
    if (iterator._isRunning && !iterator._isCancelled) {
      iterator._isCancelled = true;
      taskQueue.cancelAll();
      /**
        Ending with a Never result will propagate the Cancellation to all joiners
      **/

      end(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/


  cont && (cont.cancel = cancel); // tracks the running status

  iterator._isRunning = true; // kicks up the generator

  next(); // then return the task descriptor to the caller

  return task;
  /**
    This is the generator driver
    It's a recursive async/continuation function which calls itself
    until the generator terminates or throws
  **/

  function next(arg, isErr) {
    // Preventive measure. If we end up here, then there is really something wrong
    if (!mainTask.isRunning) {
      throw new Error('Trying to resume an already finished generator');
    }

    try {
      var result;

      if (isErr) {
        result = iterator.throw(arg);
      } else if (arg === TASK_CANCEL) {
        /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.isCancelled = true;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/

        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/

        result = __WEBPACK_IMPORTED_MODULE_1__utils__["i" /* is */].func(iterator.return) ? iterator.return(TASK_CANCEL) : {
          done: true,
          value: TASK_CANCEL
        };
      } else if (arg === CHANNEL_END) {
        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = __WEBPACK_IMPORTED_MODULE_1__utils__["i" /* is */].func(iterator.return) ? iterator.return() : {
          done: true
        };
      } else {
        result = iterator.next(arg);
      }

      if (!result.done) {
        digestEffect(result.value, parentEffectId, '', next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        mainTask.isMainRunning = false;
        mainTask.cont && mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.isCancelled) {
        logError(error);
      }

      mainTask.isMainRunning = false;
      mainTask.cont(error, true);
    }
  }

  function end(result, isErr) {
    iterator._isRunning = false; // stdChannel.close()

    if (!isErr) {
      iterator._result = result;
      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
    } else {
      if (result instanceof Error) {
        Object.defineProperty(result, 'sagaStack', {
          value: "at " + name + " \n " + (result.sagaStack || result.stack),
          configurable: true
        });
      }

      if (!task.cont) {
        if (result instanceof Error && onError) {
          onError(result);
        } else {
          // TODO: could we skip this when _deferredEnd is attached?
          logError(result);
        }
      }

      iterator._error = result;
      iterator._isAborted = true;
      iterator._deferredEnd && iterator._deferredEnd.reject(result);
    }

    task.cont && task.cont(result, isErr);
    task.joiners.forEach(function (j) {
      return j.cb(result, isErr);
    });
    task.joiners = null;
  }

  function runEffect(effect, effectId, label, currCb) {
    if (label === void 0) {
      label = '';
    }

    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      of completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    var data; // prettier-ignore

    return (// Non declarative effect
      __WEBPACK_IMPORTED_MODULE_1__utils__["i" /* is */].promise(effect) ? resolvePromise(effect, currCb) : __WEBPACK_IMPORTED_MODULE_1__utils__["i" /* is */].iterator(effect) ? resolveIterator(effect, effectId, name, currCb) // declarative effects
      : (data = __WEBPACK_IMPORTED_MODULE_3__io__["d" /* asEffect */].take(effect)) ? runTakeEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_3__io__["d" /* asEffect */].put(effect)) ? runPutEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_3__io__["d" /* asEffect */].all(effect)) ? runAllEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_3__io__["d" /* asEffect */].race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_3__io__["d" /* asEffect */].call(effect)) ? runCallEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_3__io__["d" /* asEffect */].cps(effect)) ? runCPSEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_3__io__["d" /* asEffect */].fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_3__io__["d" /* asEffect */].join(effect)) ? runJoinEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_3__io__["d" /* asEffect */].cancel(effect)) ? runCancelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_3__io__["d" /* asEffect */].select(effect)) ? runSelectEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_3__io__["d" /* asEffect */].actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_3__io__["d" /* asEffect */].flush(effect)) ? runFlushEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_3__io__["d" /* asEffect */].cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_3__io__["d" /* asEffect */].getContext(effect)) ? runGetContextEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_3__io__["d" /* asEffect */].setContext(effect)) ? runSetContextEffect(data, currCb) :
      /* anything else returned as is */
      currCb(effect)
    );
  }

  function digestEffect(effect, parentEffectId, label, cb) {
    if (label === void 0) {
      label = '';
    }

    var effectId = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["q" /* uid */])();
    sagaMonitor && sagaMonitor.effectTriggered({
      effectId: effectId,
      parentEffectId: parentEffectId,
      label: label,
      effect: effect
    });
    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/

    var effectSettled; // Completion callback passed to the appropriate effect runner

    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = __WEBPACK_IMPORTED_MODULE_1__utils__["m" /* noop */]; // defensive measure

      if (sagaMonitor) {
        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
      }

      cb(res, isErr);
    } // tracks down the current cancel


    currCb.cancel = __WEBPACK_IMPORTED_MODULE_1__utils__["m" /* noop */]; // setup cancellation logic on the parent cb

    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      /**
        propagates cancel downward
        catch uncaught cancellations errors; since we can no longer call the completion
        callback, log errors raised during cancellations into the console
      **/

      try {
        currCb.cancel();
      } catch (err) {
        logError(err);
      }

      currCb.cancel = __WEBPACK_IMPORTED_MODULE_1__utils__["m" /* noop */]; // defensive measure

      sagaMonitor && sagaMonitor.effectCancelled(effectId);
    }; // if one can find a way to decouple runEffect from closure variables
    // so it could be the call to it could be referentially transparent
    // this potentially could be simplified, finalRunEffect created beforehand
    // and this part of the code wouldnt have to know about middleware stuff


    if (__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* is */].func(middleware)) {
      middleware(function (eff) {
        return runEffect(eff, effectId, label, currCb);
      })(effect);
      return;
    }

    runEffect(effect, effectId, label, currCb);
  }

  function resolvePromise(promise, cb) {
    var cancelPromise = promise[__WEBPACK_IMPORTED_MODULE_0__symbols__["a" /* CANCEL */]];

    if (__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* is */].func(cancelPromise)) {
      cb.cancel = cancelPromise;
    } else if (__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* is */].func(promise.abort)) {
      cb.cancel = function () {
        return promise.abort();
      };
    }

    promise.then(cb, function (error) {
      return cb(error, true);
    });
  }

  function resolveIterator(iterator, effectId, name, cb) {
    proc(iterator, stdChannel, dispatch, getState, taskContext, options, effectId, name, cb);
  }

  function runTakeEffect(_ref2, cb) {
    var _ref2$channel = _ref2.channel,
        channel = _ref2$channel === void 0 ? stdChannel : _ref2$channel,
        pattern = _ref2.pattern,
        maybe = _ref2.maybe;

    var takeCb = function takeCb(input) {
      if (input instanceof Error) {
        cb(input, true);
        return;
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_4__channel__["d" /* isEnd */])(input) && !maybe) {
        cb(CHANNEL_END);
        return;
      }

      cb(input);
    };

    try {
      channel.take(takeCb, __WEBPACK_IMPORTED_MODULE_1__utils__["i" /* is */].notUndef(pattern) ? Object(__WEBPACK_IMPORTED_MODULE_5__matcher__["a" /* default */])(pattern) : null);
    } catch (err) {
      cb(err, true);
      return;
    }

    cb.cancel = takeCb.cancel;
  }

  function runPutEffect(_ref3, cb) {
    var channel = _ref3.channel,
        action = _ref3.action,
        resolve = _ref3.resolve;

    /**
      Schedule the put in case another saga is holding a lock.
      The put will be executed atomically. ie nested puts will execute after
      this put has terminated.
    **/
    Object(__WEBPACK_IMPORTED_MODULE_2__scheduler__["a" /* asap */])(function () {
      var result;

      try {
        result = (channel ? channel.put : dispatch)(action);
      } catch (error) {
        logError(error); // TODO: should such error here be passed to `onError`?
        // or is it already if we dropped error swallowing

        cb(error, true);
        return;
      }

      if (resolve && __WEBPACK_IMPORTED_MODULE_1__utils__["i" /* is */].promise(result)) {
        resolvePromise(result, cb);
      } else {
        cb(result);
        return;
      }
    }); // Put effects are non cancellables
  }

  function runCallEffect(_ref4, effectId, cb) {
    var context = _ref4.context,
        fn = _ref4.fn,
        args = _ref4.args;
    var result; // catch synchronous failures; see #152

    try {
      result = fn.apply(context, args);
    } catch (error) {
      cb(error, true);
      return;
    }

    return __WEBPACK_IMPORTED_MODULE_1__utils__["i" /* is */].promise(result) ? resolvePromise(result, cb) : __WEBPACK_IMPORTED_MODULE_1__utils__["i" /* is */].iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
  }

  function runCPSEffect(_ref5, cb) {
    var context = _ref5.context,
        fn = _ref5.fn,
        args = _ref5.args;

    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb
    // catch synchronous failures; see #152
    try {
      var cpsCb = function cpsCb(err, res) {
        return __WEBPACK_IMPORTED_MODULE_1__utils__["i" /* is */].undef(err) ? cb(res) : cb(err, true);
      };

      fn.apply(context, args.concat(cpsCb));

      if (cpsCb.cancel) {
        cb.cancel = function () {
          return cpsCb.cancel();
        };
      }
    } catch (error) {
      cb(error, true);
      return;
    }
  }

  function runForkEffect(_ref6, effectId, cb) {
    var context = _ref6.context,
        fn = _ref6.fn,
        args = _ref6.args,
        detached = _ref6.detached;
    var taskIterator = createTaskIterator({
      context: context,
      fn: fn,
      args: args
    });

    try {
      Object(__WEBPACK_IMPORTED_MODULE_2__scheduler__["c" /* suspend */])();

      var _task = proc(taskIterator, stdChannel, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : __WEBPACK_IMPORTED_MODULE_1__utils__["m" /* noop */]);

      if (detached) {
        cb(_task);
      } else {
        if (taskIterator._isRunning) {
          taskQueue.addTask(_task);
          cb(_task);
        } else if (taskIterator._error) {
          taskQueue.abort(taskIterator._error);
        } else {
          cb(_task);
        }
      }
    } finally {
      Object(__WEBPACK_IMPORTED_MODULE_2__scheduler__["b" /* flush */])();
    } // Fork effects are non cancellables

  }

  function runJoinEffect(t, cb) {
    if (t.isRunning()) {
      var joiner = {
        task: task,
        cb: cb
      };

      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["p" /* remove */])(t.joiners, joiner);
      };

      t.joiners.push(joiner);
    } else {
      t.isAborted() ? cb(t.error(), true) : cb(t.result());
    }
  }

  function runCancelEffect(taskToCancel, cb) {
    if (taskToCancel === __WEBPACK_IMPORTED_MODULE_0__symbols__["h" /* SELF_CANCELLATION */]) {
      taskToCancel = task;
    }

    if (taskToCancel.isRunning()) {
      taskToCancel.cancel();
    }

    cb(); // cancel effects are non cancellables
  }

  function runAllEffect(effects, effectId, cb) {
    var keys = Object.keys(effects);

    if (!keys.length) {
      cb(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* is */].array(effects) ? [] : {});
      return;
    }

    var completedCount = 0;
    var completed;
    var results = {};
    var childCbs = {};

    function checkEffectEnd() {
      if (completedCount === keys.length) {
        completed = true;
        cb(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* is */].array(effects) ? __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* array */].from(_extends({}, results, {
          length: keys.length
        })) : results);
      }
    }

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }

        if (isErr || Object(__WEBPACK_IMPORTED_MODULE_4__channel__["d" /* isEnd */])(res) || res === CHANNEL_END || res === TASK_CANCEL) {
          cb.cancel();
          cb(res, isErr);
        } else {
          results[key] = res;
          completedCount++;
          checkEffectEnd();
        }
      };

      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_1__utils__["m" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };

    keys.forEach(function (key) {
      return digestEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runRaceEffect(effects, effectId, cb) {
    var completed;
    var keys = Object.keys(effects);
    var childCbs = {};
    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }

        if (isErr) {
          // Race Auto cancellation
          cb.cancel();
          cb(res, true);
        } else if (!Object(__WEBPACK_IMPORTED_MODULE_4__channel__["d" /* isEnd */])(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
          var _response;

          cb.cancel();
          completed = true;
          var response = (_response = {}, _response[key] = res, _response);
          cb(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* is */].array(effects) ? [].slice.call(_extends({}, response, {
            length: keys.length
          })) : response);
        }
      };

      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_1__utils__["m" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      // prevents unnecessary cancellation
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };

    keys.forEach(function (key) {
      if (completed) {
        return;
      }

      digestEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runSelectEffect(_ref7, cb) {
    var selector = _ref7.selector,
        args = _ref7.args;

    try {
      var state = selector.apply(void 0, [getState()].concat(args));
      cb(state);
    } catch (error) {
      cb(error, true);
    }
  }

  function runChannelEffect(_ref8, cb) {
    var pattern = _ref8.pattern,
        buffer = _ref8.buffer;
    // TODO: rethink how END is handled
    var chan = Object(__WEBPACK_IMPORTED_MODULE_4__channel__["b" /* channel */])(buffer);
    var match = Object(__WEBPACK_IMPORTED_MODULE_5__matcher__["a" /* default */])(pattern);

    var taker = function taker(action) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_4__channel__["d" /* isEnd */])(action)) {
        stdChannel.take(taker, match);
      }

      chan.put(action);
    };

    stdChannel.take(taker, match);
    cb(chan);
  }

  function runCancelledEffect(data, cb) {
    cb(!!mainTask.isCancelled);
  }

  function runFlushEffect(channel, cb) {
    channel.flush(cb);
  }

  function runGetContextEffect(prop, cb) {
    cb(taskContext[prop]);
  }

  function runSetContextEffect(props, cb) {
    __WEBPACK_IMPORTED_MODULE_1__utils__["n" /* object */].assign(taskContext, props);
    cb();
  }

  function newTask(id, name, iterator, cont) {
    var _ref9;

    iterator._deferredEnd = null;
    return _ref9 = {}, _ref9[__WEBPACK_IMPORTED_MODULE_0__symbols__["i" /* TASK */]] = true, _ref9.id = id, _ref9.name = name, _ref9.toPromise = function toPromise() {
      if (iterator._deferredEnd) {
        return iterator._deferredEnd.promise;
      }

      var def = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* deferred */])();
      iterator._deferredEnd = def;

      if (!iterator._isRunning) {
        if (iterator._isAborted) {
          def.reject(iterator._error);
        } else {
          def.resolve(iterator._result);
        }
      }

      return def.promise;
    }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
      return iterator._isRunning;
    }, _ref9.isCancelled = function isCancelled() {
      return iterator._isCancelled;
    }, _ref9.isAborted = function isAborted() {
      return iterator._isAborted;
    }, _ref9.result = function result() {
      return iterator._result;
    }, _ref9.error = function error() {
      return iterator._error;
    }, _ref9.setContext = function setContext(props) {
      if (false) {
        check(props, is.object, createSetContextWarning('task', props));
      }

      __WEBPACK_IMPORTED_MODULE_1__utils__["n" /* object */].assign(taskContext, props);
    }, _ref9;
  }
}

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(8), __webpack_require__(11), __webpack_require__(13), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("lodash"), require("reselect"), require("../powerSources"), require("../../../data/data"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.lodash, global.reselect, global.powerSources, global.data);
        global.environmentalImpact = mod.exports;
    }
})(this, function (exports, _lodash, _reselect, _powerSources, _data) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getEnvironmentalImpactRatio = exports.getEnvironmentalImpact = undefined;
    exports.getTargetEnvironmentalImpact = getTargetEnvironmentalImpact;
    exports.environmentalImpact = environmentalImpact;

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function getTargetEnvironmentalImpact() {
        var locations = (0, _data.getPowerSourceLocationsData)();
        var power_sources = (0, _data.getPowerSourcesData)();
        var ratios = (0, _data.getEnergyMixData)();
        var impact_sum = _.reduce(power_sources, function (sum, power_source) {
            return sum + ratios[power_source.id] * 0.01 * locations.length * power_source['environmental-impact'];
        }, 0);
        return impact_sum;
    }
    var getEnvironmentalImpact = exports.getEnvironmentalImpact = (0, _reselect.createSelector)([_powerSources.getPopulatedPowerSources], function (power_sources) {
        if (!power_sources.length) return 0;
        return _.sumBy(power_sources, 'environmental-impact');
    });
    var getEnvironmentalImpactRatio = exports.getEnvironmentalImpactRatio = (0, _reselect.createSelector)([getEnvironmentalImpact, getTargetEnvironmentalImpact], function (actual, target) {
        if (!actual) return 0;
        var ratio = _.clamp(actual / (target * 2), 0, 1);
        return parseFloat(ratio.toFixed(2));
    });
    var initialState = 0;
    function environmentalImpact(state, action) {
        if (state === void 0) {
            state = initialState;
        }
        switch (action.type) {
            default:
                return state;
        }
    }
});

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(20), __webpack_require__(2), __webpack_require__(11), __webpack_require__(16), __webpack_require__(50), __webpack_require__(17), __webpack_require__(53), __webpack_require__(12)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("redux"), require("../actions/action"), require("reselect"), require("./screen"), require("./popup"), require("./modal"), require("./results"), require("./year"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.redux, global.action, global.reselect, global.screen, global.popup, global.modal, global.results, global.year);
        global.timer = mod.exports;
    }
})(this, function (exports, _redux, _action, _reselect, _screen, _popup, _modal, _results, _year) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.timer = exports.isTimerRunning = exports.getYearDuration = exports.timerIsPaused = exports.timerIsRunning = exports.getTime = undefined;
    var getTime = exports.getTime = function getTime(state) {
        return state.timer.time;
    };
    var timerIsRunning = exports.timerIsRunning = function timerIsRunning(state) {
        return state.timer.running;
    };
    var timerIsPaused = exports.timerIsPaused = function timerIsPaused(state) {
        return state.timer.paused;
    };
    var getYearDuration = exports.getYearDuration = (0, _reselect.createSelector)([_year.getYearData], function (year_data) {
        return year_data['time'] || 60;
    });
    function time(state, action) {
        if (state === void 0) {
            state = 0;
        }
        switch (action.type) {
            case _action.TICK_TIMER:
                {
                    return state + 1;
                }
            case _action.RESET_TIMER:
                {
                    return 0;
                }
            default:
                return state;
        }
    }
    function running(state, action) {
        if (state === void 0) {
            state = false;
        }
        switch (action.type) {
            case _action.START_TIMER:
                {
                    return true;
                }
            case _action.STOP_TIMER:
                {
                    return false;
                }
            case _action.TIMER_HAS_EXPIRED:
                {
                    return false;
                }
            default:
                return state;
        }
    }
    function paused(state, action) {
        if (state === void 0) {
            state = false;
        }
        switch (action.type) {
            case _action.PAUSE_TIMER:
                {
                    return true;
                }
            case _action.RESUME_TIMER:
            case _action.TIMER_HAS_EXPIRED:
                {
                    return false;
                }
            default:
                return state;
        }
    }
    var isTimerRunning = exports.isTimerRunning = (0, _reselect.createSelector)([timerIsRunning, _screen.getScreen, _popup.getActivePopup, _modal.getActiveModal, _results.isResultsPanelOpen], function (running, screen_id, popup_id, modal_id, ui_is_open) {
        console.group('isTimerRunning');
        console.log(running);
        console.log(screen_id);
        console.log(popup_id);
        console.log(modal_id);
        console.log(ui_is_open);
        console.log('result: ', running && screen_id === _screen.SCREENS.GAME && !popup_id && !modal_id && !ui_is_open);
        console.groupEnd();
        return running && screen_id === _screen.SCREENS.GAME && !popup_id && !modal_id && !ui_is_open;
    });
    var timer = exports.timer = (0, _redux.combineReducers)({
        time: time,
        running: running,
        paused: paused
    });
});

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("../../actions/action"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.visible = mod.exports;
    }
})(this, function (exports, _action) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getDebugConsoleVisible = undefined;
    exports.visible = visible;
    var getDebugConsoleVisible = exports.getDebugConsoleVisible = function getDebugConsoleVisible(state) {
        return state.debugConsole.visible;
    };
    var initialState = false;
    function visible(state, action) {
        if (state === void 0) {
            state = initialState;
        }
        switch (action.type) {
            case _action.TOGGLE_DEBUG_CONSOLE:
                {
                    var payload = action.payload;
                    var visible_1 = payload.visible;
                    return visible_1;
                }
            default:
                return state;
        }
    }
});

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("./action"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.score = mod.exports;
    }
})(this, function (exports, _action) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.setScore = setScore;
    exports.addScore = addScore;
    exports.resetScore = resetScore;
    exports.updateScore = updateScore;
    function setScore(score) {
        return { type: _action.SET_SCORE, payload: { score: score } };
    }
    function addScore(score) {
        return { type: _action.ADD_SCORE, payload: { score: score } };
    }
    function resetScore() {
        return { type: _action.SET_SCORE, payload: { score: 0 } };
    }
    function updateScore() {
        return { type: _action.UPDATE_SCORE, payload: {} };
    }
});

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(11), __webpack_require__(8), __webpack_require__(13), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('reselect'), require('lodash'), require('./powerSources'), require('../actions/action'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.reselect, global.lodash, global.powerSources, global.action);
        global.savedPowerSourceCounts = mod.exports;
    }
})(this, function (exports, _reselect, _lodash, _powerSources, _action) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.countPowerSourceDifferencesByType = exports.getSavedPowerSourceCounts = undefined;
    exports.savedPowerSourceCounts = savedPowerSourceCounts;

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    var getSavedPowerSourceCounts = exports.getSavedPowerSourceCounts = function getSavedPowerSourceCounts(state) {
        return state.savedPowerSourceCounts;
    };
    var countPowerSourceDifferencesByType = exports.countPowerSourceDifferencesByType = (0, _reselect.createSelector)([getSavedPowerSourceCounts, _powerSources.countPowerSourcesByType], function (saved_counts, current_counts) {
        return _.transform(saved_counts, function (result_counts, saved_count, source_id) {
            result_counts[source_id] = saved_count - current_counts[source_id];
            return result_counts;
        }, {});
    });
    function savedPowerSourceCounts(state, action) {
        if (state === void 0) {
            state = {};
        }
        switch (action.type) {
            case _action.SAVE_POWER_SOURCE_COUNTS:
                {
                    var payload = action.payload;
                    var counts = payload.counts;
                    return counts;
                }
            default:
                return state;
        }
    }
});

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("./action"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.events = mod.exports;
    }
})(this, function (exports, _action) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.chooseRelevantEvent = chooseRelevantEvent;
    exports.setEventID = setEventID;
    function chooseRelevantEvent() {
        return { type: _action.CHOOSE_SUITABLE_EVENT };
    }
    function setEventID(event_id) {
        return { type: _action.SET_EVENT_ID, payload: { event_id: event_id } };
    }
});

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('../action'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.miniGame = mod.exports;
    }
})(this, function (exports, _action) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.setMiniGameID = setMiniGameID;
    exports.activateMiniGame = activateMiniGame;
    exports.clearMiniGameID = clearMiniGameID;
    function setMiniGameID(mini_game_id) {
        return { type: _action.SET_MINI_GAME_ID, payload: { mini_game_id: mini_game_id } };
    }
    function activateMiniGame() {
        return { type: _action.ACTIVATE_MINI_GAME, payload: {} };
    }
    function clearMiniGameID() {
        return { type: _action.SET_MINI_GAME_ID, payload: { mini_game_id: null } };
    }
});

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('../action'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.deprecate = mod.exports;
    }
})(this, function (exports, _action) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.deprecateSourceType = deprecateSourceType;
    exports.setInitialDeprecate = setInitialDeprecate;
    exports.clearAllDeprecations = clearAllDeprecations;
    exports.removeDeprecatedStations = removeDeprecatedStations;
    exports.clearDeprecateType = clearDeprecateType;
    function deprecateSourceType(deprecate) {
        return { type: _action.DEPRECATE_SOURCE_TYPE, payload: { deprecate: deprecate } };
    }
    function setInitialDeprecate(deprecations) {
        return { type: _action.SET_INITIAL_DEPRECATIONS, payload: { deprecations: deprecations } };
    }
    function clearAllDeprecations() {
        return { type: _action.CLEAR_ALL_DEPRECATIONS, payload: {} };
    }
    function removeDeprecatedStations(deprecate_type) {
        return { type: _action.REMOVE_ALL_DEPRECATED_STATIONS, payload: { deprecate_type: deprecate_type } };
    }
    function clearDeprecateType() {
        return { type: _action.DEPRECATE_SOURCE_TYPE, payload: { deprecate: null } };
    }
});

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('../action'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.damage = mod.exports;
    }
})(this, function (exports, _action) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.damageSourceType = damageSourceType;
    exports.setInitialDamage = setInitialDamage;
    exports.clearAllDamage = clearAllDamage;
    exports.repairDamageAtLocation = repairDamageAtLocation;
    function damageSourceType(type) {
        return { type: _action.DAMAGE_SOURCE_TYPE, payload: { type: type } };
    }
    function setInitialDamage(damaged) {
        return { type: _action.SET_INITIAL_DAMAGE, payload: { damaged: damaged } };
    }
    function clearAllDamage() {
        console.log('clearing all damage');
        return { type: _action.CLEAR_ALL_DAMAGE };
    }
    function repairDamageAtLocation(location_id) {
        return { type: _action.REPAIR_STATION_AT_LOCATION, payload: { location_id: location_id } };
    }
});

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('../action'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.energyGenerated = mod.exports;
    }
})(this, function (exports, _action) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.recordEnergyGenerated = recordEnergyGenerated;
    exports.resetEnergyGenerated = resetEnergyGenerated;
    function recordEnergyGenerated(energy) {
        return { type: _action.RECORD_ENERGY_GENERATED, payload: { energy: energy } };
    }
    function resetEnergyGenerated() {
        return { type: _action.RESET_ENERGY_GENERATED, payload: {} };
    }
});

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2), __webpack_require__(8), __webpack_require__(11), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("../../actions/action"), require("lodash"), require("reselect"), require("../../../data/data"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action, global.lodash, global.reselect, global.data);
        global.outageQuestion = mod.exports;
    }
})(this, function (exports, _action, _lodash, _reselect, _data) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getOutageQuestionData = exports.getOutageQuestionID = undefined;
    exports.outageQuestion = outageQuestion;

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    var getOutageQuestionID = exports.getOutageQuestionID = function getOutageQuestionID(state) {
        return state.question;
    };
    var getOutageQuestionData = exports.getOutageQuestionData = (0, _reselect.createSelector)([getOutageQuestionID], function (question_id) {
        var questions = (0, _data.getQuestions)();
        return _.find(questions, ['id', question_id]) || _.first(questions);
    });
    var initialState = null;
    function outageQuestion(state, action) {
        if (state === void 0) {
            state = initialState;
        }
        switch (action.type) {
            case _action.SHOW_NEXT_OUTAGE_QUESTION:
                {
                    var question_data = (0, _data.getQuestions)();
                    var current_index = _.findIndex(question_data, ['id', state]);
                    var new_index = (current_index + 1 + question_data.length) % question_data.length || 0;
                    console.group('reducer: question');
                    console.log(current_index);
                    console.log(new_index);
                    console.log(question_data[new_index].id);
                    console.groupEnd();
                    return question_data[new_index].id;
                }
            case _action.SHOW_QUESTION:
                {
                    var payload = action.payload;
                    var question_id = payload.question_id;
                    return question_id;
                }
            default:
                return state;
        }
    }
});

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(20), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("redux"), require("../actions/action"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.redux, global.action);
        global.interaction = mod.exports;
    }
})(this, function (exports, _redux, _action) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.interaction = exports.isDragging = undefined;
    var isDragging = exports.isDragging = function isDragging(state) {
        return state.interaction.dragging;
    };
    function dragging(state, action) {
        if (state === void 0) {
            state = false;
        }
        switch (action.type) {
            case _action.START_DRAGGING:
                {
                    return true;
                }
            case _action.STOP_DRAGGING:
                {
                    return false;
                }
            default:
                return state;
        }
    }
    var interaction = exports.interaction = (0, _redux.combineReducers)({
        dragging: dragging
    });
});

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("../../actions/action"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.mapOffset = mod.exports;
    }
})(this, function (exports, _action) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getMapOffset = undefined;
    exports.mapOffset = mapOffset;
    var getMapOffset = exports.getMapOffset = function getMapOffset(state) {
        return state.mapOffset;
    };
    function mapOffset(state, action) {
        if (state === void 0) {
            state = { x: -1730, y: -2890 };
        }
        switch (action.type) {
            case _action.SET_MAP_OFFSET:
                {
                    var payload = action.payload;
                    var x = payload.ox,
                        y = payload.oy;
                    return { x: x, y: y };
                }
            default:
                return state;
        }
    }
});

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2), __webpack_require__(8), __webpack_require__(11), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("../actions/action"), require("lodash"), require("reselect"), require("../../data/data"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action, global.lodash, global.reselect, global.data);
        global.season = mod.exports;
    }
})(this, function (exports, _action, _lodash, _reselect, _data) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getSeasonIndex = exports.getSeasonData = exports.getSeasonID = undefined;
    exports.season = season;

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    var getSeasonID = exports.getSeasonID = function getSeasonID(state) {
        return state.season;
    };
    var getSeasonData = exports.getSeasonData = (0, _reselect.createSelector)([getSeasonID], function (season_id) {
        var seasons = (0, _data.getSeasonsData)();
        return _.find(seasons, ['id', season_id]);
    });
    var getSeasonIndex = exports.getSeasonIndex = (0, _reselect.createSelector)([getSeasonID], function (season_id) {
        var seasons = (0, _data.getSeasonsData)();
        return _.findIndex(seasons, ['id', season_id]);
    });
    var initialState = _.get((0, _data.getSeasonsData)(), '[0].id');
    function season(state, action) {
        if (state === void 0) {
            state = initialState;
        }
        switch (action.type) {
            case _action.SET_SEASON:
                {
                    var payload = action.payload;
                    var season_id = payload.season_id;
                    return season_id;
                }
            default:
                return state;
        }
    }
});

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2), __webpack_require__(8), __webpack_require__(11), __webpack_require__(10), __webpack_require__(12)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("../../actions/action"), require("lodash"), require("reselect"), require("../../../data/data"), require("../year"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action, global.lodash, global.reselect, global.data, global.year);
        global.yearEndQuestion = mod.exports;
    }
})(this, function (exports, _action, _lodash, _reselect, _data, _year) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getYearEndQuestionData = exports.getYearEndQuestionID = undefined;
    exports.yearEndQuestion = yearEndQuestion;

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    var getYearEndQuestionID = exports.getYearEndQuestionID = function getYearEndQuestionID(state) {
        return state.question;
    };
    var getYearEndQuestionData = exports.getYearEndQuestionData = (0, _reselect.createSelector)([getYearEndQuestionID, _year.getYearData], function (question_id, year_data) {
        var questions = (0, _data.getQuestions)();
        return _.find(questions, ['id', year_data.year]) || _.first(questions);
    });
    var initialState = null;
    function yearEndQuestion(state, action) {
        if (state === void 0) {
            state = initialState;
        }
        switch (action.type) {
            case _action.SHOW_NEXT_YEAR_END_QUESTION:
                {
                    var question_data = (0, _data.getQuestions)();
                    var current_index = _.findIndex(question_data, ['id', state]);
                    var new_index = (current_index + 1 + question_data.length) % question_data.length || 0;
                    console.group('reducer: question');
                    console.log(current_index);
                    console.log(new_index);
                    console.log(question_data[new_index].id);
                    console.groupEnd();
                    return question_data[new_index].id;
                }
            default:
                return state;
        }
    }
});

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("../../actions/action"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.mapBounds = mod.exports;
    }
})(this, function (exports, _action) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getMapBounds = undefined;
    exports.mapBounds = mapBounds;
    var getMapBounds = exports.getMapBounds = function getMapBounds(state) {
        return state.mapBounds;
    };
    function mapBounds(state, action) {
        if (state === void 0) {
            state = { width: 0, height: 0 };
        }
        switch (action.type) {
            case _action.SET_MAP_BOUNDS:
                {
                    var payload = action.payload;
                    var width = payload.width,
                        height = payload.height;
                    return { width: width, height: height };
                }
            default:
                return state;
        }
    }
});

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('../../actions/action'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.correctAnswers = mod.exports;
    }
})(this, function (exports, _action) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getCorrectAnswerCount = undefined;
    exports.correctAnswers = correctAnswers;
    var getCorrectAnswerCount = exports.getCorrectAnswerCount = function getCorrectAnswerCount(state) {
        return state.correctAnswers;
    };
    function correctAnswers(state, action) {
        if (state === void 0) {
            state = 0;
        }
        switch (action.type) {
            case _action.RECORD_CORRECT_ANSWER:
                {
                    return (state || 0) + 1;
                }
            case _action.RESET_CORRECT_ANSWERS_COUNT:
                {
                    return 0;
                }
            default:
                return state;
        }
    }
});

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(8), __webpack_require__(19), __webpack_require__(179)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("lodash"), require("../ui/button/Button"), require("./SlideShow.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.lodash, global.Button, global.SlideShow);
        global.SlideShow = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _lodash, _Button) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.SlideShow = undefined;

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    var _ = _interopRequireWildcard(_lodash);

    var _Button2 = _interopRequireDefault(_Button);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./SlideShow.scss": {
            "slideshow": "SlideShow__slideshow___3AVV9",
            "slides": "SlideShow__slides___2KBxX",
            "slide": "SlideShow__slide___Dw9U_",
            "cancel-button-container": "SlideShow__cancel-button-container___1P9Fa",
            "slideshow-buttons-container": "SlideShow__slideshow-buttons-container___27UYd",
            "skip-button": "SlideShow__skip-button___2FrgW",
            "disabled-button": "SlideShow__disabled-button___3MgLJ"
        }
    };

    var SlideShow = function (_super) {
        tslib_1.__extends(SlideShow, _super);
        function SlideShow(props, state) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.state = state;
            _this.showNextSlide = function () {
                var oindex = _this.state.slide_index;
                var slide_index = oindex + 1;
                _this.setState({ slide_index: slide_index });
            };
            _this.showPreviousSlide = function () {
                var oindex = _this.state.slide_index;
                var slide_index = oindex - 1;
                _this.setState({ slide_index: slide_index });
            };
            _this.isFirstSlide = function () {
                var slide_index = _this.state.slide_index;
                return slide_index === 0;
            };
            _this.isLastSlide = function () {
                var children = _this.props.children;
                var slide_index = _this.state.slide_index;
                return slide_index === children.length - 1;
            };
            _this.resetSlideShow = function () {};
            _this.cancelSlideShow = function () {
                var onCancel = _this.props.onCancel;
                onCancel();
            };
            _this.completeSlideShow = function () {
                var onComplete = _this.props.onComplete;
                onComplete();
            };
            _this.getSlides = function () {
                var children = _this.props.children;
                var slide_index = _this.state.slide_index;
                return _.map(children, function (child, i) {
                    return React.createElement(
                        "div",
                        { style: { transform: "translate(" + (i - slide_index) * 100 + "%, 0)" }, key: i, className: (0, _getClassName3.default)('slide', _styleModuleImportMap)
                        },
                        child
                    );
                });
            };
            _this.state = { slide_index: 0 };
            return _this;
        }
        SlideShow.prototype.render = function () {
            var _a = this.props,
                onCancel = _a.onCancel,
                onComplete = _a.onComplete;
            var is_first_slide = this.isFirstSlide();
            var is_last_slide = this.isLastSlide();
            return React.createElement(
                "div",
                {
                    className: (0, _getClassName3.default)('slideshow', _styleModuleImportMap)
                },
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('cancel-button-container', _styleModuleImportMap)
                    },
                    React.createElement(
                        _Button2.default,
                        { type: 'slideshow-cancel', onClick: this.cancelSlideShow },
                        "main menu"
                    )
                ),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('slideshow-buttons-container', _styleModuleImportMap)
                    },
                    React.createElement(
                        "span",
                        {
                            className: (0, _getClassName3.default)(is_first_slide ? 'disabled-button' : '', _styleModuleImportMap)
                        },
                        React.createElement(
                            _Button2.default,
                            { type: 'slideshow-previous', onClick: this.showPreviousSlide },
                            "back"
                        )
                    ),
                    !is_last_slide && React.createElement(
                        "span",
                        {
                            className: (0, _getClassName3.default)('skip-button', _styleModuleImportMap)
                        },
                        React.createElement(
                            _Button2.default,
                            { type: 'slideshow-skip', onClick: onComplete },
                            "skip"
                        )
                    ),
                    !is_last_slide && React.createElement(
                        _Button2.default,
                        { type: 'slideshow-next', onClick: this.showNextSlide },
                        "next"
                    ),
                    is_last_slide && React.createElement(
                        _Button2.default,
                        { type: 'slideshow-complete', onClick: this.completeSlideShow },
                        "let's go!"
                    )
                ),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('slides', _styleModuleImportMap)
                    },
                    this.getSlides()
                )
            );
        };
        return SlideShow;
    }(React.Component);
    exports.SlideShow = SlideShow;
});

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = __webpack_require__(184);

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

var _ReplaceTransition = __webpack_require__(190);

var _ReplaceTransition2 = _interopRequireDefault(_ReplaceTransition);

var _TransitionGroup = __webpack_require__(96);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _Transition = __webpack_require__(94);

var _Transition2 = _interopRequireDefault(_Transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition2.default,
  TransitionGroup: _TransitionGroup2.default,
  ReplaceTransition: _ReplaceTransition2.default,
  CSSTransition: _CSSTransition2.default
};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _propTypes = __webpack_require__(40);

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(43);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _PropTypes = __webpack_require__(95);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
var EXITED = exports.EXITED = 'exited';
var ENTERING = exports.ENTERING = 'entering';
var ENTERED = exports.ENTERED = 'entered';
var EXITING = exports.EXITING = 'exiting';

/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/741op4mmj0?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 *
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var parentGroup = context.transitionGroup;
    // In the context of a TransitionGroup all enters are really appears
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

    var initialStatus = void 0;
    _this.nextStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.nextStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.getChildContext = function getChildContext() {
    return { transitionGroup: null }; // allows for nested Transitions
  };

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus(true);
  };

  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _ref = this.pendingState || this.state,
        status = _ref.status;

    if (nextProps.in) {
      if (status === UNMOUNTED) {
        this.setState({ status: EXITED });
      }
      if (status !== ENTERING && status !== ENTERED) {
        this.nextStatus = ENTERING;
      }
    } else {
      if (status === ENTERING || status === ENTERED) {
        this.nextStatus = EXITING;
      }
    }
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
    this.updateStatus();
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;

    var exit = void 0,
        enter = void 0,
        appear = void 0;

    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }
    return { exit: exit, enter: enter, appear: appear };
  };

  Transition.prototype.updateStatus = function updateStatus() {
    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var nextStatus = this.nextStatus;

    if (nextStatus !== null) {
      this.nextStatus = null;
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };

  Transition.prototype.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;

    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

    var timeouts = this.getTimeouts();

    // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set
    if (!mounting && !enter) {
      this.safeSetState({ status: ENTERED }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);

    this.safeSetState({ status: ENTERING }, function () {
      _this2.props.onEntering(node, appearing);

      // FIXME: appear timeout?
      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  Transition.prototype.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;

    var timeouts = this.getTimeouts();

    // no exit animation skip right to EXITED
    if (!exit) {
      this.safeSetState({ status: EXITED }, function () {
        _this3.props.onExited(node);
      });
      return;
    }
    this.props.onExit(node);

    this.safeSetState({ status: EXITING }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
    var _this4 = this;

    // We need to track pending updates for instances where a cWRP fires quickly
    // after cDM and before the state flushes, which would double trigger a
    // transition
    this.pendingState = nextState;

    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, function () {
      _this4.pendingState = null;
      callback();
    });
  };

  Transition.prototype.setNextCallback = function setNextCallback(callback) {
    var _this5 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this5.nextCallback = null;

        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        childProps = _objectWithoutProperties(_props, ['children']);
    // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react2.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};


Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    return pt.apply(undefined, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};

// Name the function so it is clearer in the documentation
function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

exports.default = Transition;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _propTypes = __webpack_require__(40);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
  enter: _propTypes2.default.number,
  exit: _propTypes2.default.number
}).isRequired]);

var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterDone: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  exitDone: _propTypes2.default.string,
  exitActive: _propTypes2.default.string
})]);

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(40);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _ChildMapping = __webpack_require__(191);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes = {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes2.default.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes2.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes2.default.bool,
  /**
    * A convenience prop that enables or disables exit animations
    * for all children. Note that specifying this will override any defaults set
    * on individual children Transitions.
    */
  exit: _propTypes2.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes2.default.func
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};

/**
 * The `<TransitionGroup>` component manages a set of `<Transition>` components
 * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
 * state machine for managing the mounting and unmounting of components over
 * time.
 *
 * Consider the example below using the `Fade` CSS transition from before.
 * As items are removed or added to the TodoList the `in` prop is toggled
 * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
 * component in a `<TransitionGroup>`, not just css.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/00rqyo26kn?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual `<Transition>`
 * components. This means you can mix and match animations across different
 * list items.
 */

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    // Initial children should all be entering, dependent on appear
    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children, function (child) {
        return (0, _react.cloneElement)(child, {
          onExited: _this.handleExited.bind(_this, child),
          in: true,
          appear: _this.getProp(child, 'appear'),
          enter: _this.getProp(child, 'enter'),
          exit: _this.getProp(child, 'exit')
        });
      })
    };
    return _this;
  }

  TransitionGroup.prototype.getChildContext = function getChildContext() {
    return {
      transitionGroup: { isMounting: !this.appeared }
    };
  };
  // use child config unless explictly set by the Group


  TransitionGroup.prototype.getProp = function getProp(child, prop) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;

    return props[prop] != null ? props[prop] : child.props[prop];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var prevChildMapping = this.state.children;
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);

    var children = (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping);

    Object.keys(children).forEach(function (key) {
      var child = children[key];

      if (!(0, _react.isValidElement)(child)) return;

      var hasPrev = key in prevChildMapping;
      var hasNext = key in nextChildMapping;

      var prevChild = prevChildMapping[key];
      var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;

      // item is new (entering)
      if (hasNext && (!hasPrev || isLeaving)) {
        // console.log('entering', key)
        children[key] = (0, _react.cloneElement)(child, {
          onExited: _this2.handleExited.bind(_this2, child),
          in: true,
          exit: _this2.getProp(child, 'exit', nextProps),
          enter: _this2.getProp(child, 'enter', nextProps)
        });
      }
      // item is old (exiting)
      else if (!hasNext && hasPrev && !isLeaving) {
          // console.log('leaving', key)
          children[key] = (0, _react.cloneElement)(child, { in: false });
        }
        // item hasn't changed transition states
        // copy over the last transition props;
        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
            // console.log('unchanged', key)
            children[key] = (0, _react.cloneElement)(child, {
              onExited: _this2.handleExited.bind(_this2, child),
              in: prevChild.props.in,
              exit: _this2.getProp(child, 'exit', nextProps),
              enter: _this2.getProp(child, 'enter', nextProps)
            });
          }
    });

    this.setState({ children: children });
  };

  TransitionGroup.prototype.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);

    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    this.setState(function (state) {
      var children = _extends({}, state.children);

      delete children[child.key];
      return { children: children };
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _props = this.props,
        Component = _props.component,
        childFactory = _props.childFactory,
        props = _objectWithoutProperties(_props, ['component', 'childFactory']);

    var children = values(this.state.children).map(childFactory);

    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }
    return _react2.default.createElement(
      Component,
      props,
      children
    );
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes2.default.object.isRequired
};


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(194)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("./Clouds.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.Clouds);
        global.Clouds = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./Clouds.scss": {
            "clouds": "Clouds__clouds___ZqF3b",
            "drift": "Clouds__drift___3GuAw"
        }
    };

    var Clouds = function (_super) {
        tslib_1.__extends(Clouds, _super);
        function Clouds(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            return _this;
        }
        Clouds.prototype.render = function () {
            return React.createElement("div", {
                className: (0, _getClassName3.default)('clouds', _styleModuleImportMap)
            });
        };
        return Clouds;
    }(React.Component);
    exports.default = Clouds;
});

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(8), __webpack_require__(99), __webpack_require__(18), __webpack_require__(35), __webpack_require__(19), __webpack_require__(89), __webpack_require__(22), __webpack_require__(25), __webpack_require__(12), __webpack_require__(15), __webpack_require__(16), __webpack_require__(100)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("react-redux"), require("lodash"), require("../../../../common/VoiceOver"), require("../../../../../store/actions/modals"), require("../../../../common/highlight-text/HighlightText"), require("../../../../common/ui/button/Button"), require("../../../../../store/reducers/questions/yearEndQuestion"), require("../../../../../store/actions/calendar/year"), require("../../../../../store/actions/questions/questions"), require("../../../../../store/reducers/year"), require("../../../../../store/actions/screens"), require("../../../../../store/reducers/screen"), require("./Question.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.reactRedux, global.lodash, global.VoiceOver, global.modals, global.HighlightText, global.Button, global.yearEndQuestion, global.year, global.questions, global.year, global.screens, global.screen, global.Question);
        global.YearEndQuestion = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _reactRedux, _lodash, _VoiceOver, _modals, _HighlightText, _Button, _yearEndQuestion, _year, _questions, _year2, _screens, _screen, _Question) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    var _ = _interopRequireWildcard(_lodash);

    var _HighlightText2 = _interopRequireDefault(_HighlightText);

    var _Button2 = _interopRequireDefault(_Button);

    var styles = _interopRequireWildcard(_Question);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "styles": {
            "question-content": "Question__question-content___16wOD",
            "header": "Question__header___3Diwg Colour__yellow___2xL7_",
            "label": "Question__label___3RXBf Fonts__bold-font___3iFek",
            "image": "Question__image___1l98D",
            "source-image": "Question__source-image___bjtf-",
            "warning-icon": "Question__warning-icon___11KA5",
            "question-and-answer": "Question__question-and-answer___3P-g_",
            "answer-content": "Question__answer-content___1cc90 Question__question-content___16wOD",
            "question-slide": "Question__question-slide___1-hML",
            "answer-slide": "Question__answer-slide___2sgdt",
            "warning": "Question__warning___2mz9c",
            "warning-text": "Question__warning-text___1U409",
            "warning-attention": "Question__warning-attention___3p3L3",
            "headline": "Question__headline___1B2M8 Fonts__bold-font___3iFek",
            "body-copy": "Question__body-copy___2elJd Fonts__medium-font___3yYd3",
            "options": "Question__options___1IRKh",
            "option": "Question__option___3m8J_ Fonts__bold-font___3iFek",
            "response": "Question__response___AIMbY",
            "answer-footer": "Question__answer-footer___b9kWU"
        }
    };

    var initial_state = {
        answer: null,
        answered: false,
        width: null,
        height: null
    };
    var YearEndQuestion = function (_super) {
        tslib_1.__extends(YearEndQuestion, _super);
        function YearEndQuestion(props, state) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.state = state;
            _this.measureEl = function (el, answered) {
                var _a = _this.state,
                    sanswered = _a.answered,
                    oheight = _a.height,
                    owidth = _a.width;
                if (sanswered !== answered) return;
                if (!el) return;
                var _b = el.getBoundingClientRect(),
                    nwidth = _b.width,
                    nheight = _b.height;
                if (owidth !== nwidth || oheight !== nheight) _this.setState({ width: nwidth, height: nheight });
            };
            _this.getOptions = function () {
                return _.map(_this.props.question.answers, function (answer, i) {
                    return React.createElement(
                        _VoiceOver.VoiceOver,
                        { vo: answer.vo, style_name: styles.option, onClick: function onClick() {
                                return _this.chooseAnswer(i);
                            }, key: i },
                        answer.text
                    );
                });
            };
            _this.chooseAnswer = function (answer) {
                _this.setState({ answer: answer, answered: true });
                var is_correct = answer === _this.props.question.answer;
                if (is_correct) {
                    var recordCorrectAnswer_1 = _this.props.recordCorrectAnswer;
                    recordCorrectAnswer_1();
                }
            };
            _this.incrementYear = function () {
                var _a = _this.props,
                    incrementYear = _a.incrementYear,
                    closeModal = _a.closeModal,
                    hideModal = _a.hideModal;
                hideModal();
                closeModal();
                _.delay(function () {
                    return incrementYear();
                }, 500);
            };
            _this.getCorrectText = function () {
                var options = ["That’s right – well done!", "Woohoo – that’s correct!", "Yes! That’s the right answer – well done!", "You got it right!", "Correct – hooray!", "Well done – good choice", "You got it – well done!", "Good choice – correct!", "Correct! Good thinking", "You were paying attention – that’s the right answer"];
                return _.sample(options);
            };
            _this.getIncorrectText = function () {
                var options = ["Sorry – that’s the wrong answer", "Uh-oh… That’s not right", "That’s the wrong answer – remember to listen out for the answer at the start of each challenge", "Oh dear – remember to look out for the answer at the start of the challenge", "Bad luck – that’s the wrong answer", "Oh dear – that’s not right. Don't forget to listen carefully for the answer at the start of each challenge.", "Uh-oh… That’s not the right answer", "Oh no – that’s not the right answer", "Uh-oh – that’s not right", "Sorry, that’s not the right answer"];
                return _.sample(options);
            };
            _this.state = initial_state;
            return _this;
        }
        YearEndQuestion.prototype.render = function () {
            var _this = this;
            var _a = this.props,
                question = _a.question,
                year = _a.year,
                showGameOverModal = _a.showGameOverModal;
            var _b = this.state,
                answer = _b.answer,
                answered = _b.answered,
                width = _b.width,
                height = _b.height;
            if (!question) return null;
            var question_text = question.question,
                image = question.image,
                response = question.response,
                answers = question.answers,
                correct_answer = question.answer;
            var affects = null;
            var is_correct = answer === this.props.question.answer;
            return React.createElement(
                "div",
                {
                    className: (0, _getClassName3.default)(!answered ? 'question-content' : 'answer-content', _styleModuleImportMap)
                },
                React.createElement(
                    "div",
                    { style: { width: width, height: height }, className: (0, _getClassName3.default)('question-and-answer', _styleModuleImportMap)
                    },
                    React.createElement(
                        "div",
                        { ref: function ref(el) {
                                return _this.measureEl(el, false);
                            }, className: (0, _getClassName3.default)('question-slide', _styleModuleImportMap)
                        },
                        React.createElement(
                            _HighlightText2.default,
                            { type: 'green' },
                            "question"
                        ),
                        React.createElement(
                            "h4",
                            {
                                className: (0, _getClassName3.default)('headline', _styleModuleImportMap)
                            },
                            question_text
                        ),
                        React.createElement(
                            "div",
                            {
                                className: (0, _getClassName3.default)('options', _styleModuleImportMap)
                            },
                            this.getOptions()
                        )
                    ),
                    React.createElement(
                        "div",
                        { style: { pointerEvents: answered ? 'auto' : 'none' }, ref: function ref(el) {
                                return _this.measureEl(el, true);
                            }, className: (0, _getClassName3.default)('answer-slide', _styleModuleImportMap)
                        },
                        React.createElement(
                            "p",
                            { style: { color: is_correct ? '#396518' : '#E04C00' }, className: (0, _getClassName3.default)('label', _styleModuleImportMap)
                            },
                            is_correct ? this.getCorrectText() : this.getIncorrectText()
                        ),
                        !is_correct && React.createElement(
                            "div",
                            {
                                className: (0, _getClassName3.default)('response', _styleModuleImportMap)
                            },
                            React.createElement(
                                "p",
                                null,
                                "The correct answer is: ",
                                React.createElement(
                                    "b",
                                    null,
                                    answers[correct_answer].text
                                )
                            )
                        ),
                        year.year !== 2031 && React.createElement(
                            "div",
                            {
                                className: (0, _getClassName3.default)('answer-footer', _styleModuleImportMap)
                            },
                            is_correct && React.createElement(
                                _Button2.default,
                                { type: 'right-answer', onClick: this.incrementYear },
                                "next challenge"
                            ),
                            !is_correct && React.createElement(
                                _Button2.default,
                                { type: 'right-answer', onClick: this.incrementYear },
                                "next challenge"
                            )
                        ),
                        year.year === 2031 && React.createElement(
                            "div",
                            {
                                className: (0, _getClassName3.default)('answer-footer', _styleModuleImportMap)
                            },
                            is_correct && React.createElement(
                                _Button2.default,
                                { type: 'right-answer', onClick: showGameOverModal },
                                "see how you did"
                            ),
                            !is_correct && React.createElement(
                                _Button2.default,
                                { type: 'right-answer', onClick: showGameOverModal },
                                "see how you did"
                            )
                        )
                    )
                )
            );
        };
        return YearEndQuestion;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state) {
        return {
            question: (0, _yearEndQuestion.getYearEndQuestionData)(state),
            year: (0, _year2.getYearData)(state)
        };
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {
            incrementYear: function incrementYear() {
                return dispatch((0, _year.incrementYear)());
            },
            hideModal: function hideModal() {
                return dispatch((0, _modals.hideModal)());
            },
            closeModal: function closeModal() {
                return dispatch((0, _screens.setScreen)(_screen.SCREENS.GAME));
            },
            recordCorrectAnswer: function recordCorrectAnswer() {
                return dispatch((0, _questions.recordCorrectAnswer)());
            },
            showGameOverModal: function showGameOverModal() {
                return dispatch((0, _modals.showGameOverModal)());
            }
        };
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(YearEndQuestion);
});

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(4), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("tslib"), require("react"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.tslib, global.react);
        global.VoiceOver = mod.exports;
    }
})(this, function (exports, _tslib, _react) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.VoiceOver = undefined;

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    var VoiceOver = function (_super) {
        tslib_1.__extends(VoiceOver, _super);
        function VoiceOver(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.onMouseEnter = function () {
                console.log('playing VO', _this.props.vo);
            };
            return _this;
        }
        VoiceOver.prototype.render = function () {
            var _a = this.props,
                style_name = _a.style_name,
                onClick = _a.onClick;
            return React.createElement(
                "span",
                { className: style_name, onMouseEnter: this.onMouseEnter, onClick: onClick },
                this.props.children
            );
        };
        return VoiceOver;
    }(React.Component);
    exports.VoiceOver = VoiceOver;
});

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(216);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../node_modules/sass-loader/lib/loader.js!./Question.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../node_modules/sass-loader/lib/loader.js!./Question.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(18), __webpack_require__(17), __webpack_require__(93), __webpack_require__(19), __webpack_require__(219)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("react-redux"), require("../../../../store/actions/modals"), require("../../../../store/reducers/modal"), require("react-transition-group"), require("../../../common/ui/button/Button"), require("./ModalComponent.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.reactRedux, global.modals, global.modal, global.reactTransitionGroup, global.Button, global.ModalComponent);
        global.ModalComponent = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _reactRedux, _modals, _modal, _reactTransitionGroup, _Button, _ModalComponent) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    var _Button2 = _interopRequireDefault(_Button);

    var styles = _interopRequireWildcard(_ModalComponent);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "styles": {
            "container": "ModalComponent__container___3ykxU",
            "container-enter": "ModalComponent__container-enter___22_Hx",
            "container-enter-active": "ModalComponent__container-enter-active___uZAcv",
            "container-exit": "ModalComponent__container-exit___2bK0f",
            "container-exit-active": "ModalComponent__container-exit-active___2QYCA",
            "transparent-container": "ModalComponent__transparent-container___okiIx ModalComponent__container___3ykxU",
            "content": "ModalComponent__content___2YsFZ",
            "modal": "ModalComponent__modal___2daI6",
            "modal-enter": "ModalComponent__modal-enter___1GLrC",
            "modal-enter-active": "ModalComponent__modal-enter-active___3e3s4",
            "modal-exit": "ModalComponent__modal-exit___1PGNY",
            "modal-exit-active": "ModalComponent__modal-exit-active___1YVrv",
            "footer": "ModalComponent__footer___2Zm3Y"
        }
    };

    var ModalComponent = function (_super) {
        tslib_1.__extends(ModalComponent, _super);
        function ModalComponent(props, state) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.state = state;
            _this.onEntered = function () {
                _this.setState({ visible: true });
            };
            _this.onExited = function () {
                _this.setState({ visible: false });
            };
            _this.getStyleName = function () {
                var subtype = _this.props.subtype;
                switch (subtype) {
                    case 'transparent':
                        return 'transparent-container';
                    default:
                        return 'container';
                }
            };
            _this.onClose = function () {
                if (_this.props.onClose) _this.props.onClose();
                _this.props.close();
            };
            _this.state = { visible: false };
            return _this;
        }
        ModalComponent.prototype.render = function () {
            var _a = this.props,
                _b = _a.close_button_type,
                close_button_type = _b === void 0 ? 'ok' : _b,
                _c = _a.close_button_text,
                close_button_text = _c === void 0 ? 'ok' : _c;
            var visible = this.state.visible;
            return React.createElement(
                _reactTransitionGroup.CSSTransition,
                { "in": this.props.modal_id === this.props.active_modal_id, timeout: 500, classNames: {
                        enter: styles.containerEnter,
                        enterActive: styles.containerEnterActive,
                        exit: styles.containerExit,
                        exitActive: styles.containerExitActive
                    }, onEntered: this.onEntered, onExited: this.onExited, appear: true, unmountOnExit: true },
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)(this.getStyleName(), _styleModuleImportMap)
                    },
                    React.createElement(
                        _reactTransitionGroup.CSSTransition,
                        { "in": visible, timeout: 500, classNames: {
                                enter: styles.modalEnter,
                                enterActive: styles.modalEnterActive,
                                exit: styles.modalExit,
                                exitActive: styles.modalExitActive
                            }, appear: true, unmountOnExit: true },
                        React.createElement(
                            "div",
                            {
                                className: (0, _getClassName3.default)('modal', _styleModuleImportMap)
                            },
                            React.createElement(
                                "div",
                                {
                                    className: (0, _getClassName3.default)('content', _styleModuleImportMap)
                                },
                                (0, _react.cloneElement)(this.props.children, { onClose: this.onClose })
                            ),
                            close_button_type !== 'none' && React.createElement(
                                "div",
                                {
                                    className: (0, _getClassName3.default)('footer', _styleModuleImportMap)
                                },
                                React.createElement(
                                    _Button2.default,
                                    { type: close_button_type, onClick: this.onClose },
                                    close_button_text
                                )
                            )
                        )
                    )
                )
            );
        };
        return ModalComponent;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state) {
        return {
            active_modal_id: (0, _modal.getActiveModal)(state)
        };
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {
            close: function close() {
                return dispatch((0, _modals.hideModal)());
            }
        };
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ModalComponent);
});

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(13), __webpack_require__(241), __webpack_require__(31), __webpack_require__(12), __webpack_require__(244)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("react-redux"), require("../../../../store/reducers/powerSources"), require("../../../common/counter/Counter"), require("../../../../store/actions/powerSources"), require("../../../../store/reducers/year"), require("./PowerSource.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.reactRedux, global.powerSources, global.Counter, global.powerSources, global.year, global.PowerSource);
        global.PowerSource = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _reactRedux, _powerSources, _Counter, _powerSources2, _year) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    var _Counter2 = _interopRequireDefault(_Counter);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./PowerSource.scss": {
            "power-source": "PowerSource__power-source___3W25s",
            "image": "PowerSource__image___1cX1N",
            "tooltip": "PowerSource__tooltip___fMBVk Fonts__bold-font___3iFek",
            "closed": "PowerSource__closed___2hMea PowerSource__power-source___3W25s",
            "maxed-out": "PowerSource__maxed-out___qtRVh PowerSource__power-source___3W25s",
            "deprecated-icon": "PowerSource__deprecated-icon___W-SOx"
        }
    };

    var PowerSource = function (_super) {
        tslib_1.__extends(PowerSource, _super);
        function PowerSource(props, state) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.state = state;
            _this.onMouseDown = function (event) {
                var setDraggingPowerSource = _this.props.setDraggingPowerSource;
                var is_max = _this.state.is_max;
                if (is_max) return;
                event.preventDefault();
                setDraggingPowerSource(_this.props, event.pageX, event.pageY);
            };
            _this.isClosed = function () {
                var _a = _this.props,
                    id = _a.id,
                    count = _a.count,
                    label = _a.label,
                    year = _a.year;
                var is_max = _this.state.is_max;
                return id === 'coal' && year.year >= 2025;
            };
            var count = props.count,
                max = props.max;
            _this.state = { is_max: count >= max };
            return _this;
        }
        PowerSource.prototype.componentDidUpdate = function () {
            var _a = this.props,
                count = _a.count,
                max = _a.max;
            var nis_max = count >= max;
            var ois_max = this.state.is_max;
            if (ois_max !== nis_max) this.setState({ is_max: nis_max });
        };
        PowerSource.prototype.render = function () {
            var _a = this.props,
                id = _a.id,
                count = _a.count,
                label = _a.label,
                year = _a.year;
            var is_max = this.state.is_max;
            return React.createElement(
                "div",
                { onMouseDown: this.isClosed() ? null : this.onMouseDown, className: (0, _getClassName3.default)(this.isClosed() ? 'closed' : 'power-source', _styleModuleImportMap)
                },
                React.createElement("img", { src: "./img/game/power-sources/" + id + "@2x.png", className: (0, _getClassName3.default)(!is_max ? 'image' : 'maxed-out', _styleModuleImportMap)
                }),
                this.isClosed() && React.createElement("div", {
                    className: (0, _getClassName3.default)('deprecated-icon', _styleModuleImportMap)
                }),
                React.createElement(_Counter2.default, { count: is_max ? 'max' : count }),
                React.createElement(
                    "span",
                    {
                        className: (0, _getClassName3.default)('tooltip', _styleModuleImportMap)
                    },
                    label
                )
            );
        };
        return PowerSource;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state, props) {
        return {
            count: (0, _powerSources.countPowerSourcesByID)(state, props),
            year: (0, _year.getYearData)(state)
        };
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {
            setDraggingPowerSource: function setDraggingPowerSource(power_source, ox, oy) {
                return dispatch((0, _powerSources2.setDraggingPowerSource)(power_source, ox, oy));
            }
        };
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PowerSource);
});

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2), __webpack_require__(8), __webpack_require__(10), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("../actions/action"), require("lodash"), require("../../data/data"), require("reselect"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action, global.lodash, global.data, global.reselect);
        global.outage = mod.exports;
    }
})(this, function (exports, _action, _lodash, _data, _reselect) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getOutageAffectedPowerSources = exports.getOutageData = exports.getOutageID = undefined;
    exports.outageID = outageID;

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    var getOutageID = exports.getOutageID = function getOutageID(state) {
        return state.outage;
    };
    var getOutageData = exports.getOutageData = (0, _reselect.createSelector)([getOutageID], function (outage_id) {
        var outages = (0, _data.getOutages)();
        return _.find(outages, ['id', outage_id]);
    });
    var getOutageAffectedPowerSources = exports.getOutageAffectedPowerSources = (0, _reselect.createSelector)([getOutageData], function (outage) {
        console.log('getOutageAffectedPowerSources: outage', outage);
        if (!outage) return null;
        return outage.affects;
    });
    var initialState = null;
    function outageID(state, action) {
        if (state === void 0) {
            state = initialState;
        }
        switch (action.type) {
            case _action.SET_OUTAGE_ID:
                {
                    var payload = action.payload;
                    var outage_id = payload.outage_id;
                    return outage_id;
                }
            default:
                return state;
        }
    }
});

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
/**
 * @license
 *
 * chroma.js - JavaScript library for color conversions
 * 
 * Copyright (c) 2011-2017, Gregor Aisch
 * All rights reserved.
 * 
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 * 
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 * 
 * 3. The name Gregor Aisch may not be used to endorse or promote products
 *    derived from this software without specific prior written permission.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 * INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
 * OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 * EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 */

(function() {
  var Color, DEG2RAD, LAB_CONSTANTS, PI, PITHIRD, RAD2DEG, TWOPI, _average_lrgb, _guess_formats, _guess_formats_sorted, _input, _interpolators, abs, atan2, bezier, blend, blend_f, brewer, burn, chroma, clip_rgb, cmyk2rgb, colors, cos, css2rgb, darken, dodge, each, floor, hcg2rgb, hex2rgb, hsi2rgb, hsl2css, hsl2rgb, hsv2rgb, interpolate, interpolate_hsx, interpolate_lab, interpolate_lrgb, interpolate_num, interpolate_rgb, lab2lch, lab2rgb, lab_xyz, lch2lab, lch2rgb, lighten, limit, log, luminance_x, m, max, multiply, normal, num2rgb, overlay, pow, rgb2cmyk, rgb2css, rgb2hcg, rgb2hex, rgb2hsi, rgb2hsl, rgb2hsv, rgb2lab, rgb2lch, rgb2luminance, rgb2num, rgb2temperature, rgb2xyz, rgb_xyz, rnd, root, round, screen, sin, sqrt, temperature2rgb, type, unpack, w3cx11, xyz_lab, xyz_rgb,
    slice = [].slice;

  type = (function() {

    /*
    for browser-safe type checking+
    ported from jQuery's $.type
     */
    var classToType, len, name, o, ref;
    classToType = {};
    ref = "Boolean Number String Function Array Date RegExp Undefined Null".split(" ");
    for (o = 0, len = ref.length; o < len; o++) {
      name = ref[o];
      classToType["[object " + name + "]"] = name.toLowerCase();
    }
    return function(obj) {
      var strType;
      strType = Object.prototype.toString.call(obj);
      return classToType[strType] || "object";
    };
  })();

  limit = function(x, min, max) {
    if (min == null) {
      min = 0;
    }
    if (max == null) {
      max = 1;
    }
    if (x < min) {
      x = min;
    }
    if (x > max) {
      x = max;
    }
    return x;
  };

  unpack = function(args) {
    if (args.length >= 3) {
      return [].slice.call(args);
    } else {
      return args[0];
    }
  };

  clip_rgb = function(rgb) {
    var i, o;
    rgb._clipped = false;
    rgb._unclipped = rgb.slice(0);
    for (i = o = 0; o < 3; i = ++o) {
      if (i < 3) {
        if (rgb[i] < 0 || rgb[i] > 255) {
          rgb._clipped = true;
        }
        if (rgb[i] < 0) {
          rgb[i] = 0;
        }
        if (rgb[i] > 255) {
          rgb[i] = 255;
        }
      } else if (i === 3) {
        if (rgb[i] < 0) {
          rgb[i] = 0;
        }
        if (rgb[i] > 1) {
          rgb[i] = 1;
        }
      }
    }
    if (!rgb._clipped) {
      delete rgb._unclipped;
    }
    return rgb;
  };

  PI = Math.PI, round = Math.round, cos = Math.cos, floor = Math.floor, pow = Math.pow, log = Math.log, sin = Math.sin, sqrt = Math.sqrt, atan2 = Math.atan2, max = Math.max, abs = Math.abs;

  TWOPI = PI * 2;

  PITHIRD = PI / 3;

  DEG2RAD = PI / 180;

  RAD2DEG = 180 / PI;

  chroma = function() {
    if (arguments[0] instanceof Color) {
      return arguments[0];
    }
    return (function(func, args, ctor) {
      ctor.prototype = func.prototype;
      var child = new ctor, result = func.apply(child, args);
      return Object(result) === result ? result : child;
    })(Color, arguments, function(){});
  };

  chroma["default"] = chroma;

  _interpolators = [];

  if ((typeof module !== "undefined" && module !== null) && (module.exports != null)) {
    module.exports = chroma;
  }

  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return chroma;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    root = typeof exports !== "undefined" && exports !== null ? exports : this;
    root.chroma = chroma;
  }

  chroma.version = '1.3.5';

  _input = {};

  _guess_formats = [];

  _guess_formats_sorted = false;

  Color = (function() {
    function Color() {
      var arg, args, chk, len, len1, me, mode, o, w;
      me = this;
      args = [];
      for (o = 0, len = arguments.length; o < len; o++) {
        arg = arguments[o];
        if (arg != null) {
          args.push(arg);
        }
      }
      if (args.length > 1) {
        mode = args[args.length - 1];
      }
      if (_input[mode] != null) {
        me._rgb = clip_rgb(_input[mode](unpack(args.slice(0, -1))));
      } else {
        if (!_guess_formats_sorted) {
          _guess_formats = _guess_formats.sort(function(a, b) {
            return b.p - a.p;
          });
          _guess_formats_sorted = true;
        }
        for (w = 0, len1 = _guess_formats.length; w < len1; w++) {
          chk = _guess_formats[w];
          mode = chk.test.apply(chk, args);
          if (mode) {
            break;
          }
        }
        if (mode) {
          me._rgb = clip_rgb(_input[mode].apply(_input, args));
        }
      }
      if (me._rgb == null) {
        console.warn('unknown format: ' + args);
      }
      if (me._rgb == null) {
        me._rgb = [0, 0, 0];
      }
      if (me._rgb.length === 3) {
        me._rgb.push(1);
      }
    }

    Color.prototype.toString = function() {
      return this.hex();
    };

    Color.prototype.clone = function() {
      return chroma(me._rgb);
    };

    return Color;

  })();

  chroma._input = _input;


  /**
  	ColorBrewer colors for chroma.js
  
  	Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and The 
  	Pennsylvania State University.
  
  	Licensed under the Apache License, Version 2.0 (the "License"); 
  	you may not use this file except in compliance with the License.
  	You may obtain a copy of the License at	
  	http://www.apache.org/licenses/LICENSE-2.0
  
  	Unless required by applicable law or agreed to in writing, software distributed
  	under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
  	CONDITIONS OF ANY KIND, either express or implied. See the License for the
  	specific language governing permissions and limitations under the License.
  
      @preserve
   */

  chroma.brewer = brewer = {
    OrRd: ['#fff7ec', '#fee8c8', '#fdd49e', '#fdbb84', '#fc8d59', '#ef6548', '#d7301f', '#b30000', '#7f0000'],
    PuBu: ['#fff7fb', '#ece7f2', '#d0d1e6', '#a6bddb', '#74a9cf', '#3690c0', '#0570b0', '#045a8d', '#023858'],
    BuPu: ['#f7fcfd', '#e0ecf4', '#bfd3e6', '#9ebcda', '#8c96c6', '#8c6bb1', '#88419d', '#810f7c', '#4d004b'],
    Oranges: ['#fff5eb', '#fee6ce', '#fdd0a2', '#fdae6b', '#fd8d3c', '#f16913', '#d94801', '#a63603', '#7f2704'],
    BuGn: ['#f7fcfd', '#e5f5f9', '#ccece6', '#99d8c9', '#66c2a4', '#41ae76', '#238b45', '#006d2c', '#00441b'],
    YlOrBr: ['#ffffe5', '#fff7bc', '#fee391', '#fec44f', '#fe9929', '#ec7014', '#cc4c02', '#993404', '#662506'],
    YlGn: ['#ffffe5', '#f7fcb9', '#d9f0a3', '#addd8e', '#78c679', '#41ab5d', '#238443', '#006837', '#004529'],
    Reds: ['#fff5f0', '#fee0d2', '#fcbba1', '#fc9272', '#fb6a4a', '#ef3b2c', '#cb181d', '#a50f15', '#67000d'],
    RdPu: ['#fff7f3', '#fde0dd', '#fcc5c0', '#fa9fb5', '#f768a1', '#dd3497', '#ae017e', '#7a0177', '#49006a'],
    Greens: ['#f7fcf5', '#e5f5e0', '#c7e9c0', '#a1d99b', '#74c476', '#41ab5d', '#238b45', '#006d2c', '#00441b'],
    YlGnBu: ['#ffffd9', '#edf8b1', '#c7e9b4', '#7fcdbb', '#41b6c4', '#1d91c0', '#225ea8', '#253494', '#081d58'],
    Purples: ['#fcfbfd', '#efedf5', '#dadaeb', '#bcbddc', '#9e9ac8', '#807dba', '#6a51a3', '#54278f', '#3f007d'],
    GnBu: ['#f7fcf0', '#e0f3db', '#ccebc5', '#a8ddb5', '#7bccc4', '#4eb3d3', '#2b8cbe', '#0868ac', '#084081'],
    Greys: ['#ffffff', '#f0f0f0', '#d9d9d9', '#bdbdbd', '#969696', '#737373', '#525252', '#252525', '#000000'],
    YlOrRd: ['#ffffcc', '#ffeda0', '#fed976', '#feb24c', '#fd8d3c', '#fc4e2a', '#e31a1c', '#bd0026', '#800026'],
    PuRd: ['#f7f4f9', '#e7e1ef', '#d4b9da', '#c994c7', '#df65b0', '#e7298a', '#ce1256', '#980043', '#67001f'],
    Blues: ['#f7fbff', '#deebf7', '#c6dbef', '#9ecae1', '#6baed6', '#4292c6', '#2171b5', '#08519c', '#08306b'],
    PuBuGn: ['#fff7fb', '#ece2f0', '#d0d1e6', '#a6bddb', '#67a9cf', '#3690c0', '#02818a', '#016c59', '#014636'],
    Viridis: ['#440154', '#482777', '#3f4a8a', '#31678e', '#26838f', '#1f9d8a', '#6cce5a', '#b6de2b', '#fee825'],
    Spectral: ['#9e0142', '#d53e4f', '#f46d43', '#fdae61', '#fee08b', '#ffffbf', '#e6f598', '#abdda4', '#66c2a5', '#3288bd', '#5e4fa2'],
    RdYlGn: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee08b', '#ffffbf', '#d9ef8b', '#a6d96a', '#66bd63', '#1a9850', '#006837'],
    RdBu: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#f7f7f7', '#d1e5f0', '#92c5de', '#4393c3', '#2166ac', '#053061'],
    PiYG: ['#8e0152', '#c51b7d', '#de77ae', '#f1b6da', '#fde0ef', '#f7f7f7', '#e6f5d0', '#b8e186', '#7fbc41', '#4d9221', '#276419'],
    PRGn: ['#40004b', '#762a83', '#9970ab', '#c2a5cf', '#e7d4e8', '#f7f7f7', '#d9f0d3', '#a6dba0', '#5aae61', '#1b7837', '#00441b'],
    RdYlBu: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee090', '#ffffbf', '#e0f3f8', '#abd9e9', '#74add1', '#4575b4', '#313695'],
    BrBG: ['#543005', '#8c510a', '#bf812d', '#dfc27d', '#f6e8c3', '#f5f5f5', '#c7eae5', '#80cdc1', '#35978f', '#01665e', '#003c30'],
    RdGy: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#ffffff', '#e0e0e0', '#bababa', '#878787', '#4d4d4d', '#1a1a1a'],
    PuOr: ['#7f3b08', '#b35806', '#e08214', '#fdb863', '#fee0b6', '#f7f7f7', '#d8daeb', '#b2abd2', '#8073ac', '#542788', '#2d004b'],
    Set2: ['#66c2a5', '#fc8d62', '#8da0cb', '#e78ac3', '#a6d854', '#ffd92f', '#e5c494', '#b3b3b3'],
    Accent: ['#7fc97f', '#beaed4', '#fdc086', '#ffff99', '#386cb0', '#f0027f', '#bf5b17', '#666666'],
    Set1: ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00', '#ffff33', '#a65628', '#f781bf', '#999999'],
    Set3: ['#8dd3c7', '#ffffb3', '#bebada', '#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5', '#d9d9d9', '#bc80bd', '#ccebc5', '#ffed6f'],
    Dark2: ['#1b9e77', '#d95f02', '#7570b3', '#e7298a', '#66a61e', '#e6ab02', '#a6761d', '#666666'],
    Paired: ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c', '#fdbf6f', '#ff7f00', '#cab2d6', '#6a3d9a', '#ffff99', '#b15928'],
    Pastel2: ['#b3e2cd', '#fdcdac', '#cbd5e8', '#f4cae4', '#e6f5c9', '#fff2ae', '#f1e2cc', '#cccccc'],
    Pastel1: ['#fbb4ae', '#b3cde3', '#ccebc5', '#decbe4', '#fed9a6', '#ffffcc', '#e5d8bd', '#fddaec', '#f2f2f2']
  };

  (function() {
    var key, results;
    results = [];
    for (key in brewer) {
      results.push(brewer[key.toLowerCase()] = brewer[key]);
    }
    return results;
  })();


  /**
  	X11 color names
  
  	http://www.w3.org/TR/css3-color/#svg-color
   */

  w3cx11 = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflower: '#6495ed',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkgrey: '#a9a9a9',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkslategrey: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    gold: '#ffd700',
    goldenrod: '#daa520',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    grey: '#808080',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    laserlemon: '#ffff54',
    lavender: '#e6e6fa',
    lavenderblush: '#fff0f5',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrod: '#fafad2',
    lightgoldenrodyellow: '#fafad2',
    lightgray: '#d3d3d3',
    lightgreen: '#90ee90',
    lightgrey: '#d3d3d3',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    maroon2: '#7f0000',
    maroon3: '#b03060',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370db',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#db7093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    purple2: '#7f007f',
    purple3: '#a020f0',
    rebeccapurple: '#663399',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32'
  };

  chroma.colors = colors = w3cx11;

  lab2rgb = function() {
    var a, args, b, g, l, r, x, y, z;
    args = unpack(arguments);
    l = args[0], a = args[1], b = args[2];
    y = (l + 16) / 116;
    x = isNaN(a) ? y : y + a / 500;
    z = isNaN(b) ? y : y - b / 200;
    y = LAB_CONSTANTS.Yn * lab_xyz(y);
    x = LAB_CONSTANTS.Xn * lab_xyz(x);
    z = LAB_CONSTANTS.Zn * lab_xyz(z);
    r = xyz_rgb(3.2404542 * x - 1.5371385 * y - 0.4985314 * z);
    g = xyz_rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z);
    b = xyz_rgb(0.0556434 * x - 0.2040259 * y + 1.0572252 * z);
    return [r, g, b, args.length > 3 ? args[3] : 1];
  };

  xyz_rgb = function(r) {
    return 255 * (r <= 0.00304 ? 12.92 * r : 1.055 * pow(r, 1 / 2.4) - 0.055);
  };

  lab_xyz = function(t) {
    if (t > LAB_CONSTANTS.t1) {
      return t * t * t;
    } else {
      return LAB_CONSTANTS.t2 * (t - LAB_CONSTANTS.t0);
    }
  };

  LAB_CONSTANTS = {
    Kn: 18,
    Xn: 0.950470,
    Yn: 1,
    Zn: 1.088830,
    t0: 0.137931034,
    t1: 0.206896552,
    t2: 0.12841855,
    t3: 0.008856452
  };

  rgb2lab = function() {
    var b, g, r, ref, ref1, x, y, z;
    ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
    ref1 = rgb2xyz(r, g, b), x = ref1[0], y = ref1[1], z = ref1[2];
    return [116 * y - 16, 500 * (x - y), 200 * (y - z)];
  };

  rgb_xyz = function(r) {
    if ((r /= 255) <= 0.04045) {
      return r / 12.92;
    } else {
      return pow((r + 0.055) / 1.055, 2.4);
    }
  };

  xyz_lab = function(t) {
    if (t > LAB_CONSTANTS.t3) {
      return pow(t, 1 / 3);
    } else {
      return t / LAB_CONSTANTS.t2 + LAB_CONSTANTS.t0;
    }
  };

  rgb2xyz = function() {
    var b, g, r, ref, x, y, z;
    ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
    r = rgb_xyz(r);
    g = rgb_xyz(g);
    b = rgb_xyz(b);
    x = xyz_lab((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / LAB_CONSTANTS.Xn);
    y = xyz_lab((0.2126729 * r + 0.7151522 * g + 0.0721750 * b) / LAB_CONSTANTS.Yn);
    z = xyz_lab((0.0193339 * r + 0.1191920 * g + 0.9503041 * b) / LAB_CONSTANTS.Zn);
    return [x, y, z];
  };

  chroma.lab = function() {
    return (function(func, args, ctor) {
      ctor.prototype = func.prototype;
      var child = new ctor, result = func.apply(child, args);
      return Object(result) === result ? result : child;
    })(Color, slice.call(arguments).concat(['lab']), function(){});
  };

  _input.lab = lab2rgb;

  Color.prototype.lab = function() {
    return rgb2lab(this._rgb);
  };

  bezier = function(colors) {
    var I, I0, I1, c, lab0, lab1, lab2, lab3, ref, ref1, ref2;
    colors = (function() {
      var len, o, results;
      results = [];
      for (o = 0, len = colors.length; o < len; o++) {
        c = colors[o];
        results.push(chroma(c));
      }
      return results;
    })();
    if (colors.length === 2) {
      ref = (function() {
        var len, o, results;
        results = [];
        for (o = 0, len = colors.length; o < len; o++) {
          c = colors[o];
          results.push(c.lab());
        }
        return results;
      })(), lab0 = ref[0], lab1 = ref[1];
      I = function(t) {
        var i, lab;
        lab = (function() {
          var o, results;
          results = [];
          for (i = o = 0; o <= 2; i = ++o) {
            results.push(lab0[i] + t * (lab1[i] - lab0[i]));
          }
          return results;
        })();
        return chroma.lab.apply(chroma, lab);
      };
    } else if (colors.length === 3) {
      ref1 = (function() {
        var len, o, results;
        results = [];
        for (o = 0, len = colors.length; o < len; o++) {
          c = colors[o];
          results.push(c.lab());
        }
        return results;
      })(), lab0 = ref1[0], lab1 = ref1[1], lab2 = ref1[2];
      I = function(t) {
        var i, lab;
        lab = (function() {
          var o, results;
          results = [];
          for (i = o = 0; o <= 2; i = ++o) {
            results.push((1 - t) * (1 - t) * lab0[i] + 2 * (1 - t) * t * lab1[i] + t * t * lab2[i]);
          }
          return results;
        })();
        return chroma.lab.apply(chroma, lab);
      };
    } else if (colors.length === 4) {
      ref2 = (function() {
        var len, o, results;
        results = [];
        for (o = 0, len = colors.length; o < len; o++) {
          c = colors[o];
          results.push(c.lab());
        }
        return results;
      })(), lab0 = ref2[0], lab1 = ref2[1], lab2 = ref2[2], lab3 = ref2[3];
      I = function(t) {
        var i, lab;
        lab = (function() {
          var o, results;
          results = [];
          for (i = o = 0; o <= 2; i = ++o) {
            results.push((1 - t) * (1 - t) * (1 - t) * lab0[i] + 3 * (1 - t) * (1 - t) * t * lab1[i] + 3 * (1 - t) * t * t * lab2[i] + t * t * t * lab3[i]);
          }
          return results;
        })();
        return chroma.lab.apply(chroma, lab);
      };
    } else if (colors.length === 5) {
      I0 = bezier(colors.slice(0, 3));
      I1 = bezier(colors.slice(2, 5));
      I = function(t) {
        if (t < 0.5) {
          return I0(t * 2);
        } else {
          return I1((t - 0.5) * 2);
        }
      };
    }
    return I;
  };

  chroma.bezier = function(colors) {
    var f;
    f = bezier(colors);
    f.scale = function() {
      return chroma.scale(f);
    };
    return f;
  };


  /*
      chroma.js
  
      Copyright (c) 2011-2013, Gregor Aisch
      All rights reserved.
  
      Redistribution and use in source and binary forms, with or without
      modification, are permitted provided that the following conditions are met:
  
      * Redistributions of source code must retain the above copyright notice, this
        list of conditions and the following disclaimer.
  
      * Redistributions in binary form must reproduce the above copyright notice,
        this list of conditions and the following disclaimer in the documentation
        and/or other materials provided with the distribution.
  
      * The name Gregor Aisch may not be used to endorse or promote products
        derived from this software without specific prior written permission.
  
      THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
      AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
      IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
      DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
      INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
      BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
      DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
      OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
      NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
      EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  
      @source: https://github.com/gka/chroma.js
   */

  chroma.cubehelix = function(start, rotations, hue, gamma, lightness) {
    var dh, dl, f;
    if (start == null) {
      start = 300;
    }
    if (rotations == null) {
      rotations = -1.5;
    }
    if (hue == null) {
      hue = 1;
    }
    if (gamma == null) {
      gamma = 1;
    }
    if (lightness == null) {
      lightness = [0, 1];
    }
    dh = 0;
    if (type(lightness) === 'array') {
      dl = lightness[1] - lightness[0];
    } else {
      dl = 0;
      lightness = [lightness, lightness];
    }
    f = function(fract) {
      var a, amp, b, cos_a, g, h, l, r, sin_a;
      a = TWOPI * ((start + 120) / 360 + rotations * fract);
      l = pow(lightness[0] + dl * fract, gamma);
      h = dh !== 0 ? hue[0] + fract * dh : hue;
      amp = h * l * (1 - l) / 2;
      cos_a = cos(a);
      sin_a = sin(a);
      r = l + amp * (-0.14861 * cos_a + 1.78277 * sin_a);
      g = l + amp * (-0.29227 * cos_a - 0.90649 * sin_a);
      b = l + amp * (+1.97294 * cos_a);
      return chroma(clip_rgb([r * 255, g * 255, b * 255]));
    };
    f.start = function(s) {
      if (s == null) {
        return start;
      }
      start = s;
      return f;
    };
    f.rotations = function(r) {
      if (r == null) {
        return rotations;
      }
      rotations = r;
      return f;
    };
    f.gamma = function(g) {
      if (g == null) {
        return gamma;
      }
      gamma = g;
      return f;
    };
    f.hue = function(h) {
      if (h == null) {
        return hue;
      }
      hue = h;
      if (type(hue) === 'array') {
        dh = hue[1] - hue[0];
        if (dh === 0) {
          hue = hue[1];
        }
      } else {
        dh = 0;
      }
      return f;
    };
    f.lightness = function(h) {
      if (h == null) {
        return lightness;
      }
      if (type(h) === 'array') {
        lightness = h;
        dl = h[1] - h[0];
      } else {
        lightness = [h, h];
        dl = 0;
      }
      return f;
    };
    f.scale = function() {
      return chroma.scale(f);
    };
    f.hue(hue);
    return f;
  };

  chroma.random = function() {
    var code, digits, i, o;
    digits = '0123456789abcdef';
    code = '#';
    for (i = o = 0; o < 6; i = ++o) {
      code += digits.charAt(floor(Math.random() * 16));
    }
    return new Color(code);
  };

  _interpolators = [];

  interpolate = function(col1, col2, f, m) {
    var interpol, len, o, res;
    if (f == null) {
      f = 0.5;
    }
    if (m == null) {
      m = 'rgb';
    }

    /*
    interpolates between colors
    f = 0 --> me
    f = 1 --> col
     */
    if (type(col1) !== 'object') {
      col1 = chroma(col1);
    }
    if (type(col2) !== 'object') {
      col2 = chroma(col2);
    }
    for (o = 0, len = _interpolators.length; o < len; o++) {
      interpol = _interpolators[o];
      if (m === interpol[0]) {
        res = interpol[1](col1, col2, f, m);
        break;
      }
    }
    if (res == null) {
      throw "color mode " + m + " is not supported";
    }
    return res.alpha(col1.alpha() + f * (col2.alpha() - col1.alpha()));
  };

  chroma.interpolate = interpolate;

  Color.prototype.interpolate = function(col2, f, m) {
    return interpolate(this, col2, f, m);
  };

  chroma.mix = interpolate;

  Color.prototype.mix = Color.prototype.interpolate;

  _input.rgb = function() {
    var k, ref, results, v;
    ref = unpack(arguments);
    results = [];
    for (k in ref) {
      v = ref[k];
      results.push(v);
    }
    return results;
  };

  chroma.rgb = function() {
    return (function(func, args, ctor) {
      ctor.prototype = func.prototype;
      var child = new ctor, result = func.apply(child, args);
      return Object(result) === result ? result : child;
    })(Color, slice.call(arguments).concat(['rgb']), function(){});
  };

  Color.prototype.rgb = function(round) {
    if (round == null) {
      round = true;
    }
    if (round) {
      return this._rgb.map(Math.round).slice(0, 3);
    } else {
      return this._rgb.slice(0, 3);
    }
  };

  Color.prototype.rgba = function(round) {
    if (round == null) {
      round = true;
    }
    if (!round) {
      return this._rgb.slice(0);
    }
    return [Math.round(this._rgb[0]), Math.round(this._rgb[1]), Math.round(this._rgb[2]), this._rgb[3]];
  };

  _guess_formats.push({
    p: 3,
    test: function(n) {
      var a;
      a = unpack(arguments);
      if (type(a) === 'array' && a.length === 3) {
        return 'rgb';
      }
      if (a.length === 4 && type(a[3]) === "number" && a[3] >= 0 && a[3] <= 1) {
        return 'rgb';
      }
    }
  });

  _input.lrgb = _input.rgb;

  interpolate_lrgb = function(col1, col2, f, m) {
    var xyz0, xyz1;
    xyz0 = col1._rgb;
    xyz1 = col2._rgb;
    return new Color(sqrt(pow(xyz0[0], 2) * (1 - f) + pow(xyz1[0], 2) * f), sqrt(pow(xyz0[1], 2) * (1 - f) + pow(xyz1[1], 2) * f), sqrt(pow(xyz0[2], 2) * (1 - f) + pow(xyz1[2], 2) * f), m);
  };

  _average_lrgb = function(colors) {
    var col, f, len, o, rgb, xyz;
    f = 1 / colors.length;
    xyz = [0, 0, 0, 0];
    for (o = 0, len = colors.length; o < len; o++) {
      col = colors[o];
      rgb = col._rgb;
      xyz[0] += pow(rgb[0], 2) * f;
      xyz[1] += pow(rgb[1], 2) * f;
      xyz[2] += pow(rgb[2], 2) * f;
      xyz[3] += rgb[3] * f;
    }
    xyz[0] = sqrt(xyz[0]);
    xyz[1] = sqrt(xyz[1]);
    xyz[2] = sqrt(xyz[2]);
    return new Color(xyz);
  };

  _interpolators.push(['lrgb', interpolate_lrgb]);

  chroma.average = function(colors, mode) {
    var A, alpha, c, cnt, dx, dy, first, i, l, len, o, xyz, xyz2;
    if (mode == null) {
      mode = 'rgb';
    }
    l = colors.length;
    colors = colors.map(function(c) {
      return chroma(c);
    });
    first = colors.splice(0, 1)[0];
    if (mode === 'lrgb') {
      return _average_lrgb(colors);
    }
    xyz = first.get(mode);
    cnt = [];
    dx = 0;
    dy = 0;
    for (i in xyz) {
      xyz[i] = xyz[i] || 0;
      cnt.push(!isNaN(xyz[i]) ? 1 : 0);
      if (mode.charAt(i) === 'h' && !isNaN(xyz[i])) {
        A = xyz[i] / 180 * PI;
        dx += cos(A);
        dy += sin(A);
      }
    }
    alpha = first.alpha();
    for (o = 0, len = colors.length; o < len; o++) {
      c = colors[o];
      xyz2 = c.get(mode);
      alpha += c.alpha();
      for (i in xyz) {
        if (!isNaN(xyz2[i])) {
          xyz[i] += xyz2[i];
          cnt[i] += 1;
          if (mode.charAt(i) === 'h') {
            A = xyz[i] / 180 * PI;
            dx += cos(A);
            dy += sin(A);
          }
        }
      }
    }
    for (i in xyz) {
      xyz[i] = xyz[i] / cnt[i];
      if (mode.charAt(i) === 'h') {
        A = atan2(dy / cnt[i], dx / cnt[i]) / PI * 180;
        while (A < 0) {
          A += 360;
        }
        while (A >= 360) {
          A -= 360;
        }
        xyz[i] = A;
      }
    }
    return chroma(xyz, mode).alpha(alpha / l);
  };

  hex2rgb = function(hex) {
    var a, b, g, r, rgb, u;
    if (hex.match(/^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)) {
      if (hex.length === 4 || hex.length === 7) {
        hex = hex.substr(1);
      }
      if (hex.length === 3) {
        hex = hex.split("");
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      u = parseInt(hex, 16);
      r = u >> 16;
      g = u >> 8 & 0xFF;
      b = u & 0xFF;
      return [r, g, b, 1];
    }
    if (hex.match(/^#?([A-Fa-f0-9]{8})$/)) {
      if (hex.length === 9) {
        hex = hex.substr(1);
      }
      u = parseInt(hex, 16);
      r = u >> 24 & 0xFF;
      g = u >> 16 & 0xFF;
      b = u >> 8 & 0xFF;
      a = round((u & 0xFF) / 0xFF * 100) / 100;
      return [r, g, b, a];
    }
    if ((_input.css != null) && (rgb = _input.css(hex))) {
      return rgb;
    }
    throw "unknown color: " + hex;
  };

  rgb2hex = function(channels, mode) {
    var a, b, g, hxa, r, str, u;
    if (mode == null) {
      mode = 'rgb';
    }
    r = channels[0], g = channels[1], b = channels[2], a = channels[3];
    r = Math.round(r);
    g = Math.round(g);
    b = Math.round(b);
    u = r << 16 | g << 8 | b;
    str = "000000" + u.toString(16);
    str = str.substr(str.length - 6);
    hxa = '0' + round(a * 255).toString(16);
    hxa = hxa.substr(hxa.length - 2);
    return "#" + (function() {
      switch (mode.toLowerCase()) {
        case 'rgba':
          return str + hxa;
        case 'argb':
          return hxa + str;
        default:
          return str;
      }
    })();
  };

  _input.hex = function(h) {
    return hex2rgb(h);
  };

  chroma.hex = function() {
    return (function(func, args, ctor) {
      ctor.prototype = func.prototype;
      var child = new ctor, result = func.apply(child, args);
      return Object(result) === result ? result : child;
    })(Color, slice.call(arguments).concat(['hex']), function(){});
  };

  Color.prototype.hex = function(mode) {
    if (mode == null) {
      mode = 'rgb';
    }
    return rgb2hex(this._rgb, mode);
  };

  _guess_formats.push({
    p: 4,
    test: function(n) {
      if (arguments.length === 1 && type(n) === "string") {
        return 'hex';
      }
    }
  });

  hsl2rgb = function() {
    var args, b, c, g, h, i, l, o, r, ref, s, t1, t2, t3;
    args = unpack(arguments);
    h = args[0], s = args[1], l = args[2];
    if (s === 0) {
      r = g = b = l * 255;
    } else {
      t3 = [0, 0, 0];
      c = [0, 0, 0];
      t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
      t1 = 2 * l - t2;
      h /= 360;
      t3[0] = h + 1 / 3;
      t3[1] = h;
      t3[2] = h - 1 / 3;
      for (i = o = 0; o <= 2; i = ++o) {
        if (t3[i] < 0) {
          t3[i] += 1;
        }
        if (t3[i] > 1) {
          t3[i] -= 1;
        }
        if (6 * t3[i] < 1) {
          c[i] = t1 + (t2 - t1) * 6 * t3[i];
        } else if (2 * t3[i] < 1) {
          c[i] = t2;
        } else if (3 * t3[i] < 2) {
          c[i] = t1 + (t2 - t1) * ((2 / 3) - t3[i]) * 6;
        } else {
          c[i] = t1;
        }
      }
      ref = [round(c[0] * 255), round(c[1] * 255), round(c[2] * 255)], r = ref[0], g = ref[1], b = ref[2];
    }
    if (args.length > 3) {
      return [r, g, b, args[3]];
    } else {
      return [r, g, b];
    }
  };

  rgb2hsl = function(r, g, b) {
    var h, l, min, ref, s;
    if (r !== void 0 && r.length >= 3) {
      ref = r, r = ref[0], g = ref[1], b = ref[2];
    }
    r /= 255;
    g /= 255;
    b /= 255;
    min = Math.min(r, g, b);
    max = Math.max(r, g, b);
    l = (max + min) / 2;
    if (max === min) {
      s = 0;
      h = Number.NaN;
    } else {
      s = l < 0.5 ? (max - min) / (max + min) : (max - min) / (2 - max - min);
    }
    if (r === max) {
      h = (g - b) / (max - min);
    } else if (g === max) {
      h = 2 + (b - r) / (max - min);
    } else if (b === max) {
      h = 4 + (r - g) / (max - min);
    }
    h *= 60;
    if (h < 0) {
      h += 360;
    }
    return [h, s, l];
  };

  chroma.hsl = function() {
    return (function(func, args, ctor) {
      ctor.prototype = func.prototype;
      var child = new ctor, result = func.apply(child, args);
      return Object(result) === result ? result : child;
    })(Color, slice.call(arguments).concat(['hsl']), function(){});
  };

  _input.hsl = hsl2rgb;

  Color.prototype.hsl = function() {
    return rgb2hsl(this._rgb);
  };

  hsv2rgb = function() {
    var args, b, f, g, h, i, p, q, r, ref, ref1, ref2, ref3, ref4, ref5, s, t, v;
    args = unpack(arguments);
    h = args[0], s = args[1], v = args[2];
    v *= 255;
    if (s === 0) {
      r = g = b = v;
    } else {
      if (h === 360) {
        h = 0;
      }
      if (h > 360) {
        h -= 360;
      }
      if (h < 0) {
        h += 360;
      }
      h /= 60;
      i = floor(h);
      f = h - i;
      p = v * (1 - s);
      q = v * (1 - s * f);
      t = v * (1 - s * (1 - f));
      switch (i) {
        case 0:
          ref = [v, t, p], r = ref[0], g = ref[1], b = ref[2];
          break;
        case 1:
          ref1 = [q, v, p], r = ref1[0], g = ref1[1], b = ref1[2];
          break;
        case 2:
          ref2 = [p, v, t], r = ref2[0], g = ref2[1], b = ref2[2];
          break;
        case 3:
          ref3 = [p, q, v], r = ref3[0], g = ref3[1], b = ref3[2];
          break;
        case 4:
          ref4 = [t, p, v], r = ref4[0], g = ref4[1], b = ref4[2];
          break;
        case 5:
          ref5 = [v, p, q], r = ref5[0], g = ref5[1], b = ref5[2];
      }
    }
    return [r, g, b, args.length > 3 ? args[3] : 1];
  };

  rgb2hsv = function() {
    var b, delta, g, h, min, r, ref, s, v;
    ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
    min = Math.min(r, g, b);
    max = Math.max(r, g, b);
    delta = max - min;
    v = max / 255.0;
    if (max === 0) {
      h = Number.NaN;
      s = 0;
    } else {
      s = delta / max;
      if (r === max) {
        h = (g - b) / delta;
      }
      if (g === max) {
        h = 2 + (b - r) / delta;
      }
      if (b === max) {
        h = 4 + (r - g) / delta;
      }
      h *= 60;
      if (h < 0) {
        h += 360;
      }
    }
    return [h, s, v];
  };

  chroma.hsv = function() {
    return (function(func, args, ctor) {
      ctor.prototype = func.prototype;
      var child = new ctor, result = func.apply(child, args);
      return Object(result) === result ? result : child;
    })(Color, slice.call(arguments).concat(['hsv']), function(){});
  };

  _input.hsv = hsv2rgb;

  Color.prototype.hsv = function() {
    return rgb2hsv(this._rgb);
  };

  num2rgb = function(num) {
    var b, g, r;
    if (type(num) === "number" && num >= 0 && num <= 0xFFFFFF) {
      r = num >> 16;
      g = (num >> 8) & 0xFF;
      b = num & 0xFF;
      return [r, g, b, 1];
    }
    console.warn("unknown num color: " + num);
    return [0, 0, 0, 1];
  };

  rgb2num = function() {
    var b, g, r, ref;
    ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
    return (r << 16) + (g << 8) + b;
  };

  chroma.num = function(num) {
    return new Color(num, 'num');
  };

  Color.prototype.num = function(mode) {
    if (mode == null) {
      mode = 'rgb';
    }
    return rgb2num(this._rgb, mode);
  };

  _input.num = num2rgb;

  _guess_formats.push({
    p: 1,
    test: function(n) {
      if (arguments.length === 1 && type(n) === "number" && n >= 0 && n <= 0xFFFFFF) {
        return 'num';
      }
    }
  });

  hcg2rgb = function() {
    var _c, _g, args, b, c, f, g, h, i, p, q, r, ref, ref1, ref2, ref3, ref4, ref5, t, v;
    args = unpack(arguments);
    h = args[0], c = args[1], _g = args[2];
    c = c / 100;
    g = g / 100 * 255;
    _c = c * 255;
    if (c === 0) {
      r = g = b = _g;
    } else {
      if (h === 360) {
        h = 0;
      }
      if (h > 360) {
        h -= 360;
      }
      if (h < 0) {
        h += 360;
      }
      h /= 60;
      i = floor(h);
      f = h - i;
      p = _g * (1 - c);
      q = p + _c * (1 - f);
      t = p + _c * f;
      v = p + _c;
      switch (i) {
        case 0:
          ref = [v, t, p], r = ref[0], g = ref[1], b = ref[2];
          break;
        case 1:
          ref1 = [q, v, p], r = ref1[0], g = ref1[1], b = ref1[2];
          break;
        case 2:
          ref2 = [p, v, t], r = ref2[0], g = ref2[1], b = ref2[2];
          break;
        case 3:
          ref3 = [p, q, v], r = ref3[0], g = ref3[1], b = ref3[2];
          break;
        case 4:
          ref4 = [t, p, v], r = ref4[0], g = ref4[1], b = ref4[2];
          break;
        case 5:
          ref5 = [v, p, q], r = ref5[0], g = ref5[1], b = ref5[2];
      }
    }
    return [r, g, b, args.length > 3 ? args[3] : 1];
  };

  rgb2hcg = function() {
    var _g, b, c, delta, g, h, min, r, ref;
    ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
    min = Math.min(r, g, b);
    max = Math.max(r, g, b);
    delta = max - min;
    c = delta * 100 / 255;
    _g = min / (255 - delta) * 100;
    if (delta === 0) {
      h = Number.NaN;
    } else {
      if (r === max) {
        h = (g - b) / delta;
      }
      if (g === max) {
        h = 2 + (b - r) / delta;
      }
      if (b === max) {
        h = 4 + (r - g) / delta;
      }
      h *= 60;
      if (h < 0) {
        h += 360;
      }
    }
    return [h, c, _g];
  };

  chroma.hcg = function() {
    return (function(func, args, ctor) {
      ctor.prototype = func.prototype;
      var child = new ctor, result = func.apply(child, args);
      return Object(result) === result ? result : child;
    })(Color, slice.call(arguments).concat(['hcg']), function(){});
  };

  _input.hcg = hcg2rgb;

  Color.prototype.hcg = function() {
    return rgb2hcg(this._rgb);
  };

  css2rgb = function(css) {
    var aa, ab, hsl, i, m, o, rgb, w;
    css = css.toLowerCase();
    if ((chroma.colors != null) && chroma.colors[css]) {
      return hex2rgb(chroma.colors[css]);
    }
    if (m = css.match(/rgb\(\s*(\-?\d+),\s*(\-?\d+)\s*,\s*(\-?\d+)\s*\)/)) {
      rgb = m.slice(1, 4);
      for (i = o = 0; o <= 2; i = ++o) {
        rgb[i] = +rgb[i];
      }
      rgb[3] = 1;
    } else if (m = css.match(/rgba\(\s*(\-?\d+),\s*(\-?\d+)\s*,\s*(\-?\d+)\s*,\s*([01]|[01]?\.\d+)\)/)) {
      rgb = m.slice(1, 5);
      for (i = w = 0; w <= 3; i = ++w) {
        rgb[i] = +rgb[i];
      }
    } else if (m = css.match(/rgb\(\s*(\-?\d+(?:\.\d+)?)%,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*\)/)) {
      rgb = m.slice(1, 4);
      for (i = aa = 0; aa <= 2; i = ++aa) {
        rgb[i] = round(rgb[i] * 2.55);
      }
      rgb[3] = 1;
    } else if (m = css.match(/rgba\(\s*(\-?\d+(?:\.\d+)?)%,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)/)) {
      rgb = m.slice(1, 5);
      for (i = ab = 0; ab <= 2; i = ++ab) {
        rgb[i] = round(rgb[i] * 2.55);
      }
      rgb[3] = +rgb[3];
    } else if (m = css.match(/hsl\(\s*(\-?\d+(?:\.\d+)?),\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*\)/)) {
      hsl = m.slice(1, 4);
      hsl[1] *= 0.01;
      hsl[2] *= 0.01;
      rgb = hsl2rgb(hsl);
      rgb[3] = 1;
    } else if (m = css.match(/hsla\(\s*(\-?\d+(?:\.\d+)?),\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)/)) {
      hsl = m.slice(1, 4);
      hsl[1] *= 0.01;
      hsl[2] *= 0.01;
      rgb = hsl2rgb(hsl);
      rgb[3] = +m[4];
    }
    return rgb;
  };

  rgb2css = function(rgba) {
    var mode;
    mode = rgba[3] < 1 ? 'rgba' : 'rgb';
    if (mode === 'rgb') {
      return mode + '(' + rgba.slice(0, 3).map(round).join(',') + ')';
    } else if (mode === 'rgba') {
      return mode + '(' + rgba.slice(0, 3).map(round).join(',') + ',' + rgba[3] + ')';
    } else {

    }
  };

  rnd = function(a) {
    return round(a * 100) / 100;
  };

  hsl2css = function(hsl, alpha) {
    var mode;
    mode = alpha < 1 ? 'hsla' : 'hsl';
    hsl[0] = rnd(hsl[0] || 0);
    hsl[1] = rnd(hsl[1] * 100) + '%';
    hsl[2] = rnd(hsl[2] * 100) + '%';
    if (mode === 'hsla') {
      hsl[3] = alpha;
    }
    return mode + '(' + hsl.join(',') + ')';
  };

  _input.css = function(h) {
    return css2rgb(h);
  };

  chroma.css = function() {
    return (function(func, args, ctor) {
      ctor.prototype = func.prototype;
      var child = new ctor, result = func.apply(child, args);
      return Object(result) === result ? result : child;
    })(Color, slice.call(arguments).concat(['css']), function(){});
  };

  Color.prototype.css = function(mode) {
    if (mode == null) {
      mode = 'rgb';
    }
    if (mode.slice(0, 3) === 'rgb') {
      return rgb2css(this._rgb);
    } else if (mode.slice(0, 3) === 'hsl') {
      return hsl2css(this.hsl(), this.alpha());
    }
  };

  _input.named = function(name) {
    return hex2rgb(w3cx11[name]);
  };

  _guess_formats.push({
    p: 5,
    test: function(n) {
      if (arguments.length === 1 && (w3cx11[n] != null)) {
        return 'named';
      }
    }
  });

  Color.prototype.name = function(n) {
    var h, k;
    if (arguments.length) {
      if (w3cx11[n]) {
        this._rgb = hex2rgb(w3cx11[n]);
      }
      this._rgb[3] = 1;
      this;
    }
    h = this.hex();
    for (k in w3cx11) {
      if (h === w3cx11[k]) {
        return k;
      }
    }
    return h;
  };

  lch2lab = function() {

    /*
    Convert from a qualitative parameter h and a quantitative parameter l to a 24-bit pixel.
    These formulas were invented by David Dalrymple to obtain maximum contrast without going
    out of gamut if the parameters are in the range 0-1.
    
    A saturation multiplier was added by Gregor Aisch
     */
    var c, h, l, ref;
    ref = unpack(arguments), l = ref[0], c = ref[1], h = ref[2];
    h = h * DEG2RAD;
    return [l, cos(h) * c, sin(h) * c];
  };

  lch2rgb = function() {
    var L, a, args, b, c, g, h, l, r, ref, ref1;
    args = unpack(arguments);
    l = args[0], c = args[1], h = args[2];
    ref = lch2lab(l, c, h), L = ref[0], a = ref[1], b = ref[2];
    ref1 = lab2rgb(L, a, b), r = ref1[0], g = ref1[1], b = ref1[2];
    return [r, g, b, args.length > 3 ? args[3] : 1];
  };

  lab2lch = function() {
    var a, b, c, h, l, ref;
    ref = unpack(arguments), l = ref[0], a = ref[1], b = ref[2];
    c = sqrt(a * a + b * b);
    h = (atan2(b, a) * RAD2DEG + 360) % 360;
    if (round(c * 10000) === 0) {
      h = Number.NaN;
    }
    return [l, c, h];
  };

  rgb2lch = function() {
    var a, b, g, l, r, ref, ref1;
    ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
    ref1 = rgb2lab(r, g, b), l = ref1[0], a = ref1[1], b = ref1[2];
    return lab2lch(l, a, b);
  };

  chroma.lch = function() {
    var args;
    args = unpack(arguments);
    return new Color(args, 'lch');
  };

  chroma.hcl = function() {
    var args;
    args = unpack(arguments);
    return new Color(args, 'hcl');
  };

  _input.lch = lch2rgb;

  _input.hcl = function() {
    var c, h, l, ref;
    ref = unpack(arguments), h = ref[0], c = ref[1], l = ref[2];
    return lch2rgb([l, c, h]);
  };

  Color.prototype.lch = function() {
    return rgb2lch(this._rgb);
  };

  Color.prototype.hcl = function() {
    return rgb2lch(this._rgb).reverse();
  };

  rgb2cmyk = function(mode) {
    var b, c, f, g, k, m, r, ref, y;
    if (mode == null) {
      mode = 'rgb';
    }
    ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
    r = r / 255;
    g = g / 255;
    b = b / 255;
    k = 1 - Math.max(r, Math.max(g, b));
    f = k < 1 ? 1 / (1 - k) : 0;
    c = (1 - r - k) * f;
    m = (1 - g - k) * f;
    y = (1 - b - k) * f;
    return [c, m, y, k];
  };

  cmyk2rgb = function() {
    var alpha, args, b, c, g, k, m, r, y;
    args = unpack(arguments);
    c = args[0], m = args[1], y = args[2], k = args[3];
    alpha = args.length > 4 ? args[4] : 1;
    if (k === 1) {
      return [0, 0, 0, alpha];
    }
    r = c >= 1 ? 0 : 255 * (1 - c) * (1 - k);
    g = m >= 1 ? 0 : 255 * (1 - m) * (1 - k);
    b = y >= 1 ? 0 : 255 * (1 - y) * (1 - k);
    return [r, g, b, alpha];
  };

  _input.cmyk = function() {
    return cmyk2rgb(unpack(arguments));
  };

  chroma.cmyk = function() {
    return (function(func, args, ctor) {
      ctor.prototype = func.prototype;
      var child = new ctor, result = func.apply(child, args);
      return Object(result) === result ? result : child;
    })(Color, slice.call(arguments).concat(['cmyk']), function(){});
  };

  Color.prototype.cmyk = function() {
    return rgb2cmyk(this._rgb);
  };

  _input.gl = function() {
    var i, k, o, rgb, v;
    rgb = (function() {
      var ref, results;
      ref = unpack(arguments);
      results = [];
      for (k in ref) {
        v = ref[k];
        results.push(v);
      }
      return results;
    }).apply(this, arguments);
    for (i = o = 0; o <= 2; i = ++o) {
      rgb[i] *= 255;
    }
    return rgb;
  };

  chroma.gl = function() {
    return (function(func, args, ctor) {
      ctor.prototype = func.prototype;
      var child = new ctor, result = func.apply(child, args);
      return Object(result) === result ? result : child;
    })(Color, slice.call(arguments).concat(['gl']), function(){});
  };

  Color.prototype.gl = function() {
    var rgb;
    rgb = this._rgb;
    return [rgb[0] / 255, rgb[1] / 255, rgb[2] / 255, rgb[3]];
  };

  rgb2luminance = function(r, g, b) {
    var ref;
    ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
    r = luminance_x(r);
    g = luminance_x(g);
    b = luminance_x(b);
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
  };

  luminance_x = function(x) {
    x /= 255;
    if (x <= 0.03928) {
      return x / 12.92;
    } else {
      return pow((x + 0.055) / 1.055, 2.4);
    }
  };

  interpolate_rgb = function(col1, col2, f, m) {
    var xyz0, xyz1;
    xyz0 = col1._rgb;
    xyz1 = col2._rgb;
    return new Color(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), m);
  };

  _interpolators.push(['rgb', interpolate_rgb]);

  Color.prototype.luminance = function(lum, mode) {
    var cur_lum, eps, max_iter, test;
    if (mode == null) {
      mode = 'rgb';
    }
    if (!arguments.length) {
      return rgb2luminance(this._rgb);
    }
    if (lum === 0) {
      this._rgb = [0, 0, 0, this._rgb[3]];
    } else if (lum === 1) {
      this._rgb = [255, 255, 255, this._rgb[3]];
    } else {
      eps = 1e-7;
      max_iter = 20;
      test = function(l, h) {
        var lm, m;
        m = l.interpolate(h, 0.5, mode);
        lm = m.luminance();
        if (Math.abs(lum - lm) < eps || !max_iter--) {
          return m;
        }
        if (lm > lum) {
          return test(l, m);
        }
        return test(m, h);
      };
      cur_lum = rgb2luminance(this._rgb);
      this._rgb = (cur_lum > lum ? test(chroma('black'), this) : test(this, chroma('white'))).rgba();
    }
    return this;
  };

  temperature2rgb = function(kelvin) {
    var b, g, r, temp;
    temp = kelvin / 100;
    if (temp < 66) {
      r = 255;
      g = -155.25485562709179 - 0.44596950469579133 * (g = temp - 2) + 104.49216199393888 * log(g);
      b = temp < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (b = temp - 10) + 115.67994401066147 * log(b);
    } else {
      r = 351.97690566805693 + 0.114206453784165 * (r = temp - 55) - 40.25366309332127 * log(r);
      g = 325.4494125711974 + 0.07943456536662342 * (g = temp - 50) - 28.0852963507957 * log(g);
      b = 255;
    }
    return [r, g, b];
  };

  rgb2temperature = function() {
    var b, eps, g, maxTemp, minTemp, r, ref, rgb, temp;
    ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
    minTemp = 1000;
    maxTemp = 40000;
    eps = 0.4;
    while (maxTemp - minTemp > eps) {
      temp = (maxTemp + minTemp) * 0.5;
      rgb = temperature2rgb(temp);
      if ((rgb[2] / rgb[0]) >= (b / r)) {
        maxTemp = temp;
      } else {
        minTemp = temp;
      }
    }
    return round(temp);
  };

  chroma.temperature = chroma.kelvin = function() {
    return (function(func, args, ctor) {
      ctor.prototype = func.prototype;
      var child = new ctor, result = func.apply(child, args);
      return Object(result) === result ? result : child;
    })(Color, slice.call(arguments).concat(['temperature']), function(){});
  };

  _input.temperature = _input.kelvin = _input.K = temperature2rgb;

  Color.prototype.temperature = function() {
    return rgb2temperature(this._rgb);
  };

  Color.prototype.kelvin = Color.prototype.temperature;

  chroma.contrast = function(a, b) {
    var l1, l2, ref, ref1;
    if ((ref = type(a)) === 'string' || ref === 'number') {
      a = new Color(a);
    }
    if ((ref1 = type(b)) === 'string' || ref1 === 'number') {
      b = new Color(b);
    }
    l1 = a.luminance();
    l2 = b.luminance();
    if (l1 > l2) {
      return (l1 + 0.05) / (l2 + 0.05);
    } else {
      return (l2 + 0.05) / (l1 + 0.05);
    }
  };

  chroma.distance = function(a, b, mode) {
    var d, i, l1, l2, ref, ref1, sum_sq;
    if (mode == null) {
      mode = 'lab';
    }
    if ((ref = type(a)) === 'string' || ref === 'number') {
      a = new Color(a);
    }
    if ((ref1 = type(b)) === 'string' || ref1 === 'number') {
      b = new Color(b);
    }
    l1 = a.get(mode);
    l2 = b.get(mode);
    sum_sq = 0;
    for (i in l1) {
      d = (l1[i] || 0) - (l2[i] || 0);
      sum_sq += d * d;
    }
    return Math.sqrt(sum_sq);
  };

  chroma.deltaE = function(a, b, L, C) {
    var L1, L2, a1, a2, b1, b2, c1, c2, c4, dH2, delA, delB, delC, delL, f, h1, ref, ref1, ref2, ref3, sc, sh, sl, t, v1, v2, v3;
    if (L == null) {
      L = 1;
    }
    if (C == null) {
      C = 1;
    }
    if ((ref = type(a)) === 'string' || ref === 'number') {
      a = new Color(a);
    }
    if ((ref1 = type(b)) === 'string' || ref1 === 'number') {
      b = new Color(b);
    }
    ref2 = a.lab(), L1 = ref2[0], a1 = ref2[1], b1 = ref2[2];
    ref3 = b.lab(), L2 = ref3[0], a2 = ref3[1], b2 = ref3[2];
    c1 = sqrt(a1 * a1 + b1 * b1);
    c2 = sqrt(a2 * a2 + b2 * b2);
    sl = L1 < 16.0 ? 0.511 : (0.040975 * L1) / (1.0 + 0.01765 * L1);
    sc = (0.0638 * c1) / (1.0 + 0.0131 * c1) + 0.638;
    h1 = c1 < 0.000001 ? 0.0 : (atan2(b1, a1) * 180.0) / PI;
    while (h1 < 0) {
      h1 += 360;
    }
    while (h1 >= 360) {
      h1 -= 360;
    }
    t = (h1 >= 164.0) && (h1 <= 345.0) ? 0.56 + abs(0.2 * cos((PI * (h1 + 168.0)) / 180.0)) : 0.36 + abs(0.4 * cos((PI * (h1 + 35.0)) / 180.0));
    c4 = c1 * c1 * c1 * c1;
    f = sqrt(c4 / (c4 + 1900.0));
    sh = sc * (f * t + 1.0 - f);
    delL = L1 - L2;
    delC = c1 - c2;
    delA = a1 - a2;
    delB = b1 - b2;
    dH2 = delA * delA + delB * delB - delC * delC;
    v1 = delL / (L * sl);
    v2 = delC / (C * sc);
    v3 = sh;
    return sqrt(v1 * v1 + v2 * v2 + (dH2 / (v3 * v3)));
  };

  Color.prototype.get = function(modechan) {
    var channel, i, me, mode, ref, src;
    me = this;
    ref = modechan.split('.'), mode = ref[0], channel = ref[1];
    src = me[mode]();
    if (channel) {
      i = mode.indexOf(channel);
      if (i > -1) {
        return src[i];
      } else {
        return console.warn('unknown channel ' + channel + ' in mode ' + mode);
      }
    } else {
      return src;
    }
  };

  Color.prototype.set = function(modechan, value) {
    var channel, i, me, mode, ref, src;
    me = this;
    ref = modechan.split('.'), mode = ref[0], channel = ref[1];
    if (channel) {
      src = me[mode]();
      i = mode.indexOf(channel);
      if (i > -1) {
        if (type(value) === 'string') {
          switch (value.charAt(0)) {
            case '+':
              src[i] += +value;
              break;
            case '-':
              src[i] += +value;
              break;
            case '*':
              src[i] *= +(value.substr(1));
              break;
            case '/':
              src[i] /= +(value.substr(1));
              break;
            default:
              src[i] = +value;
          }
        } else {
          src[i] = value;
        }
      } else {
        console.warn('unknown channel ' + channel + ' in mode ' + mode);
      }
    } else {
      src = value;
    }
    return chroma(src, mode).alpha(me.alpha());
  };

  Color.prototype.clipped = function() {
    return this._rgb._clipped || false;
  };

  Color.prototype.alpha = function(a) {
    if (arguments.length) {
      return chroma.rgb([this._rgb[0], this._rgb[1], this._rgb[2], a]);
    }
    return this._rgb[3];
  };

  Color.prototype.darken = function(amount) {
    var lab, me;
    if (amount == null) {
      amount = 1;
    }
    me = this;
    lab = me.lab();
    lab[0] -= LAB_CONSTANTS.Kn * amount;
    return chroma.lab(lab).alpha(me.alpha());
  };

  Color.prototype.brighten = function(amount) {
    if (amount == null) {
      amount = 1;
    }
    return this.darken(-amount);
  };

  Color.prototype.darker = Color.prototype.darken;

  Color.prototype.brighter = Color.prototype.brighten;

  Color.prototype.saturate = function(amount) {
    var lch, me;
    if (amount == null) {
      amount = 1;
    }
    me = this;
    lch = me.lch();
    lch[1] += amount * LAB_CONSTANTS.Kn;
    if (lch[1] < 0) {
      lch[1] = 0;
    }
    return chroma.lch(lch).alpha(me.alpha());
  };

  Color.prototype.desaturate = function(amount) {
    if (amount == null) {
      amount = 1;
    }
    return this.saturate(-amount);
  };

  Color.prototype.premultiply = function() {
    var a, rgb;
    rgb = this.rgb();
    a = this.alpha();
    return chroma(rgb[0] * a, rgb[1] * a, rgb[2] * a, a);
  };

  blend = function(bottom, top, mode) {
    if (!blend[mode]) {
      throw 'unknown blend mode ' + mode;
    }
    return blend[mode](bottom, top);
  };

  blend_f = function(f) {
    return function(bottom, top) {
      var c0, c1;
      c0 = chroma(top).rgb();
      c1 = chroma(bottom).rgb();
      return chroma(f(c0, c1), 'rgb');
    };
  };

  each = function(f) {
    return function(c0, c1) {
      var i, o, out;
      out = [];
      for (i = o = 0; o <= 3; i = ++o) {
        out[i] = f(c0[i], c1[i]);
      }
      return out;
    };
  };

  normal = function(a, b) {
    return a;
  };

  multiply = function(a, b) {
    return a * b / 255;
  };

  darken = function(a, b) {
    if (a > b) {
      return b;
    } else {
      return a;
    }
  };

  lighten = function(a, b) {
    if (a > b) {
      return a;
    } else {
      return b;
    }
  };

  screen = function(a, b) {
    return 255 * (1 - (1 - a / 255) * (1 - b / 255));
  };

  overlay = function(a, b) {
    if (b < 128) {
      return 2 * a * b / 255;
    } else {
      return 255 * (1 - 2 * (1 - a / 255) * (1 - b / 255));
    }
  };

  burn = function(a, b) {
    return 255 * (1 - (1 - b / 255) / (a / 255));
  };

  dodge = function(a, b) {
    if (a === 255) {
      return 255;
    }
    a = 255 * (b / 255) / (1 - a / 255);
    if (a > 255) {
      return 255;
    } else {
      return a;
    }
  };

  blend.normal = blend_f(each(normal));

  blend.multiply = blend_f(each(multiply));

  blend.screen = blend_f(each(screen));

  blend.overlay = blend_f(each(overlay));

  blend.darken = blend_f(each(darken));

  blend.lighten = blend_f(each(lighten));

  blend.dodge = blend_f(each(dodge));

  blend.burn = blend_f(each(burn));

  chroma.blend = blend;

  chroma.analyze = function(data) {
    var len, o, r, val;
    r = {
      min: Number.MAX_VALUE,
      max: Number.MAX_VALUE * -1,
      sum: 0,
      values: [],
      count: 0
    };
    for (o = 0, len = data.length; o < len; o++) {
      val = data[o];
      if ((val != null) && !isNaN(val)) {
        r.values.push(val);
        r.sum += val;
        if (val < r.min) {
          r.min = val;
        }
        if (val > r.max) {
          r.max = val;
        }
        r.count += 1;
      }
    }
    r.domain = [r.min, r.max];
    r.limits = function(mode, num) {
      return chroma.limits(r, mode, num);
    };
    return r;
  };

  chroma.scale = function(colors, positions) {
    var _classes, _colorCache, _colors, _correctLightness, _domain, _fixed, _gamma, _max, _min, _mode, _nacol, _out, _padding, _pos, _spread, _useCache, classifyValue, f, getClass, getColor, resetCache, setColors, tmap;
    _mode = 'rgb';
    _nacol = chroma('#ccc');
    _spread = 0;
    _fixed = false;
    _domain = [0, 1];
    _pos = [];
    _padding = [0, 0];
    _classes = false;
    _colors = [];
    _out = false;
    _min = 0;
    _max = 1;
    _correctLightness = false;
    _colorCache = {};
    _useCache = true;
    _gamma = 1;
    setColors = function(colors) {
      var c, col, o, ref, ref1, w;
      if (colors == null) {
        colors = ['#fff', '#000'];
      }
      if ((colors != null) && type(colors) === 'string' && (chroma.brewer != null)) {
        colors = chroma.brewer[colors] || chroma.brewer[colors.toLowerCase()] || colors;
      }
      if (type(colors) === 'array') {
        colors = colors.slice(0);
        for (c = o = 0, ref = colors.length - 1; 0 <= ref ? o <= ref : o >= ref; c = 0 <= ref ? ++o : --o) {
          col = colors[c];
          if (type(col) === "string") {
            colors[c] = chroma(col);
          }
        }
        _pos.length = 0;
        for (c = w = 0, ref1 = colors.length - 1; 0 <= ref1 ? w <= ref1 : w >= ref1; c = 0 <= ref1 ? ++w : --w) {
          _pos.push(c / (colors.length - 1));
        }
      }
      resetCache();
      return _colors = colors;
    };
    getClass = function(value) {
      var i, n;
      if (_classes != null) {
        n = _classes.length - 1;
        i = 0;
        while (i < n && value >= _classes[i]) {
          i++;
        }
        return i - 1;
      }
      return 0;
    };
    tmap = function(t) {
      return t;
    };
    classifyValue = function(value) {
      var i, maxc, minc, n, val;
      val = value;
      if (_classes.length > 2) {
        n = _classes.length - 1;
        i = getClass(value);
        minc = _classes[0] + (_classes[1] - _classes[0]) * (0 + _spread * 0.5);
        maxc = _classes[n - 1] + (_classes[n] - _classes[n - 1]) * (1 - _spread * 0.5);
        val = _min + ((_classes[i] + (_classes[i + 1] - _classes[i]) * 0.5 - minc) / (maxc - minc)) * (_max - _min);
      }
      return val;
    };
    getColor = function(val, bypassMap) {
      var c, col, i, k, o, p, ref, t;
      if (bypassMap == null) {
        bypassMap = false;
      }
      if (isNaN(val)) {
        return _nacol;
      }
      if (!bypassMap) {
        if (_classes && _classes.length > 2) {
          c = getClass(val);
          t = c / (_classes.length - 2);
        } else if (_max !== _min) {
          t = (val - _min) / (_max - _min);
        } else {
          t = 1;
        }
      } else {
        t = val;
      }
      if (!bypassMap) {
        t = tmap(t);
      }
      if (_gamma !== 1) {
        t = pow(t, _gamma);
      }
      t = _padding[0] + (t * (1 - _padding[0] - _padding[1]));
      t = Math.min(1, Math.max(0, t));
      k = Math.floor(t * 10000);
      if (_useCache && _colorCache[k]) {
        col = _colorCache[k];
      } else {
        if (type(_colors) === 'array') {
          for (i = o = 0, ref = _pos.length - 1; 0 <= ref ? o <= ref : o >= ref; i = 0 <= ref ? ++o : --o) {
            p = _pos[i];
            if (t <= p) {
              col = _colors[i];
              break;
            }
            if (t >= p && i === _pos.length - 1) {
              col = _colors[i];
              break;
            }
            if (t > p && t < _pos[i + 1]) {
              t = (t - p) / (_pos[i + 1] - p);
              col = chroma.interpolate(_colors[i], _colors[i + 1], t, _mode);
              break;
            }
          }
        } else if (type(_colors) === 'function') {
          col = _colors(t);
        }
        if (_useCache) {
          _colorCache[k] = col;
        }
      }
      return col;
    };
    resetCache = function() {
      return _colorCache = {};
    };
    setColors(colors);
    f = function(v) {
      var c;
      c = chroma(getColor(v));
      if (_out && c[_out]) {
        return c[_out]();
      } else {
        return c;
      }
    };
    f.classes = function(classes) {
      var d;
      if (classes != null) {
        if (type(classes) === 'array') {
          _classes = classes;
          _domain = [classes[0], classes[classes.length - 1]];
        } else {
          d = chroma.analyze(_domain);
          if (classes === 0) {
            _classes = [d.min, d.max];
          } else {
            _classes = chroma.limits(d, 'e', classes);
          }
        }
        return f;
      }
      return _classes;
    };
    f.domain = function(domain) {
      var c, d, k, len, o, ref, w;
      if (!arguments.length) {
        return _domain;
      }
      _min = domain[0];
      _max = domain[domain.length - 1];
      _pos = [];
      k = _colors.length;
      if (domain.length === k && _min !== _max) {
        for (o = 0, len = domain.length; o < len; o++) {
          d = domain[o];
          _pos.push((d - _min) / (_max - _min));
        }
      } else {
        for (c = w = 0, ref = k - 1; 0 <= ref ? w <= ref : w >= ref; c = 0 <= ref ? ++w : --w) {
          _pos.push(c / (k - 1));
        }
      }
      _domain = [_min, _max];
      return f;
    };
    f.mode = function(_m) {
      if (!arguments.length) {
        return _mode;
      }
      _mode = _m;
      resetCache();
      return f;
    };
    f.range = function(colors, _pos) {
      setColors(colors, _pos);
      return f;
    };
    f.out = function(_o) {
      _out = _o;
      return f;
    };
    f.spread = function(val) {
      if (!arguments.length) {
        return _spread;
      }
      _spread = val;
      return f;
    };
    f.correctLightness = function(v) {
      if (v == null) {
        v = true;
      }
      _correctLightness = v;
      resetCache();
      if (_correctLightness) {
        tmap = function(t) {
          var L0, L1, L_actual, L_diff, L_ideal, max_iter, pol, t0, t1;
          L0 = getColor(0, true).lab()[0];
          L1 = getColor(1, true).lab()[0];
          pol = L0 > L1;
          L_actual = getColor(t, true).lab()[0];
          L_ideal = L0 + (L1 - L0) * t;
          L_diff = L_actual - L_ideal;
          t0 = 0;
          t1 = 1;
          max_iter = 20;
          while (Math.abs(L_diff) > 1e-2 && max_iter-- > 0) {
            (function() {
              if (pol) {
                L_diff *= -1;
              }
              if (L_diff < 0) {
                t0 = t;
                t += (t1 - t) * 0.5;
              } else {
                t1 = t;
                t += (t0 - t) * 0.5;
              }
              L_actual = getColor(t, true).lab()[0];
              return L_diff = L_actual - L_ideal;
            })();
          }
          return t;
        };
      } else {
        tmap = function(t) {
          return t;
        };
      }
      return f;
    };
    f.padding = function(p) {
      if (p != null) {
        if (type(p) === 'number') {
          p = [p, p];
        }
        _padding = p;
        return f;
      } else {
        return _padding;
      }
    };
    f.colors = function(numColors, out) {
      var dd, dm, i, o, ref, result, results, samples, w;
      if (arguments.length < 2) {
        out = 'hex';
      }
      result = [];
      if (arguments.length === 0) {
        result = _colors.slice(0);
      } else if (numColors === 1) {
        result = [f(0.5)];
      } else if (numColors > 1) {
        dm = _domain[0];
        dd = _domain[1] - dm;
        result = (function() {
          results = [];
          for (var o = 0; 0 <= numColors ? o < numColors : o > numColors; 0 <= numColors ? o++ : o--){ results.push(o); }
          return results;
        }).apply(this).map(function(i) {
          return f(dm + i / (numColors - 1) * dd);
        });
      } else {
        colors = [];
        samples = [];
        if (_classes && _classes.length > 2) {
          for (i = w = 1, ref = _classes.length; 1 <= ref ? w < ref : w > ref; i = 1 <= ref ? ++w : --w) {
            samples.push((_classes[i - 1] + _classes[i]) * 0.5);
          }
        } else {
          samples = _domain;
        }
        result = samples.map(function(v) {
          return f(v);
        });
      }
      if (chroma[out]) {
        result = result.map(function(c) {
          return c[out]();
        });
      }
      return result;
    };
    f.cache = function(c) {
      if (c != null) {
        _useCache = c;
        return f;
      } else {
        return _useCache;
      }
    };
    f.gamma = function(g) {
      if (g != null) {
        _gamma = g;
        return f;
      } else {
        return _gamma;
      }
    };
    return f;
  };

  if (chroma.scales == null) {
    chroma.scales = {};
  }

  chroma.scales.cool = function() {
    return chroma.scale([chroma.hsl(180, 1, .9), chroma.hsl(250, .7, .4)]);
  };

  chroma.scales.hot = function() {
    return chroma.scale(['#000', '#f00', '#ff0', '#fff'], [0, .25, .75, 1]).mode('rgb');
  };

  chroma.analyze = function(data, key, filter) {
    var add, k, len, o, r, val, visit;
    r = {
      min: Number.MAX_VALUE,
      max: Number.MAX_VALUE * -1,
      sum: 0,
      values: [],
      count: 0
    };
    if (filter == null) {
      filter = function() {
        return true;
      };
    }
    add = function(val) {
      if ((val != null) && !isNaN(val)) {
        r.values.push(val);
        r.sum += val;
        if (val < r.min) {
          r.min = val;
        }
        if (val > r.max) {
          r.max = val;
        }
        r.count += 1;
      }
    };
    visit = function(val, k) {
      if (filter(val, k)) {
        if ((key != null) && type(key) === 'function') {
          return add(key(val));
        } else if ((key != null) && type(key) === 'string' || type(key) === 'number') {
          return add(val[key]);
        } else {
          return add(val);
        }
      }
    };
    if (type(data) === 'array') {
      for (o = 0, len = data.length; o < len; o++) {
        val = data[o];
        visit(val);
      }
    } else {
      for (k in data) {
        val = data[k];
        visit(val, k);
      }
    }
    r.domain = [r.min, r.max];
    r.limits = function(mode, num) {
      return chroma.limits(r, mode, num);
    };
    return r;
  };

  chroma.limits = function(data, mode, num) {
    var aa, ab, ac, ad, ae, af, ag, ah, ai, aj, ak, al, am, assignments, best, centroids, cluster, clusterSizes, dist, i, j, kClusters, limits, max_log, min, min_log, mindist, n, nb_iters, newCentroids, o, p, pb, pr, ref, ref1, ref10, ref11, ref12, ref13, ref14, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, repeat, sum, tmpKMeansBreaks, v, value, values, w;
    if (mode == null) {
      mode = 'equal';
    }
    if (num == null) {
      num = 7;
    }
    if (type(data) === 'array') {
      data = chroma.analyze(data);
    }
    min = data.min;
    max = data.max;
    sum = data.sum;
    values = data.values.sort(function(a, b) {
      return a - b;
    });
    if (num === 1) {
      return [min, max];
    }
    limits = [];
    if (mode.substr(0, 1) === 'c') {
      limits.push(min);
      limits.push(max);
    }
    if (mode.substr(0, 1) === 'e') {
      limits.push(min);
      for (i = o = 1, ref = num - 1; 1 <= ref ? o <= ref : o >= ref; i = 1 <= ref ? ++o : --o) {
        limits.push(min + (i / num) * (max - min));
      }
      limits.push(max);
    } else if (mode.substr(0, 1) === 'l') {
      if (min <= 0) {
        throw 'Logarithmic scales are only possible for values > 0';
      }
      min_log = Math.LOG10E * log(min);
      max_log = Math.LOG10E * log(max);
      limits.push(min);
      for (i = w = 1, ref1 = num - 1; 1 <= ref1 ? w <= ref1 : w >= ref1; i = 1 <= ref1 ? ++w : --w) {
        limits.push(pow(10, min_log + (i / num) * (max_log - min_log)));
      }
      limits.push(max);
    } else if (mode.substr(0, 1) === 'q') {
      limits.push(min);
      for (i = aa = 1, ref2 = num - 1; 1 <= ref2 ? aa <= ref2 : aa >= ref2; i = 1 <= ref2 ? ++aa : --aa) {
        p = (values.length - 1) * i / num;
        pb = floor(p);
        if (pb === p) {
          limits.push(values[pb]);
        } else {
          pr = p - pb;
          limits.push(values[pb] * (1 - pr) + values[pb + 1] * pr);
        }
      }
      limits.push(max);
    } else if (mode.substr(0, 1) === 'k') {

      /*
      implementation based on
      http://code.google.com/p/figue/source/browse/trunk/figue.js#336
      simplified for 1-d input values
       */
      n = values.length;
      assignments = new Array(n);
      clusterSizes = new Array(num);
      repeat = true;
      nb_iters = 0;
      centroids = null;
      centroids = [];
      centroids.push(min);
      for (i = ab = 1, ref3 = num - 1; 1 <= ref3 ? ab <= ref3 : ab >= ref3; i = 1 <= ref3 ? ++ab : --ab) {
        centroids.push(min + (i / num) * (max - min));
      }
      centroids.push(max);
      while (repeat) {
        for (j = ac = 0, ref4 = num - 1; 0 <= ref4 ? ac <= ref4 : ac >= ref4; j = 0 <= ref4 ? ++ac : --ac) {
          clusterSizes[j] = 0;
        }
        for (i = ad = 0, ref5 = n - 1; 0 <= ref5 ? ad <= ref5 : ad >= ref5; i = 0 <= ref5 ? ++ad : --ad) {
          value = values[i];
          mindist = Number.MAX_VALUE;
          for (j = ae = 0, ref6 = num - 1; 0 <= ref6 ? ae <= ref6 : ae >= ref6; j = 0 <= ref6 ? ++ae : --ae) {
            dist = abs(centroids[j] - value);
            if (dist < mindist) {
              mindist = dist;
              best = j;
            }
          }
          clusterSizes[best]++;
          assignments[i] = best;
        }
        newCentroids = new Array(num);
        for (j = af = 0, ref7 = num - 1; 0 <= ref7 ? af <= ref7 : af >= ref7; j = 0 <= ref7 ? ++af : --af) {
          newCentroids[j] = null;
        }
        for (i = ag = 0, ref8 = n - 1; 0 <= ref8 ? ag <= ref8 : ag >= ref8; i = 0 <= ref8 ? ++ag : --ag) {
          cluster = assignments[i];
          if (newCentroids[cluster] === null) {
            newCentroids[cluster] = values[i];
          } else {
            newCentroids[cluster] += values[i];
          }
        }
        for (j = ah = 0, ref9 = num - 1; 0 <= ref9 ? ah <= ref9 : ah >= ref9; j = 0 <= ref9 ? ++ah : --ah) {
          newCentroids[j] *= 1 / clusterSizes[j];
        }
        repeat = false;
        for (j = ai = 0, ref10 = num - 1; 0 <= ref10 ? ai <= ref10 : ai >= ref10; j = 0 <= ref10 ? ++ai : --ai) {
          if (newCentroids[j] !== centroids[i]) {
            repeat = true;
            break;
          }
        }
        centroids = newCentroids;
        nb_iters++;
        if (nb_iters > 200) {
          repeat = false;
        }
      }
      kClusters = {};
      for (j = aj = 0, ref11 = num - 1; 0 <= ref11 ? aj <= ref11 : aj >= ref11; j = 0 <= ref11 ? ++aj : --aj) {
        kClusters[j] = [];
      }
      for (i = ak = 0, ref12 = n - 1; 0 <= ref12 ? ak <= ref12 : ak >= ref12; i = 0 <= ref12 ? ++ak : --ak) {
        cluster = assignments[i];
        kClusters[cluster].push(values[i]);
      }
      tmpKMeansBreaks = [];
      for (j = al = 0, ref13 = num - 1; 0 <= ref13 ? al <= ref13 : al >= ref13; j = 0 <= ref13 ? ++al : --al) {
        tmpKMeansBreaks.push(kClusters[j][0]);
        tmpKMeansBreaks.push(kClusters[j][kClusters[j].length - 1]);
      }
      tmpKMeansBreaks = tmpKMeansBreaks.sort(function(a, b) {
        return a - b;
      });
      limits.push(tmpKMeansBreaks[0]);
      for (i = am = 1, ref14 = tmpKMeansBreaks.length - 1; am <= ref14; i = am += 2) {
        v = tmpKMeansBreaks[i];
        if (!isNaN(v) && limits.indexOf(v) === -1) {
          limits.push(v);
        }
      }
    }
    return limits;
  };

  hsi2rgb = function(h, s, i) {

    /*
    borrowed from here:
    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/hsi2rgb.cpp
     */
    var args, b, g, r;
    args = unpack(arguments);
    h = args[0], s = args[1], i = args[2];
    if (isNaN(h)) {
      h = 0;
    }
    h /= 360;
    if (h < 1 / 3) {
      b = (1 - s) / 3;
      r = (1 + s * cos(TWOPI * h) / cos(PITHIRD - TWOPI * h)) / 3;
      g = 1 - (b + r);
    } else if (h < 2 / 3) {
      h -= 1 / 3;
      r = (1 - s) / 3;
      g = (1 + s * cos(TWOPI * h) / cos(PITHIRD - TWOPI * h)) / 3;
      b = 1 - (r + g);
    } else {
      h -= 2 / 3;
      g = (1 - s) / 3;
      b = (1 + s * cos(TWOPI * h) / cos(PITHIRD - TWOPI * h)) / 3;
      r = 1 - (g + b);
    }
    r = limit(i * r * 3);
    g = limit(i * g * 3);
    b = limit(i * b * 3);
    return [r * 255, g * 255, b * 255, args.length > 3 ? args[3] : 1];
  };

  rgb2hsi = function() {

    /*
    borrowed from here:
    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/rgb2hsi.cpp
     */
    var b, g, h, i, min, r, ref, s;
    ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
    TWOPI = Math.PI * 2;
    r /= 255;
    g /= 255;
    b /= 255;
    min = Math.min(r, g, b);
    i = (r + g + b) / 3;
    s = 1 - min / i;
    if (s === 0) {
      h = 0;
    } else {
      h = ((r - g) + (r - b)) / 2;
      h /= Math.sqrt((r - g) * (r - g) + (r - b) * (g - b));
      h = Math.acos(h);
      if (b > g) {
        h = TWOPI - h;
      }
      h /= TWOPI;
    }
    return [h * 360, s, i];
  };

  chroma.hsi = function() {
    return (function(func, args, ctor) {
      ctor.prototype = func.prototype;
      var child = new ctor, result = func.apply(child, args);
      return Object(result) === result ? result : child;
    })(Color, slice.call(arguments).concat(['hsi']), function(){});
  };

  _input.hsi = hsi2rgb;

  Color.prototype.hsi = function() {
    return rgb2hsi(this._rgb);
  };

  interpolate_hsx = function(col1, col2, f, m) {
    var dh, hue, hue0, hue1, lbv, lbv0, lbv1, res, sat, sat0, sat1, xyz0, xyz1;
    if (m === 'hsl') {
      xyz0 = col1.hsl();
      xyz1 = col2.hsl();
    } else if (m === 'hsv') {
      xyz0 = col1.hsv();
      xyz1 = col2.hsv();
    } else if (m === 'hcg') {
      xyz0 = col1.hcg();
      xyz1 = col2.hcg();
    } else if (m === 'hsi') {
      xyz0 = col1.hsi();
      xyz1 = col2.hsi();
    } else if (m === 'lch' || m === 'hcl') {
      m = 'hcl';
      xyz0 = col1.hcl();
      xyz1 = col2.hcl();
    }
    if (m.substr(0, 1) === 'h') {
      hue0 = xyz0[0], sat0 = xyz0[1], lbv0 = xyz0[2];
      hue1 = xyz1[0], sat1 = xyz1[1], lbv1 = xyz1[2];
    }
    if (!isNaN(hue0) && !isNaN(hue1)) {
      if (hue1 > hue0 && hue1 - hue0 > 180) {
        dh = hue1 - (hue0 + 360);
      } else if (hue1 < hue0 && hue0 - hue1 > 180) {
        dh = hue1 + 360 - hue0;
      } else {
        dh = hue1 - hue0;
      }
      hue = hue0 + f * dh;
    } else if (!isNaN(hue0)) {
      hue = hue0;
      if ((lbv1 === 1 || lbv1 === 0) && m !== 'hsv') {
        sat = sat0;
      }
    } else if (!isNaN(hue1)) {
      hue = hue1;
      if ((lbv0 === 1 || lbv0 === 0) && m !== 'hsv') {
        sat = sat1;
      }
    } else {
      hue = Number.NaN;
    }
    if (sat == null) {
      sat = sat0 + f * (sat1 - sat0);
    }
    lbv = lbv0 + f * (lbv1 - lbv0);
    return res = chroma[m](hue, sat, lbv);
  };

  _interpolators = _interpolators.concat((function() {
    var len, o, ref, results;
    ref = ['hsv', 'hsl', 'hsi', 'hcl', 'lch', 'hcg'];
    results = [];
    for (o = 0, len = ref.length; o < len; o++) {
      m = ref[o];
      results.push([m, interpolate_hsx]);
    }
    return results;
  })());

  interpolate_num = function(col1, col2, f, m) {
    var n1, n2;
    n1 = col1.num();
    n2 = col2.num();
    return chroma.num(n1 + (n2 - n1) * f, 'num');
  };

  _interpolators.push(['num', interpolate_num]);

  interpolate_lab = function(col1, col2, f, m) {
    var res, xyz0, xyz1;
    xyz0 = col1.lab();
    xyz1 = col2.lab();
    return res = new Color(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), m);
  };

  _interpolators.push(['lab', interpolate_lab]);

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47)(module)))

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(8), __webpack_require__(286)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("lodash"), require("./Calendar.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.lodash, global.Calendar);
        global.Calendar = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _lodash) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./Calendar.scss": {
            "calendar": "Calendar__calendar___1EF9T",
            "digit": "Calendar__digit___334S2 Fonts__bold-font___3iFek",
            "year-intro-digit": "Calendar__year-intro-digit___1iSF9 Calendar__digit___334S2 Fonts__bold-font___3iFek"
        }
    };

    var Calendar = function (_super) {
        tslib_1.__extends(Calendar, _super);
        function Calendar(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.getDigits = function () {
                var _a = _this.props,
                    year = _a.year,
                    year_intro = _a.year_intro;
                var year_str = _.toString(year);
                return _.map(year_str, function (digit, i) {
                    return React.createElement(
                        "span",
                        { key: i, className: (0, _getClassName3.default)(!year_intro ? 'digit' : 'year-intro-digit', _styleModuleImportMap)
                        },
                        digit
                    );
                });
            };
            return _this;
        }
        Calendar.prototype.render = function () {
            return React.createElement(
                "div",
                {
                    className: (0, _getClassName3.default)('calendar', _styleModuleImportMap)
                },
                this.getDigits()
            );
        };
        return Calendar;
    }(React.Component);
    exports.default = Calendar;
});

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(3), __webpack_require__(43), __webpack_require__(117)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("react"), require("react-dom"), require("./app/PowerMapGame"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.react, global.reactDom, global.PowerMapGame);
        global.index = mod.exports;
    }
})(this, function (exports, _react, _reactDom, _PowerMapGame) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.init = init;

    var React = _interopRequireWildcard(_react);

    var ReactDOM = _interopRequireWildcard(_reactDom);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function init() {
        ReactDOM.render(React.createElement(_PowerMapGame.PowerMapGame), document.getElementById('power-map'));
    }
});

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(59),n=__webpack_require__(60),p=__webpack_require__(36),q="function"===typeof Symbol&&Symbol["for"],r=q?Symbol["for"]("react.element"):60103,t=q?Symbol["for"]("react.call"):60104,u=q?Symbol["for"]("react.return"):60105,v=q?Symbol["for"]("react.portal"):60106,w=q?Symbol["for"]("react.fragment"):60107,x="function"===typeof Symbol&&Symbol.iterator;
function y(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var z={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function A(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}A.prototype.isReactComponent={};A.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?y("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};A.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function B(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}function C(){}C.prototype=A.prototype;var D=B.prototype=new C;D.constructor=B;m(D,A.prototype);D.isPureReactComponent=!0;function E(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}var F=E.prototype=new C;F.constructor=E;m(F,A.prototype);F.unstable_isAsyncReactComponent=!0;F.render=function(){return this.props.children};var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
function J(a,b,e){var c,d={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)H.call(b,c)&&!I.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var h=Array(f),l=0;l<f;l++)h[l]=arguments[l+2];d.children=h}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:r,type:a,key:g,ref:k,props:d,_owner:G.current}}function K(a){return"object"===typeof a&&null!==a&&a.$$typeof===r}
function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var L=/\/+/g,M=[];function N(a,b,e,c){if(M.length){var d=M.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function O(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>M.length&&M.push(a)}
function P(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case r:case t:case u:case v:g=!0}}if(g)return e(c,a,""===b?"."+Q(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+Q(d,k);g+=P(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=x&&a[x]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=
f.call(a),k=0;!(d=a.next()).done;)d=d.value,f=b+Q(d,k++),g+=P(d,f,e,c);else"object"===d&&(e=""+a,y("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function Q(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function R(a,b){a.func.call(a.context,b,a.count++)}
function S(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?T(a,c,e,p.thatReturnsArgument):null!=a&&(K(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(L,"$\x26/")+"/")+e,a={$$typeof:r,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function T(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(L,"$\x26/")+"/");b=N(b,g,c,d);null==a||P(a,"",S,b);O(b)}
var U={Children:{map:function(a,b,e){if(null==a)return a;var c=[];T(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=N(null,null,b,e);null==a||P(a,"",R,b);O(b)},count:function(a){return null==a?0:P(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];T(a,b,null,p.thatReturnsArgument);return b},only:function(a){K(a)?void 0:y("143");return a}},Component:A,PureComponent:B,unstable_AsyncComponent:E,Fragment:w,createElement:J,cloneElement:function(a,b,e){var c=m({},a.props),
d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)H.call(b,h)&&!I.hasOwnProperty(h)&&(c[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)c.children=e;else if(1<h){f=Array(h);for(var l=0;l<h;l++)f[l]=arguments[l+2];c.children=f}return{$$typeof:r,type:a.type,key:d,ref:g,props:c,_owner:k}},createFactory:function(a){var b=J.bind(null,a);b.type=a;return b},
isValidElement:K,version:"16.2.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:G,assign:m}},V=Object.freeze({default:U}),W=V&&U||V;module.exports=W["default"]?W["default"]:W;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(3),l=__webpack_require__(109),B=__webpack_require__(59),C=__webpack_require__(36),ba=__webpack_require__(110),da=__webpack_require__(111),ea=__webpack_require__(112),fa=__webpack_require__(113),ia=__webpack_require__(116),D=__webpack_require__(60);
function E(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}aa?void 0:E("227");
var oa={children:!0,dangerouslySetInnerHTML:!0,defaultValue:!0,defaultChecked:!0,innerHTML:!0,suppressContentEditableWarning:!0,suppressHydrationWarning:!0,style:!0};function pa(a,b){return(a&b)===b}
var ta={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=ta,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){ua.hasOwnProperty(f)?E("48",f):void 0;var g=f.toLowerCase(),h=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:pa(h,b.MUST_USE_PROPERTY),
hasBooleanValue:pa(h,b.HAS_BOOLEAN_VALUE),hasNumericValue:pa(h,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:pa(h,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:pa(h,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:pa(h,b.HAS_STRING_BOOLEAN_VALUE)};1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue?void 0:E("50",f);e.hasOwnProperty(f)&&(g.attributeName=e[f]);d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]);a.hasOwnProperty(f)&&(g.mutationMethod=a[f]);ua[f]=g}}},ua={};
function va(a,b){if(oa.hasOwnProperty(a)||2<a.length&&("o"===a[0]||"O"===a[0])&&("n"===a[1]||"N"===a[1]))return!1;if(null===b)return!0;switch(typeof b){case "boolean":return oa.hasOwnProperty(a)?a=!0:(b=wa(a))?a=b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue:(a=a.toLowerCase().slice(0,5),a="data-"===a||"aria-"===a),a;case "undefined":case "number":case "string":case "object":return!0;default:return!1}}function wa(a){return ua.hasOwnProperty(a)?ua[a]:null}
var xa=ta,ya=xa.MUST_USE_PROPERTY,K=xa.HAS_BOOLEAN_VALUE,za=xa.HAS_NUMERIC_VALUE,Aa=xa.HAS_POSITIVE_NUMERIC_VALUE,Ba=xa.HAS_OVERLOADED_BOOLEAN_VALUE,Ca=xa.HAS_STRING_BOOLEAN_VALUE,Da={Properties:{allowFullScreen:K,async:K,autoFocus:K,autoPlay:K,capture:Ba,checked:ya|K,cols:Aa,contentEditable:Ca,controls:K,"default":K,defer:K,disabled:K,download:Ba,draggable:Ca,formNoValidate:K,hidden:K,loop:K,multiple:ya|K,muted:ya|K,noValidate:K,open:K,playsInline:K,readOnly:K,required:K,reversed:K,rows:Aa,rowSpan:za,
scoped:K,seamless:K,selected:ya|K,size:Aa,start:za,span:Aa,spellCheck:Ca,style:0,tabIndex:0,itemScope:K,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:Ca},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&a.ownerDocument.activeElement!==a&&
a.setAttribute("value",""+b)}}},Ea=xa.HAS_STRING_BOOLEAN_VALUE,M={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},Ga={Properties:{autoReverse:Ea,externalResourcesRequired:Ea,preserveAlpha:Ea},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:M.xlink,xlinkArcrole:M.xlink,xlinkHref:M.xlink,xlinkRole:M.xlink,xlinkShow:M.xlink,xlinkTitle:M.xlink,xlinkType:M.xlink,
xmlBase:M.xml,xmlLang:M.xml,xmlSpace:M.xml}},Ha=/[\-\:]([a-z])/g;function Ia(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Ha,
Ia);Ga.Properties[b]=0;Ga.DOMAttributeNames[b]=a});xa.injectDOMPropertyConfig(Da);xa.injectDOMPropertyConfig(Ga);
var P={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?E("197"):void 0;Ja=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){Ja.apply(P,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){P.invokeGuardedCallback.apply(this,arguments);if(P.hasCaughtError()){var q=P.clearCaughtError();P._hasRethrowError||(P._hasRethrowError=!0,P._rethrowError=
q)}},rethrowCaughtError:function(){return Ka.apply(P,arguments)},hasCaughtError:function(){return P._hasCaughtError},clearCaughtError:function(){if(P._hasCaughtError){var a=P._caughtError;P._caughtError=null;P._hasCaughtError=!1;return a}E("198")}};function Ja(a,b,c,d,e,f,g,h,k){P._hasCaughtError=!1;P._caughtError=null;var q=Array.prototype.slice.call(arguments,3);try{b.apply(c,q)}catch(v){P._caughtError=v,P._hasCaughtError=!0}}
function Ka(){if(P._hasRethrowError){var a=P._rethrowError;P._rethrowError=null;P._hasRethrowError=!1;throw a;}}var La=null,Ma={};
function Na(){if(La)for(var a in Ma){var b=Ma[a],c=La.indexOf(a);-1<c?void 0:E("96",a);if(!Oa[c]){b.extractEvents?void 0:E("97",a);Oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;Pa.hasOwnProperty(h)?E("99",h):void 0;Pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&Qa(k[e],g,h);e=!0}else f.registrationName?(Qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:E("98",d,a)}}}}
function Qa(a,b,c){Ra[a]?E("100",a):void 0;Ra[a]=b;Sa[a]=b.eventTypes[c].dependencies}var Oa=[],Pa={},Ra={},Sa={};function Ta(a){La?E("101"):void 0;La=Array.prototype.slice.call(a);Na()}function Ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];Ma.hasOwnProperty(c)&&Ma[c]===d||(Ma[c]?E("102",c):void 0,Ma[c]=d,b=!0)}b&&Na()}
var Va=Object.freeze({plugins:Oa,eventNameDispatchConfigs:Pa,registrationNameModules:Ra,registrationNameDependencies:Sa,possibleRegistrationNames:null,injectEventPluginOrder:Ta,injectEventPluginsByName:Ua}),Wa=null,Xa=null,Ya=null;function Za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Ya(d);P.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function $a(a,b){null==b?E("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function ab(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var bb=null;
function cb(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Za(a,b,c[e],d[e]);else c&&Za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function db(a){return cb(a,!0)}function gb(a){return cb(a,!1)}var hb={injectEventPluginOrder:Ta,injectEventPluginsByName:Ua};
function ib(a,b){var c=a.stateNode;if(!c)return null;var d=Wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?E("231",b,typeof c):void 0;
return c}function jb(a,b,c,d){for(var e,f=0;f<Oa.length;f++){var g=Oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=$a(e,g))}return e}function kb(a){a&&(bb=$a(bb,a))}function lb(a){var b=bb;bb=null;b&&(a?ab(b,db):ab(b,gb),bb?E("95"):void 0,P.rethrowCaughtError())}var mb=Object.freeze({injection:hb,getListener:ib,extractEvents:jb,enqueueEvents:kb,processEventQueue:lb}),nb=Math.random().toString(36).slice(2),Q="__reactInternalInstance$"+nb,ob="__reactEventHandlers$"+nb;
function pb(a){if(a[Q])return a[Q];for(var b=[];!a[Q];)if(b.push(a),a.parentNode)a=a.parentNode;else return null;var c=void 0,d=a[Q];if(5===d.tag||6===d.tag)return d;for(;a&&(d=a[Q]);a=b.pop())c=d;return c}function qb(a){if(5===a.tag||6===a.tag)return a.stateNode;E("33")}function rb(a){return a[ob]||null}
var sb=Object.freeze({precacheFiberNode:function(a,b){b[Q]=a},getClosestInstanceFromNode:pb,getInstanceFromNode:function(a){a=a[Q];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:qb,getFiberCurrentPropsFromNode:rb,updateFiberProps:function(a,b){a[ob]=b}});function tb(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function ub(a,b,c){for(var d=[];a;)d.push(a),a=tb(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}
function vb(a,b,c){if(b=ib(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a)}function wb(a){a&&a.dispatchConfig.phasedRegistrationNames&&ub(a._targetInst,vb,a)}function xb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?tb(b):null;ub(b,vb,a)}}
function yb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=ib(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a))}function zb(a){a&&a.dispatchConfig.registrationName&&yb(a._targetInst,null,a)}function Ab(a){ab(a,wb)}
function Bb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=tb(h))g++;h=0;for(var k=f;k;k=tb(k))h++;for(;0<g-h;)e=tb(e),g--;for(;0<h-g;)f=tb(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=tb(e);f=tb(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=tb(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=tb(d)}for(d=0;d<e.length;d++)yb(e[d],"bubbled",a);for(a=c.length;0<a--;)yb(c[a],"captured",b)}
var Cb=Object.freeze({accumulateTwoPhaseDispatches:Ab,accumulateTwoPhaseDispatchesSkipTarget:function(a){ab(a,xb)},accumulateEnterLeaveDispatches:Bb,accumulateDirectDispatches:function(a){ab(a,zb)}}),Db=null;function Eb(){!Db&&l.canUseDOM&&(Db="textContent"in document.documentElement?"textContent":"innerText");return Db}var S={_root:null,_startText:null,_fallbackText:null};
function Fb(){if(S._fallbackText)return S._fallbackText;var a,b=S._startText,c=b.length,d,e=Gb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);S._fallbackText=e.slice(a,1<d?1-d:void 0);return S._fallbackText}function Gb(){return"value"in S._root?S._root.value:S._root[Eb()]}
var Hb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Ib={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function T(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
B(T.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<Hb.length;a++)this[Hb[a]]=null}});T.Interface=Ib;T.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;B(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=B({},this.Interface,b);a.augmentClass=this.augmentClass;Jb(a)};Jb(T);function Kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Lb(a){a instanceof this?void 0:E("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Jb(a){a.eventPool=[];a.getPooled=Kb;a.release=Lb}function Mb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Mb,{data:null});function Nb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Nb,{data:null});var Pb=[9,13,27,32],Vb=l.canUseDOM&&"CompositionEvent"in window,Wb=null;l.canUseDOM&&"documentMode"in document&&(Wb=document.documentMode);var Xb;
if(Xb=l.canUseDOM&&"TextEvent"in window&&!Wb){var Yb=window.opera;Xb=!("object"===typeof Yb&&"function"===typeof Yb.version&&12>=parseInt(Yb.version(),10))}
var Zb=Xb,$b=l.canUseDOM&&(!Vb||Wb&&8<Wb&&11>=Wb),ac=String.fromCharCode(32),bc={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},cc=!1;
function dc(a,b){switch(a){case "topKeyUp":return-1!==Pb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function ec(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var fc=!1;function gc(a,b){switch(a){case "topCompositionEnd":return ec(b);case "topKeyPress":if(32!==b.which)return null;cc=!0;return ac;case "topTextInput":return a=b.data,a===ac&&cc?null:a;default:return null}}
function hc(a,b){if(fc)return"topCompositionEnd"===a||!Vb&&dc(a,b)?(a=Fb(),S._root=null,S._startText=null,S._fallbackText=null,fc=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return $b?null:b.data;default:return null}}
var ic={eventTypes:bc,extractEvents:function(a,b,c,d){var e;if(Vb)b:{switch(a){case "topCompositionStart":var f=bc.compositionStart;break b;case "topCompositionEnd":f=bc.compositionEnd;break b;case "topCompositionUpdate":f=bc.compositionUpdate;break b}f=void 0}else fc?dc(a,c)&&(f=bc.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=bc.compositionStart);f?($b&&(fc||f!==bc.compositionStart?f===bc.compositionEnd&&fc&&(e=Fb()):(S._root=d,S._startText=Gb(),fc=!0)),f=Mb.getPooled(f,b,c,d),e?f.data=
e:(e=ec(c),null!==e&&(f.data=e)),Ab(f),e=f):e=null;(a=Zb?gc(a,c):hc(a,c))?(b=Nb.getPooled(bc.beforeInput,b,c,d),b.data=a,Ab(b)):b=null;return[e,b]}},jc=null,kc=null,lc=null;function mc(a){if(a=Xa(a)){jc&&"function"===typeof jc.restoreControlledState?void 0:E("194");var b=Wa(a.stateNode);jc.restoreControlledState(a.stateNode,a.type,b)}}var nc={injectFiberControlledHostComponent:function(a){jc=a}};function oc(a){kc?lc?lc.push(a):lc=[a]:kc=a}
function pc(){if(kc){var a=kc,b=lc;lc=kc=null;mc(a);if(b)for(a=0;a<b.length;a++)mc(b[a])}}var qc=Object.freeze({injection:nc,enqueueStateRestore:oc,restoreStateIfNeeded:pc});function rc(a,b){return a(b)}var sc=!1;function tc(a,b){if(sc)return rc(a,b);sc=!0;try{return rc(a,b)}finally{sc=!1,pc()}}var uc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};
function vc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!uc[a.type]:"textarea"===b?!0:!1}function wc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var xc;l.canUseDOM&&(xc=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));
function yc(a,b){if(!l.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"===typeof c[b]);!c&&xc&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0"));return c}function zc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ac(a){var b=zc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function Bc(a){a._valueTracker||(a._valueTracker=Ac(a))}function Cc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=zc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Dc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};
function Ec(a,b,c){a=T.getPooled(Dc.change,a,b,c);a.type="change";oc(c);Ab(a);return a}var Fc=null,Gc=null;function Hc(a){kb(a);lb(!1)}function Ic(a){var b=qb(a);if(Cc(b))return a}function Jc(a,b){if("topChange"===a)return b}var Kc=!1;l.canUseDOM&&(Kc=yc("input")&&(!document.documentMode||9<document.documentMode));function Lc(){Fc&&(Fc.detachEvent("onpropertychange",Mc),Gc=Fc=null)}function Mc(a){"value"===a.propertyName&&Ic(Gc)&&(a=Ec(Gc,a,wc(a)),tc(Hc,a))}
function Nc(a,b,c){"topFocus"===a?(Lc(),Fc=b,Gc=c,Fc.attachEvent("onpropertychange",Mc)):"topBlur"===a&&Lc()}function Oc(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return Ic(Gc)}function Pc(a,b){if("topClick"===a)return Ic(b)}function $c(a,b){if("topInput"===a||"topChange"===a)return Ic(b)}
var ad={eventTypes:Dc,_isInputEventSupported:Kc,extractEvents:function(a,b,c,d){var e=b?qb(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Jc;else if(vc(e))if(Kc)g=$c;else{g=Oc;var h=Nc}else f=e.nodeName,!f||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Pc);if(g&&(g=g(a,b)))return Ec(g,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,e.getAttribute("value")!==
a&&e.setAttribute("value",a))}};function bd(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(bd,{view:null,detail:null});var cd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=cd[a])?!!b[a]:!1}function ed(){return dd}function fd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(fd,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});
var gd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},hd={eventTypes:gd,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?pb(b):null):a=null;if(a===
b)return null;var f=null==a?e:qb(a);e=null==b?e:qb(b);var g=fd.getPooled(gd.mouseLeave,a,c,d);g.type="mouseleave";g.target=f;g.relatedTarget=e;c=fd.getPooled(gd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=f;Bb(g,c,a,b);return[g,c]}},id=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner;function jd(a){a=a.type;return"string"===typeof a?a:"function"===typeof a?a.displayName||a.name:null}
function kd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){return(a=a._reactInternalFiber)?2===kd(a):!1}function md(a){2!==kd(a)?E("188"):void 0}
function nd(a){var b=a.alternate;if(!b)return b=kd(a),3===b?E("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return md(e),a;if(g===d)return md(e),b;g=g.sibling}E("188")}if(c["return"]!==d["return"])c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:E("189")}}c.alternate!==d?E("190"):void 0}3!==c.tag?E("188"):void 0;return c.stateNode.current===c?a:b}function od(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function pd(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var qd=[];
function rd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=pb(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],sd(a.topLevelType,b,a.nativeEvent,wc(a.nativeEvent))}var td=!0,sd=void 0;function ud(a){td=!!a}function U(a,b,c){return c?ba.listen(c,b,vd.bind(null,a)):null}function wd(a,b,c){return c?ba.capture(c,b,vd.bind(null,a)):null}
function vd(a,b){if(td){var c=wc(b);c=pb(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(qd.length){var d=qd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{tc(rd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>qd.length&&qd.push(a)}}}
var xd=Object.freeze({get _enabled(){return td},get _handleTopLevel(){return sd},setHandleTopLevel:function(a){sd=a},setEnabled:ud,isEnabled:function(){return td},trapBubbledEvent:U,trapCapturedEvent:wd,dispatchEvent:vd});function yd(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var zd={animationend:yd("Animation","AnimationEnd"),animationiteration:yd("Animation","AnimationIteration"),animationstart:yd("Animation","AnimationStart"),transitionend:yd("Transition","TransitionEnd")},Ad={},Bd={};l.canUseDOM&&(Bd=document.createElement("div").style,"AnimationEvent"in window||(delete zd.animationend.animation,delete zd.animationiteration.animation,delete zd.animationstart.animation),"TransitionEvent"in window||delete zd.transitionend.transition);
function Cd(a){if(Ad[a])return Ad[a];if(!zd[a])return a;var b=zd[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Bd)return Ad[a]=b[c];return""}
var Dd={topAbort:"abort",topAnimationEnd:Cd("animationend")||"animationend",topAnimationIteration:Cd("animationiteration")||"animationiteration",topAnimationStart:Cd("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",
topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",
topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:Cd("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},Ed={},Fd=0,Gd="_reactListenersID"+(""+Math.random()).slice(2);function Hd(a){Object.prototype.hasOwnProperty.call(a,Gd)||(a[Gd]=Fd++,Ed[a[Gd]]={});return Ed[a[Gd]]}function Id(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Jd(a,b){var c=Id(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Id(c)}}function Kd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var Ld=l.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Md={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Nd=null,Od=null,Pd=null,Qd=!1;
function Rd(a,b){if(Qd||null==Nd||Nd!==da())return null;var c=Nd;"selectionStart"in c&&Kd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Pd&&ea(Pd,c)?null:(Pd=c,a=T.getPooled(Md.select,Od,a,b),a.type="select",a.target=Nd,Ab(a),a)}
var Sd={eventTypes:Md,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Hd(e);f=Sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?qb(b):window;switch(a){case "topFocus":if(vc(e)||"true"===e.contentEditable)Nd=e,Od=b,Pd=null;break;case "topBlur":Pd=Od=Nd=null;break;case "topMouseDown":Qd=!0;break;case "topContextMenu":case "topMouseUp":return Qd=!1,Rd(c,d);case "topSelectionChange":if(Ld)break;
case "topKeyDown":case "topKeyUp":return Rd(c,d)}return null}};function Td(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Td,{animationName:null,elapsedTime:null,pseudoElement:null});function Ud(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Ud,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}});function Vd(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(Vd,{relatedTarget:null});
function Wd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;return 32<=a||13===a?a:0}
var Xd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Yd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function Zd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(Zd,{key:function(a){if(a.key){var b=Xd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Wd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Yd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===a.type?Wd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?Wd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}});function $d(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass($d,{dataTransfer:null});function ae(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(ae,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed});function be(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(be,{propertyName:null,elapsedTime:null,pseudoElement:null});
function ce(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass(ce,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var de={},ee={};
"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+
a.slice(1),c="on"+b;b="top"+b;c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]};de[a]=c;ee[b]=c});
var fe={eventTypes:de,extractEvents:function(a,b,c,d){var e=ee[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Wd(c))return null;case "topKeyDown":case "topKeyUp":a=Zd;break;case "topBlur":case "topFocus":a=Vd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=fd;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=
$d;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=ae;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Td;break;case "topTransitionEnd":a=be;break;case "topScroll":a=bd;break;case "topWheel":a=ce;break;case "topCopy":case "topCut":case "topPaste":a=Ud;break;default:a=T}b=a.getPooled(e,b,c,d);Ab(b);return b}};sd=function(a,b,c,d){a=jb(a,b,c,d);kb(a);lb(!1)};hb.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
Wa=sb.getFiberCurrentPropsFromNode;Xa=sb.getInstanceFromNode;Ya=sb.getNodeFromInstance;hb.injectEventPluginsByName({SimpleEventPlugin:fe,EnterLeaveEventPlugin:hd,ChangeEventPlugin:ad,SelectEventPlugin:Sd,BeforeInputEventPlugin:ic});var ge=[],he=-1;function V(a){0>he||(a.current=ge[he],ge[he]=null,he--)}function W(a,b){he++;ge[he]=a.current;a.current=b}new Set;var ie={current:D},X={current:!1},je=D;function ke(a){return le(a)?je:ie.current}
function me(a,b){var c=a.type.contextTypes;if(!c)return D;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function le(a){return 2===a.tag&&null!=a.type.childContextTypes}function ne(a){le(a)&&(V(X,a),V(ie,a))}
function oe(a,b,c){null!=ie.cursor?E("168"):void 0;W(ie,b,a);W(X,c,a)}function pe(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:E("108",jd(a)||"Unknown",e);return B({},b,c)}function qe(a){if(!le(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||D;je=ie.current;W(ie,b,a);W(X,X.current,a);return!0}
function re(a,b){var c=a.stateNode;c?void 0:E("169");if(b){var d=pe(a,je);c.__reactInternalMemoizedMergedChildContext=d;V(X,a);V(ie,a);W(ie,d,a)}else V(X,a);W(X,b,a)}
function Y(a,b,c){this.tag=a;this.key=b;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null;this.internalContextTag=c;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function se(a,b,c){var d=a.alternate;null===d?(d=new Y(a.tag,a.key,a.internalContextTag),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.pendingProps=b;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function te(a,b,c){var d=void 0,e=a.type,f=a.key;"function"===typeof e?(d=e.prototype&&e.prototype.isReactComponent?new Y(2,f,b):new Y(0,f,b),d.type=e,d.pendingProps=a.props):"string"===typeof e?(d=new Y(5,f,b),d.type=e,d.pendingProps=a.props):"object"===typeof e&&null!==e&&"number"===typeof e.tag?(d=e,d.pendingProps=a.props):E("130",null==e?e:typeof e,"");d.expirationTime=c;return d}function ue(a,b,c,d){b=new Y(10,d,b);b.pendingProps=a;b.expirationTime=c;return b}
function ve(a,b,c){b=new Y(6,null,b);b.pendingProps=a;b.expirationTime=c;return b}function we(a,b,c){b=new Y(7,a.key,b);b.type=a.handler;b.pendingProps=a;b.expirationTime=c;return b}function xe(a,b,c){a=new Y(9,null,b);a.expirationTime=c;return a}function ye(a,b,c){b=new Y(4,a.key,b);b.pendingProps=a.children||[];b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var ze=null,Ae=null;
function Be(a){return function(b){try{return a(b)}catch(c){}}}function Ce(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);ze=Be(function(a){return b.onCommitFiberRoot(c,a)});Ae=Be(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function De(a){"function"===typeof ze&&ze(a)}function Ee(a){"function"===typeof Ae&&Ae(a)}
function Fe(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1}}function Ge(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}
function He(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=Fe(null));null!==c?(a=c.updateQueue,null===a&&(a=c.updateQueue=Fe(null))):a=null;a=a!==d?a:null;null===a?Ge(d,b):null===d.last||null===a.last?(Ge(d,b),Ge(a,b)):(Ge(d,b),a.last=b)}function Ie(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Je(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var g=!0,h=c.first,k=!1;null!==h;){var q=h.expirationTime;if(q>f){var v=c.expirationTime;if(0===v||v>q)c.expirationTime=q;k||(k=!0,c.baseState=a)}else{k||(c.first=h.next,null===
c.first&&(c.last=null));if(h.isReplace)a=Ie(h,d,a,e),g=!0;else if(q=Ie(h,d,a,e))a=g?B({},a,q):B(a,q),g=!1;h.isForced&&(c.hasForceUpdate=!0);null!==h.callback&&(q=c.callbackList,null===q&&(q=c.callbackList=[]),q.push(h))}h=h.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||(b.updateQueue=null);k||(c.baseState=a);return a}
function Ke(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?E("191",e):void 0;e.call(b)}}
function Le(a,b,c,d){function e(a,b){b.updater=f;a.stateNode=b;b._reactInternalFiber=a}var f={isMounted:ld,enqueueSetState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!1,isForced:!1,nextCallback:null,next:null});a(c,g)},enqueueReplaceState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!0,isForced:!1,nextCallback:null,next:null});
a(c,g)},enqueueForceUpdate:function(c,d){c=c._reactInternalFiber;d=void 0===d?null:d;var e=b(c);He(c,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,nextCallback:null,next:null});a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=ke(a),f=2===a.tag&&null!=a.type.contextTypes,g=f?me(a,d):D;b=new c(b,g);e(a,b);f&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=d,a.__reactInternalMemoizedMaskedChildContext=g);return b},mountClassInstance:function(a,
b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g?void 0:E("158");var h=ke(a);d.props=g;d.state=a.memoizedState=e;d.refs=D;d.context=me(a,h);null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=1);"function"===typeof d.componentWillMount&&(e=d.state,d.componentWillMount(),e!==d.state&&f.enqueueReplaceState(d,d.state,null),e=a.updateQueue,null!==e&&(d.state=Je(c,a,e,d,g,b)));"function"===typeof d.componentDidMount&&(a.effectTag|=
4)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps;g.state=b.memoizedState;var h=b.memoizedProps,k=b.pendingProps;k||(k=h,null==k?E("159"):void 0);var u=g.context,z=ke(b);z=me(b,z);"function"!==typeof g.componentWillReceiveProps||h===k&&u===z||(u=g.state,g.componentWillReceiveProps(k,z),g.state!==u&&f.enqueueReplaceState(g,g.state,null));u=b.memoizedState;e=null!==b.updateQueue?Je(a,b,b.updateQueue,g,k,e):u;if(!(h!==k||u!==e||X.current||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==
typeof g.componentDidUpdate||h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),!1;var G=k;if(null===h||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)G=!0;else{var I=b.stateNode,L=b.type;G="function"===typeof I.shouldComponentUpdate?I.shouldComponentUpdate(G,e,z):L.prototype&&L.prototype.isPureReactComponent?!ea(h,G)||!ea(u,e):!0}G?("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(k,e,z),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4)):("function"!==typeof g.componentDidUpdate||
h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),c(b,k),d(b,e));g.props=k;g.state=e;g.context=z;return G}}}var Qe="function"===typeof Symbol&&Symbol["for"],Re=Qe?Symbol["for"]("react.element"):60103,Se=Qe?Symbol["for"]("react.call"):60104,Te=Qe?Symbol["for"]("react.return"):60105,Ue=Qe?Symbol["for"]("react.portal"):60106,Ve=Qe?Symbol["for"]("react.fragment"):60107,We="function"===typeof Symbol&&Symbol.iterator;
function Xe(a){if(null===a||"undefined"===typeof a)return null;a=We&&a[We]||a["@@iterator"];return"function"===typeof a?a:null}var Ye=Array.isArray;
function Ze(a,b){var c=b.ref;if(null!==c&&"function"!==typeof c){if(b._owner){b=b._owner;var d=void 0;b&&(2!==b.tag?E("110"):void 0,d=b.stateNode);d?void 0:E("147",c);var e=""+c;if(null!==a&&null!==a.ref&&a.ref._stringRef===e)return a.ref;a=function(a){var b=d.refs===D?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};a._stringRef=e;return a}"string"!==typeof c?E("148"):void 0;b._owner?void 0:E("149",c)}return c}
function $e(a,b){"textarea"!==a.type&&E("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function af(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=se(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=ve(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ze(b,c),d["return"]=a,d;d=te(c,a.internalContextTag,d);d.ref=Ze(b,c);d["return"]=a;return d}function q(a,b,c,d){if(null===b||7!==b.tag)return b=we(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);
b["return"]=a;return b}function v(a,b,c,d){if(null===b||9!==b.tag)return b=xe(c,a.internalContextTag,d),b.type=c.value,b["return"]=a,b;b=e(b,null,d);b.type=c.value;b["return"]=a;return b}function y(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=ye(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function u(a,b,c,d,f){if(null===b||10!==b.tag)return b=ue(c,a.internalContextTag,
d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function z(a,b,c){if("string"===typeof b||"number"===typeof b)return b=ve(""+b,a.internalContextTag,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Re:if(b.type===Ve)return b=ue(b.props.children,a.internalContextTag,c,b.key),b["return"]=a,b;c=te(b,a.internalContextTag,c);c.ref=Ze(null,b);c["return"]=a;return c;case Se:return b=we(b,a.internalContextTag,c),b["return"]=a,b;case Te:return c=xe(b,a.internalContextTag,
c),c.type=b.value,c["return"]=a,c;case Ue:return b=ye(b,a.internalContextTag,c),b["return"]=a,b}if(Ye(b)||Xe(b))return b=ue(b,a.internalContextTag,c,null),b["return"]=a,b;$e(a,b)}return null}function G(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Re:return c.key===e?c.type===Ve?u(a,b,c.props.children,d,e):k(a,b,c,d):null;case Se:return c.key===e?q(a,b,c,d):null;case Te:return null===
e?v(a,b,c,d):null;case Ue:return c.key===e?y(a,b,c,d):null}if(Ye(c)||Xe(c))return null!==e?null:u(a,b,c,d,null);$e(a,c)}return null}function I(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Re:return a=a.get(null===d.key?c:d.key)||null,d.type===Ve?u(b,a,d.props.children,e,d.key):k(b,a,d,e);case Se:return a=a.get(null===d.key?c:d.key)||null,q(b,a,d,e);case Te:return a=a.get(c)||null,v(b,a,d,e);case Ue:return a=
a.get(null===d.key?c:d.key)||null,y(b,a,d,e)}if(Ye(d)||Xe(d))return a=a.get(c)||null,u(b,a,d,e,null);$e(b,d)}return null}function L(e,g,m,A){for(var h=null,r=null,n=g,w=g=0,k=null;null!==n&&w<m.length;w++){n.index>w?(k=n,n=null):k=n.sibling;var x=G(e,n,m[w],A);if(null===x){null===n&&(n=k);break}a&&n&&null===x.alternate&&b(e,n);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x;n=k}if(w===m.length)return c(e,n),h;if(null===n){for(;w<m.length;w++)if(n=z(e,m[w],A))g=f(n,g,w),null===r?h=n:r.sibling=n,r=n;return h}for(n=
d(e,n);w<m.length;w++)if(k=I(n,e,w,m[w],A)){if(a&&null!==k.alternate)n["delete"](null===k.key?w:k.key);g=f(k,g,w);null===r?h=k:r.sibling=k;r=k}a&&n.forEach(function(a){return b(e,a)});return h}function N(e,g,m,A){var h=Xe(m);"function"!==typeof h?E("150"):void 0;m=h.call(m);null==m?E("151"):void 0;for(var r=h=null,n=g,w=g=0,k=null,x=m.next();null!==n&&!x.done;w++,x=m.next()){n.index>w?(k=n,n=null):k=n.sibling;var J=G(e,n,x.value,A);if(null===J){n||(n=k);break}a&&n&&null===J.alternate&&b(e,n);g=f(J,
g,w);null===r?h=J:r.sibling=J;r=J;n=k}if(x.done)return c(e,n),h;if(null===n){for(;!x.done;w++,x=m.next())x=z(e,x.value,A),null!==x&&(g=f(x,g,w),null===r?h=x:r.sibling=x,r=x);return h}for(n=d(e,n);!x.done;w++,x=m.next())if(x=I(n,e,w,x.value,A),null!==x){if(a&&null!==x.alternate)n["delete"](null===x.key?w:x.key);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x}a&&n.forEach(function(a){return b(e,a)});return h}return function(a,d,f,h){"object"===typeof f&&null!==f&&f.type===Ve&&null===f.key&&(f=f.props.children);
var m="object"===typeof f&&null!==f;if(m)switch(f.$$typeof){case Re:a:{var r=f.key;for(m=d;null!==m;){if(m.key===r)if(10===m.tag?f.type===Ve:m.type===f.type){c(a,m.sibling);d=e(m,f.type===Ve?f.props.children:f.props,h);d.ref=Ze(m,f);d["return"]=a;a=d;break a}else{c(a,m);break}else b(a,m);m=m.sibling}f.type===Ve?(d=ue(f.props.children,a.internalContextTag,h,f.key),d["return"]=a,a=d):(h=te(f,a.internalContextTag,h),h.ref=Ze(d,f),h["return"]=a,a=h)}return g(a);case Se:a:{for(m=f.key;null!==d;){if(d.key===
m)if(7===d.tag){c(a,d.sibling);d=e(d,f,h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=we(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a);case Te:a:{if(null!==d)if(9===d.tag){c(a,d.sibling);d=e(d,null,h);d.type=f.value;d["return"]=a;a=d;break a}else c(a,d);d=xe(f,a.internalContextTag,h);d.type=f.value;d["return"]=a;a=d}return g(a);case Ue:a:{for(m=f.key;null!==d;){if(d.key===m)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===
f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=ye(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h)):(c(a,d),d=ve(f,a.internalContextTag,h)),d["return"]=a,a=d,g(a);if(Ye(f))return L(a,d,f,h);if(Xe(f))return N(a,d,f,h);m&&$e(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:h=a.type,E("152",h.displayName||
h.name||"Component")}return c(a,d)}}var bf=af(!0),cf=af(!1);
function df(a,b,c,d,e){function f(a,b,c){var d=b.expirationTime;b.child=null===a?cf(b,null,c,d):bf(b,a.child,c,d)}function g(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=128)}function h(a,b,c,d){g(a,b);if(!c)return d&&re(b,!1),q(a,b);c=b.stateNode;id.current=b;var e=c.render();b.effectTag|=1;f(a,b,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&re(b,!0);return b.child}function k(a){var b=a.stateNode;b.pendingContext?oe(a,b.pendingContext,b.pendingContext!==b.context):b.context&&oe(a,
b.context,!1);I(a,b.containerInfo)}function q(a,b){null!==a&&b.child!==a.child?E("153"):void 0;if(null!==b.child){a=b.child;var c=se(a,a.pendingProps,a.expirationTime);b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=se(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}function v(a,b){switch(b.tag){case 3:k(b);break;case 2:qe(b);break;case 4:I(b,b.stateNode.containerInfo)}return null}var y=a.shouldSetTextContent,u=a.useSyncScheduling,z=a.shouldDeprioritizeSubtree,
G=b.pushHostContext,I=b.pushHostContainer,L=c.enterHydrationState,N=c.resetHydrationState,J=c.tryToClaimNextHydratableInstance;a=Le(d,e,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var w=a.adoptClassInstance,m=a.constructClassInstance,A=a.mountClassInstance,Ob=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c)return v(a,b);switch(b.tag){case 0:null!==a?E("155"):void 0;var d=b.type,e=b.pendingProps,r=ke(b);r=me(b,r);d=d(e,r);b.effectTag|=
1;"object"===typeof d&&null!==d&&"function"===typeof d.render?(b.tag=2,e=qe(b),w(b,d),A(b,c),b=h(a,b,!0,e)):(b.tag=1,f(a,b,d),b.memoizedProps=e,b=b.child);return b;case 1:a:{e=b.type;c=b.pendingProps;d=b.memoizedProps;if(X.current)null===c&&(c=d);else if(null===c||d===c){b=q(a,b);break a}d=ke(b);d=me(b,d);e=e(c,d);b.effectTag|=1;f(a,b,e);b.memoizedProps=c;b=b.child}return b;case 2:return e=qe(b),d=void 0,null===a?b.stateNode?E("153"):(m(b,b.pendingProps),A(b,c),d=!0):d=Ob(a,b,c),h(a,b,d,e);case 3:return k(b),
e=b.updateQueue,null!==e?(d=b.memoizedState,e=Je(a,b,e,null,null,c),d===e?(N(),b=q(a,b)):(d=e.element,r=b.stateNode,(null===a||null===a.child)&&r.hydrate&&L(b)?(b.effectTag|=2,b.child=cf(b,null,d,c)):(N(),f(a,b,d)),b.memoizedState=e,b=b.child)):(N(),b=q(a,b)),b;case 5:G(b);null===a&&J(b);e=b.type;var n=b.memoizedProps;d=b.pendingProps;null===d&&(d=n,null===d?E("154"):void 0);r=null!==a?a.memoizedProps:null;X.current||null!==d&&n!==d?(n=d.children,y(e,d)?n=null:r&&y(e,r)&&(b.effectTag|=16),g(a,b),
2147483647!==c&&!u&&z(e,d)?(b.expirationTime=2147483647,b=null):(f(a,b,n),b.memoizedProps=d,b=b.child)):b=q(a,b);return b;case 6:return null===a&&J(b),a=b.pendingProps,null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case 8:b.tag=7;case 7:e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null===e?E("154"):void 0);else if(null===e||b.memoizedProps===e)e=b.memoizedProps;d=e.children;b.stateNode=null===a?cf(b,b.stateNode,d,c):bf(b,b.stateNode,d,c);b.memoizedProps=e;return b.stateNode;
case 9:return null;case 4:a:{I(b,b.stateNode.containerInfo);e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null==e?E("154"):void 0);else if(null===e||b.memoizedProps===e){b=q(a,b);break a}null===a?b.child=bf(b,null,e,c):f(a,b,e);b.memoizedProps=e;b=b.child}return b;case 10:a:{c=b.pendingProps;if(X.current)null===c&&(c=b.memoizedProps);else if(null===c||b.memoizedProps===c){b=q(a,b);break a}f(a,b,c);b.memoizedProps=c;b=b.child}return b;default:E("156")}},beginFailedWork:function(a,b,
c){switch(b.tag){case 2:qe(b);break;case 3:k(b);break;default:E("157")}b.effectTag|=64;null===a?b.child=null:b.child!==a.child&&(b.child=a.child);if(0===b.expirationTime||b.expirationTime>c)return v(a,b);b.firstEffect=null;b.lastEffect=null;b.child=null===a?cf(b,null,null,c):bf(b,a.child,null,c);2===b.tag&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state);return b.child}}}
function ef(a,b,c){function d(a){a.effectTag|=4}var e=a.createInstance,f=a.createTextInstance,g=a.appendInitialChild,h=a.finalizeInitialChildren,k=a.prepareUpdate,q=a.persistence,v=b.getRootHostContainer,y=b.popHostContext,u=b.getHostContext,z=b.popHostContainer,G=c.prepareToHydrateHostInstance,I=c.prepareToHydrateHostTextInstance,L=c.popHydrationState,N=void 0,J=void 0,w=void 0;a.mutation?(N=function(){},J=function(a,b,c){(b.updateQueue=c)&&d(b)},w=function(a,b,c,e){c!==e&&d(b)}):q?E("235"):E("236");
return{completeWork:function(a,b,c){var m=b.pendingProps;if(null===m)m=b.memoizedProps;else if(2147483647!==b.expirationTime||2147483647===c)b.pendingProps=null;switch(b.tag){case 1:return null;case 2:return ne(b),null;case 3:z(b);V(X,b);V(ie,b);m=b.stateNode;m.pendingContext&&(m.context=m.pendingContext,m.pendingContext=null);if(null===a||null===a.child)L(b),b.effectTag&=-3;N(b);return null;case 5:y(b);c=v();var A=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,q=b.stateNode,x=u();q=
k(q,A,p,m,c,x);J(a,b,q,A,p,m,c);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!m)return null===b.stateNode?E("166"):void 0,null;a=u();if(L(b))G(b,c,a)&&d(b);else{a=e(A,m,c,a,b);a:for(p=b.child;null!==p;){if(5===p.tag||6===p.tag)g(a,p.stateNode);else if(4!==p.tag&&null!==p.child){p.child["return"]=p;p=p.child;continue}if(p===b)break;for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}h(a,A,m,c)&&d(b);b.stateNode=a}null!==b.ref&&
(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)w(a,b,a.memoizedProps,m);else{if("string"!==typeof m)return null===b.stateNode?E("166"):void 0,null;a=v();c=u();L(b)?I(b)&&d(b):b.stateNode=f(m,a,c,b)}return null;case 7:(m=b.memoizedProps)?void 0:E("165");b.tag=8;A=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==p;){if(5===p.tag||6===p.tag||4===p.tag)E("247");else if(9===p.tag)A.push(p.type);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===
p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=m.handler;m=p(m.props,A);b.child=bf(b,null!==a?a.child:null,m,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 10:return null;case 4:return z(b),N(b),null;case 0:E("167");default:E("156")}}}}
function ff(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(A){b(a,A)}}function d(a){"function"===typeof Ee&&Ee(a);switch(a.tag){case 2:c(a);var d=a.stateNode;if("function"===typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(A){b(a,A)}break;case 5:c(a);break;case 7:e(a.stateNode);break;case 4:k&&g(a)}}function e(a){for(var b=a;;)if(d(b),null===b.child||k&&4===b.tag){if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||
b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function f(a){return 5===a.tag||3===a.tag||4===a.tag}function g(a){for(var b=a,c=!1,f=void 0,g=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?E("160"):void 0;switch(c.tag){case 5:f=c.stateNode;g=!1;break a;case 3:f=c.stateNode.containerInfo;g=!0;break a;case 4:f=c.stateNode.containerInfo;g=!0;break a}c=c["return"]}c=!0}if(5===b.tag||6===b.tag)e(b),g?J(f,b.stateNode):N(f,b.stateNode);
else if(4===b.tag?f=b.stateNode.containerInfo:d(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var h=a.getPublicInstance,k=a.mutation;a=a.persistence;k||(a?E("235"):E("236"));var q=k.commitMount,v=k.commitUpdate,y=k.resetTextContent,u=k.commitTextUpdate,z=k.appendChild,G=k.appendChildToContainer,I=k.insertBefore,L=k.insertInContainerBefore,
N=k.removeChild,J=k.removeChildFromContainer;return{commitResetTextContent:function(a){y(a.stateNode)},commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(f(b)){var c=b;break a}b=b["return"]}E("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:E("161")}c.effectTag&16&&(y(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||f(c["return"])){c=
null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?L(b,e.stateNode,c):I(b,e.stateNode,c):d?G(b,e.stateNode):z(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===
a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){g(a);a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&v(c,f,e,a,d,b)}break;case 6:null===b.stateNode?E("162"):void 0;c=b.memoizedProps;u(b.stateNode,null!==a?a.memoizedProps:
c,c);break;case 3:break;default:E("163")}},commitLifeCycles:function(a,b){switch(b.tag){case 2:var c=b.stateNode;if(b.effectTag&4)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState;c.props=b.memoizedProps;c.state=b.memoizedState;c.componentDidUpdate(d,a)}b=b.updateQueue;null!==b&&Ke(b,c);break;case 3:c=b.updateQueue;null!==c&&Ke(c,null!==b.child?b.child.stateNode:null);break;case 5:c=b.stateNode;null===a&&b.effectTag&4&&q(c,
b.type,b.memoizedProps,b);break;case 6:break;case 4:break;default:E("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:b(h(c));break;default:b(c)}}},commitDetachRef:function(a){a=a.ref;null!==a&&a(null)}}}var gf={};
function hf(a){function b(a){a===gf?E("174"):void 0;return a}var c=a.getChildHostContext,d=a.getRootHostContext,e={current:gf},f={current:gf},g={current:gf};return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){V(e,a);V(f,a);V(g,a)},popHostContext:function(a){f.current===a&&(V(e,a),V(f,a))},pushHostContainer:function(a,b){W(g,b,a);b=d(b);W(f,a,a);W(e,b,a)},pushHostContext:function(a){var d=b(g.current),h=b(e.current);
d=c(h,a.type,d);h!==d&&(W(f,a,a),W(e,d,a))},resetHostContainer:function(){e.current=gf;g.current=gf}}}
function jf(a){function b(a,b){var c=new Y(5,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=g(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];y=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){E("175")},prepareToHydrateHostTextInstance:function(){E("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,g=a.canHydrateTextInstance,h=a.getNextHydratableSibling,k=a.getFirstHydratableChild,q=a.hydrateInstance,v=a.hydrateTextInstance,y=null,u=null,z=!1;return{enterHydrationState:function(a){u=
k(a.stateNode.containerInfo);y=a;return z=!0},resetHydrationState:function(){u=y=null;z=!1},tryToClaimNextHydratableInstance:function(a){if(z){var d=u;if(d){if(!c(a,d)){d=h(d);if(!d||!c(a,d)){a.effectTag|=2;z=!1;y=a;return}b(y,u)}y=a;u=k(d)}else a.effectTag|=2,z=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){b=q(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return v(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
y)return!1;if(!z)return d(a),z=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=u;c;)b(a,c),c=h(c);d(a);u=y?h(a.stateNode):null;return!0}}}
function kf(a){function b(a){Qb=ja=!0;var b=a.stateNode;b.current===a?E("177"):void 0;b.isReadyForCommit=!1;id.current=null;if(1<a.effectTag)if(null!==a.lastEffect){a.lastEffect.nextEffect=a;var c=a.firstEffect}else c=a;else c=a.firstEffect;yg();for(t=c;null!==t;){var d=!1,e=void 0;try{for(;null!==t;){var f=t.effectTag;f&16&&zg(t);if(f&128){var g=t.alternate;null!==g&&Ag(g)}switch(f&-242){case 2:Ne(t);t.effectTag&=-3;break;case 6:Ne(t);t.effectTag&=-3;Oe(t.alternate,t);break;case 4:Oe(t.alternate,
t);break;case 8:Sc=!0,Bg(t),Sc=!1}t=t.nextEffect}}catch(Tc){d=!0,e=Tc}d&&(null===t?E("178"):void 0,h(t,e),null!==t&&(t=t.nextEffect))}Cg();b.current=a;for(t=c;null!==t;){c=!1;d=void 0;try{for(;null!==t;){var k=t.effectTag;k&36&&Dg(t.alternate,t);k&128&&Eg(t);if(k&64)switch(e=t,f=void 0,null!==R&&(f=R.get(e),R["delete"](e),null==f&&null!==e.alternate&&(e=e.alternate,f=R.get(e),R["delete"](e))),null==f?E("184"):void 0,e.tag){case 2:e.stateNode.componentDidCatch(f.error,{componentStack:f.componentStack});
break;case 3:null===ca&&(ca=f.error);break;default:E("157")}var Qc=t.nextEffect;t.nextEffect=null;t=Qc}}catch(Tc){c=!0,d=Tc}c&&(null===t?E("178"):void 0,h(t,d),null!==t&&(t=t.nextEffect))}ja=Qb=!1;"function"===typeof De&&De(a.stateNode);ha&&(ha.forEach(G),ha=null);null!==ca&&(a=ca,ca=null,Ob(a));b=b.current.expirationTime;0===b&&(qa=R=null);return b}function c(a){for(;;){var b=Fg(a.alternate,a,H),c=a["return"],d=a.sibling;var e=a;if(2147483647===H||2147483647!==e.expirationTime){if(2!==e.tag&&3!==
e.tag)var f=0;else f=e.updateQueue,f=null===f?0:f.expirationTime;for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;
if(null!==c)a=c;else{a.stateNode.isReadyForCommit=!0;break}}return null}function d(a){var b=rg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function e(a){var b=Gg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function f(a){if(null!==R){if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=k(F)?e(F):d(F);else for(;null!==F&&!A();)F=k(F)?e(F):d(F)}else if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=d(F);else for(;null!==F&&!A();)F=d(F)}function g(a,b){ja?E("243"):void 0;ja=!0;a.isReadyForCommit=
!1;if(a!==ra||b!==H||null===F){for(;-1<he;)ge[he]=null,he--;je=D;ie.current=D;X.current=!1;x();ra=a;H=b;F=se(ra.current,null,b)}var c=!1,d=null;try{f(b)}catch(Rc){c=!0,d=Rc}for(;c;){if(eb){ca=d;break}var g=F;if(null===g)eb=!0;else{var k=h(g,d);null===k?E("183"):void 0;if(!eb){try{c=k;d=b;for(k=c;null!==g;){switch(g.tag){case 2:ne(g);break;case 5:qg(g);break;case 3:p(g);break;case 4:p(g)}if(g===k||g.alternate===k)break;g=g["return"]}F=e(c);f(d)}catch(Rc){c=!0;d=Rc;continue}break}}}b=ca;eb=ja=!1;ca=
null;null!==b&&Ob(b);return a.isReadyForCommit?a.current.alternate:null}function h(a,b){var c=id.current=null,d=!1,e=!1,f=null;if(3===a.tag)c=a,q(a)&&(eb=!0);else for(var g=a["return"];null!==g&&null===c;){2===g.tag?"function"===typeof g.stateNode.componentDidCatch&&(d=!0,f=jd(g),c=g,e=!0):3===g.tag&&(c=g);if(q(g)){if(Sc||null!==ha&&(ha.has(g)||null!==g.alternate&&ha.has(g.alternate)))return null;c=null;e=!1}g=g["return"]}if(null!==c){null===qa&&(qa=new Set);qa.add(c);var h="";g=a;do{a:switch(g.tag){case 0:case 1:case 2:case 5:var k=
g._debugOwner,Qc=g._debugSource;var m=jd(g);var n=null;k&&(n=jd(k));k=Qc;m="\n    in "+(m||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":n?" (created by "+n+")":"");break a;default:m=""}h+=m;g=g["return"]}while(g);g=h;a=jd(a);null===R&&(R=new Map);b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e};R.set(c,b);try{var p=b.error;p&&p.suppressReactErrorLogging||console.error(p)}catch(Vc){Vc&&
Vc.suppressReactErrorLogging||console.error(Vc)}Qb?(null===ha&&(ha=new Set),ha.add(c)):G(c);return c}null===ca&&(ca=b);return null}function k(a){return null!==R&&(R.has(a)||null!==a.alternate&&R.has(a.alternate))}function q(a){return null!==qa&&(qa.has(a)||null!==a.alternate&&qa.has(a.alternate))}function v(){return 20*(((I()+100)/20|0)+1)}function y(a){return 0!==ka?ka:ja?Qb?1:H:!Hg||a.internalContextTag&1?v():1}function u(a,b){return z(a,b,!1)}function z(a,b){for(;null!==a;){if(0===a.expirationTime||
a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a["return"])if(3===a.tag){var c=a.stateNode;!ja&&c===ra&&b<H&&(F=ra=null,H=0);var d=c,e=b;Rb>Ig&&E("185");if(null===d.nextScheduledRoot)d.remainingExpirationTime=e,null===O?(sa=O=d,d.nextScheduledRoot=d):(O=O.nextScheduledRoot=d,O.nextScheduledRoot=sa);else{var f=d.remainingExpirationTime;if(0===f||e<f)d.remainingExpirationTime=e}Fa||(la?
Sb&&(ma=d,na=1,m(ma,na)):1===e?w(1,null):L(e));!ja&&c===ra&&b<H&&(F=ra=null,H=0)}else break;a=a["return"]}}function G(a){z(a,1,!0)}function I(){return Uc=((Wc()-Pe)/10|0)+2}function L(a){if(0!==Tb){if(a>Tb)return;Jg(Xc)}var b=Wc()-Pe;Tb=a;Xc=Kg(J,{timeout:10*(a-2)-b})}function N(){var a=0,b=null;if(null!==O)for(var c=O,d=sa;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===O?E("244"):void 0;if(d===d.nextScheduledRoot){sa=O=d.nextScheduledRoot=null;break}else if(d===sa)sa=e=d.nextScheduledRoot,
O.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===O){O=c;O.nextScheduledRoot=sa;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===O)break;c=d;d=d.nextScheduledRoot}}c=ma;null!==c&&c===b?Rb++:Rb=0;ma=b;na=a}function J(a){w(0,a)}function w(a,b){fb=b;for(N();null!==ma&&0!==na&&(0===a||na<=a)&&!Yc;)m(ma,na),N();null!==fb&&(Tb=0,Xc=-1);0!==na&&L(na);fb=null;Yc=!1;Rb=0;if(Ub)throw a=Zc,Zc=
null,Ub=!1,a;}function m(a,c){Fa?E("245"):void 0;Fa=!0;if(c<=I()){var d=a.finishedWork;null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(a.remainingExpirationTime=b(d)))}else d=a.finishedWork,null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(A()?a.finishedWork=d:a.remainingExpirationTime=b(d)));Fa=!1}function A(){return null===fb||fb.timeRemaining()>Lg?!1:Yc=!0}function Ob(a){null===ma?E("246"):
void 0;ma.remainingExpirationTime=0;Ub||(Ub=!0,Zc=a)}var r=hf(a),n=jf(a),p=r.popHostContainer,qg=r.popHostContext,x=r.resetHostContainer,Me=df(a,r,n,u,y),rg=Me.beginWork,Gg=Me.beginFailedWork,Fg=ef(a,r,n).completeWork;r=ff(a,h);var zg=r.commitResetTextContent,Ne=r.commitPlacement,Bg=r.commitDeletion,Oe=r.commitWork,Dg=r.commitLifeCycles,Eg=r.commitAttachRef,Ag=r.commitDetachRef,Wc=a.now,Kg=a.scheduleDeferredCallback,Jg=a.cancelDeferredCallback,Hg=a.useSyncScheduling,yg=a.prepareForCommit,Cg=a.resetAfterCommit,
Pe=Wc(),Uc=2,ka=0,ja=!1,F=null,ra=null,H=0,t=null,R=null,qa=null,ha=null,ca=null,eb=!1,Qb=!1,Sc=!1,sa=null,O=null,Tb=0,Xc=-1,Fa=!1,ma=null,na=0,Yc=!1,Ub=!1,Zc=null,fb=null,la=!1,Sb=!1,Ig=1E3,Rb=0,Lg=1;return{computeAsyncExpiration:v,computeExpirationForFiber:y,scheduleWork:u,batchedUpdates:function(a,b){var c=la;la=!0;try{return a(b)}finally{(la=c)||Fa||w(1,null)}},unbatchedUpdates:function(a){if(la&&!Sb){Sb=!0;try{return a()}finally{Sb=!1}}return a()},flushSync:function(a){var b=la;la=!0;try{a:{var c=
ka;ka=1;try{var d=a();break a}finally{ka=c}d=void 0}return d}finally{la=b,Fa?E("187"):void 0,w(1,null)}},deferredUpdates:function(a){var b=ka;ka=v();try{return a()}finally{ka=b}}}}
function lf(a){function b(a){a=od(a);return null===a?null:a.stateNode}var c=a.getPublicInstance;a=kf(a);var d=a.computeAsyncExpiration,e=a.computeExpirationForFiber,f=a.scheduleWork;return{createContainer:function(a,b){var c=new Y(3,null,0);a={current:c,containerInfo:a,pendingChildren:null,remainingExpirationTime:0,isReadyForCommit:!1,finishedWork:null,context:null,pendingContext:null,hydrate:b,nextScheduledRoot:null};return c.stateNode=a},updateContainer:function(a,b,c,q){var g=b.current;if(c){c=
c._reactInternalFiber;var h;b:{2===kd(c)&&2===c.tag?void 0:E("170");for(h=c;3!==h.tag;){if(le(h)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}(h=h["return"])?void 0:E("171")}h=h.stateNode.context}c=le(c)?pe(c,h):h}else c=D;null===b.context?b.context=c:b.pendingContext=c;b=q;b=void 0===b?null:b;q=null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent?d():e(g);He(g,{expirationTime:q,partialState:{element:a},callback:b,isReplace:!1,isForced:!1,
nextCallback:null,next:null});f(g,q)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:b,findHostInstanceWithNoPortals:function(a){a=pd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var c=a.findFiberByHostInstance;return Ce(B({},
a,{findHostInstanceByFiber:function(a){return b(a)},findFiberByHostInstance:function(a){return c?c(a):null}}))}}}var mf=Object.freeze({default:lf}),nf=mf&&lf||mf,of=nf["default"]?nf["default"]:nf;function pf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ue,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var qf="object"===typeof performance&&"function"===typeof performance.now,rf=void 0;rf=qf?function(){return performance.now()}:function(){return Date.now()};
var sf=void 0,tf=void 0;
if(l.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var uf=null,vf=!1,wf=-1,xf=!1,yf=0,zf=33,Af=33,Bf;Bf=qf?{didTimeout:!1,timeRemaining:function(){var a=yf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=yf-Date.now();return 0<a?a:0}};var Cf="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Cf){vf=!1;a=rf();if(0>=yf-a)if(-1!==wf&&wf<=
a)Bf.didTimeout=!0;else{xf||(xf=!0,requestAnimationFrame(Df));return}else Bf.didTimeout=!1;wf=-1;a=uf;uf=null;null!==a&&a(Bf)}},!1);var Df=function(a){xf=!1;var b=a-yf+Af;b<Af&&zf<Af?(8>b&&(b=8),Af=b<zf?zf:b):zf=b;yf=a+Af;vf||(vf=!0,window.postMessage(Cf,"*"))};sf=function(a,b){uf=a;null!=b&&"number"===typeof b.timeout&&(wf=rf()+b.timeout);xf||(xf=!0,requestAnimationFrame(Df));return 0};tf=function(){uf=null;vf=!1;wf=-1}}else sf=window.requestIdleCallback,tf=window.cancelIdleCallback;else sf=function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity}})})},
tf=function(a){clearTimeout(a)};var Ef=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Ff={},Gf={};
function Hf(a){if(Gf.hasOwnProperty(a))return!0;if(Ff.hasOwnProperty(a))return!1;if(Ef.test(a))return Gf[a]=!0;Ff[a]=!0;return!1}
function If(a,b,c){var d=wa(b);if(d&&va(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?Jf(a,b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else Kf(a,b,va(b,c)?c:null)}
function Kf(a,b,c){Hf(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))}function Jf(a,b){var c=wa(b);c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=c.hasBooleanValue?!1:"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}
function Lf(a,b){var c=b.value,d=b.checked;return B({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?d:a._wrapperState.initialChecked})}function Mf(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}
function Nf(a,b){b=b.checked;null!=b&&If(a,"checked",b)}function Of(a,b){Nf(a,b);var c=b.value;if(null!=c)if(0===c&&""===a.value)a.value="0";else if("number"===b.type){if(b=parseFloat(a.value)||0,c!=b||c==b&&a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Pf(a,b){switch(b.type){case "submit":case "reset":break;case "color":case "date":case "datetime":case "datetime-local":case "month":case "time":case "week":a.value="";a.value=a.defaultValue;break;default:a.value=a.value}b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Qf(a){var b="";aa.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
function Rf(a,b){a=B({children:void 0},b);if(b=Qf(b.children))a.children=b;return a}function Sf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Tf(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Uf(a,b){null!=b.dangerouslySetInnerHTML?E("91"):void 0;return B({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Vf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?E("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:E("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Wf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Xf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Yf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Zf(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function $f(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Zf(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ag=void 0,bg=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Yf.svg||"innerHTML"in a)a.innerHTML=b;else{ag=ag||document.createElement("div");ag.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=ag.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function cg(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var dg={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},eg=["Webkit","ms","Moz","O"];Object.keys(dg).forEach(function(a){eg.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);dg[b]=dg[a]})});
function fg(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||dg.hasOwnProperty(e)&&dg[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var gg=B({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function hg(a,b,c){b&&(gg[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?E("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?E("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:E("61")),null!=b.style&&"object"!==typeof b.style?E("62",c()):void 0)}
function ig(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var jg=Yf.html,kg=C.thatReturns("");
function lg(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Hd(a);b=Sa[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?wd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(wd("topFocus","focus",a),wd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(yc("cancel",!0)&&wd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(yc("close",!0)&&wd("topClose","close",a),c.topClose=!0):Dd.hasOwnProperty(e)&&U(e,Dd[e],a),c[e]=!0)}}
var mg={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",
topWaiting:"waiting"};function ng(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===jg&&(d=Zf(a));d===jg?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function og(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function pg(a,b,c,d){var e=ig(b,c);switch(b){case "iframe":case "object":U("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);f=c;break;case "source":U("topError","error",a);f=c;break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);f=c;break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);f=c;break;case "details":U("topToggle","toggle",a);f=c;break;case "input":Mf(a,c);f=Lf(a,c);U("topInvalid","invalid",a);
lg(d,"onChange");break;case "option":f=Rf(a,c);break;case "select":Tf(a,c);f=B({},c,{value:void 0});U("topInvalid","invalid",a);lg(d,"onChange");break;case "textarea":Vf(a,c);f=Uf(a,c);U("topInvalid","invalid",a);lg(d,"onChange");break;default:f=c}hg(b,f,kg);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?fg(a,k,kg):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&bg(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&cg(a,k):"number"===typeof k&&cg(a,
""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(Ra.hasOwnProperty(h)?null!=k&&lg(d,h):e?Kf(a,h,k):null!=k&&If(a,h,k))}switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Sf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Sf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=
C)}}
function sg(a,b,c,d,e){var f=null;switch(b){case "input":c=Lf(a,c);d=Lf(a,d);f=[];break;case "option":c=Rf(a,c);d=Rf(a,d);f=[];break;case "select":c=B({},c,{value:void 0});d=B({},d,{value:void 0});f=[];break;case "textarea":c=Uf(a,c);d=Uf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}hg(b,d,kg);var g,h;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(h in b=c[g],b)b.hasOwnProperty(h)&&(a||(a={}),a[h]=
"");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(Ra.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var k=d[g];b=null!=c?c[g]:void 0;if(d.hasOwnProperty(g)&&k!==b&&(null!=k||null!=b))if("style"===g)if(b){for(h in b)!b.hasOwnProperty(h)||k&&k.hasOwnProperty(h)||(a||(a={}),a[h]="");for(h in k)k.hasOwnProperty(h)&&b[h]!==k[h]&&(a||(a={}),a[h]=k[h])}else a||(f||(f=[]),f.push(g,a)),a=k;else"dangerouslySetInnerHTML"===
g?(k=k?k.__html:void 0,b=b?b.__html:void 0,null!=k&&b!==k&&(f=f||[]).push(g,""+k)):"children"===g?b===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(g,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&(Ra.hasOwnProperty(g)?(null!=k&&lg(e,g),f||b===k||(f=[])):(f=f||[]).push(g,k))}a&&(f=f||[]).push("style",a);return f}
function tg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Nf(a,e);ig(c,d);d=ig(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?fg(a,h,kg):"dangerouslySetInnerHTML"===g?bg(a,h):"children"===g?cg(a,h):d?null!=h?Kf(a,g,h):a.removeAttribute(g):null!=h?If(a,g,h):Jf(a,g)}switch(c){case "input":Of(a,e);break;case "textarea":Wf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Sf(a,
!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?Sf(a,!!e.multiple,e.defaultValue,!0):Sf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function ug(a,b,c,d,e){switch(b){case "iframe":case "object":U("topLoad","load",a);break;case "video":case "audio":for(var f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);break;case "source":U("topError","error",a);break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);break;case "details":U("topToggle","toggle",a);break;case "input":Mf(a,c);U("topInvalid","invalid",a);lg(e,"onChange");break;case "select":Tf(a,c);
U("topInvalid","invalid",a);lg(e,"onChange");break;case "textarea":Vf(a,c),U("topInvalid","invalid",a),lg(e,"onChange")}hg(b,c,kg);d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Ra.hasOwnProperty(g)&&null!=f&&lg(e,g));switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function vg(a,b){return a.nodeValue!==b}
var wg=Object.freeze({createElement:ng,createTextNode:og,setInitialProperties:pg,diffProperties:sg,updateProperties:tg,diffHydratedProperties:ug,diffHydratedText:vg,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Of(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=rb(d);e?void 0:E("90");Cc(d);Of(d,e)}}}break;case "textarea":Wf(a,c);break;case "select":b=c.value,null!=b&&Sf(a,!!c.multiple,b,!1)}}});nc.injectFiberControlledHostComponent(wg);var xg=null,Mg=null;function Ng(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function Og(a){a=a?9===a.nodeType?a.documentElement:a.firstChild:null;return!(!a||1!==a.nodeType||!a.hasAttribute("data-reactroot"))}
var Z=of({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:$f(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=$f(a,b)}return a},getChildHostContext:function(a,b){return $f(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){xg=td;var a=da();if(Kd(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(z){b=null;break a}var f=0,g=-1,h=-1,k=0,q=0,v=a,y=null;b:for(;;){for(var u;;){v!==b||0!==d&&3!==v.nodeType||(g=f+d);v!==e||0!==c&&3!==v.nodeType||(h=f+c);3===v.nodeType&&(f+=v.nodeValue.length);if(null===(u=v.firstChild))break;y=v;v=u}for(;;){if(v===a)break b;y===b&&++k===d&&(g=f);y===e&&++q===c&&(h=f);if(null!==(u=v.nextSibling))break;v=y;y=v.parentNode}v=u}b=-1===g||-1===h?null:
{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;Mg={focusedElem:a,selectionRange:b};ud(!1)},resetAfterCommit:function(){var a=Mg,b=da(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&fa(document.documentElement,c)){if(Kd(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[Eb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=Jd(c,a);var f=Jd(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var g=document.createRange();g.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(g),b.extend(f.node,f.offset)):(g.setEnd(f.node,f.offset),b.addRange(g))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});ia(c);for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=
a.top}Mg=null;ud(xg);xg=null},createInstance:function(a,b,c,d,e){a=ng(a,b,c,d);a[Q]=e;a[ob]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){pg(a,b,c,d);a:{switch(b){case "button":case "input":case "select":case "textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return sg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===
typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=og(a,b);a[Q]=d;return a},now:rf,mutation:{commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){a[ob]=e;tg(a,b,c,d,e)},resetTextContent:function(a){a.textContent=""},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,
b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,
b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[Q]=f;a[ob]=c;return ug(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[Q]=c;return vg(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},
didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:sf,cancelDeferredCallback:tf,useSyncScheduling:!0});rc=Z.batchedUpdates;
function Pg(a,b,c,d,e){Ng(c)?void 0:E("200");var f=c._reactRootContainer;if(f)Z.updateContainer(b,f,a,e);else{d=d||Og(c);if(!d)for(f=void 0;f=c.lastChild;)c.removeChild(f);var g=Z.createContainer(c,d);f=c._reactRootContainer=g;Z.unbatchedUpdates(function(){Z.updateContainer(b,g,a,e)})}return Z.getPublicRootInstance(f)}function Qg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Ng(b)?void 0:E("200");return pf(a,b,null,c)}
function Rg(a,b){this._reactRootContainer=Z.createContainer(a,b)}Rg.prototype.render=function(a,b){Z.updateContainer(a,this._reactRootContainer,null,b)};Rg.prototype.unmount=function(a){Z.updateContainer(null,this._reactRootContainer,null,a)};
var Sg={createPortal:Qg,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(b)return Z.findHostInstance(b);"function"===typeof a.render?E("188"):E("213",Object.keys(a))},hydrate:function(a,b,c){return Pg(null,a,b,!0,c)},render:function(a,b,c){return Pg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?E("38"):void 0;return Pg(a,b,c,!1,d)},unmountComponentAtNode:function(a){Ng(a)?void 0:
E("40");return a._reactRootContainer?(Z.unbatchedUpdates(function(){Pg(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:Qg,unstable_batchedUpdates:tc,unstable_deferredUpdates:Z.deferredUpdates,flushSync:Z.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:mb,EventPluginRegistry:Va,EventPropagators:Cb,ReactControlledComponent:qc,ReactDOMComponentTree:sb,ReactDOMEventListener:xd}};
Z.injectIntoDevTools({findFiberByHostInstance:pb,bundleType:0,version:"16.2.0",rendererPackageName:"react-dom"});var Tg=Object.freeze({default:Sg}),Ug=Tg&&Sg||Tg;module.exports=Ug["default"]?Ug["default"]:Ug;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(36);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(114);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(115);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(145), __webpack_require__(172), __webpack_require__(16), __webpack_require__(229), __webpack_require__(176), __webpack_require__(183), __webpack_require__(196), __webpack_require__(201), __webpack_require__(221), __webpack_require__(224), __webpack_require__(227)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("react-redux"), require("../store/store"), require("./screens/preloader/Preloader"), require("../store/reducers/screen"), require("./screens/game/Game"), require("./screens/game-intro/GameIntro"), require("./screens/main-menu/MainMenu"), require("./debug/DebugConsole"), require("./screens/mini-game/MiniGame"), require("./screens/leaderboard/Leaderboard"), require("./screens/how-to-play/HowToPlay"), require("./PowerMapGame.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.reactRedux, global.store, global.Preloader, global.screen, global.Game, global.GameIntro, global.MainMenu, global.DebugConsole, global.MiniGame, global.Leaderboard, global.HowToPlay, global.PowerMapGame);
        global.PowerMapGame = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _reactRedux, _store, _Preloader, _screen, _Game, _GameIntro, _MainMenu, _DebugConsole, _MiniGame, _Leaderboard, _HowToPlay) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.PowerMapGame = undefined;

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    var _Preloader2 = _interopRequireDefault(_Preloader);

    var _Game2 = _interopRequireDefault(_Game);

    var _GameIntro2 = _interopRequireDefault(_GameIntro);

    var _MainMenu2 = _interopRequireDefault(_MainMenu);

    var _DebugConsole2 = _interopRequireDefault(_DebugConsole);

    var _MiniGame2 = _interopRequireDefault(_MiniGame);

    var _Leaderboard2 = _interopRequireDefault(_Leaderboard);

    var _HowToPlay2 = _interopRequireDefault(_HowToPlay);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./PowerMapGame.scss": {
            "power-map-game": "PowerMapGame__power-map-game___6OQgx"
        }
    };

    var PowerMapGame = function (_super) {
        tslib_1.__extends(PowerMapGame, _super);
        function PowerMapGame(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            return _this;
        }
        PowerMapGame.prototype.render = function () {
            return React.createElement(
                _reactRedux.Provider,
                { store: _store.store },
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('power-map-game', _styleModuleImportMap)
                    },
                    React.createElement(_Preloader2.default, { screen: _screen.SCREENS.PRELOADER }),
                    React.createElement(_GameIntro2.default, { screen: _screen.SCREENS.INTRO }),
                    React.createElement(_HowToPlay2.default, { screen: _screen.SCREENS.HOW_TO_PLAY }),
                    React.createElement(_Leaderboard2.default, { screen: _screen.SCREENS.LEADERBOARD }),
                    React.createElement(_GameIntro2.default, { screen: _screen.SCREENS.GAME_INTRO }),
                    React.createElement(_Game2.default, { screen: _screen.SCREENS.GAME }),
                    React.createElement(_MiniGame2.default, { screen: _screen.SCREENS.MINI_GAME }),
                    React.createElement(_MainMenu2.default, { screen: _screen.SCREENS.MAIN_MENU }),
                    React.createElement(_DebugConsole2.default, null)
                )
            );
        };
        return PowerMapGame;
    }(React.Component);
    exports.PowerMapGame = PowerMapGame;
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(44);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(36);
var invariant = __webpack_require__(62);
var ReactPropTypesSecret = __webpack_require__(120);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(143);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(69);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(131);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(129);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)))

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(66);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(133);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(136);


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(137);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46), __webpack_require__(47)(module)))

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(67);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(68);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(69);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(70);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(144);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(44);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(20), __webpack_require__(41), __webpack_require__(16), __webpack_require__(50), __webpack_require__(37), __webpack_require__(17), __webpack_require__(153), __webpack_require__(13), __webpack_require__(76), __webpack_require__(154), __webpack_require__(155), __webpack_require__(85), __webpack_require__(169), __webpack_require__(170), __webpack_require__(86), __webpack_require__(57), __webpack_require__(53), __webpack_require__(38), __webpack_require__(87), __webpack_require__(55), __webpack_require__(88), __webpack_require__(12), __webpack_require__(52), __webpack_require__(89), __webpack_require__(79), __webpack_require__(30), __webpack_require__(90), __webpack_require__(42), __webpack_require__(28), __webpack_require__(91), __webpack_require__(171)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("redux"), require("redux-saga"), require("./reducers/screen"), require("./reducers/popup"), require("./reducers/location"), require("./reducers/modal"), require("./reducers/outputs"), require("./reducers/powerSources"), require("./reducers/timer"), require("./reducers/debug-console/debugConsole"), require("./sagas/rootSagas"), require("./reducers/questions/outageQuestion"), require("./reducers/answer"), require("./reducers/event"), require("./reducers/interaction"), require("./reducers/score"), require("./reducers/results"), require("./reducers/draggingPowerSource"), require("./reducers/map/mapOffset"), require("./reducers/highlightLocation"), require("./reducers/season"), require("./reducers/year"), require("./reducers/energy/energyDemand"), require("./reducers/questions/yearEndQuestion"), require("./reducers/savedPowerSourceCounts"), require("./reducers/power-sources/damage"), require("./reducers/map/mapBounds"), require("./reducers/mini-game/miniGame"), require("./reducers/power-sources/deprecate"), require("./reducers/questions/correctAnswers"), require("./reducers/mini-game/energyGenerated"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.redux, global.reduxSaga, global.screen, global.popup, global.location, global.modal, global.outputs, global.powerSources, global.timer, global.debugConsole, global.rootSagas, global.outageQuestion, global.answer, global.event, global.interaction, global.score, global.results, global.draggingPowerSource, global.mapOffset, global.highlightLocation, global.season, global.year, global.energyDemand, global.yearEndQuestion, global.savedPowerSourceCounts, global.damage, global.mapBounds, global.miniGame, global.deprecate, global.correctAnswers, global.energyGenerated);
        global.store = mod.exports;
    }
})(this, function (exports, _redux, _reduxSaga, _screen, _popup, _location, _modal, _outputs, _powerSources, _timer, _debugConsole, _rootSagas, _outageQuestion, _answer, _event, _interaction, _score, _results, _draggingPowerSource, _mapOffset, _highlightLocation, _season, _year, _energyDemand, _yearEndQuestion, _savedPowerSourceCounts, _damage, _mapBounds, _miniGame, _deprecate, _correctAnswers, _energyGenerated) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.store = undefined;
    exports.logStore = logStore;

    var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

    var _rootSagas2 = _interopRequireDefault(_rootSagas);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var initialState = {};
    var root_reducer = (0, _redux.combineReducers)({
        screen: _screen.screen,
        modal: _modal.modal,
        popup: _popup.popup,
        interaction: _interaction.interaction,
        location: _location.location,
        highlightLocation: _highlightLocation.highlightLocation,
        powerSources: _powerSources.powerSources,
        powerSourcesCountsByType: _savedPowerSourceCounts.savedPowerSourceCounts,
        outputs: _outputs.outputs,
        energyDemand: _energyDemand.energyDemand,
        energyGenerated: _energyGenerated.energyGenerated,
        timer: _timer.timer,
        season: _season.season,
        year: _year.year,
        debugConsole: _debugConsole.debugConsole,
        damage: _damage.damage,
        deprecate: _deprecate.deprecate,
        miniGame: _miniGame.miniGame,
        outageQuestion: _outageQuestion.outageQuestion,
        yearEndQuestion: _yearEndQuestion.yearEndQuestion,
        answer: _answer.answer,
        event: _event.event,
        resultsPanelOpen: _results.resultsPanelOpen,
        score: _score.score,
        draggingPowerSource: _draggingPowerSource.draggingPowerSource,
        draggingOrigin: _draggingPowerSource.draggingOrigin,
        correctAnswers: _correctAnswers.correctAnswers,
        mapOffset: _mapOffset.mapOffset,
        mapBounds: _mapBounds.mapBounds
    });
    var saga_middleware = (0, _reduxSaga2.default)();
    var store = exports.store = (0, _redux.createStore)(root_reducer, initialState, (0, _redux.applyMiddleware)(saga_middleware));
    saga_middleware.run(_rootSagas2.default);
    function logStore() {
        console.info('logStore', store.getState());
    }
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sagaMiddlewareFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channel__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__runSaga__ = __webpack_require__(73);
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }





function sagaMiddlewareFactory(_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? {} : _ref2$context,
      options = _objectWithoutProperties(_ref2, ["context"]);

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError,
      effectMiddlewares = options.effectMiddlewares;

  if (false) {
    if (is.notUndef(logger)) {
      check(logger, is.func, 'options.logger passed to the Saga middleware is not a function!');
    }

    if (is.notUndef(onError)) {
      check(onError, is.func, 'options.onError passed to the Saga middleware is not a function!');
    }

    if (is.notUndef(options.emitter)) {
      check(options.emitter, is.func, 'options.emitter passed to the Saga middleware is not a function!');
    }
  }

  function sagaMiddleware(_ref3) {
    var getState = _ref3.getState,
        dispatch = _ref3.dispatch;
    var channel = Object(__WEBPACK_IMPORTED_MODULE_1__channel__["f" /* stdChannel */])();
    channel.put = (options.emitter || __WEBPACK_IMPORTED_MODULE_0__utils__["g" /* identity */])(channel.put);
    sagaMiddleware.run = __WEBPACK_IMPORTED_MODULE_2__runSaga__["a" /* runSaga */].bind(null, {
      context: context,
      channel: channel,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor,
      logger: logger,
      onError: onError,
      effectMiddlewares: effectMiddlewares
    });
    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }

        var result = next(action); // hit reducers

        channel.put(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
  };

  sagaMiddleware.setContext = function (props) {
    if (false) {
      check(props, is.object, createSetContextWarning('sagaMiddleware', props));
    }

    __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* object */].assign(context, props);
  };

  return sagaMiddleware;
}

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__takeEvery__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__takeLatest__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__throttle__ = __webpack_require__(150);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__takeEvery__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__takeLatest__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__throttle__["a"]; });





/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeEvery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(23);



function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = {
    done: false,
    value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["t" /* take */])(patternOrChannel)
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: __WEBPACK_IMPORTED_MODULE_1__io__["k" /* fork */].apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var action,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q1', yFork(action)];
    }
  }, 'q1', "takeEvery(" + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ", " + worker.name + ")");
}

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeLatest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(23);



function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = {
    done: false,
    value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["t" /* take */])(patternOrChannel)
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: __WEBPACK_IMPORTED_MODULE_1__io__["k" /* fork */].apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var yCancel = function yCancel(task) {
    return {
      done: false,
      value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["f" /* cancel */])(task)
    };
  };

  var task, action;

  var setTask = function setTask(t) {
    return task = t;
  };

  var setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
    },
    q3: function q3() {
      return ['q1', yFork(action), setTask];
    }
  }, 'q1', "takeLatest(" + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ", " + worker.name + ")");
}

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buffers__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(14);





function throttle(delayLength, pattern, worker) {
  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action, channel;
  var yActionChannel = {
    done: false,
    value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["a" /* actionChannel */])(pattern, __WEBPACK_IMPORTED_MODULE_3__buffers__["sliding"](1))
  };

  var yTake = function yTake() {
    return {
      done: false,
      value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["t" /* take */])(channel)
    };
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: __WEBPACK_IMPORTED_MODULE_1__io__["k" /* fork */].apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var yDelay = {
    done: false,
    value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["e" /* call */])(__WEBPACK_IMPORTED_MODULE_4__utils__["f" /* delay */], delayLength)
  };

  var setAction = function setAction(ac) {
    return action = ac;
  };

  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    }
  }, 'q1', "throttle(" + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(pattern) + ", " + worker.name + ")");
}

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_utils__ = __webpack_require__(14);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "noop", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "is", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "deferred", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "arrayOfDeferred", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createMockTask", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cloneableGenerator", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_symbols__ = __webpack_require__(27);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SAGA_ACTION", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_symbols__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TASK", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_symbols__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_io__ = __webpack_require__(24);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "asEffect", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_io__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_proc__ = __webpack_require__(74);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CHANNEL_END", function() { return __WEBPACK_IMPORTED_MODULE_3__internal_proc__["a"]; });





/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports = {"power-sources":[{"id":"solar","label":"solar","type":"renewable","cost-per-mw":52,"energy-output":1.4,"environmental-impact":0,"carbon-output":0,"requirements":["land","coastal"],"max":35,"requirement-reason":"solar power plants must be placed on the land.","description":"The UK isn’t known for being a sunny destination, but <b>we get enough sunlight to make solar power a viable energy source</b> – even if it’s only ever going to be a relatively small contributor to our energy mix! <b>(*This is a clue!*)</b>\n\nSolar is a <b>low-carbon power source</b>: no carbon emissions are released to convert the sun’s energy into electricity, and it doesn't produce pollution either.\n\nLike wind power though, it’s <b>highly variable</b>: you don’t get much power from solar during our dark British winters, or at all in the night! So <b>you need to include other, more predictable power sources in your mix too</b> – like nuclear and gas – to balance supply.\n\nYou’re also restricted in how many solar farms you can put on the map: too many might be unpopular with residents and becomes expensive to manage. This is because solar power can’t be stored very easily or cheaply over a long period (from one season to the next).\n","vo":null},{"id":"nuclear","label":"nuclear","type":"nuclear","cost-per-mw":69,"energy-output":12.6,"environmental-impact":0,"carbon-output":0,"max":13,"requirements":["coastal"],"requirement-reason":"nuclear power plants must be placed on the coast","description":"Nuclear power stations use the energy released from a controlled nuclear reaction to heat water into steam, which drives turbines. <b>They need to be located near water</b>, as this is pumped in to cool down the steam so it can be re-used in the process.\n\nNuclear is a <b>low-carbon source of power</b>. It uses a non-renewable fuel (uranium) to produce the nuclear reaction, but no carbon is released during the generation process.\n\nNuclear power stations provide <b>baseload electricity</b>, so they can be relied on to produce power throughout the year, whether day or night. They also have a <b>higher output than renewables</b> – and don’t take up anywhere near as much land.\n\nBut building a nuclear power station is a big project – involving government and lots of organisations – and works best in the energy mix alongside a combination of other sources.\n"},{"id":"wind-land","label":"wind","type":"renewable","cost-per-mw":45,"energy-output":4.2,"energy-multipliers":[1,0.33,0.33,1],"environmental-impact":0,"carbon-output":0,"description":"<b>Wind is a low-carbon power source:</b> turbines don’t emit any carbon emissions or produce pollution, and they’re also relatively inexpensive to run, with no fuel costs.\n\nWe’re also a windy country, so wind is in plentiful supply!\n\nOnshore wind generates more electricity than offshore at the moment – simply because there are more of them. But you’re limited with onshore wind by the available land space… Wind farms can’t be built in areas of outstanding national beauty and if you covered the UK in wind farms, you wouldn’t be very popular with residents!\n\nRemember too that <b>this renewable power source is highly variable</b>: no wind means no electricity.\n\nSo <b>you need other, more predictable power sources in your mix too</b> – like nuclear and gas – to help balance supply.\n"},{"id":"wind-sea","label":"wind","type":"renewable","cost-per-mw":66,"energy-output":6,"energy-multipliers":[1,0.33,0.33,1],"environmental-impact":0,"carbon-output":0,"description":"Offshore wind is a <b>low-carbon power source</b>: turbines don’t emit any carbon emissions or produce pollution, and they’re also relatively inexpensive to run, with no fuel costs.\n\nOffshore wind farms have bigger turbines than their onshore equivalents, so they can generate more electricity. But it’s trickier and more expensive to build a wind turbine out at sea.\n\nWind speeds are stronger out at sea, but offshore wind is still a <b>highly variable power source</b>. So if there’s no wind, there’s no electricity.\n\nThis is <b>why you need other, more predictable power sources in your energy mix too</b> – like nuclear and gas – to help balance supply.\n","include":false},{"id":"coal","label":"coal","type":"fossil","cost-per-mw":114,"energy-output":6.3,"environmental-impact":10,"carbon-output":1,"requirements":["land","coastal"],"requirement-reason":"coal power plants must be placed on the land","description":"Coal power stations use the heat from burning coal to turn water into steam, which drives a turbine to produce electricity.\n\nCoal power plants have long been used to <b>provide baseload electricity</b>, as the cost of generation is low and plants can be run 24/7. It’s also a <b>flexible power source</b>, as a sudden increase in demand can be met by burning more coal.\n\nBut coal is a fossil fuel and generating electricity this way produces high carbon emissions – THREE TIMES more than gas. This is why it’s being phased out by the Government.\n"},{"id":"gas","label":"gas","type":"fossil","cost-per-mw":128,"energy-output":6.3,"environmental-impact":5,"carbon-output":1,"requirements":["land","coastal"],"requirement-reason":"gas power plants must be placed on the coast","description":"Gas power stations use the heat from burning gas to turn water into steam, which drives a turbine to produce electricity.\n\nGas has become a popular energy source as it’s a <b>reliable, flexible and fairly low-cost way to generate lots of power</b>. So if there’s a sudden increase in demand, it can be met by burning more gas.\n\nBut gas is a fossil fuel, so generating electricity this way produces carbon dioxide and contributes to climate change.\n"},{"id":"other","label":"other renewables","type":"renewable","cost-per-mw":87,"energy-output":6,"environmental-impact":0,"carbon-output":0,"description":"Other renewables includes hydropower, biomass and other smaller types of renewable generation – such as tidal, wave and geothermal.\n\n<b>Hydropower</b> is one of the oldest and most reliable low-carbon power sources. The Dinorwig power station in Wales can go from zero to 1,320MW in 12 seconds! But hydropower needs both a large body of water and a big drop next to it, which limits the number of places where hydropower plants can be built.\n\n<b>Biomass</b> power plants produce electricity from burning organic matter – like woodchips, even chicken poo  – which is why it’s often referred to as a low-carbon power source . Critics, however, say that new fuel isn't being grown quickly enough to keep pace . The Government also plans to remove financial support for some types of biomass over the period .\n\n<b>Other renewable technologies like tidal and wave</b> are still at an early stage of development; while we’re limited geographically by our ability to generate power from <b>geothermal energy</b>.\n\nSince the scale of these other renewables is limited, the number of ‘other renewables’ power stations is fixed in the game and <b>you can’t add or remove these pins from your map</b>. They will deliver the same amount of low-carbon energy sources by 2032 as they do today.\n","include":false,"removable":false}],"power-source-locations":[{"position":[59,49],"type":"land","vo":"land"},{"position":[51,46],"type":"land","vo":"land"},{"position":[47,25],"type":"land","vo":"land"},{"position":[36,53],"type":"land","vo":"land"},{"position":[53,40],"type":"land","vo":"land"},{"position":[46,36],"type":"land","vo":"land"},{"position":[79,76],"type":"land","vo":"land"},{"position":[56,66],"type":"land","vo":"land"},{"position":[43,39],"type":"land","vo":"land"},{"position":[57,76],"type":"land","vo":"land"},{"position":[71,73],"type":"land","vo":"land"},{"position":[76,66],"type":"land","vo":"land"},{"position":[67,66],"type":"land","vo":"land"},{"position":[75,71],"type":"land","vo":"land"},{"position":[58,63],"type":"land","vo":"land"},{"position":[69,54],"type":"land","vo":"land"},{"position":[51,35],"type":"land","vo":"land"},{"position":[68,71],"type":"land","vo":"land"},{"position":[47,43],"type":"land","vo":"land"},{"position":[49,50],"type":"land","vo":"land"},{"position":[65,55],"type":"land","vo":"land"},{"position":[55,36],"type":"land","vo":"land"},{"position":[46,29],"type":"land","vo":"land"},{"position":[30,55],"type":"land","vo":"land"},{"position":[51,32],"type":"land","vo":"land"},{"position":[43,33],"type":"land","vo":"land"},{"position":[27,53],"type":"land","vo":"land"},{"position":[52,63],"type":"land","vo":"land"},{"position":[57,60],"type":"land","vo":"land"},{"position":[48,79],"type":"land","vo":"land"},{"position":[64,74],"type":"land","vo":"land"},{"position":[82,65],"type":"land","vo":"land"},{"position":[62,62],"type":"land","vo":"land"},{"position":[71,68],"type":"land","vo":"land"},{"position":[48,47],"type":"land","vo":"land"},{"position":[64,58],"type":"land","vo":"land"},{"position":[73,60],"type":"land","vo":"land"},{"position":[56,52],"type":"land","vo":"land"},{"position":[54,46],"type":"land","vo":"land"},{"position":[25,50],"type":"land","vo":"land"},{"position":[67,59],"type":"land","vo":"land"},{"position":[53,43],"type":"land","vo":"land"},{"position":[47,33],"type":"land","vo":"land"},{"position":[32,52],"type":"land","vo":"land"},{"position":[57,31],"type":"land","vo":"land"},{"position":[48,40],"type":"land","vo":"land"},{"position":[80,69],"type":"land","vo":"land"},{"position":[64,69],"type":"land","vo":"land"},{"position":[59,70],"type":"land","vo":"land"},{"position":[34,49],"type":"land","vo":"land"},{"position":[61,53],"type":"land","vo":"land"},{"position":[54,78],"type":"land","vo":"land"},{"position":[51,24],"type":"land","vo":"land"},{"position":[54,70],"type":"land","vo":"land"},{"position":[49,71],"type":"land","vo":"land"},{"position":[60,57],"type":"land","vo":"land"},{"position":[70,62],"type":"land","vo":"land"},{"position":[62,66],"type":"land","vo":"land"},{"position":[62,47],"type":"land","vo":"land"},{"position":[58,44],"type":"land","vo":"land"},{"position":[64,45],"type":"coastal","vo":"coastal"},{"position":[23,53],"type":"coastal","vo":"coastal"},{"position":[66,51],"type":"coastal","vo":"coastal"},{"position":[38,30],"type":"coastal","vo":"coastal"},{"position":[63,31],"type":"coastal","vo":"coastal"},{"position":[43,49],"type":"coastal","vo":"coastal"},{"position":[47,62],"type":"coastal","vo":"coastal"},{"position":[42,71],"type":"coastal","vo":"coastal"},{"position":[51,73],"type":"coastal","vo":"coastal"},{"position":[55,23],"type":"coastal","vo":"coastal"},{"position":[58,40],"type":"coastal","vo":"coastal"},{"position":[44,44],"type":"coastal","vo":"coastal"},{"position":[49,66],"type":"coastal","vo":"coastal"},{"position":[51,82],"type":"coastal","vo":"coastal"},{"position":[55,56],"type":"coastal","vo":"coastal"},{"position":[40,66],"type":"sea","vo":"sea"},{"position":[71,33],"type":"sea","vo":"sea"},{"position":[79,52],"type":"sea","vo":"sea"},{"position":[33,79],"type":"sea","vo":"sea"},{"position":[91,68],"type":"sea","vo":"sea"},{"position":[61,82],"type":"sea","vo":"sea"},{"position":[28,41],"type":"sea","vo":"sea"},{"position":[38,20],"type":"sea","vo":"sea"},{"position":[63,24],"type":"sea","vo":"sea"},{"position":[25,26],"type":"sea","vo":"sea"},{"position":[67,39],"type":"sea","vo":"sea"},{"position":[73,46],"type":"sea","vo":"sea"},{"position":[86,59],"type":"sea","vo":"sea"},{"position":[42,58],"type":"sea","vo":"sea"},{"position":[75,83],"type":"sea","vo":"sea"},{"position":[50,17],"type":"sea","vo":"sea"},{"position":[93,63],"type":"sea","vo":"sea"},{"position":[35,72],"type":"sea","vo":"sea"},{"position":[43,53],"type":"sea","vo":"sea"},{"position":[24,31],"type":"sea","vo":"sea"},{"position":[72,42],"type":"sea","vo":"sea"},{"position":[65,35],"type":"sea","vo":"sea"},{"position":[36,46],"type":"sea","vo":"sea"},{"position":[82,56],"type":"sea","vo":"sea"},{"position":[88,76],"type":"sea","vo":"sea"},{"position":[30,20],"type":"sea","vo":"sea"},{"position":[69,28],"type":"sea","vo":"sea"},{"position":[92,72],"type":"sea","vo":"sea"},{"position":[68,81],"type":"sea","vo":"sea"},{"position":[41,86],"type":"sea","vo":"sea"},{"position":[50,56],"type":"sea","vo":"sea"},{"position":[41,76],"type":"sea","vo":"sea"},{"position":[29,36],"type":"sea","vo":"sea"},{"position":[84,80],"type":"sea","vo":"sea"},{"position":[61,20],"type":"sea","vo":"sea"},{"position":[21,38],"type":"sea","vo":"sea"},{"position":[20,21],"type":"sea","vo":"sea"},{"position":[24,15],"type":"sea","vo":"sea"},{"position":[45,13],"type":"sea","vo":"sea"},{"position":[72,22],"type":"sea","vo":"sea"},{"position":[79,38],"type":"sea","vo":"sea"},{"position":[15,45],"type":"sea","vo":"sea"},{"position":[85,46],"type":"sea","vo":"sea"},{"position":[25,78],"type":"sea","vo":"sea"},{"position":[35,15],"type":"sea","vo":"sea"},{"position":[81,28],"type":"sea","vo":"sea"},{"position":[75,89],"type":"sea","vo":"sea"},{"position":[29,85],"type":"sea","vo":"sea"},{"position":[16,33],"type":"sea","vo":"sea"},{"position":[89,41],"type":"sea","vo":"sea"},{"position":[55,11],"type":"sea","vo":"sea"},{"position":[88,51],"type":"sea","vo":"sea"},{"position":[62,87],"type":"sea","vo":"sea"},{"position":[22,83],"type":"sea","vo":"sea"},{"position":[38,9],"type":"sea","vo":"sea"},{"position":[95,56],"type":"sea","vo":"sea"},{"position":[73,15],"type":"sea","vo":"sea"},{"position":[14,27],"type":"sea","vo":"sea"},{"position":[51,85],"type":"sea","vo":"sea"},{"position":[85,87],"type":"sea","vo":"sea"},{"position":[16,79],"type":"sea","vo":"sea"},{"position":[85,35],"type":"sea","vo":"sea"},{"position":[30,10],"type":"sea","vo":"sea"},{"position":[36,90],"type":"sea","vo":"sea"},{"position":[55,89],"type":"sea","vo":"sea"},{"position":[79,33],"type":"sea","vo":"sea"},{"position":[28,74],"type":"sea","vo":"sea"},{"position":[79,21],"type":"sea","vo":"sea"},{"position":[67,18],"type":"sea","vo":"sea"},{"position":[80,44],"type":"sea","vo":"sea"}],"default-power-sources":["solar","solar","solar","solar","solar","solar","solar","solar","solar","solar","solar","solar","solar","solar","other","other","other","coal","coal","coal","gas","gas","gas","gas","gas","gas","gas","gas","gas","gas","gas","gas","gas","gas","gas","gas","gas","gas","gas","gas","gas","gas","gas","gas","gas","gas","gas","undefined","undefined","undefined","wind-land","wind-land","wind-land","undefined","undefined","undefined","undefined","undefined","undefined","undefined","nuclear","nuclear","nuclear","nuclear","nuclear","undefined","undefined","undefined","undefined","undefined","undefined","undefined","undefined","undefined","undefined","wind-sea","wind-sea","wind-sea","undefined","undefined","undefined","undefined","undefined","undefined","undefined"],"energy-mix":{"solar":10,"nuclear":30,"wind-land":10,"wind-sea":30,"coal":0,"gas":15,"hydro":2.5,"biomass":2.5},"kpis":{"energy-output":250,"environmental-impact":250,"cost-per-mw":250},"years":[{"year":2019,"headline":"The year is 2019 and your first challenge is to start working towards the Government’s low-carbon target by generating <b>55% of electricity from low-carbon sources (it’s just below 50% at the moment)</b>.\n","description":"\nRemember… <b>Low-carbon sources don’t emit carbon emissions to generate electricity</b>. This includes <b>renewable power sources</b> – like wind, solar, tidal, wave, hydro and geothermal – but also nuclear power and biofuels.\n\n<b>The benefit of renewable power sources is that they will never run out.</b> But <b>they can be unreliable</b> because they’re dependent on the natural world and elements like the weather.\n\nReady for your first challenge? You need to <b>add or replace power stations to the map to generate 55% of electricity from low-carbon sources</b>.\n","year-end-success":"<b>Wow – you were quick!</b> Great work. Now test your knowledge to find out how much you know how much you remember about renewable power…","year-end-fail":"<b>You nearly did it!</b> Now test your knowledge to find out how much you remember about renewable power…","reminder":"2019 challenge: Generate 55% of electricity from low-carbon sources","demand":321,"ignore":{"energy":true},"carbon-target":5.5},{"year":2020,"headline":"It’s 2020 and <b>unfortunately a technical fault has occurred with the pipes carrying gas to your gas power stations – oh no!</b>\n","description":"Gas is an important part of the energy mix because it’s reliable and flexible. This means gas power stations can respond quickly to short-term increases in demand.\n\nBut gas is also a fossil fuel, which means it’s <b>non-renewable – so we’ll run out of it eventually</b>.\n\nEnough gassing though… Are you ready for this year’s challenge? <b>You have 30 seconds to go round the map and click on the warning symbols next to each of your gas power stations to fix the technical problem.</b>\n","year-end-success":"<b>Wow – you were quick!</b> Great work. Now test your knowledge to find out how much you know about this power source…","year-end-fail":"<b>You nearly did it!</b> Now test your knowledge to find out how much you know about this power source…","reminder":"2020 challenge: Click on the warning symbol on your gas power stations","time":30,"demand":321,"outage":"gas-pipeline","carbon-target":5},{"year":2021,"headline":"It’s 2021 and although we’re not yet hoverboarding to school and work, we’re definitely buying more electric cars than ever before…\n","description":"Electric cars are considered to be better for the environment than petrol or diesel vehicles because they run more efficiently and don’t release pollutants out of the exhaust pipe. They can also be low carbon if the electricity they run on comes from a low-carbon power source, like nuclear or renewables.\n\nWidespread adoption of electric vehicles brings with it some big changes to our daily lives though. <b>Charging an electric vehicle takes longer than filling a petrol tank</b>, for instance, and we’ll need to pipe more electricity into our homes to charge our cars here, rather than at a petrol station.\n\nBack to your challenge… With more electric cars on the roads, <b>check that your energy mix is delivering enough power (your output needs to be green). Add or replace power sources on the map – choose low-carbon power sources</b> wherever possible!\n","year-end-success":"<b>Wow, you’re already meeting demand!</b> Now, let’s see how much you know about electric cars.","year-end-fail":"<b>Time’s up!</b> Check your progress bar to see if you met demand (green) or not (red). And now let’s see how much you know about electric cars.","reminder":"2021 challenge: Add more power sources if your output is in the red","demand":357,"carbon-target":5},{"year":2022,"headline":"It’s 2022 and unfortunately your year has not got off to a good start… One in five of your power stations have gone offline due to manufacturing problems.\n","description":"<b>You need to call on back-up power – and fast!</b> Otherwise homes and businesses could be left without electricity. How will you keep warm, cook dinner or charge your mobile phone without any power?\n\nBack-up power sources include <b>battery storage plants, hydropower stations, and gas and coal power stations that only provide back-up power.</b>\n\n<b>You have 8 seconds to hit the spacebar – or tap your screen – as fast as you can to bring back-up electricity online.</b>\n","reminder":"2022 challenge: Hit the spacebar or screen as fast as you can!","demand":357,"mini-game":"generate-back-up","carbon-target":5},{"year":2023,"headline":"It’s 2023 and your target this year is to generate <b>65% of electricity from low-carbon sources</b>.\n","description":"Did you know that nuclear power is a low-carbon power source? It uses a non-renewable energy source called uranium to produce the nuclear reaction. But <b>unlike fossil fuels, uranium isn’t going to run out any time soon</b> and no carbon emissions are released to produce electricity.\n\nBack to your challenge… Can you switch your energy mix to <b>reduce</b> the nation’s dependence on fossil fuels and <b>increase</b> its dependence on renewables and nuclear power? <b>Add or replace power sources on the map to reach the 65% target.</b>\n","year-end-success":"Wow, you’re well on your way to reaching the Government’s low-carbon target – good work! Now let’s see how much you remember about the energy mix.","year-end-fail":"<b>Time’s up!</b> Check your progress bar to see what percentage of low-carbon sources you have in your mix and if you’re meeting demand. Now let’s see how much you remember about the energy mix.","reminder":"2023 challenge: Get 65% of electricity from low-carbon sources","demand":357,"carbon-target":6.5},{"year":2024,"headline":"It’s 2024 and the whole of Europe has been struck down by the Beast from the East’s bigger brother, the Siberian Savage!\n","description":"The exceptionally cold weather is causing havoc in the UK. Worst of all – for you, as the Energy Boss – this severe weather has increased demand for gas across all of Europe… and this is threatening the UK’s supply of gas.\n\nThankfully, you can call on your flexible power stations to plug the gap. <b>Non-renewable power sources, like gas and coal, are flexible or ‘dispatchable’ sources of energy</b>, as they’re able to provide power whenever it’s needed.\n\n<b>You have 30 seconds to click on coal and gas power stations on the map to bring additional power online.</b>\n","year-end-success":"<b>Quick clicking!</b> Now answer this question to see how much you remember about the challenge…","year-end-fail":"<b>So close!</b> Now answer this question to see how much you remembered about the challenge…","reminder":"2024 challenge: Click on all your coal and gas power stations","demand":357,"time":30,"outage":"cold-weather","carbon-target":6.5,"map-state":"snow"},{"year":2025,"headline":"2025 is a pivotal year in the history of the UK’s energy, as it’s the year when all our old polluting coal plants close.\n","description":"This means any coal power plants you have no longer operate and <b>you need to add or replace power sources on your map to meet demand for electricity!</b>\n\nIt’s the end of an era for a nation that was almost wholly reliant on coal in the 1950s through to the 90s and 00s. But over the last 20 years, its use has declined dramatically.\n\n<b>In 2016, wind generated more electricity than coal.</b> And in April 2017, the UK had its first day without coal since the first coal power station opened in 1882.\n\nBack to your challenge… <b>You have 60 seconds to add new (ideally low-carbon!) power sources to the map to make sure you can meet demand for electricity.</b>\n","year-end-success":"<b>You were way ahead of the deadline!</b> Let’s see what you’ve learnt about coal.","year-end-fail":"<b>Time’s up!</b> Check your progress bar to see if you met increased demand or not. And let’s see what you’ve learnt about coal.","reminder":"2025 challenge: Add or replace power sources to meet demand","demand":357,"carbon-target":6.5,"deprecate":"coal"},{"year":2026,"headline":"2026 dawns and the trend for electrification continues… Now we’re replacing our gas heating (radiators) in the home with electric sources of heating (such as heat pumps).\n","description":"Heat pumps can produce heat from electricity extremely efficiently. In fact, you can produce more than one Joule of heat energy for every one Joule of electricity you put in! That’s because this clever technology uses energy from the air in the surroundings – in addition to the electricity that goes in – to produce heat.\n\nThis extra demand for electric heating though means demand has gone up for electricity. Your challenge this year, therefore, is to <b>add more power sources to your map in order to meet increased demand for electricity</b>. Are you ready?\n","year-end-success":"<b>Wow – you’re already meeting demand!</b> Now, let’s see how much you remember about using electricity to heat our homes.","year-end-fail":"<b>Time’s up!</b> Check your progress bar to see how you did in meeting the increased demand for electricity. And now, let’s see how much you remember about using electricity to heat our homes.","reminder":"2026 challenge: Check your power output and add or replace power sources to meet demand","demand":382,"carbon-target":6.5,"ignore":{"carbon":true}},{"year":2027,"headline":"This year is an important year for nuclear, as several old nuclear power stations come to the end of their working life.\n","description":"This means that 4,400MW of power is no longer available, so <b>you’ll need to find a way to meet the fall in your electricity output by adding new power stations to the map (*clue* – this can include new nuclear!)</b>\n\nNuclear is an important low-carbon energy source. Nuclear power stations create heat through a process called nuclear fission, which doesn’t produce any carbon emissions.\n\n<b>Don’t confuse nuclear fission with nuclear fusion though.</b> Nuclear fission is the splitting of an atom – and how we generate nuclear power today – whereas nuclear fusion is the joining of two nuclei to make one nucleus. It’s what happens inside the sun and it’s very hard to recreate in a stable way on Earth.\n\nBack to this year’s challenge… <b>You need to add more power sources to your map – *clue* this can include new nuclear plants – or rejig your energy mix to make sure you’re meeting demand for electricity.</b> Let’s get started!\n","year-end-success":"<b>No blackouts on your watch!</b> Let’s see how much you remember about nuclear power.","year-end-fail":"<b>Time’s up!</b> Check the progress bar to see if you need to add more power sources on to meet demand. And now let’s see how much you remember about nuclear power.","reminder":"2027 challenge: Add more power sources to make sure your power output is green","demand":383,"carbon-target":6.5,"deprecate":"nuclear","ignore":{"carbon":true}},{"year":2028,"headline":"It’s 2028! This year’s challenge is to switch your energy mix so that <b>75% of electricity comes from low-carbon sources</b>.\n","description":"<b>Remember: gas and coal are non-renewable energy resources</b>, so once they’ve been used up, they’re gone forever. They are <b>fossil fuels</b> and when they’re burned to produce electricity, they emit harmful gases, which contribute to climate change.\n\nThey are flexible sources of electricity, however, as they can meet a sudden change in demand, so you’ll need some gas in your final energy mix (*this is a clue!*)\n\nYour challenge this year is to <b>add or replace power sources on the map so that 75% of electricity comes from low-carbon sources.</b>\n","year-end-success":"Well done, you’re so close to your final target! Now let’s see how much you remember about fossil fuels.","year-end-fail":"<b>Time’s up!</b> Check the progress bar to see how close you are to achieving 75% low-carbon generation. And now let’s see how much you remember about fossil fuels.","reminder":"2028 challenge: Add or replace power stations to get 75% of electricity from low-carbon sources","demand":383,"carbon-target":7.5,"ignore":{"energy":true}},{"year":2029,"headline":"It’s 2029 and the UK has experienced a population boom! The result? An increase in demand for electricity.\n","description":"Your challenge this year, therefore, is to <b>bring on more power sources in order to meet increased demand</b>.\n\nConsider what low-carbon sources you can add to your energy mix, so you achieve the Government’s target of generating 82% to 87% electricity from low-carbon sources by 2032.\n\n<b>Like renewables, nuclear is a low-carbon energy source.</b> It uses a non-renewable fuel to generate electricity, but it doesn’t emit any carbon emissions in the process.\n\nNuclear is also a <b>reliable source of power</b> that can deliver baseload electricity, as nuclear stations produce a predictable amount of energy, day and night, all year round.\n\nAre you ready for your challenge? <b>Add or replace power sources to your map to meet increased demand for electricity.</b>\n","year-end-success":"<b>Wow – you’re already meeting demand!</b> Let’s see what you remember about nuclear power.","year-end-fail":"<b>Time’s up!</b> Check your progress bar to see how your power output compares to demand. And let’s see how much you remember about nuclear power next.","reminder":"2029 challenge: Check your power output and add power sources to make it green","demand":395,"carbon-target":7.5,"ignore":{"carbon":true}},{"year":2030,"headline":"It’s 2030 and the weather has been pretty uneventful this year… No chilling Siberian winds during winter or record-breaking heatwaves in the summer.\n","description":"Instead it’s been calm and cloudy most of the time, which would be a good thing… If wind turbines worked as effectively in these conditions.\n\nWind is a low-carbon power source: turbines don’t emit any carbon emissions or produce pollution, and they’re also relatively inexpensive to run, with no fuel costs.\n\nYou need a lot of turbines to get the same power output as a gas or nuclear power station though – and a lot of land. To produce 1TWh of electricity from nuclear power – about 0.3% of UK demand – you need the space of about five football pitches. <b>But to produce the same amount of electricity from wind, it’s more than 7,000!</b>\n\nTo fill the shortfall in output from your wind farms, you need to flex your gas power stations and increase their output by <b>hitting the spacebar – or tapping your screen – as fast as you can in the next 8 seconds.</b>\n","year-end":"Time","reminder":"2030 challenge: Hit the spacebar or tap the screen as fast as you can!","demand":396,"carbon-target":7.5,"mini-game":"increase-gas-output"},{"year":2031,"headline":"It’s 2031 – and your last chance to switch your energy mix so that between 82% and 87% of the UK’s electricity comes from low-carbon energy sources… While making sure you meet demand for power!\n","description":"Fossil fuels have played such an important role in our historic energy mix as they were the cheapest way of getting power on a large scale. In 1950, the UK relied on coal for 97% of its electricity. While the 1990s were characterised by the ‘dash for gas’.\n\nBut since the start of this century, our energy mix has become more varied – with more low-carbon sources, like nuclear and renewables – driven by the Government’s commitments to tackling climate change. <b>By 2008, the UK’s energy mix was 46% gas, 32% coal, 12% nuclear, 5% renewables, 2% oil, 2% hydro and 1% other (e.g. biomass).</b>\n\nAre you ready for your final challenge? <b>It’s your last chance to switch your energy mix so that between 82% and 87% of electricity comes from low-carbon sources – but beware of sacrificing your power output!</b>\n","year-end-success":"<b>Congratulations</b> – you’ve met the target early! What do you remember about the UK’s changing energy mix though?","year-end-fail":"<b>Time’s up!</b> Check the progress bar to see what percentage of low-carbon sources are in your final selection. And let’s see how much you remember about the UK’s energy mix next.","reminder":"2031 challenge: Add or replace power sources to hit the low-carbon target zone","demand":385,"carbon-target":8.5}],"seasons":[{"id":"spring","title":"spring","energy-demand":340,"description":"spring is a lovely season with lots of new green leaves.\n"},{"id":"summer","title":"summer","energy-demand":340,"description":"summer is nice and sunny\n"},{"id":"autumn","title":"autumn","energy-demand":340,"description":"autumn is cold and windy\n"},{"id":"winter","title":"winter","energy-demand":340,"description":"winter has no sun :(\n"}],"season-duration":300,"outages":[{"id":"gas-pipeline","title":"your gas power stations are about to go offline!","image":null,"description":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.\nUt enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.\n","affects":["gas"],"vo":"outages__gas-offline"},{"id":"cold-weather","title":"the whole of Europe has been struck down by the Beast from the East!","image":null,"time":30,"description":"Click on as many gas and coal plants on your map as you can in 30 seconds to bring additional power online – GO!\n","affects":["gas","coal"],"vo":"outages__gas-offline"}],"questions":[{"id":2019,"image":null,"question":"Which of the following is NOT a renewable resource?","answers":[{"text":"wind","vo":"one merts"},{"text":"gas","vo":"one merts"},{"text":"hydro","vo":"one merts"}],"answer":1,"response":"Gas is non-renewable – so we’ll run out of this fossil fuel eventually.","vo":"question__low-energy-mix"},{"id":2020,"image":null,"question":"Which of the following is TRUE about gas?","answers":[{"text":"It will run out","vo":"one merts"},{"text":"It’s an inflexible power source","vo":"one merts"},{"text":"It’s a renewable power source","vo":"one merts"}],"answer":0,"response":"Gas is a reliable source of power and gas power stations are flexible, so they can respond quickly to short-term increases in demand.","vo":"question__low-energy-mix"},{"id":2021,"image":null,"question":"Which of the following statements about electric cars is FALSE?","answers":[{"text":"They can run on low-carbon electricity","vo":"one merts"},{"text":"They don’t release air pollutants out of their exhaust pipe","vo":"one merts"},{"text":"They charge in less time than it takes to fill a petrol tank","vo":"one merts"}],"answer":2,"response":"Charging an electric vehicle takes longer than filling a petrol tank.","vo":"question__low-energy-mix"},{"id":2022,"image":null,"question":"Which of the following is NOT a back-up power source?","answers":[{"text":"wind farm","vo":"one merts"},{"text":"battery storage plant","vo":"one merts"},{"text":"gas-fired power station","vo":"one merts"}],"answer":0,"response":"Back-up power sources include battery storage plants, hydropower stations, and gas and coal power stations that only provide back-up power.","vo":"question__low-energy-mix"},{"id":2023,"image":null,"question":"Which of the following is NOT a fossil fuel?","answers":[{"text":"gas","vo":"one merts"},{"text":"uranium","vo":"one merts"},{"text":"oil","vo":"one merts"}],"answer":1,"response":"Nuclear power uses a non-renewable energy source called uranium to produce the nuclear reaction. But unlike fossil fuels, uranium isn’t going to run out any time soon and no carbon emissions are released to produce electricity.","vo":"question__low-energy-mix"},{"id":2024,"image":null,"question":"Which of the following can provide reliable (or ‘dispatchable’) electricity?","answers":[{"text":"coal","vo":"one merts"},{"text":"wind","vo":"one merts"},{"text":"solar","vo":"one merts"}],"answer":0,"response":"Non-renewable power sources, like gas and coal, are flexible or ‘dispatchable’ sources of energy, as they’re able to provide power whenever it’s needed.","vo":"question__low-energy-mix"},{"id":2025,"image":null,"question":"In 2016, what renewable power source generated more electricity than coal?","answers":[{"text":"solar","vo":"one merts"},{"text":"hydro","vo":"one merts"},{"text":"wind","vo":"one merts"}],"answer":2,"response":"In 2016, wind generated more electricity than coal.","vo":"question__low-energy-mix"},{"id":2026,"image":null,"question":"Which of the following is a low-carbon way to heat homes?","answers":[{"text":"Gas boiler","vo":"one merts"},{"text":"Heat pumps using low-carbon electricity","vo":"one merts"},{"text":"Oil boiler","vo":"one merts"}],"answer":1,"response":"Heat pumps can produce heat from electricity extremely efficiently. In fact, you can produce more than one Joule of heat energy for every one Joule of electricity you put in!","vo":"question__low-energy-mix"},{"id":2027,"image":null,"question":"Today’s nuclear power stations create heat through a process called what?","answers":[{"text":"nuclear fusion","vo":"one merts"},{"text":"nuclear bonding","vo":"one merts"},{"text":"nuclear fission","vo":"one merts"}],"answer":2,"response":"To create the conditions for a nuclear reaction to occur, uranium atoms are bombarded by neutrons inside a reactor vessel. This causes the nucleus in each atom to split in two in a process called ‘nuclear fission’","vo":"question__low-energy-mix"},{"id":2028,"image":null,"question":"Which of these statements about gas and coal power stations is FALSE?","answers":[{"text":"They use a fuel source that comes from prehistoric remains","vo":"one merts"},{"text":"They produce more electricity than renewables","vo":"one merts"},{"text":"They are good for the environment","vo":"one merts"}],"answer":2,"response":"When coal is burned to produce electricity, it emits harmful gases, which contribute to climate change.","vo":"question__low-energy-mix"},{"id":2029,"image":null,"question":"Which of these sentences is FALSE about nuclear?","answers":[{"text":"Nuclear power is a low-carbon energy source","vo":"one merts"},{"text":"Nuclear power stations use a renewable fuel source","vo":"one merts"},{"text":"Nuclear power delivers a reliable source of fuel","vo":"one merts"}],"answer":1,"response":"Unlike fossil fuels, uranium isn’t going to run out any time soon and no carbon emissions are released to produce electricity.","vo":"question__low-energy-mix"},{"id":2030,"image":null,"question":"To produce 1TWh of electricity from wind, you need the equivalent space of how many football pitches?","answers":[{"text":"1,000","vo":"one merts"},{"text":"5,000","vo":"one merts"},{"text":"7,000","vo":"one merts"}],"answer":2,"response":"To produce 1TWh of electricity from nuclear power – about 0.3% of UK demand – you need the space of about five football pitches. But to produce the same amount of electricity from wind, it’s more than 7,000!","vo":"question__low-energy-mix"},{"id":2031,"image":null,"question":"What three power sources produced the majority of the UK’s electricity in 2008?","answers":[{"text":"Gas, coal, nuclear","vo":"one merts"},{"text":"Coal, oil, gas","vo":"one merts"},{"text":"Gas, nuclear, oil","vo":"one merts"}],"answer":0,"response":"To produce 1TWh of electricity from nuclear power – about 0.3% of UK demand – you need the space of about five football pitches. But to produce the same amount of electricity from wind, it’s more than 7,000!","vo":"question__low-energy-mix"}],"mini-games":[{"id":"generate-back-up","category":"energy-spike","type":"energy spike","title":"generate more power!","description":"You need to call on back-up power – and fast! Otherwise homes and businesses could be left without electricity.","result-text":"mini-game result text would go here","results":["Fast work! Great job. Now let’s see what you remember about back-up power.","Good attempt – see if you can tap faster next time! Now let’s see what you remember about back-up power."],"vo":"events__world-cup"},{"id":"increase-gas-output","category":"energy-spike","type":"energy spike","title":"generate more power!","description":"to fill the shortfall in output from your wind farms, you need to increase the output of your gas power stations.","result-text":"mini-game result text would go here","results":["Fast work! Great job. Now let’s see what you remember about wind power.","Great attempt – keep it up. Now let’s see what you remember about wind power."],"vo":"events__world-cup"}],"hints":[{"year":2019,"hints":["Remember you can remove power stations from the map by clicking on the cross next to each one, as well as add new power stations.","Which power sources on your map aren’t low-carbon? Consider replacing some of these with low-carbon power sources (like nuclear, wind and solar).","Renewable power sources produce less electricity than non-renewables. So you’ll need to add on a greater number of wind and solar farms to produce the same amount of energy as a non-renewable power station.","You always need some reliable power sources in the mix too. Nuclear is reliable – and a low-carbon power source."]},{"year":2020},{"year":2021,"hints":["Remember you can remove power stations from the map by clicking on the cross next to each one, as well as add new power stations.","Which power sources are low carbon? Consider adding more of these.","You always need some reliable power sources in the mix too. How many nuclear and gas power stations do you have on the map – could you add any more?"]},{"year":2022},{"year":2023,"hints":["Remember you can remove power stations from the map by clicking on the cross next to each one, as well as add new power stations.","How many <b>NON low-carbon power sources</b> do you still have on your map? Consider replacing some of these with low-carbon alternatives, but <b>remember to keep some flexible sources</b> – like gas – in reserve!","Renewable power sources produce less electricity than non-renewables. So you’ll need to add on a greater number of wind and solar farms to produce the same amount of energy as a non-renewable power station.","But remember renewables take up a lot more space – so think about which other low-carbon sources you can include in your mix…\n\n…To produce 1TWh of electricity (about 0.3% of UK demand) from nuclear power, you need the space of about five football pitches. But to produce the same amount of electricity from solar you need the space of 4,400 football pitches – and for wind, it’s more than 7,000!\n"]},{"year":2024},{"year":2025,"hints":["Can you add on more renewable power sources?","You’ll need some reliable power sources that can deliver baseload electricity in the mix too. Which power sources might do this?","Do you have any flexible power sources that might fill the gaps when the sun’s not shining or the wind blowing? (If you can’t remember which power sources are flexible, re-read the information about each power type.)"]},{"year":2026,"hints":["Remember you can remove power stations from the map by clicking on the cross next to each one, as well as add new power stations.","Can you add on any more renewable power sources?","You’ll need some reliable power sources that can deliver baseload electricity in the mix too. Which power sources might do this?","And do you have enough flexible power sources for when the weather is variable?"]},{"year":2027,"hints":["Remember you can remove power stations from the map by clicking on the cross next to each one, as well as add new power stations.","What low-carbon power sources can you add to your map?","What reliable power sources that can deliver baseload electricity do you have in the mix? You might be saying goodbye to some old nuclear power plants, but that doesn’t mean you can’t add any new ones…","Check you’ve got enough flexible power sources in the mix too (like gas), in case the weather is intermittent"]},{"year":2028,"hints":["How many NON low-carbon power sources do you still have on your map? Consider replacing some of these with low-carbon alternatives.","Remember you can remove power stations from the map by clicking on the cross next to each one, as well as add new power stations.","Renewable power sources produce less electricity than non-renewables. So you’ll need to add on a greater number of wind and solar farms to produce the same amount of energy as a non-renewable power station.","But remember they also take up a lot more space – so think about which other low-carbon sources you can include in your mix.\nTo produce 1TWh of electricity (about 0.3% of UK demand) from nuclear power (*this is a clue!*), you need the space of about five football pitches. But to produce the same amount of electricity from solar you’d need the space of 4,400 football pitches – and for wind, it’s more than 7,000!\n"]},{"year":2029,"hints":["Could you add any more renewable power sources?","Have you got some reliable power sources in the mix too, which can deliver baseload electricity – like nuclear and gas?","What about any energy sources that give you flexibility – like gas – in case you need to respond quickly to a sudden increase in demand or the weather’s not right for renewables?"]},{"year":2030},{"year":2031,"hints":["How many NON low-carbon power sources do you still have on your map? Consider replacing some of these with low-carbon alternatives.","Renewable power sources produce less electricity than non-renewables. So you’ll need to add on a greater number of wind and solar farms to produce the same amount of energy as a non-renewable power station.","But remember they also take up a lot more space – so think about which other low-carbon sources you can include in your mix. To produce 1TWh of electricity from nuclear power, you need about the space of five football pitches. But to produce the same amount of electricity from solar you need the space of 4,400 football pitches – and for wind, it’s more than 7,000!"]},{"year":2032}],"game-over-hints":{"energy-output":["you did great with the energy output","you did ok with the energy output","ugh energy output terrible"],"carbon-neutral":["you did great with the carbon","you did ok with the carbon","ugh carbon neutral terrible"],"spacebar":["you did great with the spacebar","you did ok with the spacebar","ugh spacebar terrible"],"questions":["you did great with the questions","you did ok with the questions","ugh questions terrible"]},"content":{"answer-a-question":{"text":"answer a question to fix your power station","vo":"content__anwer-a-question"},"mini-game-intro":{"title":"game time!","description":"Lorem ipsum dolor sit amet, consectetur adipiscing elit","vo":"content__anwer-a-question"},"mini-game-outro":{"title":"great work!","description":"Lorem ipsum dolor sit amet, consectetur adipiscing elit","vo":"content__anwer-a-question"}},"game-over-results":[{"energy":[350,410],"carbon":[0,81],"text":"You <b>met demand for electricity</b> and managed to keep the lights on in people’s homes.\n\nHaving too much gas in your mix, however, means <b>you’ve not met the Government’s low-carbon target</b>.\n\nTop tip! Think about replacing some of your gas power stations with low-carbon sources – like nuclear and renewables – next time.\n"},{"energy":[410,800],"carbon":[0,81],"text":"<b>You more than met demand for electricity.</b> This means people didn’t go without power… But some electricity will have been wasted because you produced too much, which is expensive and a waste of resources.\n\nYou <b>didn’t meet the Government’s low-carbon target</b>, because you have too much gas in your energy mix.\n\nTop tip! Think about replacing some of your gas power stations with low-carbon sources – like nuclear and renewables – next time.\n"},{"energy":[0,350],"carbon":[0,81],"text":"Oh no, <b>you weren’t able to meet demand for electricity</b>, so there could be power outages in homes and businesses!\n\n<b>You didn’t hit the Government’s low-carbon target either.</b>\n\nNext time, remember how much we rely on electricity in our everyday lives: for heating, working, cooking and relaxing… And consider what makes up a balanced low-carbon energy mix to ensure you hit the Government’s decarbonisation target and keep the lights on.\n"},{"energy":[349,410],"carbon":[80,88],"text":"Woohoo, you <b>met demand for electricity and your final energy mix made it into the low-carbon target zone!</b>\n\nYou recognise that we need a balanced mix of low-carbon power sources – like renewables and nuclear – with a much smaller contribution coming from gas, to provide some flexibility when the wind isn’t blowing and the sun doesn’t shine.\n"},{"energy":[349,410],"carbon":[80,88],"wind":7,"text":"<b>You met demand for electricity and your final energy mix made it into the low-carbon target zone!</b>\n\nYou know how important renewables – like wind and solar – are in the future energy mix. They’re low carbon and work well in the right weather conditions.\n\nBut remember that a renewables-dominant energy mix can come at a higher cost, as you need to build in extra flexibility to ensure you can meet demand when the wind doesn’t blow or sun doesn’t shine.\n\nNext time, consider how you might make your energy mix more diverse by including power sources that are known for their reliability and predictability, such as nuclear and gas.\n"},{"energy":[350,409],"carbon":[87,110],"wind":7,"text":"You <b>met demand for electricity</b> and managed to keep the lights on in people’s homes!\n\nYou also <b>exceeded the Government’s low-carbon target</b>.\n\nIt’s clear you understand the importance of moving to a low-carbon energy mix in the future. But be aware of moving too fast, too soon!\n\nA renewables-dominant energy mix can come at a higher cost, as you need to build in extra flexibility to ensure you can meet demand when the wind doesn’t blow or the sun doesn’t shine.\n\nNext time, consider how you might make your energy mix more diverse by including more power sources that are known for their reliability and predictability, such as nuclear and gas, to stay within the low-carbon target zone.\n"},{"energy":[409,800],"carbon":[87,110],"wind":7,"text":"<b>You more than met demand for electricity – and you exceeded the Government’s low-carbon target.</b>\n\nIt’s clear you understand the importance of moving to a low-carbon energy mix in the future. But be aware of moving too fast, too soon!\n\nA renewables-dominant energy mix can come at a higher cost, as you need to build in extra flexibility – through nuclear and gas – to ensure you can meet demand when the wind doesn’t blow or the sun doesn’t shine.\n\nProducing too much power is also expensive and a waste of resources.\n\nNext time, consider how you might make your energy mix more diverse and avoid producing too much electricity.\n"}],"question-results":[{"correct":4,"text":"You’re an Energy Apprentice: You answered $questions questions correctly. Why not have another go to see if you can improve your score?"},{"correct":9,"text":"You’re a Low-Carbon Learner: You answered $questions questions correctly. Good effort! Can you do better next time?"},{"correct":12,"text":"You’re a Power Hitter: You answered $questions questions correctly. Great achievement!"},{"correct":13,"text":"You’re an Energy Expert: You answered 12/12 questions correctly. Woohoo! Why not see if you can match your score again?"}]}

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(20), __webpack_require__(51), __webpack_require__(29), __webpack_require__(75)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("redux"), require("./outputs/costPerMw"), require("./outputs/energyOutput"), require("./outputs/environmentalImpact"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.redux, global.costPerMw, global.energyOutput, global.environmentalImpact);
        global.outputs = mod.exports;
    }
})(this, function (exports, _redux, _costPerMw, _energyOutput, _environmentalImpact) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.outputs = undefined;
    var outputs = exports.outputs = (0, _redux.combineReducers)({
        energyOutput: _energyOutput.energyOutput,
        costPerMw: _costPerMw.costPerMw,
        environmentalImpact: _environmentalImpact.environmentalImpact
    });
});

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(77), __webpack_require__(20)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("./visible"), require("redux"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.visible, global.redux);
        global.debugConsole = mod.exports;
    }
})(this, function (exports, _visible, _redux) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.debugConsole = undefined;
    var debugConsole = exports.debugConsole = (0, _redux.combineReducers)({
        visible: _visible.visible
    });
});

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(4), __webpack_require__(21), __webpack_require__(156), __webpack_require__(158), __webpack_require__(167), __webpack_require__(159), __webpack_require__(160), __webpack_require__(161), __webpack_require__(163)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("tslib"), require("redux-saga/effects"), require("./handleLocationInteractions"), require("./handleScore"), require("./handleGameEvents"), require("./handleHints"), require("./handleOutages"), require("./handleEvents"), require("./handleCalendar"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.tslib, global.effects, global.handleLocationInteractions, global.handleScore, global.handleGameEvents, global.handleHints, global.handleOutages, global.handleEvents, global.handleCalendar);
        global.rootSagas = mod.exports;
    }
})(this, function (exports, _tslib, _effects, _handleLocationInteractions, _handleScore, _handleGameEvents, _handleHints, _handleOutages, _handleEvents, _handleCalendar) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.default = rootSaga;

    var tslib_1 = _interopRequireWildcard(_tslib);

    var _handleLocationInteractions2 = _interopRequireDefault(_handleLocationInteractions);

    var _handleScore2 = _interopRequireDefault(_handleScore);

    var _handleGameEvents2 = _interopRequireDefault(_handleGameEvents);

    var _handleHints2 = _interopRequireDefault(_handleHints);

    var _handleOutages2 = _interopRequireDefault(_handleOutages);

    var _handleEvents2 = _interopRequireDefault(_handleEvents);

    var _handleCalendar2 = _interopRequireDefault(_handleCalendar);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function rootSaga() {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.all)([(0, _effects.fork)(_handleLocationInteractions2.default), (0, _effects.fork)(_handleEvents2.default), (0, _effects.fork)(_handleGameEvents2.default), (0, _effects.fork)(_handleScore2.default), (0, _effects.fork)(_handleHints2.default), (0, _effects.fork)(_handleOutages2.default), (0, _effects.fork)(_handleEvents2.default), (0, _effects.fork)(_handleCalendar2.default)])];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }
});

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(4), __webpack_require__(21), __webpack_require__(8), __webpack_require__(2), __webpack_require__(13), __webpack_require__(10), __webpack_require__(37), __webpack_require__(18), __webpack_require__(157), __webpack_require__(31), __webpack_require__(54), __webpack_require__(38), __webpack_require__(55), __webpack_require__(22), __webpack_require__(41)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("tslib"), require("redux-saga/effects"), require("lodash"), require("../actions/action"), require("../reducers/powerSources"), require("../../data/data"), require("../reducers/location"), require("../actions/modals"), require("../actions/popups"), require("../actions/powerSources"), require("../actions/locations"), require("../reducers/draggingPowerSource"), require("../reducers/highlightLocation"), require("../actions/calendar/year"), require("redux-saga"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.tslib, global.effects, global.lodash, global.action, global.powerSources, global.data, global.location, global.modals, global.popups, global.powerSources, global.locations, global.draggingPowerSource, global.highlightLocation, global.year, global.reduxSaga);
        global.handleLocationInteractions = mod.exports;
    }
})(this, function (exports, _tslib, _effects, _lodash, _action, _powerSources, _data, _location, _modals, _popups, _powerSources2, _locations, _draggingPowerSource, _highlightLocation, _year, _reduxSaga) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.default = handleSelectedLocation;

    var tslib_1 = _interopRequireWildcard(_tslib);

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function handleSelectedLocation() {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.takeEvery)(_action.SET_SELECTED_LOCATION, onSelectedLocationChange)];
                case 1:
                    _a.sent();
                    return [4, (0, _effects.takeEvery)(_action.SET_SELECTED_POWER_SOURCE, onPowerSourceSelection)];
                case 2:
                    _a.sent();
                    return [4, (0, _effects.takeEvery)(_action.PLACE_POWER_SOURCE, onPowerSourcePlace)];
                case 3:
                    _a.sent();
                    return [4, (0, _effects.takeEvery)(_action.REMOVE_POWER_SOURCE, onPowerSourceRemoval)];
                case 4:
                    _a.sent();
                    return [2];
            }
        });
    }
    function onSelectedLocationChange(action) {
        var location_id, power_sources, source_at_location, location_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.select)(_location.getSelectedLocation)];
                case 1:
                    location_id = _a.sent();
                    return [4, (0, _effects.select)(_powerSources.getPowerSources)];
                case 2:
                    power_sources = _a.sent();
                    source_at_location = power_sources[location_id];
                    if (!source_at_location) return [3, 4];
                    return [4, (0, _effects.put)((0, _modals.showPowerSourceDetailsModal)())];
                case 3:
                    _a.sent();
                    return [3, 6];
                case 4:
                    location_1 = (0, _data.getPowerSourceLocationData)(location_id);
                    return [4, (0, _effects.put)((0, _popups.showAddPowerSourcePopup)(location_1.position[0], location_1.position[1]))];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6:
                    return [2];
            }
        });
    }
    function onPowerSourceSelection(action) {
        var payload, power_source, location_id;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = action.payload;
                    power_source = payload.power_source;
                    return [4, (0, _effects.select)(_location.getSelectedLocation)];
                case 1:
                    location_id = _a.sent();
                    return [4, (0, _effects.put)((0, _powerSources2.addPowerSourceAtLocation)(power_source, location_id))];
                case 2:
                    _a.sent();
                    return [4, (0, _effects.put)((0, _locations.clearSelectedLocation)())];
                case 3:
                    _a.sent();
                    return [4, (0, _effects.put)((0, _popups.hidePopup)())];
                case 4:
                    _a.sent();
                    return [2];
            }
        });
    }
    function onPowerSourcePlace(action) {
        var power_source, location, location_id, is_valid, specific_power_source;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.select)(_draggingPowerSource.getDraggingPowerSource)];
                case 1:
                    power_source = _a.sent();
                    return [4, (0, _effects.select)(_highlightLocation.getHighlightLocationData)];
                case 2:
                    location = _a.sent();
                    return [4, (0, _effects.select)(_highlightLocation.getHighlightLocation)];
                case 3:
                    location_id = _a.sent();
                    return [4, (0, _effects.select)(_location.isLocationValidForDraggingPowerSource, location_id)];
                case 4:
                    is_valid = _a.sent();
                    if (!(_.isFinite(location_id) && location_id !== -1 && is_valid)) return [3, 6];
                    specific_power_source = void 0;
                    switch (power_source.id) {
                        case 'wind':
                            specific_power_source = location.type !== 'sea' ? power_source : (0, _data.getPowerSourceDataByID)('wind-sea');
                            break;
                        default:
                            specific_power_source = power_source;
                            break;
                    }
                    if (!(specific_power_source && !!~location_id)) return [3, 6];
                    return [4, (0, _effects.put)((0, _powerSources2.addPowerSourceAtLocation)(specific_power_source, location_id))];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6:
                    return [4, (0, _effects.put)((0, _powerSources2.setDraggingPowerSource)())];
                case 7:
                    _a.sent();
                    return [4, (0, _effects.put)((0, _locations.setHighlightLocation)())];
                case 8:
                    _a.sent();
                    return [4, (0, _effects.call)(_reduxSaga.delay, 500)];
                case 9:
                    _a.sent();
                    return [4, (0, _effects.put)((0, _year.testAnnualTargets)())];
                case 10:
                    _a.sent();
                    return [2];
            }
        });
    }
    function onPowerSourceRemoval(action) {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.put)((0, _modals.hideModal)())];
                case 1:
                    _a.sent();
                    return [4, (0, _effects.put)((0, _year.testAnnualTargets)())];
                case 2:
                    _a.sent();
                    return [2];
            }
        });
    }
});

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2), __webpack_require__(50)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("./action"), require("../reducers/popup"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action, global.popup);
        global.popups = mod.exports;
    }
})(this, function (exports, _action, _popup) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.hidePopup = hidePopup;
    exports.showAddPowerSourcePopup = showAddPowerSourcePopup;
    function hidePopup() {
        return { type: _action.HIDE_POPUP, payload: {} };
    }
    function showAddPowerSourcePopup(x, y) {
        return { type: _action.SET_POPUP, payload: { popup_id: _popup.POPUPS.ADD_POWER_SOURCE, x: x, y: y } };
    }
});

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(4), __webpack_require__(2), __webpack_require__(21), __webpack_require__(8), __webpack_require__(29), __webpack_require__(78), __webpack_require__(12), __webpack_require__(79), __webpack_require__(32), __webpack_require__(30)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("tslib"), require("../actions/action"), require("redux-saga/effects"), require("lodash"), require("../reducers/outputs/energyOutput"), require("../actions/score"), require("../reducers/year"), require("../reducers/savedPowerSourceCounts"), require("../reducers/outputs/carbonOutput"), require("../reducers/power-sources/damage"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.tslib, global.action, global.effects, global.lodash, global.energyOutput, global.score, global.year, global.savedPowerSourceCounts, global.carbonOutput, global.damage);
        global.handleScore = mod.exports;
    }
})(this, function (exports, _tslib, _action, _effects, _lodash, _energyOutput, _score, _year, _savedPowerSourceCounts, _carbonOutput, _damage) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.default = handleScoreUpdates;

    var tslib_1 = _interopRequireWildcard(_tslib);

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function handleScoreUpdates() {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.takeEvery)(_action.UPDATE_SCORE, onUpdateScore)];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }
    function onUpdateScore(action) {
        var year, demand, carbon_target, add_sources, outage, score, source_changes, change, carbon_output, carbon_target_1, ratio, damage, damage_count;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.select)(_year.getYearData)];
                case 1:
                    year = _a.sent();
                    console.group('onUpdateScore');
                    demand = year.demand, carbon_target = year["carbon-target"], add_sources = year["add-sources"], outage = year.outage;
                    score = 0;
                    if (!add_sources) return [3, 3];
                    return [4, (0, _effects.select)(_savedPowerSourceCounts.countPowerSourceDifferencesByType)];
                case 2:
                    source_changes = _a.sent();
                    change = source_changes[add_sources];
                    if (change > 4) score += 1000;
                    console.log('sources score', change > 4);
                    _a.label = 3;
                case 3:
                    if (!carbon_target) return [3, 6];
                    return [4, (0, _effects.select)(_carbonOutput.getCarbonOutput)];
                case 4:
                    carbon_output = _a.sent();
                    return [4, (0, _effects.select)(_carbonOutput.getCarbonOutputTarget)];
                case 5:
                    carbon_target_1 = _a.sent();
                    if (carbon_output < carbon_target_1) score += 1000;
                    console.log('carbon score', carbon_output < carbon_target_1 ? 1000 : 0);
                    _a.label = 6;
                case 6:
                    if (!demand) return [3, 8];
                    return [4, (0, _effects.select)(_energyOutput.getEnergyOutputRatio)];
                case 7:
                    ratio = _a.sent();
                    score += (1 - ratio) * 1000;
                    console.log('demand score', ratio, (1 - ratio) * 1000);
                    _a.label = 8;
                case 8:
                    if (!outage) return [3, 10];
                    return [4, (0, _effects.select)(_damage.getDamage)];
                case 9:
                    damage = _a.sent();
                    damage_count = _.reduce(damage, function (count, damaged) {
                        count += damaged === true ? 1 : 0;
                        return count;
                    }, 0);
                    score -= damage_count * 1000;
                    console.log('damage score', damage_count * -1000);
                    _a.label = 10;
                case 10:
                    console.log('new score', score);
                    console.groupEnd();
                    return [4, (0, _effects.put)((0, _score.addScore)(score))];
                case 11:
                    _a.sent();
                    return [2];
            }
        });
    }
});

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(4)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("tslib"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.tslib);
        global.handleHints = mod.exports;
    }
})(this, function (exports, _tslib) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.default = handleHints;

    var tslib_1 = _interopRequireWildcard(_tslib);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function handleHints() {
        return tslib_1.__generator(this, function (_a) {
            return [2];
        });
    }
    function onRequestGeneralHint(action) {
        return tslib_1.__generator(this, function (_a) {
            return [2];
        });
    }
    function onRequestIncreasePowerSourceHint(action) {
        return tslib_1.__generator(this, function (_a) {
            return [2];
        });
    }
    function onRequestDecreasePowerSourceHint(action) {
        return tslib_1.__generator(this, function (_a) {
            return [2];
        });
    }
});

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(4), __webpack_require__(2), __webpack_require__(21)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("tslib"), require("../actions/action"), require("redux-saga/effects"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.tslib, global.action, global.effects);
        global.handleOutages = mod.exports;
    }
})(this, function (exports, _tslib, _action, _effects) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.default = handleOutages;

    var tslib_1 = _interopRequireWildcard(_tslib);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function handleOutages() {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.takeEvery)(_action.CHOOSE_SUITABLE_OUTAGE, onRequestOutage)];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }
    function onRequestOutage(action) {
        return tslib_1.__generator(this, function (_a) {
            return [2];
        });
    }
});

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(4), __webpack_require__(8), __webpack_require__(2), __webpack_require__(21), __webpack_require__(162), __webpack_require__(51), __webpack_require__(29), __webpack_require__(75), __webpack_require__(10), __webpack_require__(80)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("tslib"), require("lodash"), require("../actions/action"), require("redux-saga/effects"), require("../reducers/getEnergyMix"), require("../reducers/outputs/costPerMw"), require("../reducers/outputs/energyOutput"), require("../reducers/outputs/environmentalImpact"), require("../../data/data"), require("../actions/events"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.tslib, global.lodash, global.action, global.effects, global.getEnergyMix, global.costPerMw, global.energyOutput, global.environmentalImpact, global.data, global.events);
        global.handleEvents = mod.exports;
    }
})(this, function (exports, _tslib, _lodash, _action, _effects, _getEnergyMix, _costPerMw, _energyOutput, _environmentalImpact, _data, _events) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.default = handleEvents;

    var tslib_1 = _interopRequireWildcard(_tslib);

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function handleEvents() {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.takeEvery)(_action.CHOOSE_SUITABLE_EVENT, onRequestEvent)];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }
    function onRequestEvent(action) {
        var energy_mix, cost_per_mw, energy_output, environmental, kpis, events, event;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.select)(_getEnergyMix.getEnergyMix)];
                case 1:
                    energy_mix = _a.sent();
                    return [4, (0, _effects.select)(_costPerMw.getCostPerMw)];
                case 2:
                    cost_per_mw = _a.sent();
                    return [4, (0, _effects.select)(_energyOutput.getEnergyOutput)];
                case 3:
                    energy_output = _a.sent();
                    return [4, (0, _effects.select)(_environmentalImpact.getEnvironmentalImpact)];
                case 4:
                    environmental = _a.sent();
                    kpis = { energy_mix: energy_mix, cost: cost_per_mw, energy_output: energy_output, environmental: environmental };
                    events = (0, _data.getMiniGames)();
                    event = _.sample(events);
                    return [4, (0, _effects.put)((0, _events.setEventID)(event.id))];
                case 5:
                    _a.sent();
                    return [2];
            }
        });
    }
});

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(11), __webpack_require__(8), __webpack_require__(10), __webpack_require__(13)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("reselect"), require("lodash"), require("../../data/data"), require("./powerSources"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.reselect, global.lodash, global.data, global.powerSources);
        global.getEnergyMix = mod.exports;
    }
})(this, function (exports, _reselect, _lodash, _data, _powerSources) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getPowerSourceDifferenceRatios = exports.getPowerSourceDifferenceRatio = exports.getPowerSourceDifference = exports.getEnergyMix = undefined;

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    var getEnergyMix = exports.getEnergyMix = (0, _reselect.createSelector)([_powerSources.countPowerSources, _powerSources.countPowerSourcesByType], function (total_count, power_sources) {
        var ideal_mix = (0, _data.getEnergyMixData)();
        if (!total_count) return 0;
        var total_difference = _.reduce(ideal_mix, function (sum, ideal_ratio, id) {
            if (id === void 0) {
                id = '';
            }
            var count = power_sources[id] || 0;
            var relative_pc = count / total_count / 0.01;
            var difference = ideal_mix[id] / relative_pc;
            var real_difference = _.isFinite(difference) ? difference : 0;
            var abs_difference = Math.abs(1 - Math.abs(real_difference));
            return sum + abs_difference;
        }, 0);
        var n_sources = (0, _data.getAllPowerSourcesData)().length;
        return (1 - total_difference / n_sources) * 100;
    });
    var getPowerSourceDifference = exports.getPowerSourceDifference = (0, _reselect.createSelector)([_powerSources.getPowerSourceID, _powerSources.countPowerSourcesByID], function (power_source_id, power_source_count) {
        var ideal_mix = (0, _data.getEnergyMixData)();
        return ideal_mix[power_source_id] - power_source_count;
    });
    var getPowerSourceDifferenceRatio = exports.getPowerSourceDifferenceRatio = (0, _reselect.createSelector)([_powerSources.getPowerSourceID, getPowerSourceDifference], function (power_source_id, difference) {
        var ideal_mix = (0, _data.getEnergyMixData)();
        return difference / ideal_mix[power_source_id];
    });
    var getPowerSourceDifferenceRatios = exports.getPowerSourceDifferenceRatios = (0, _reselect.createSelector)([_powerSources.countPowerSources, _powerSources.countPowerSourcesByType], function (total_source_count, populated_power_sources) {
        var power_sources = (0, _data.getPowerSourcesData)();
        var ideal_percentages = (0, _data.getEnergyMixData)();
        var locations_count = (0, _data.getPowerSourceLocationsData)().length;
        var ratios = _.transform(power_sources, function (ratios, power_source) {
            var id = power_source.id;
            var ideal_percentage = ideal_percentages[id];
            var ideal_count = Math.round(locations_count * ideal_percentage * 0.01);
            var actual_count = populated_power_sources[id] || 0;
            var difference = actual_count - ideal_count;
            var ratio = difference / ideal_count;
            ratios[id] = _.clamp(ratio, -1, 1);
            return ratios;
        }, {});
        return ratios;
    });
});

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(4), __webpack_require__(2), __webpack_require__(21), __webpack_require__(10), __webpack_require__(18), __webpack_require__(17), __webpack_require__(56), __webpack_require__(33), __webpack_require__(12), __webpack_require__(164), __webpack_require__(166), __webpack_require__(13), __webpack_require__(165), __webpack_require__(78), __webpack_require__(22), __webpack_require__(39), __webpack_require__(81), __webpack_require__(41), __webpack_require__(42), __webpack_require__(16), __webpack_require__(15), __webpack_require__(82)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("tslib"), require("../actions/action"), require("redux-saga/effects"), require("../../data/data"), require("../actions/modals"), require("../reducers/modal"), require("../actions/outages"), require("../actions/timer"), require("../reducers/year"), require("../actions/energy/setEnergyDemand"), require("../actions/carbon/setCarbonTarget"), require("../reducers/powerSources"), require("../actions/power-sources/savePowerSourceCounts.ts"), require("../actions/score"), require("../actions/calendar/year"), require("../reducers/calendar/isYearAlreadyComplete"), require("../actions/mini-game/miniGame"), require("redux-saga"), require("../reducers/mini-game/miniGame"), require("../reducers/screen"), require("../actions/screens"), require("../actions/power-sources/deprecate"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.tslib, global.action, global.effects, global.data, global.modals, global.modal, global.outages, global.timer, global.year, global.setEnergyDemand, global.setCarbonTarget, global.powerSources, global.savePowerSourceCounts, global.score, global.year, global.isYearAlreadyComplete, global.miniGame, global.reduxSaga, global.miniGame, global.screen, global.screens, global.deprecate);
        global.handleCalendar = mod.exports;
    }
})(this, function (exports, _tslib, _action, _effects, _data, _modals, _modal, _outages, _timer, _year, _setEnergyDemand, _setCarbonTarget, _powerSources, _savePowerSourceCounts, _score, _year2, _isYearAlreadyComplete, _miniGame, _reduxSaga, _miniGame2, _screen, _screens, _deprecate) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.default = handleCalendar;

    var tslib_1 = _interopRequireWildcard(_tslib);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function handleCalendar() {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.takeEvery)(_action.START_YEAR, onStartYear)];
                case 1:
                    _a.sent();
                    return [4, (0, _effects.takeEvery)(_action.END_YEAR, onEndYear)];
                case 2:
                    _a.sent();
                    return [4, (0, _effects.takeEvery)(_action.INCREMENT_YEAR, onIncrementYear)];
                case 3:
                    _a.sent();
                    return [4, (0, _effects.takeEvery)(_action.TEST_ANNUAL_TARGETS, onTestAnnualTargets)];
                case 4:
                    _a.sent();
                    return [4, (0, _effects.takeEvery)(_action.ACTIVATE_MINI_GAME, onActivateMiniGame)];
                case 5:
                    _a.sent();
                    return [2];
            }
        });
    }
    function onStartYear(action) {
        var year_index, year_data, power_source_counts, demand, carbon_target, outage, previous_year, odeprecate, deprecate, mini_game;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.select)(_year.getYearIndex)];
                case 1:
                    year_index = _a.sent();
                    return [4, (0, _effects.select)(_year.getYearData)];
                case 2:
                    year_data = _a.sent();
                    return [4, (0, _effects.select)(_powerSources.countPowerSourcesByType)];
                case 3:
                    power_source_counts = _a.sent();
                    return [4, (0, _effects.put)((0, _savePowerSourceCounts.savePowerSourceCounts)(power_source_counts))];
                case 4:
                    _a.sent();
                    demand = year_data.demand;
                    if (!demand) return [3, 6];
                    return [4, (0, _effects.put)((0, _setEnergyDemand.setEnergyDemand)(demand))];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6:
                    carbon_target = year_data["carbon-target"];
                    if (!carbon_target) return [3, 8];
                    return [4, (0, _effects.put)((0, _setCarbonTarget.setCarbonTarget)(carbon_target))];
                case 7:
                    _a.sent();
                    _a.label = 8;
                case 8:
                    outage = year_data.outage;
                    return [4, (0, _effects.put)(outage ? (0, _outages.setOutageID)(outage) : (0, _outages.clearOutageID)())];
                case 9:
                    _a.sent();
                    return [4, (0, _effects.select)(_year.getPreviousYearData)];
                case 10:
                    previous_year = _a.sent();
                    odeprecate = (previous_year || {}).deprecate;
                    if (!odeprecate) return [3, 13];
                    return [4, (0, _effects.put)((0, _deprecate.removeDeprecatedStations)(odeprecate))];
                case 11:
                    _a.sent();
                    return [4, (0, _effects.put)((0, _deprecate.clearDeprecateType)())];
                case 12:
                    _a.sent();
                    _a.label = 13;
                case 13:
                    deprecate = year_data.deprecate;
                    return [4, (0, _effects.put)(deprecate ? (0, _deprecate.deprecateSourceType)(deprecate) : (0, _deprecate.clearDeprecateType)())];
                case 14:
                    _a.sent();
                    mini_game = year_data["mini-game"];
                    if (!mini_game) return [3, 16];
                    return [4, (0, _effects.put)((0, _miniGame.setMiniGameID)(mini_game))];
                case 15:
                    _a.sent();
                    _a.label = 16;
                case 16:
                    return [4, (0, _effects.put)((0, _timer.resetTimer)())];
                case 17:
                    _a.sent();
                    return [4, (0, _effects.put)((0, _timer.startTimer)())];
                case 18:
                    _a.sent();
                    return [4, (0, _effects.put)((0, _modals.showModal)(_modal.MODALS.YEAR))];
                case 19:
                    _a.sent();
                    return [2];
            }
        });
    }
    function onEndYear(action) {
        var years_data, year_index, year, deprecate;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.put)((0, _score.updateScore)())];
                case 1:
                    _a.sent();
                    return [4, (0, _effects.put)((0, _miniGame.clearMiniGameID)())];
                case 2:
                    _a.sent();
                    return [4, (0, _effects.put)((0, _screens.setScreen)(_screen.SCREENS.GAME))];
                case 3:
                    _a.sent();
                    return [4, (0, _effects.select)(_data.getYearsData)];
                case 4:
                    years_data = _a.sent();
                    return [4, (0, _effects.select)(_year.getYearIndex)];
                case 5:
                    year_index = _a.sent();
                    return [4, (0, _effects.select)(_year.getYearData)];
                case 6:
                    year = _a.sent();
                    deprecate = year.deprecate;
                    if (!(year['year-end'] || year['year-end-success'])) return [3, 8];
                    return [4, (0, _effects.put)((0, _modals.showModal)(_modal.MODALS.YEAR_END_STATUS))];
                case 7:
                    _a.sent();
                    return [3, 10];
                case 8:
                    return [4, (0, _effects.put)((0, _year2.incrementYear)())];
                case 9:
                    _a.sent();
                    _a.label = 10;
                case 10:
                    return [2];
            }
        });
    }
    function onIncrementYear(action) {
        var year_index, year_data, n_years;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.select)(_year.getYearIndex)];
                case 1:
                    year_index = _a.sent();
                    return [4, (0, _effects.select)(_year.getYearData)];
                case 2:
                    year_data = _a.sent();
                    return [4, (0, _effects.put)((0, _timer.resetTimer)())];
                case 3:
                    _a.sent();
                    return [4, (0, _effects.put)((0, _year2.startYear)())];
                case 4:
                    _a.sent();
                    n_years = (0, _data.getYearsData)().length;
                    return [2];
            }
        });
    }
    function onTestAnnualTargets(action) {
        var is_complete;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.select)(_isYearAlreadyComplete.isYearAlreadyComplete)];
                case 1:
                    is_complete = _a.sent();
                    if (!is_complete) return [3, 3];
                    return [4, (0, _effects.put)((0, _year2.endYear)())];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    return [2];
            }
        });
    }
    function onActivateMiniGame(action) {
        var mini_game_data;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.select)(_miniGame2.getMiniGameData)];
                case 1:
                    mini_game_data = _a.sent();
                    if (!mini_game_data) return [2];
                    return [4, (0, _reduxSaga.delay)(500)];
                case 2:
                    _a.sent();
                    return [4, (0, _effects.put)((0, _modals.showModal)(_modal.MODALS.EVENT))];
                case 3:
                    _a.sent();
                    return [2];
            }
        });
    }
});

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('../action'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.setEnergyDemand = mod.exports;
    }
})(this, function (exports, _action) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.setEnergyDemand = setEnergyDemand;
    function setEnergyDemand(demand) {
        return { type: _action.SET_ENERGY_DEMAND, payload: { demand: demand } };
    }
});

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('../action'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.savePowerSourceCountsTs = mod.exports;
    }
})(this, function (exports, _action) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.savePowerSourceCounts = savePowerSourceCounts;
    function savePowerSourceCounts(counts) {
        return { type: _action.SAVE_POWER_SOURCE_COUNTS, payload: { counts: counts } };
    }
});

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('../action'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.setCarbonTarget = mod.exports;
    }
})(this, function (exports, _action) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.setCarbonOutput = setCarbonOutput;
    exports.setCarbonTarget = setCarbonTarget;
    function setCarbonOutput(carbon_output) {
        return { type: _action.SET_CARBON_OUTPUT, payload: { carbon_output: carbon_output } };
    }
    function setCarbonTarget(carbon_target) {
        console.log('updating carbon target:', carbon_target);
        return { type: _action.SET_CARBON_TARGET, payload: { carbon_target: carbon_target } };
    }
});

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(4), __webpack_require__(2), __webpack_require__(21), __webpack_require__(8), __webpack_require__(18), __webpack_require__(17), __webpack_require__(33), __webpack_require__(16), __webpack_require__(15), __webpack_require__(31), __webpack_require__(41), __webpack_require__(83), __webpack_require__(10), __webpack_require__(13), __webpack_require__(22), __webpack_require__(82), __webpack_require__(25), __webpack_require__(84), __webpack_require__(39), __webpack_require__(28), __webpack_require__(168)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("tslib"), require("../actions/action"), require("redux-saga/effects"), require("lodash"), require("../actions/modals"), require("../reducers/modal"), require("../actions/timer"), require("../reducers/screen"), require("../actions/screens"), require("../actions/powerSources"), require("redux-saga"), require("../actions/power-sources/damage"), require("../../data/data"), require("../reducers/powerSources"), require("../actions/calendar/year"), require("../actions/power-sources/deprecate"), require("../actions/questions/questions"), require("../actions/mini-game/energyGenerated"), require("../reducers/calendar/isYearAlreadyComplete"), require("../reducers/power-sources/deprecate"), require("../actions/power-sources/removePowerSources"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.tslib, global.action, global.effects, global.lodash, global.modals, global.modal, global.timer, global.screen, global.screens, global.powerSources, global.reduxSaga, global.damage, global.data, global.powerSources, global.year, global.deprecate, global.questions, global.energyGenerated, global.isYearAlreadyComplete, global.deprecate, global.removePowerSources);
        global.handleGameEvents = mod.exports;
    }
})(this, function (exports, _tslib, _action, _effects, _lodash, _modals, _modal, _timer, _screen, _screens, _powerSources, _reduxSaga, _damage, _data, _powerSources2, _year, _deprecate, _questions, _energyGenerated, _isYearAlreadyComplete, _deprecate2, _removePowerSources) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.default = handleGameEvents;

    var tslib_1 = _interopRequireWildcard(_tslib);

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function handleGameEvents() {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.takeEvery)(_action.SHOW_GAME_INTRO, onShowGameIntro)];
                case 1:
                    _a.sent();
                    return [4, (0, _effects.takeEvery)(_action.START_GAME, onStartGame)];
                case 2:
                    _a.sent();
                    return [4, (0, _effects.takeEvery)(_action.RESUME_GAME, onResumeGame)];
                case 3:
                    _a.sent();
                    return [4, (0, _effects.takeEvery)(_action.SHOW_HINT, onShowHint)];
                case 4:
                    _a.sent();
                    return [4, (0, _effects.takeEvery)(_action.SHOW_NEXT_YEAR_END_QUESTION, onShowYearEndQuestion)];
                case 5:
                    _a.sent();
                    return [4, (0, _effects.takeEvery)(_action.SHOW_POWER_SOURCE_DETAILS, onShowPowerSourceDetails)];
                case 6:
                    _a.sent();
                    return [4, (0, _effects.takeEvery)(_action.SET_OUTAGE_ID, onOutageID)];
                case 7:
                    _a.sent();
                    return [4, (0, _effects.takeEvery)(_action.DEPRECATE_SOURCE_TYPE, onDeprecateType)];
                case 8:
                    _a.sent();
                    return [4, (0, _effects.takeEvery)(_action.SET_EVENT_ID, onEventID)];
                case 9:
                    _a.sent();
                    return [4, (0, _effects.takeEvery)(_action.SET_MODAL, onSetModal)];
                case 10:
                    _a.sent();
                    return [4, (0, _effects.takeEvery)(_action.ADD_POWER_SOURCE_AT_LOCATION, onPowerSourceAdded)];
                case 11:
                    _a.sent();
                    return [4, (0, _effects.takeEvery)(_action.REPAIR_STATION_AT_LOCATION, onPowerSourceRepaired)];
                case 12:
                    _a.sent();
                    return [4, (0, _effects.takeEvery)(_action.REMOVE_ALL_DEPRECATED_STATIONS, removeDeprecatedStations)];
                case 13:
                    _a.sent();
                    return [2];
            }
        });
    }
    function onShowGameIntro(action) {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.put)((0, _year.resetYear)())];
                case 1:
                    _a.sent();
                    return [4, (0, _effects.put)((0, _timer.resetTimer)())];
                case 2:
                    _a.sent();
                    return [4, (0, _effects.put)((0, _powerSources.resetAllPowerSources)())];
                case 3:
                    _a.sent();
                    return [4, (0, _effects.put)((0, _modals.hideModal)())];
                case 4:
                    _a.sent();
                    return [4, (0, _effects.put)((0, _screens.setScreen)(_screen.SCREENS.GAME_INTRO))];
                case 5:
                    _a.sent();
                    return [2];
            }
        });
    }
    function onStartGame(action) {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.put)((0, _year.resetYear)())];
                case 1:
                    _a.sent();
                    return [4, (0, _effects.put)((0, _timer.resetTimer)())];
                case 2:
                    _a.sent();
                    return [4, (0, _effects.put)((0, _powerSources.resetAllPowerSources)())];
                case 3:
                    _a.sent();
                    return [4, (0, _effects.put)((0, _deprecate.clearDeprecateType)())];
                case 4:
                    _a.sent();
                    return [4, (0, _effects.put)((0, _screens.setScreen)(_screen.SCREENS.GAME))];
                case 5:
                    _a.sent();
                    return [4, (0, _effects.put)((0, _year.startYear)())];
                case 6:
                    _a.sent();
                    return [4, (0, _effects.put)((0, _questions.resetCorrectAnswerCount)())];
                case 7:
                    _a.sent();
                    return [4, (0, _effects.put)((0, _energyGenerated.resetEnergyGenerated)())];
                case 8:
                    _a.sent();
                    return [2];
            }
        });
    }
    function onResumeGame(action) {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.put)((0, _screens.setScreen)(_screen.SCREENS.GAME))];
                case 1:
                    _a.sent();
                    return [4, (0, _effects.call)(_reduxSaga.delay, 2000)];
                case 2:
                    _a.sent();
                    return [4, (0, _effects.put)((0, _timer.startTimer)())];
                case 3:
                    _a.sent();
                    return [2];
            }
        });
    }
    function onShowHint(action) {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.put)((0, _modals.showModal)(_modal.MODALS.HINT))];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }
    function onOutageID(action) {
        var payload, outage_id, outages, outage, affects_1, power_sources, damage;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = action.payload;
                    outage_id = payload.outage_id;
                    console.group('onOutageID');
                    console.log('outage', outage_id);
                    console.groupEnd();
                    if (!!outage_id) return [3, 2];
                    return [4, (0, _effects.put)((0, _damage.clearAllDamage)())];
                case 1:
                    _a.sent();
                    return [3, 5];
                case 2:
                    outages = (0, _data.getOutages)();
                    outage = _.find(outages, { id: outage_id });
                    affects_1 = outage.affects;
                    return [4, (0, _effects.select)(_powerSources2.getPowerSources)];
                case 3:
                    power_sources = _a.sent();
                    damage = _.map(power_sources, function (power_source) {
                        return power_source && _.includes(affects_1, power_source.id);
                    });
                    return [4, (0, _effects.put)((0, _damage.setInitialDamage)(damage))];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    return [2];
            }
        });
    }
    function onDeprecateType(action) {
        var payload, deprecate, power_sources, potential_deprecations, counts, nuclear_count, nuclear_deprecate, deprecated_sources_1, deprecations;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = action.payload;
                    deprecate = payload.deprecate;
                    if (!!deprecate) return [3, 2];
                    return [4, (0, _effects.put)((0, _deprecate.clearAllDeprecations)())];
                case 1:
                    _a.sent();
                    return [3, 6];
                case 2:
                    return [4, (0, _effects.select)(_powerSources2.getPowerSources)];
                case 3:
                    power_sources = _a.sent();
                    potential_deprecations = _.filter(power_sources, function (source) {
                        return source && source.id === deprecate;
                    });
                    return [4, (0, _effects.select)(_powerSources2.countPowerSourcesByType)];
                case 4:
                    counts = _a.sent();
                    nuclear_count = counts['nuclear'];
                    nuclear_deprecate = nuclear_count <= 5 ? nuclear_count - 1 : 5;
                    deprecated_sources_1 = _.sampleSize(potential_deprecations, deprecate === 'nuclear' ? nuclear_deprecate : 50);
                    deprecations = _.map(power_sources, function (source) {
                        return _.includes(deprecated_sources_1, source);
                    });
                    return [4, (0, _effects.put)((0, _deprecate.setInitialDeprecate)(deprecations))];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6:
                    return [2];
            }
        });
    }
    function removeDeprecatedStations(action) {
        var deprecated_sources;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.select)(_deprecate2.getDeprecations)];
                case 1:
                    deprecated_sources = _a.sent();
                    console.group('removeDeprecatedStations');
                    console.log('deprecated_sources', deprecated_sources);
                    console.groupEnd();
                    return [4, (0, _effects.put)((0, _removePowerSources.removePowerSources)(deprecated_sources))];
                case 2:
                    _a.sent();
                    return [2];
            }
        });
    }
    function onShowOutageQuestion(action) {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.call)(_reduxSaga.delay, 500)];
                case 1:
                    _a.sent();
                    return [4, (0, _effects.put)((0, _modals.showModal)(_modal.MODALS.OUTAGE_QUESTION))];
                case 2:
                    _a.sent();
                    return [2];
            }
        });
    }
    function onShowYearEndQuestion(action) {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.call)(_reduxSaga.delay, 500)];
                case 1:
                    _a.sent();
                    return [4, (0, _effects.put)((0, _modals.showModal)(_modal.MODALS.YEAR_END_QUESTION))];
                case 2:
                    _a.sent();
                    return [2];
            }
        });
    }
    function onEventID(action) {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.put)((0, _modals.showModal)(_modal.MODALS.EVENT))];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }
    function onShowPowerSourceDetails(action) {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.put)((0, _modals.showModal)(_modal.MODALS.POWER_SOURCE_DETAILS))];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }
    function onSetModal(action) {
        var payload, modal_id;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = action.payload;
                    modal_id = payload.modal_id;
                    return [4, (0, _effects.put)(modal_id ? (0, _timer.pauseTimer)() : (0, _timer.resumeTimer)())];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }
    function onPowerSourceAdded(action) {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.put)((0, _timer.startTimer)())];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }
    function onPowerSourceRepaired(action) {
        var all_repaired;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.select)(_isYearAlreadyComplete.allDamagedStationsRepaired)];
                case 1:
                    all_repaired = _a.sent();
                    if (!all_repaired) return [3, 3];
                    return [4, (0, _effects.put)((0, _year.endYear)())];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    return [2];
            }
        });
    }
    function onTimerExpired(action) {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, (0, _effects.put)((0, _timer.stopTimer)())];
                case 1:
                    _a.sent();
                    return [4, (0, _effects.put)((0, _modals.showGameOverModal)())];
                case 2:
                    _a.sent();
                    return [2];
            }
        });
    }
});

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('../action'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.removePowerSources = mod.exports;
    }
})(this, function (exports, _action) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.removePowerSourceType = removePowerSourceType;
    exports.removePowerSources = removePowerSources;
    function removePowerSourceType(source_type) {
        return { type: _action.REMOVE_ALL_POWER_SOURCE_TYPE, payload: { source_type: source_type } };
    }
    function removePowerSources(stations) {
        return { type: _action.REMOVE_STATIONS, payload: { stations: stations } };
    }
});

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("../actions/action"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.answer = mod.exports;
    }
})(this, function (exports, _action) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getSelectedAnswer = undefined;
    exports.answer = answer;
    var getSelectedAnswer = exports.getSelectedAnswer = function getSelectedAnswer(state) {
        return state.answer;
    };
    var initialState = null;
    function answer(state, action) {
        if (state === void 0) {
            state = initialState;
        }
        switch (action.type) {
            case _action.CHOOSE_ANSWER:
                {
                    var payload = action.payload;
                    var answer_id = payload.answer_id;
                    return answer_id;
                }
            default:
                return state;
        }
    }
});

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2), __webpack_require__(8), __webpack_require__(10), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("../actions/action"), require("lodash"), require("../../data/data"), require("reselect"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action, global.lodash, global.data, global.reselect);
        global.event = mod.exports;
    }
})(this, function (exports, _action, _lodash, _data, _reselect) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getMiniGameData = exports.getEventID = undefined;
    exports.event = event;

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    var getEventID = exports.getEventID = function getEventID(state) {
        return state.event;
    };
    var getMiniGameData = exports.getMiniGameData = (0, _reselect.createSelector)([getEventID], function (event_id) {
        var events = (0, _data.getMiniGames)();
        return _.find(events, ['id', event_id]);
    });
    var initialState = null;
    function event(state, action) {
        if (state === void 0) {
            state = initialState;
        }
        switch (action.type) {
            case _action.SET_EVENT_ID:
                {
                    var payload = action.payload;
                    var event_id = payload.event_id;
                    return event_id;
                }
            default:
                return state;
        }
    }
});

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('../../actions/action'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.energyGenerated = mod.exports;
    }
})(this, function (exports, _action) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getEnergyGenerated = undefined;
    exports.energyGenerated = energyGenerated;
    var getEnergyGenerated = exports.getEnergyGenerated = function getEnergyGenerated(state) {
        return state.energyGenerated;
    };
    function energyGenerated(state, action) {
        if (state === void 0) {
            state = 0;
        }
        switch (action.type) {
            case _action.RECORD_ENERGY_GENERATED:
                {
                    var payload = action.payload;
                    var energy = payload.energy;
                    return (state || 0) + energy;
                }
            case _action.RESET_ENERGY_GENERATED:
                {
                    return 0;
                }
            default:
                return state;
        }
    }
});

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(26), __webpack_require__(173)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("tslib"), require("react"), require("react-redux"), require("../screenComponent"), require("./Preloader.css"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.tslib, global.react, global.reactRedux, global.screenComponent, global.Preloader);
        global.Preloader = mod.exports;
    }
})(this, function (exports, _tslib, _react, _reactRedux, _screenComponent) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    var Preloader = function (_super) {
        tslib_1.__extends(Preloader, _super);
        function Preloader(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            return _this;
        }
        Preloader.prototype.render = function () {
            if (!this.props.active) return null;
            return React.createElement(
                "div",
                null,
                "preloader"
            );
        };
        return Preloader;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state) {
        return {};
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {};
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _screenComponent.screenComponent)()(Preloader));
});

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(174);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./Preloader.css", function() {
			var newContent = require("!!../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./Preloader.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"Preloader.css","sourceRoot":""}]);

// exports


/***/ }),
/* 175 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(26), __webpack_require__(15), __webpack_require__(92), __webpack_require__(34), __webpack_require__(181)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("react-redux"), require("../screenComponent"), require("../../../store/actions/screens"), require("../../common/slideshow/SlideShow"), require("../../../store/actions/game"), require("./GameIntro.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.reactRedux, global.screenComponent, global.screens, global.SlideShow, global.game, global.GameIntro);
        global.GameIntro = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _reactRedux, _screenComponent, _screens, _SlideShow, _game) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./GameIntro.scss": {
            "back-button": "GameIntro__back-button___195ux",
            "slide": "GameIntro__slide___1pj8U"
        }
    };

    var GameIntro = function (_super) {
        tslib_1.__extends(GameIntro, _super);
        function GameIntro(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            return _this;
        }
        GameIntro.prototype.render = function () {
            var _a = this.props,
                showMainMenu = _a.showMainMenu,
                startGame = _a.startGame;
            if (!this.props.active) return null;
            return React.createElement(
                _SlideShow.SlideShow,
                { onCancel: showMainMenu, onComplete: startGame },
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('slide', _styleModuleImportMap)
                    },
                    React.createElement("img", { src: "./img/game-intro/1.png" })
                ),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('slide', _styleModuleImportMap)
                    },
                    React.createElement("img", { src: "./img/game-intro/2.png" })
                ),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('slide', _styleModuleImportMap)
                    },
                    React.createElement("img", { src: "./img/game-intro/3.png" })
                ),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('slide', _styleModuleImportMap)
                    },
                    React.createElement("img", { src: "./img/game-intro/3a.png" })
                ),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('slide', _styleModuleImportMap)
                    },
                    React.createElement("img", { src: "./img/game-intro/4.png" })
                ),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('slide', _styleModuleImportMap)
                    },
                    React.createElement("img", { src: "./img/game-intro/5.png" })
                ),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('slide', _styleModuleImportMap)
                    },
                    React.createElement("img", { src: "./img/game-intro/6.png" })
                ),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('slide', _styleModuleImportMap)
                    },
                    React.createElement("img", { src: "./img/game-intro/7.png" })
                ),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('slide', _styleModuleImportMap)
                    },
                    React.createElement("img", { src: "./img/game-intro/8.png" })
                ),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('slide', _styleModuleImportMap)
                    },
                    React.createElement("img", { src: "./img/game-intro/9.png" })
                ),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('slide', _styleModuleImportMap)
                    },
                    React.createElement("img", { src: "./img/game-intro/10.png" })
                ),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('slide', _styleModuleImportMap)
                    },
                    React.createElement("img", { src: "./img/game-intro/11.png" })
                )
            );
        };
        return GameIntro;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state) {
        return {};
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {
            startGame: function startGame() {
                return dispatch((0, _game.startGame)());
            },
            showMainMenu: function showMainMenu() {
                return dispatch((0, _screens.showMainMenu)());
            }
        };
    };
    exports.default = (0, _screenComponent.screenComponent)()((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GameIntro));
});

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(178);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../node_modules/sass-loader/lib/loader.js!./Button.scss", function() {
			var newContent = require("!!../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../node_modules/sass-loader/lib/loader.js!./Button.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports
exports.i(__webpack_require__(0), undefined);
exports.i(__webpack_require__(1), undefined);

// module
exports.push([module.i, ".Button__button___wCHGy{display:flex;justify-content:center;align-items:center;border:none;border-radius:5px;color:#fff;cursor:pointer;box-shadow:0 0 0 6px #fff,0 5px 10px rgba(0,0,0,.5);white-space:nowrap;text-transform:capitalize;font-size:20px;padding:15px 25px;transition:background-color .1s ease-out;margin:6px;user-select:none}.Button__button___wCHGy a{color:inherit;text-decoration:none}.Button__icon___3m-TG{white-space:nowrap}.Button__padded-icon___2A2-D{margin-right:.5em}.Button__show-leaderboard___2Skw9{font-size:25px;padding:15px 30px}.Button__play-game___3y39L{padding:20px 30px;font-size:25px;flex-direction:row-reverse}.Button__play-game___3y39L .Button__icon___3m-TG{margin-right:0;margin-left:.5em}.Button__file-download___2a0mB,.Button__show-how-to-play___3-9kE{padding:20px 30px;font-size:25px}.Button__skip-year___wg_7D{padding:20px 30px;font-size:20px}.Button__slideshow-cancel___2cCIY,.Button__slideshow-next___1_hc0,.Button__slideshow-previous___SMlEA,.Button__slideshow-skip___1t1Xc{font-size:25px;padding:15px 30px}.Button__slideshow-complete___2IUJd{font-size:20px;padding:20px 40px}.Button__remove-power-source___1AVpJ{width:100%}.Button__main-menu___2ZEOD,.Button__more-info___2XDfA,.Button__play-again___2xmW_{font-size:20px;padding:15px 20px}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/common/ui/button/Button.scss"],"names":[],"mappings":"AAAA,wBAAmD,aAAa,uBAAuB,mBAAmB,YAAY,kBAAkB,WAAc,eAAe,oDAAqD,mBAAmB,0BAA0B,eAAe,kBAAkB,yCAA0C,WAAW,gBAAgB,CAAC,0BAAU,cAAc,oBAAoB,CAAC,sBAAM,kBAAkB,CAAC,6BAA2B,iBAAkB,CAAC,AAAyV,kCAAuC,eAAe,iBAAiB,CAAC,2BAAiC,kBAAkB,eAAe,0BAA0B,CAAC,iDAAiB,eAAe,gBAAiB,CAAC,AAAuE,iEAAmC,kBAAkB,cAAc,CAAC,2BAAiC,kBAAkB,cAAc,CAAC,AAAuN,sIAAqC,eAAe,iBAAiB,CAAC,oCAA0C,eAAe,iBAAiB,CAAC,qCAAyC,UAAU,CAAC,AAAiR,kFAAkC,eAAe,iBAAiB,CAAC","file":"Button.scss","sourcesContent":[".button{composes:bold-font from '../../Fonts.scss';display:flex;justify-content:center;align-items:center;border:none;border-radius:5px;color:#ffffff;cursor:pointer;box-shadow:0 0 0 6px #fff,rgba(0,0,0,0.5) 0 5px 10px;white-space:nowrap;text-transform:capitalize;font-size:20px;padding:15px 25px;transition:background-color 0.1s ease-out;margin:6px;user-select:none}.button a{color:inherit;text-decoration:none}.icon{white-space:nowrap}.padded-icon{composes:icon;margin-right:0.5em}.blue-button{composes:button;composes:blue-hoverable from '../../Colour.scss'}.yellow-button{composes:button;composes:yellow-hoverable from '../../Colour.scss'}.green-button{composes:button;composes:green-hoverable from '../../Colour.scss'}.red-button{composes:button;composes:red-hoverable from '../../Colour.scss'}.basic{composes:green-button}.show-leaderboard{composes:blue-button;font-size:25px;padding:15px 30px}.play-game{composes:green-button;padding:20px 30px;font-size:25px;flex-direction:row-reverse}.play-game .icon{margin-right:0;margin-left:0.5em}.show-how-to-play{composes:red-button;padding:20px 30px;font-size:25px}.file-download{composes:red-button;padding:20px 30px;font-size:25px}.skip-year{composes:green-button;padding:20px 30px;font-size:20px}.slideshow-cancel{composes:red-button;font-size:25px;padding:15px 30px}.slideshow-previous{composes:blue-button;font-size:25px;padding:15px 30px}.slideshow-next{composes:blue-button;font-size:25px;padding:15px 30px}.slideshow-skip{composes:blue-button;font-size:25px;padding:15px 30px}.slideshow-complete{composes:green-button;font-size:20px;padding:20px 40px}.remove-power-source{composes:red-button;width:100%}.submit-score{composes:blue-button}.show-detailed-results{composes:green-button}.quit-game{composes:blue-button}.close{composes:green-button}.play-again{composes:green-button;font-size:20px;padding:15px 20px}.main-menu{composes:blue-button;font-size:20px;padding:15px 20px}.more-info{composes:yellow-button;font-size:20px;padding:15px 20px}.show-hints{composes:blue-button}.quit-game{composes:blue-button}.ok{composes:green-button}.right-answer{composes:green-button}.wrong-answer{composes:red-button}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"button": "Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + "",
	"icon": "Button__icon___3m-TG",
	"padded-icon": "Button__padded-icon___2A2-D Button__icon___3m-TG",
	"paddedIcon": "Button__padded-icon___2A2-D Button__icon___3m-TG",
	"blue-button": "Button__blue-button___3oNWY Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["blue-hoverable"] + "",
	"blueButton": "Button__blue-button___3oNWY Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["blue-hoverable"] + "",
	"yellow-button": "Button__yellow-button___2fo4W Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["yellow-hoverable"] + "",
	"yellowButton": "Button__yellow-button___2fo4W Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["yellow-hoverable"] + "",
	"green-button": "Button__green-button___1rQ5K Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["green-hoverable"] + "",
	"greenButton": "Button__green-button___1rQ5K Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["green-hoverable"] + "",
	"red-button": "Button__red-button___13_B8 Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["red-hoverable"] + "",
	"redButton": "Button__red-button___13_B8 Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["red-hoverable"] + "",
	"basic": "Button__basic___3BXRg Button__green-button___1rQ5K Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["green-hoverable"] + "",
	"show-leaderboard": "Button__show-leaderboard___2Skw9 Button__blue-button___3oNWY Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["blue-hoverable"] + "",
	"showLeaderboard": "Button__show-leaderboard___2Skw9 Button__blue-button___3oNWY Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["blue-hoverable"] + "",
	"play-game": "Button__play-game___3y39L Button__green-button___1rQ5K Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["green-hoverable"] + "",
	"playGame": "Button__play-game___3y39L Button__green-button___1rQ5K Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["green-hoverable"] + "",
	"show-how-to-play": "Button__show-how-to-play___3-9kE Button__red-button___13_B8 Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["red-hoverable"] + "",
	"showHowToPlay": "Button__show-how-to-play___3-9kE Button__red-button___13_B8 Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["red-hoverable"] + "",
	"file-download": "Button__file-download___2a0mB Button__red-button___13_B8 Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["red-hoverable"] + "",
	"fileDownload": "Button__file-download___2a0mB Button__red-button___13_B8 Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["red-hoverable"] + "",
	"skip-year": "Button__skip-year___wg_7D Button__green-button___1rQ5K Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["green-hoverable"] + "",
	"skipYear": "Button__skip-year___wg_7D Button__green-button___1rQ5K Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["green-hoverable"] + "",
	"slideshow-cancel": "Button__slideshow-cancel___2cCIY Button__red-button___13_B8 Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["red-hoverable"] + "",
	"slideshowCancel": "Button__slideshow-cancel___2cCIY Button__red-button___13_B8 Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["red-hoverable"] + "",
	"slideshow-previous": "Button__slideshow-previous___SMlEA Button__blue-button___3oNWY Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["blue-hoverable"] + "",
	"slideshowPrevious": "Button__slideshow-previous___SMlEA Button__blue-button___3oNWY Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["blue-hoverable"] + "",
	"slideshow-next": "Button__slideshow-next___1_hc0 Button__blue-button___3oNWY Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["blue-hoverable"] + "",
	"slideshowNext": "Button__slideshow-next___1_hc0 Button__blue-button___3oNWY Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["blue-hoverable"] + "",
	"slideshow-skip": "Button__slideshow-skip___1t1Xc Button__blue-button___3oNWY Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["blue-hoverable"] + "",
	"slideshowSkip": "Button__slideshow-skip___1t1Xc Button__blue-button___3oNWY Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["blue-hoverable"] + "",
	"slideshow-complete": "Button__slideshow-complete___2IUJd Button__green-button___1rQ5K Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["green-hoverable"] + "",
	"slideshowComplete": "Button__slideshow-complete___2IUJd Button__green-button___1rQ5K Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["green-hoverable"] + "",
	"remove-power-source": "Button__remove-power-source___1AVpJ Button__red-button___13_B8 Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["red-hoverable"] + "",
	"removePowerSource": "Button__remove-power-source___1AVpJ Button__red-button___13_B8 Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["red-hoverable"] + "",
	"submit-score": "Button__submit-score___3DhKm Button__blue-button___3oNWY Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["blue-hoverable"] + "",
	"submitScore": "Button__submit-score___3DhKm Button__blue-button___3oNWY Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["blue-hoverable"] + "",
	"show-detailed-results": "Button__show-detailed-results___2YZxn Button__green-button___1rQ5K Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["green-hoverable"] + "",
	"showDetailedResults": "Button__show-detailed-results___2YZxn Button__green-button___1rQ5K Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["green-hoverable"] + "",
	"quit-game": "Button__quit-game___18JFJ Button__blue-button___3oNWY Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["blue-hoverable"] + " Button__blue-button___3oNWY Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["blue-hoverable"] + "",
	"quitGame": "Button__quit-game___18JFJ Button__blue-button___3oNWY Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["blue-hoverable"] + " Button__blue-button___3oNWY Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["blue-hoverable"] + "",
	"close": "Button__close___D73X- Button__green-button___1rQ5K Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["green-hoverable"] + "",
	"play-again": "Button__play-again___2xmW_ Button__green-button___1rQ5K Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["green-hoverable"] + "",
	"playAgain": "Button__play-again___2xmW_ Button__green-button___1rQ5K Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["green-hoverable"] + "",
	"main-menu": "Button__main-menu___2ZEOD Button__blue-button___3oNWY Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["blue-hoverable"] + "",
	"mainMenu": "Button__main-menu___2ZEOD Button__blue-button___3oNWY Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["blue-hoverable"] + "",
	"more-info": "Button__more-info___2XDfA Button__yellow-button___2fo4W Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["yellow-hoverable"] + "",
	"moreInfo": "Button__more-info___2XDfA Button__yellow-button___2fo4W Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["yellow-hoverable"] + "",
	"show-hints": "Button__show-hints___33h97 Button__blue-button___3oNWY Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["blue-hoverable"] + "",
	"showHints": "Button__show-hints___33h97 Button__blue-button___3oNWY Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["blue-hoverable"] + "",
	"ok": "Button__ok___Cq5ty Button__green-button___1rQ5K Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["green-hoverable"] + "",
	"right-answer": "Button__right-answer___2rCIj Button__green-button___1rQ5K Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["green-hoverable"] + "",
	"rightAnswer": "Button__right-answer___2rCIj Button__green-button___1rQ5K Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["green-hoverable"] + "",
	"wrong-answer": "Button__wrong-answer___2phMW Button__red-button___13_B8 Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["red-hoverable"] + "",
	"wrongAnswer": "Button__wrong-answer___2phMW Button__red-button___13_B8 Button__button___wCHGy " + __webpack_require__(0).locals["bold-font"] + " " + __webpack_require__(1).locals["red-hoverable"] + ""
};

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(180);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./SlideShow.scss", function() {
			var newContent = require("!!../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./SlideShow.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports


// module
exports.push([module.i, ".SlideShow__slides___2KBxX,.SlideShow__slideshow___3AVV9{position:absolute;top:0;left:0;width:100%;height:100%}.SlideShow__slides___2KBxX{overflow:hidden}.SlideShow__slide___Dw9U_{position:absolute;top:0;left:0;width:100%;height:100%;transition:transform .5s ease-in-out}.SlideShow__cancel-button-container___1P9Fa{position:absolute;top:0;left:0;padding:40px;z-index:10}.SlideShow__slideshow-buttons-container___27UYd{position:absolute;display:flex;align-items:flex-end;justify-content:space-between;box-sizing:border-box;bottom:0;left:0;width:100%;padding:40px;z-index:10}.SlideShow__skip-button___2FrgW{margin-left:auto;margin-right:40px}.SlideShow__disabled-button___3MgLJ{visibility:hidden;pointer-events:none}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/common/slideshow/SlideShow.scss"],"names":[],"mappings":"AAAiE,yDAAtD,kBAAkB,MAAM,OAAO,WAAW,WAAW,CAA+E,AAA9E,2BAA8D,eAAe,CAAC,0BAAO,kBAAkB,MAAM,OAAO,WAAW,YAAY,oCAAqC,CAAC,4CAAyB,kBAAkB,MAAM,OAAO,aAAa,UAAU,CAAC,gDAA6B,kBAAkB,aAAa,qBAAqB,8BAA8B,sBAAsB,SAAS,OAAO,WAAW,aAAa,UAAU,CAAC,gCAAa,iBAAiB,iBAAiB,CAAC,oCAAiB,kBAAkB,mBAAmB,CAAC","file":"SlideShow.scss","sourcesContent":[".slideshow{position:absolute;top:0;left:0;width:100%;height:100%}.slides{position:absolute;top:0;left:0;width:100%;height:100%;overflow:hidden}.slide{position:absolute;top:0;left:0;width:100%;height:100%;transition:transform 0.5s ease-in-out}.cancel-button-container{position:absolute;top:0;left:0;padding:40px;z-index:10}.slideshow-buttons-container{position:absolute;display:flex;align-items:flex-end;justify-content:space-between;box-sizing:border-box;bottom:0;left:0;width:100%;padding:40px;z-index:10}.skip-button{margin-left:auto;margin-right:40px}.disabled-button{visibility:hidden;pointer-events:none}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"slideshow": "SlideShow__slideshow___3AVV9",
	"slides": "SlideShow__slides___2KBxX",
	"slide": "SlideShow__slide___Dw9U_",
	"cancel-button-container": "SlideShow__cancel-button-container___1P9Fa",
	"cancelButtonContainer": "SlideShow__cancel-button-container___1P9Fa",
	"slideshow-buttons-container": "SlideShow__slideshow-buttons-container___27UYd",
	"slideshowButtonsContainer": "SlideShow__slideshow-buttons-container___27UYd",
	"skip-button": "SlideShow__skip-button___2FrgW",
	"skipButton": "SlideShow__skip-button___2FrgW",
	"disabled-button": "SlideShow__disabled-button___3MgLJ",
	"disabledButton": "SlideShow__disabled-button___3MgLJ"
};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(182);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./GameIntro.scss", function() {
			var newContent = require("!!../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./GameIntro.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports


// module
exports.push([module.i, ".GameIntro__back-button___195ux{position:absolute;top:20px;left:20px}.GameIntro__slide___1pj8U{position:absolute;width:100%;height:100%;display:flex;justify-content:center;align-items:center;overflow:hidden}.GameIntro__slide___1pj8U>img{border:1000px solid rgba(0,0,0,.85);max-height:80vh}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game-intro/GameIntro.scss"],"names":[],"mappings":"AAAA,gCAAa,kBAAkB,SAAS,SAAS,CAAC,0BAAO,kBAAkB,WAAW,YAAY,aAAa,uBAAuB,mBAAmB,eAAe,CAAC,8BAAW,oCAAqC,eAAe,CAAC","file":"GameIntro.scss","sourcesContent":[".back-button{position:absolute;top:20px;left:20px}.slide{position:absolute;width:100%;height:100%;display:flex;justify-content:center;align-items:center;overflow:hidden}.slide>img{border:1000px solid rgba(0,0,0,0.85);max-height:80vh}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"back-button": "GameIntro__back-button___195ux",
	"backButton": "GameIntro__back-button___195ux",
	"slide": "GameIntro__slide___1pj8U"
};

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(8), __webpack_require__(9), __webpack_require__(26), __webpack_require__(15), __webpack_require__(34), __webpack_require__(19), __webpack_require__(93), __webpack_require__(192), __webpack_require__(97)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("lodash"), require("react-redux"), require("../screenComponent"), require("../../../store/actions/screens"), require("../../../store/actions/game"), require("../../common/ui/button/Button"), require("react-transition-group"), require("./MainMenu.scss"), require("../game/map/Clouds"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.lodash, global.reactRedux, global.screenComponent, global.screens, global.game, global.Button, global.reactTransitionGroup, global.MainMenu, global.Clouds);
        global.MainMenu = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _lodash, _reactRedux, _screenComponent, _screens, _game, _Button, _reactTransitionGroup, _MainMenu, _Clouds) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    var _ = _interopRequireWildcard(_lodash);

    var _Button2 = _interopRequireDefault(_Button);

    var styles = _interopRequireWildcard(_MainMenu);

    var _Clouds2 = _interopRequireDefault(_Clouds);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "styles": {
            "main-menu": "MainMenu__main-menu___31I_r",
            "background": "MainMenu__background___2kowq",
            "education-logo": "MainMenu__education-logo___2EsER",
            "content": "MainMenu__content___1GSGu",
            "menu-buttons": "MainMenu__menu-buttons___3-LNn",
            "play-button": "MainMenu__play-button___XEQlg",
            "enter": "MainMenu__enter___2xAQx",
            "enter-active": "MainMenu__enter-active___22P4A",
            "exit": "MainMenu__exit___2Em-g",
            "exit-active": "MainMenu__exit-active___UkWlP"
        }
    };

    var MainMenu = function (_super) {
        tslib_1.__extends(MainMenu, _super);
        function MainMenu(props, state) {
            if (state === void 0) {
                state = { active: false };
            }
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.state = state;
            _this.onMount = _.debounce(function () {
                _this.setState({ active: true });
            }, 10);
            return _this;
        }
        MainMenu.prototype.render = function () {
            var pactive = this.props.active;
            var sactive = this.state.active;
            var active = pactive && sactive;
            return React.createElement(
                _reactTransitionGroup.CSSTransition,
                { "in": active, timeout: 400, classNames: {
                        enter: styles.enter,
                        enterActive: styles.enterActive,
                        exit: styles.exit,
                        exitActive: styles.exitActive
                    }, appear: true, mountOnEnter: true, unmountOnExit: true, ref: this.onMount },
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('main-menu', _styleModuleImportMap)
                    },
                    React.createElement("div", {
                        className: (0, _getClassName3.default)('background', _styleModuleImportMap)
                    }),
                    React.createElement(_Clouds2.default, null),
                    React.createElement(
                        "div",
                        {
                            className: (0, _getClassName3.default)('content', _styleModuleImportMap)
                        },
                        React.createElement("img", { src: "./img/main-menu/logo.png" })
                    ),
                    React.createElement("div", {
                        className: (0, _getClassName3.default)('education-logo', _styleModuleImportMap)
                    }),
                    React.createElement(
                        "div",
                        {
                            className: (0, _getClassName3.default)('menu-buttons', _styleModuleImportMap)
                        },
                        React.createElement(
                            _Button2.default,
                            { type: 'file-download', onClick: null },
                            React.createElement(
                                "a",
                                { href: 'assets/supporting-notes.pdf', download: "Supporting Notes.pdf" },
                                "Supporting notes"
                            )
                        ),
                        React.createElement(
                            _Button2.default,
                            { type: 'play-game', onClick: this.props.showGameIntro },
                            "Start"
                        )
                    )
                )
            );
        };
        return MainMenu;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state) {
        return {};
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {
            showLeaderboard: function showLeaderboard() {
                return dispatch((0, _screens.showLeaderboard)());
            },
            showGameIntro: function showGameIntro() {
                return dispatch((0, _game.showGameIntro)());
            },
            showHowToPlay: function showHowToPlay() {
                return dispatch((0, _screens.showHowToPlay)());
            }
        };
    };
    exports.default = (0, _screenComponent.screenComponent)()((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MainMenu));
});

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(40);

var PropTypes = _interopRequireWildcard(_propTypes);

var _addClass = __webpack_require__(187);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(189);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _Transition = __webpack_require__(94);

var _Transition2 = _interopRequireDefault(_Transition);

var _PropTypes = __webpack_require__(95);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass2.default)(node, c);
  });
};
var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass2.default)(node, c);
  });
};

var propTypes = _extends({}, _Transition2.default.propTypes, {

  /**
   * The animation classNames applied to the component as it enters, exits or has finished the transition.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
});

/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation. After the animation,
 * matching `done` class names are applied to persist the animation state.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/m77l2vp00x?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 */

var CSSTransition = function (_React$Component) {
  _inherits(CSSTransition, _React$Component);

  function CSSTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');
      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.onEntered = function (node, appearing) {
      var _this$getClassNames3 = _this.getClassNames('enter'),
          doneClassName = _this$getClassNames3.doneClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');
      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    }, _this.onExit = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          className = _this$getClassNames4.className;

      _this.removeClasses(node, 'appear');
      _this.removeClasses(node, 'enter');
      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.onExiting = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames5.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    }, _this.onExited = function (node) {
      var _this$getClassNames6 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames6.doneClassName;

      _this.removeClasses(node, 'exit');
      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    }, _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;


      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;

      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';

      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';

      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
    var _getClassNames = this.getClassNames(type),
        className = _getClassNames.className,
        activeClassName = _getClassNames.activeClassName,
        doneClassName = _getClassNames.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    /* eslint-disable no-unused-expressions */
    node && node.scrollTop;
    /* eslint-enable no-unused-expressions */
    addClass(node, className);
  };

  CSSTransition.prototype.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;

    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react2.default.Component);

CSSTransition.propTypes =  false ? propTypes : {};

exports.default = CSSTransition;
module.exports = exports['default'];

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(36);
var invariant = __webpack_require__(62);
var ReactPropTypesSecret = __webpack_require__(186);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(188);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}
module.exports = exports['default'];

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(40);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(43);

var _TransitionGroup = __webpack_require__(96);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  in: _propTypes2.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react2.default.Children.count(props[propName]) !== 2) return new Error('"' + propName + '" must be exactly two transition components.');

    return null;
  }
};

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition = function (_React$Component) {
  _inherits(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, ReplaceTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  ReplaceTransition.prototype.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react2.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  ReplaceTransition.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        inProp = _props.in,
        props = _objectWithoutProperties(_props, ['children', 'in']);

    var _React$Children$toArr = _react2.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;

    return _react2.default.createElement(
      _TransitionGroup2.default,
      props,
      inProp ? _react2.default.cloneElement(first, {
        key: 'first',
        onEnter: this.handleEnter,
        onEntering: this.handleEntering,
        onEntered: this.handleEntered

      }) : _react2.default.cloneElement(second, {
        key: 'second',
        onEnter: this.handleExit,
        onEntering: this.handleExiting,
        onEntered: this.handleExited
      })
    );
  };

  return ReplaceTransition;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleEnter = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _this2.handleLifecycle('onEnter', 0, args);
  };

  this.handleEntering = function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _this2.handleLifecycle('onEntering', 0, args);
  };

  this.handleEntered = function () {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return _this2.handleLifecycle('onEntered', 0, args);
  };

  this.handleExit = function () {
    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    return _this2.handleLifecycle('onExit', 1, args);
  };

  this.handleExiting = function () {
    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    return _this2.handleLifecycle('onExiting', 1, args);
  };

  this.handleExited = function () {
    for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    return _this2.handleLifecycle('onExited', 1, args);
  };
};

ReplaceTransition.propTypes =  false ? propTypes : {};

exports.default = ReplaceTransition;
module.exports = exports['default'];

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(3);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = Object.create(null);

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(193);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./MainMenu.scss", function() {
			var newContent = require("!!../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./MainMenu.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports


// module
exports.push([module.i, ".MainMenu__main-menu___31I_r{position:absolute;width:100%;height:100%;overflow:hidden}.MainMenu__education-logo___2EsER{position:absolute;top:30px;left:50%;transform:translate(-50%);color:#fff}.MainMenu__content___1GSGu{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);text-align:center}.MainMenu__menu-buttons___3-LNn{position:absolute;bottom:5%;left:50%;transform:translate(-50%,-50%);display:flex;align-items:flex-end;justify-content:space-between}.MainMenu__menu-buttons___3-LNn>button{margin:0 20px}.MainMenu__menu-buttons___3-LNn>button:last-of-type{margin-left:60px}.MainMenu__menu-buttons___3-LNn .MainMenu__play-button___XEQlg{margin-left:auto}.MainMenu__enter___2xAQx .MainMenu__background___2kowq{opacity:0;transform:scale(1.5);transition:all 1s ease-out}.MainMenu__enter___2xAQx .MainMenu__education-logo___2EsER{top:-30px;transition:all .6s cubic-bezier(.175,.885,.32,1.275);transition-delay:2s}.MainMenu__enter___2xAQx .MainMenu__content___1GSGu{opacity:0;transform:translate(-50%,-40%) scale(.9) rotate(10deg);transition:all 1s cubic-bezier(.175,.885,.32,1.275);transition-delay:1s}.MainMenu__enter___2xAQx .MainMenu__menu-buttons___3-LNn{opacity:0;bottom:5%;transition:all 1s ease-out;transition-delay:3s}.MainMenu__enter-active___22P4A .MainMenu__background___2kowq{opacity:1;transform:scale(1)}.MainMenu__enter-active___22P4A .MainMenu__education-logo___2EsER{top:30px}.MainMenu__enter-active___22P4A .MainMenu__content___1GSGu{opacity:1;transform:translate(-50%,-50%) scale(1) rotate(0)}.MainMenu__enter-active___22P4A .MainMenu__menu-buttons___3-LNn{opacity:1;bottom:10%}.MainMenu__exit___2Em-g .MainMenu__background___2kowq{opacity:1}.MainMenu__exit-active___UkWlP .MainMenu__background___2kowq{opacity:0;transition:all .5s ease-out}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/main-menu/MainMenu.scss"],"names":[],"mappings":"AAAA,6BAAW,kBAAkB,WAAW,YAAY,eAAe,CAAC,kCAAgB,kBAAkB,SAAS,SAAS,0BAA0B,UAAW,CAAC,2BAAS,kBAAkB,QAAQ,SAAS,+BAAgC,iBAAiB,CAAC,gCAAc,kBAAkB,UAAU,SAAS,+BAAgC,aAAa,qBAAqB,6BAA6B,CAAC,uCAAqB,aAAa,CAAC,oDAAkC,gBAAgB,CAAC,+DAA2B,gBAAgB,CAAC,uDAAmB,UAAU,qBAAqB,0BAA0B,CAAC,2DAAuB,UAAU,qDAA6D,mBAAmB,CAAC,oDAAgB,UAAU,uDAAyD,oDAA0D,mBAAmB,CAAC,yDAAqB,UAAU,UAAU,2BAA2B,mBAAmB,CAAC,8DAA0B,UAAU,kBAAkB,CAAC,kEAA8B,QAAQ,CAAC,2DAAuB,UAAU,iDAAkD,CAAC,gEAA4B,UAAU,UAAU,CAAC,sDAAkB,SAAS,CAAC,6DAAyB,UAAU,2BAA4B,CAAC","file":"MainMenu.scss","sourcesContent":[".main-menu{position:absolute;width:100%;height:100%;overflow:hidden}.education-logo{position:absolute;top:30px;left:50%;transform:translate(-50%);color:white}.content{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);text-align:center}.menu-buttons{position:absolute;bottom:5%;left:50%;transform:translate(-50%, -50%);display:flex;align-items:flex-end;justify-content:space-between}.menu-buttons>button{margin:0 20px}.menu-buttons>button:last-of-type{margin-left:60px}.menu-buttons .play-button{margin-left:auto}.enter .background{opacity:0;transform:scale(1.5);transition:all 1s ease-out}.enter .education-logo{top:-30px;transition:all 600ms cubic-bezier(0.175, 0.885, 0.32, 1.275);transition-delay:2s}.enter .content{opacity:0;transform:translate(-50%, -40%) scale(0.9) rotate(10deg);transition:all 1s cubic-bezier(0.175, 0.885, 0.32, 1.275);transition-delay:1s}.enter .menu-buttons{opacity:0;bottom:5%;transition:all 1s ease-out;transition-delay:3s}.enter-active .background{opacity:1;transform:scale(1)}.enter-active .education-logo{top:30px}.enter-active .content{opacity:1;transform:translate(-50%, -50%) scale(1) rotate(0)}.enter-active .menu-buttons{opacity:1;bottom:10%}.exit .background{opacity:1}.exit-active .background{opacity:0;transition:all 0.5s ease-out}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"main-menu": "MainMenu__main-menu___31I_r",
	"mainMenu": "MainMenu__main-menu___31I_r",
	"education-logo": "MainMenu__education-logo___2EsER",
	"educationLogo": "MainMenu__education-logo___2EsER",
	"content": "MainMenu__content___1GSGu",
	"menu-buttons": "MainMenu__menu-buttons___3-LNn",
	"menuButtons": "MainMenu__menu-buttons___3-LNn",
	"play-button": "MainMenu__play-button___XEQlg",
	"playButton": "MainMenu__play-button___XEQlg",
	"enter": "MainMenu__enter___2xAQx",
	"background": "MainMenu__background___2kowq",
	"enter-active": "MainMenu__enter-active___22P4A",
	"enterActive": "MainMenu__enter-active___22P4A",
	"exit": "MainMenu__exit___2Em-g",
	"exit-active": "MainMenu__exit-active___UkWlP",
	"exitActive": "MainMenu__exit-active___UkWlP"
};

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(195);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../node_modules/sass-loader/lib/loader.js!./Clouds.scss", function() {
			var newContent = require("!!../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../node_modules/sass-loader/lib/loader.js!./Clouds.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports


// module
exports.push([module.i, "@keyframes Clouds__drift___3GuAw{0%{background-position:-100%}to{background-position:0}}.Clouds__clouds___ZqF3b{position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;background-image:url(\"img/game/clouds.png\");background-size:cover;animation:Clouds__drift___3GuAw 180s infinite}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game/map/Clouds.scss"],"names":[],"mappings":"AAAA,iCAAiB,GAAG,yBAAyB,CAAC,GAAK,qBAAqB,CAAC,CAAC,wBAAQ,kBAAkB,MAAM,OAAO,WAAW,YAAY,oBAAoB,4CAA4C,sBAAsB,6CAA6B,CAAC","file":"Clouds.scss","sourcesContent":["@keyframes drift{0%{background-position:-100%}100%{background-position:0}}.clouds{position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;background-image:url(\"img/game/clouds.png\");background-size:cover;animation:drift 180s infinite}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"clouds": "Clouds__clouds___ZqF3b",
	"drift": "Clouds__drift___3GuAw"
};

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(77), __webpack_require__(197), __webpack_require__(18), __webpack_require__(17), __webpack_require__(33), __webpack_require__(198), __webpack_require__(56), __webpack_require__(25), __webpack_require__(80), __webpack_require__(57), __webpack_require__(15), __webpack_require__(16), __webpack_require__(22), __webpack_require__(199)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("react-redux"), require("../../store/reducers/debug-console/visible"), require("../../store/actions/debug-console/visible"), require("../../store/actions/modals"), require("../../store/reducers/modal"), require("../../store/actions/timer"), require("../../store/actions/hints"), require("../../store/actions/outages"), require("../../store/actions/questions/questions"), require("../../store/actions/events"), require("../../store/reducers/score"), require("../../store/actions/screens"), require("../../store/reducers/screen"), require("../../store/actions/calendar/year"), require("./DebugConsole.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.reactRedux, global.visible, global.visible, global.modals, global.modal, global.timer, global.hints, global.outages, global.questions, global.events, global.score, global.screens, global.screen, global.year, global.DebugConsole);
        global.DebugConsole = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _reactRedux, _visible, _visible2, _modals, _modal, _timer, _hints, _outages, _questions, _events, _score, _screens, _screen, _year) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./DebugConsole.scss": {
            "debug-console": "DebugConsole__debug-console___255dD",
            "visible": "DebugConsole__visible___3_csI",
            "button-group": "DebugConsole__button-group___3qPXg"
        }
    };

    var DebugConsole = function (_super) {
        tslib_1.__extends(DebugConsole, _super);
        function DebugConsole(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.toggleConsole = function (event) {
                if (event.keyCode === 223 || event.keyCode === 192) _this.props.toggleConsole(!_this.props.visible);
            };
            return _this;
        }
        DebugConsole.prototype.componentDidMount = function () {
            document.addEventListener('keyup', this.toggleConsole);
        };
        DebugConsole.prototype.render = function () {
            var _this = this;
            if (!this.props.visible) return null;
            return React.createElement(
                "div",
                {
                    className: (0, _getClassName3.default)('debug-console', _styleModuleImportMap)
                },
                React.createElement(
                    "h1",
                    null,
                    "debug console"
                ),
                React.createElement(
                    "h3",
                    null,
                    "modals"
                ),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('button-group', _styleModuleImportMap)
                    },
                    React.createElement(
                        "button",
                        { onClick: this.props.showMainMenu },
                        "start game timer"
                    ),
                    React.createElement(
                        "button",
                        { onClick: this.props.showStartTimer },
                        "start game timer"
                    ),
                    React.createElement(
                        "button",
                        { onClick: this.props.showOutage },
                        "outage"
                    ),
                    React.createElement(
                        "button",
                        { onClick: this.props.showHint },
                        "hint"
                    ),
                    React.createElement(
                        "button",
                        { onClick: function onClick() {
                                return _this.props.showModal(_modal.MODALS.OUTAGE);
                            } },
                        "power source"
                    ),
                    React.createElement(
                        "button",
                        { onClick: this.props.showQuestion },
                        "question"
                    ),
                    React.createElement(
                        "button",
                        { onClick: this.props.showEvent },
                        "event"
                    ),
                    React.createElement(
                        "button",
                        { onClick: this.props.showGameOver },
                        "game over"
                    ),
                    React.createElement(
                        "button",
                        { onClick: function onClick() {
                                return _this.props.showModal(null);
                            } },
                        "none"
                    ),
                    React.createElement(
                        "button",
                        { onClick: this.props.skipToEnd },
                        "skip"
                    )
                ),
                React.createElement(
                    "h3",
                    null,
                    "timer"
                ),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('button-group', _styleModuleImportMap)
                    },
                    React.createElement(
                        "button",
                        { onClick: this.props.startTimer },
                        "start"
                    ),
                    React.createElement(
                        "button",
                        { onClick: this.props.stopTimer },
                        "stop"
                    ),
                    React.createElement(
                        "button",
                        { onClick: this.props.pauseTimer },
                        "pause"
                    ),
                    React.createElement(
                        "button",
                        { onClick: this.props.resumeTimer },
                        "resume"
                    )
                ),
                React.createElement(
                    "h3",
                    null,
                    "score"
                ),
                React.createElement(
                    "p",
                    null,
                    this.props.score
                )
            );
        };
        return DebugConsole;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state) {
        return {
            visible: (0, _visible.getDebugConsoleVisible)(state),
            score: (0, _score.getScore)(state)
        };
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {
            toggleConsole: function toggleConsole(visible) {
                return dispatch((0, _visible2.toggleDebugConsole)(visible));
            },
            showModal: function showModal(modal_id) {
                return dispatch((0, _modals.showModal)(modal_id));
            },
            startTimer: function startTimer() {
                return dispatch((0, _timer.startTimer)());
            },
            stopTimer: function stopTimer() {
                return dispatch((0, _timer.stopTimer)());
            },
            pauseTimer: function pauseTimer() {
                return dispatch((0, _timer.pauseTimer)());
            },
            resumeTimer: function resumeTimer() {
                return dispatch((0, _timer.resumeTimer)());
            },
            skipToEnd: function skipToEnd() {
                return dispatch((0, _year.setYear)(12));
            },
            showMainMenu: function showMainMenu() {
                return dispatch((0, _screens.setScreen)(_screen.SCREENS.MAIN_MENU));
            },
            showStartTimer: function showStartTimer() {
                return dispatch((0, _modals.showTimerStartModal)());
            },
            showHint: function showHint() {
                return dispatch((0, _hints.showHint)('low-energy-mix'));
            },
            showOutage: function showOutage() {
                return dispatch((0, _outages.chooseRelevantOutage)());
            },
            showQuestion: function showQuestion() {
                return dispatch((0, _questions.showNextOutageQuestion)('low-energy-mix'));
            },
            showEvent: function showEvent() {
                return dispatch((0, _events.setEventID)('world-cup'));
            },
            showGameOver: function showGameOver() {
                return dispatch((0, _modals.showGameOverModal)());
            }
        };
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DebugConsole);
});

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("../action"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.visible = mod.exports;
    }
})(this, function (exports, _action) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.showDebugConsole = showDebugConsole;
    exports.hideDebugConsole = hideDebugConsole;
    exports.toggleDebugConsole = toggleDebugConsole;
    function showDebugConsole() {
        return { type: _action.TOGGLE_DEBUG_CONSOLE, payload: { visible: true } };
    }
    function hideDebugConsole() {
        return { type: _action.TOGGLE_DEBUG_CONSOLE, payload: { visible: false } };
    }
    function toggleDebugConsole(visible) {
        return { type: _action.TOGGLE_DEBUG_CONSOLE, payload: { visible: visible } };
    }
});

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("./action"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.hints = mod.exports;
    }
})(this, function (exports, _action) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.chooseGeneralHint = chooseGeneralHint;
    exports.chooseIncreasePowerSourceHint = chooseIncreasePowerSourceHint;
    exports.showHint = showHint;
    exports.showHints = showHints;
    function chooseGeneralHint() {
        return { type: _action.CHOOSE_GENERAL_HINT };
    }
    function chooseIncreasePowerSourceHint() {
        return { type: _action.CHOOSE_INCREASE_POWER_SOURCE_HINT };
    }
    function showHint(hint_id) {
        return { type: _action.SHOW_HINT, payload: { hint_id: hint_id } };
    }
    function showHints() {
        return { type: _action.SHOW_HINT, payload: {} };
    }
});

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(200);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./DebugConsole.scss", function() {
			var newContent = require("!!../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./DebugConsole.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports


// module
exports.push([module.i, ".DebugConsole__debug-console___255dD{position:fixed;top:0;left:0;right:0;height:500px;background-color:hsla(0,0%,100%,.9);padding:40px}.DebugConsole__visible___3_csI{opacity:.2}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/debug/DebugConsole.scss"],"names":[],"mappings":"AAAA,qCAAe,eAAe,MAAM,OAAO,QAAQ,aAAa,oCAAuC,YAAY,CAAC,+BAAS,UAAW,CAAC","file":"DebugConsole.scss","sourcesContent":[".debug-console{position:fixed;top:0;left:0;right:0;height:500px;background-color:rgba(255,255,255,0.9);padding:40px}.visible{opacity:0.2}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"debug-console": "DebugConsole__debug-console___255dD",
	"debugConsole": "DebugConsole__debug-console___255dD",
	"visible": "DebugConsole__visible___3_csI"
};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(8), __webpack_require__(26), __webpack_require__(202), __webpack_require__(205), __webpack_require__(17), __webpack_require__(18), __webpack_require__(101), __webpack_require__(208), __webpack_require__(34), __webpack_require__(213), __webpack_require__(22), __webpack_require__(84), __webpack_require__(25), __webpack_require__(15), __webpack_require__(16), __webpack_require__(98), __webpack_require__(217)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("react-redux"), require("lodash"), require("../screenComponent"), require("./WorldCup"), require("./modals/intro/Intro"), require("../../../store/reducers/modal"), require("../../../store/actions/modals"), require("../game/modals/ModalComponent"), require("./modals/outro/Outro"), require("../../../store/actions/game"), require("./BatteryIndicator"), require("../../../store/actions/calendar/year"), require("../../../store/actions/mini-game/energyGenerated"), require("../../../store/actions/questions/questions"), require("../../../store/actions/screens"), require("../../../store/reducers/screen"), require("../game/modals/event-question/YearEndQuestion"), require("./MiniGame.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.reactRedux, global.lodash, global.screenComponent, global.WorldCup, global.Intro, global.modal, global.modals, global.ModalComponent, global.Outro, global.game, global.BatteryIndicator, global.year, global.energyGenerated, global.questions, global.screens, global.screen, global.YearEndQuestion, global.MiniGame);
        global.MiniGame = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _reactRedux, _lodash, _screenComponent, _WorldCup, _Intro, _modal, _modals, _ModalComponent, _Outro, _game, _BatteryIndicator, _year, _energyGenerated, _questions, _screens, _screen, _YearEndQuestion) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    var _ = _interopRequireWildcard(_lodash);

    var _WorldCup2 = _interopRequireDefault(_WorldCup);

    var _Intro2 = _interopRequireDefault(_Intro);

    var _ModalComponent2 = _interopRequireDefault(_ModalComponent);

    var _Outro2 = _interopRequireDefault(_Outro);

    var _BatteryIndicator2 = _interopRequireDefault(_BatteryIndicator);

    var _YearEndQuestion2 = _interopRequireDefault(_YearEndQuestion);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./MiniGame.scss": {
            "mini-game": "MiniGame__mini-game___1pWRT",
            "timer": "MiniGame__timer___2A5mn Fonts__bold-font___3iFek",
            "instructions": "MiniGame__instructions___2g-O5 Fonts__bold-font___3iFek"
        }
    };

    var game_time = 8;
    var initial_state = {
        time_remaining: game_time,
        energy: 0
    };
    var MiniGame = function (_super) {
        tslib_1.__extends(MiniGame, _super);
        function MiniGame(props, state) {
            if (state === void 0) {
                state = initial_state;
            }
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.state = state;
            _this.energy_add = 5;
            _this.energy_decay = 1;
            _this.addListeners = function () {
                document.addEventListener('keyup', _this.onKeyUp);
            };
            _this.removeListeners = function () {
                document.removeEventListener('keyup', _this.onKeyUp);
            };
            _this.onKeyUp = function (event) {
                if (event.keyCode !== 32) return;
                var time_remaining = _this.state.time_remaining;
                if (!time_remaining) return;
                var energy = Math.min(_this.state.energy + _this.energy_add, 100);
                _this.setState({ energy: energy });
            };
            _this.getMiniMiniGame = function () {
                var Component = _WorldCup2.default;
                var _a = _this.state,
                    time_remaining = _a.time_remaining,
                    energy = _a.energy;
                return React.createElement(Component, { time_remaining: Math.floor(time_remaining), energy: energy });
            };
            _this.prepGame = function () {
                _this.setState({
                    time_remaining: game_time,
                    energy: 0
                });
                _this.props.showIntro();
            };
            _this.startGame = function () {
                _this.timer = window.setInterval(_this.onTick, 100);
                _this.addListeners();
            };
            _this.stopGame = function () {
                if (_this.timer) clearInterval(_this.timer);
                _this.removeListeners();
                _this.props.showOutro();
            };
            _this.onTick = function () {
                var _a = _this.state,
                    time_remaining = _a.time_remaining,
                    energy = _a.energy;
                var new_time_remaining = time_remaining - 0.1;
                if (new_time_remaining <= 0) {
                    var recordEnergyGenerated_1 = _this.props.recordEnergyGenerated;
                    recordEnergyGenerated_1(energy);
                    return _this.stopGame();
                }
                var new_energy = Math.max(energy - _this.energy_decay, 0);
                _this.setState({
                    time_remaining: new_time_remaining,
                    energy: new_energy
                });
            };
            _this.onEndClick = function () {
                var _a = _this.props,
                    showQuestion = _a.showQuestion,
                    closeModal = _a.closeModal;
                _.delay(showQuestion, 500);
            };
            _this.onQuestionCloseClick = function () {
                console.group('onQuestionCloseClick');
                console.log('closing', true);
                console.groupEnd();
            };
            return _this;
        }
        MiniGame.prototype.componentDidMount = function () {};
        MiniGame.prototype.componentDidUpdate = function (prev_props, prev_state) {
            var active = this.props.active;
            if (!prev_props || prev_props.active === active) return;
            if (active) this.prepGame();
        };
        MiniGame.prototype.render = function () {
            var _a = this.props,
                active = _a.active,
                resumeGame = _a.resumeGame,
                endYear = _a.endYear;
            var _b = this.state,
                time_remaining = _b.time_remaining,
                energy = _b.energy;
            if (!active) return null;
            var time_str = _.isFinite(time_remaining) ? time_remaining.toFixed(1) : null;
            return React.createElement(
                "div",
                {
                    className: (0, _getClassName3.default)('mini-game', _styleModuleImportMap)
                },
                this.getMiniMiniGame(),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('timer', _styleModuleImportMap)
                    },
                    React.createElement("i", { className: "far fa-clock" }),
                    React.createElement(
                        "p",
                        null,
                        time_str,
                        " seconds"
                    )
                ),
                React.createElement(_BatteryIndicator2.default, { energy: energy }),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('instructions', _styleModuleImportMap)
                    },
                    React.createElement(
                        "p",
                        null,
                        "Hit the spacebar or screen as fast as you can!"
                    )
                ),
                React.createElement(
                    _ModalComponent2.default,
                    { subtype: 'transparent', modal_id: _modal.MODALS.MINI_GAME_INTRO, close_button_type: 'none', onClose: this.startGame },
                    React.createElement(_Intro2.default, { startGame: this.startGame })
                ),
                React.createElement(
                    _ModalComponent2.default,
                    { modal_id: _modal.MODALS.MINI_GAME_OUTRO, onClose: _.debounce(this.onEndClick, 500) },
                    React.createElement(_Outro2.default, { energy: energy })
                ),
                React.createElement(
                    _ModalComponent2.default,
                    { modal_id: _modal.MODALS.MINI_GAME_END_QUESTION, close_button_type: 'none' },
                    React.createElement(_YearEndQuestion2.default, null)
                )
            );
        };
        return MiniGame;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state) {
        return {};
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {
            showIntro: function showIntro() {
                return dispatch((0, _modals.showModal)(_modal.MODALS.MINI_GAME_INTRO));
            },
            showOutro: function showOutro() {
                return dispatch((0, _modals.showModal)(_modal.MODALS.MINI_GAME_OUTRO));
            },
            showQuestion: function showQuestion() {
                return dispatch((0, _modals.showModal)(_modal.MODALS.MINI_GAME_END_QUESTION));
            },
            resumeGame: function resumeGame() {
                return dispatch((0, _game.resumeGame)());
            },
            endYear: function endYear() {
                return dispatch((0, _year.endYear)());
            },
            recordEnergyGenerated: function recordEnergyGenerated(energy) {
                return dispatch((0, _energyGenerated.recordEnergyGenerated)(energy));
            },
            closeModal: function closeModal() {
                return dispatch((0, _screens.setScreen)(_screen.SCREENS.GAME));
            },
            showYearEndQuestion: function showYearEndQuestion() {
                return dispatch((0, _questions.showNextYearEndQuestion)());
            }
        };
    };
    exports.default = (0, _screenComponent.screenComponent)()((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MiniGame));
});

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(8), __webpack_require__(9), __webpack_require__(203)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("lodash"), require("react-redux"), require("./WorldCup.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.lodash, global.reactRedux, global.WorldCup);
        global.WorldCup = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _lodash, _reactRedux) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./WorldCup.scss": {
            "grass": "WorldCup__grass___3Ljne",
            "sky": "WorldCup__sky___1ixqf",
            "balls": "WorldCup__balls___3yH7P"
        }
    };

    var elements = ['grass', 'sky', 'balls'];
    var WorldCup = function (_super) {
        tslib_1.__extends(WorldCup, _super);
        function WorldCup(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.elements = [];
            _this.registerElement = function (el) {
                if (!el) return;
                _this.elements.push(el);
            };
            _this.getElements = function () {
                var energy = _this.props.energy;
                var interval = 1 / elements.length;
                var current_value = energy / 100;
                if (!_this.elements) return;
                var nodes = _.map(elements, function (id, i) {
                    var min_value = interval * i;
                    var max_value = interval * (i + 1);
                    var raw_opacity = (current_value - min_value) / (max_value - min_value);
                    var opacity = _.clamp(raw_opacity || 0, 0, 1);
                    return React.createElement("div", { style: { opacity: opacity }, ref: _this.registerElement, key: i, className: (0, _getClassName3.default)(id, _styleModuleImportMap)
                    });
                });
                return nodes;
            };
            return _this;
        }
        WorldCup.prototype.componentDidMount = function () {
            this.elements = [];
        };
        WorldCup.prototype.componentWillUnmount = function () {
            this.elements = null;
        };
        WorldCup.prototype.render = function () {
            var _a = this.props,
                time_remaining = _a.time_remaining,
                energy = _a.energy;
            return React.createElement(
                "div",
                null,
                this.getElements()
            );
        };
        return WorldCup;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state) {
        return {};
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {};
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WorldCup);
});

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(204);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./WorldCup.scss", function() {
			var newContent = require("!!../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./WorldCup.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports


// module
exports.push([module.i, ".WorldCup__grass___3Ljne{top:50px;left:50px;background-color:red}.WorldCup__grass___3Ljne,.WorldCup__sky___1ixqf{display:none;position:absolute;width:100px;height:100px}.WorldCup__sky___1ixqf{top:200px;left:200px;background-color:green}.WorldCup__balls___3yH7P{display:none;position:absolute;top:500px;left:500px;width:100px;height:100px;background-color:blue}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/mini-game/WorldCup.scss"],"names":[],"mappings":"AAAA,yBAAsC,SAAS,UAAU,AAAyB,oBAAoB,CAAC,gDAAhG,aAAa,kBAAkB,AAAmB,YAAY,YAAa,CAA8H,AAAzG,uBAAoC,UAAU,WAAW,AAAyB,sBAAsB,CAAC,yBAAO,aAAa,kBAAkB,UAAU,WAAW,YAAY,aAAa,qBAAqB,CAAC","file":"WorldCup.scss","sourcesContent":[".grass{display:none;position:absolute;top:50px;left:50px;width:100px;height:100px;background-color:red}.sky{display:none;position:absolute;top:200px;left:200px;width:100px;height:100px;background-color:green}.balls{display:none;position:absolute;top:500px;left:500px;width:100px;height:100px;background-color:blue}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"grass": "WorldCup__grass___3Ljne",
	"sky": "WorldCup__sky___1ixqf",
	"balls": "WorldCup__balls___3yH7P"
};

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(8), __webpack_require__(18), __webpack_require__(206)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("react-redux"), require("lodash"), require("../../../../../store/actions/modals"), require("./Intro.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.reactRedux, global.lodash, global.modals, global.Intro);
        global.Intro = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _reactRedux, _lodash, _modals) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./Intro.scss": {
            "event-intro": "Intro__event-intro___1Vik6",
            "countdown": "Intro__countdown___1FYFu",
            "bounce": "Intro__bounce___3bH95"
        }
    };

    var Intro = function (_super) {
        tslib_1.__extends(Intro, _super);
        function Intro(props, state) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.state = state;
            _this.startCountDown = function () {
                _this.interval = setInterval(_this.onTick, 1000);
            };
            _this.onTick = function () {
                var ocountdown = _this.state.countdown;
                var ncountdown = ocountdown - 1;
                if (ncountdown <= 0) return _this.stopCountDown();
                _this.setState({ countdown: ncountdown });
                _this.countdown_el.classList.remove('bounce');
                _.delay(function () {
                    return _this.countdown_el.classList.add('bounce');
                }, 50);
            };
            _this.stopCountDown = function () {
                clearInterval(_this.interval);
                var _a = _this.props,
                    startGame = _a.startGame,
                    closeModal = _a.closeModal;
                closeModal();
                startGame();
            };
            _this.state = { countdown: 5 };
            return _this;
        }
        Intro.prototype.componentDidMount = function () {
            this.startCountDown();
        };
        Intro.prototype.componentWillUpdate = function () {};
        Intro.prototype.render = function () {
            var _this = this;
            var countdown = this.state.countdown;
            return React.createElement(
                "div",
                {
                    className: (0, _getClassName3.default)('event-intro', _styleModuleImportMap)
                },
                React.createElement(
                    "p",
                    { ref: function ref(el) {
                            return _this.countdown_el = el;
                        }, className: (0, _getClassName3.default)('countdown bounce', _styleModuleImportMap)
                    },
                    countdown
                )
            );
        };
        return Intro;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state) {
        return {};
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {
            closeModal: function closeModal() {
                return dispatch((0, _modals.hideModal)());
            }
        };
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Intro);
});

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(207);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../node_modules/sass-loader/lib/loader.js!./Intro.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../node_modules/sass-loader/lib/loader.js!./Intro.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports


// module
exports.push([module.i, ".Intro__event-intro___1Vik6{text-align:center}.Intro__countdown___1FYFu{font-size:300px;color:#fff;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;animation-iteration-count:infinite;-webkit-animation-iteration-count:infinite;transform-origin:center}@keyframes Intro__bounce___3bH95{0%{transform:scale(1);opacity:1}50%{transform:scale(1.05);opacity:.8}to{transform:scale(1);opacity:1}}.Intro__bounce___3bH95{animation-name:Intro__bounce___3bH95}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/mini-game/modals/intro/Intro.scss"],"names":[],"mappings":"AAAA,4BAAa,iBAAiB,CAAC,0BAAW,gBAAgB,WAAY,8BAA8B,sBAAsB,iCAAiC,yBAAyB,8CAA8C,sCAAsC,mCAAmC,2CAA2C,uBAAuB,CAAC,iCAAkB,GAAG,mBAAmB,SAAS,CAAC,IAAI,sBAAsB,UAAW,CAAC,GAAK,mBAAmB,SAAS,CAAC,CAAC,uBAAQ,oCAAqB,CAAC","file":"Intro.scss","sourcesContent":[".event-intro{text-align:center}.countdown{font-size:300px;color:white;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;animation-iteration-count:infinite;-webkit-animation-iteration-count:infinite;transform-origin:center}@keyframes bounce{0%{transform:scale(1);opacity:1}50%{transform:scale(1.05);opacity:0.8}100%{transform:scale(1);opacity:1}}.bounce{animation-name:bounce}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"event-intro": "Intro__event-intro___1Vik6",
	"eventIntro": "Intro__event-intro___1Vik6",
	"countdown": "Intro__countdown___1FYFu",
	"bounce": "Intro__bounce___3bH95"
};

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(35), __webpack_require__(42), __webpack_require__(211)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("react-redux"), require("../../../../common/highlight-text/HighlightText"), require("../../../../../store/reducers/mini-game/miniGame"), require("./Outro.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.reactRedux, global.HighlightText, global.miniGame, global.Outro);
        global.Outro = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _reactRedux, _HighlightText, _miniGame) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    var _HighlightText2 = _interopRequireDefault(_HighlightText);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./Outro.scss": {
            "event-outro": "Outro__event-outro___AVjvB",
            "header": "Outro__header___1E52_ Colour__red___3L8_4",
            "image": "Outro__image___2ZBJU",
            "text-column": "Outro__text-column___1Uya_",
            "headline": "Outro__headline___uIsid Fonts__bold-font___3iFek",
            "body-copy": "Outro__body-copy___3fW8a Fonts__medium-font___3yYd3"
        }
    };

    var Outro = function (_super) {
        tslib_1.__extends(Outro, _super);
        function Outro(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            return _this;
        }
        Outro.prototype.render = function () {
            var _a = this.props,
                energy = _a.energy,
                game_data = _a.game_data;
            return React.createElement(
                "div",
                {
                    className: (0, _getClassName3.default)('event-outro', _styleModuleImportMap)
                },
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('header', _styleModuleImportMap)
                    },
                    React.createElement("img", { src: "./img/game/event-details/energy-spike@3x.png", className: (0, _getClassName3.default)('image', _styleModuleImportMap)
                    })
                ),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('text-column', _styleModuleImportMap)
                    },
                    React.createElement(
                        _HighlightText2.default,
                        { type: 'red' },
                        "Time's up!"
                    ),
                    React.createElement(
                        "h4",
                        {
                            className: (0, _getClassName3.default)('headline', _styleModuleImportMap)
                        },
                        "you generated ",
                        energy,
                        "% of the back-up electricity needed!"
                    ),
                    React.createElement(
                        "p",
                        {
                            className: (0, _getClassName3.default)('body-copy', _styleModuleImportMap)
                        },
                        energy > 60 ? game_data.results[0] : game_data.results[1]
                    )
                )
            );
        };
        return Outro;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state) {
        return {
            game_data: (0, _miniGame.getMiniGameData)(state)
        };
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {};
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Outro);
});

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(210);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./HighlightText.scss", function() {
			var newContent = require("!!../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./HighlightText.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports
exports.i(__webpack_require__(0), undefined);
exports.i(__webpack_require__(1), undefined);

// module
exports.push([module.i, ".HighlightText__highlight-text___28uI7{display:inline-block;color:#fff;padding:10px 20px;border-radius:5px;text-transform:uppercase;margin:0}.HighlightText__yellow___2eXiL{color:#000}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/common/highlight-text/HighlightText.scss"],"names":[],"mappings":"AAAA,uCAAwD,qBAAqB,WAAY,kBAAkB,kBAAkB,yBAAyB,QAAQ,CAAC,AAAsI,+BAAsE,UAAW,CAAC","file":"HighlightText.scss","sourcesContent":[".highlight-text{composes:bold-text from '../Fonts.scss';display:inline-block;color:white;padding:10px 20px;border-radius:5px;text-transform:uppercase;margin:0}.blue{composes:highlight-text;composes:blue from '../Colour.scss'}.green{composes:highlight-text;composes:green from '../Colour.scss'}.yellow{composes:highlight-text;composes:yellow from '../Colour.scss';color:black}.red{composes:highlight-text;composes:red from '../Colour.scss'}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"highlight-text": "HighlightText__highlight-text___28uI7 " + __webpack_require__(0).locals["bold-text"] + "",
	"highlightText": "HighlightText__highlight-text___28uI7 " + __webpack_require__(0).locals["bold-text"] + "",
	"blue": "HighlightText__blue___3qtGF HighlightText__highlight-text___28uI7 " + __webpack_require__(0).locals["bold-text"] + " " + __webpack_require__(1).locals["blue"] + "",
	"green": "HighlightText__green___3oMeU HighlightText__highlight-text___28uI7 " + __webpack_require__(0).locals["bold-text"] + " " + __webpack_require__(1).locals["green"] + "",
	"yellow": "HighlightText__yellow___2eXiL HighlightText__highlight-text___28uI7 " + __webpack_require__(0).locals["bold-text"] + " " + __webpack_require__(1).locals["yellow"] + "",
	"red": "HighlightText__red___1nODN HighlightText__highlight-text___28uI7 " + __webpack_require__(0).locals["bold-text"] + " " + __webpack_require__(1).locals["red"] + ""
};

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(212);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../node_modules/sass-loader/lib/loader.js!./Outro.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../node_modules/sass-loader/lib/loader.js!./Outro.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports
exports.i(__webpack_require__(1), undefined);
exports.i(__webpack_require__(0), undefined);

// module
exports.push([module.i, ".Outro__event-outro___AVjvB{text-align:center}.Outro__header___1E52_{height:30px;display:flex;justify-content:center;align-items:center;border-top-left-radius:10px;border-top-right-radius:10px}.Outro__image___2ZBJU{width:70px;height:auto}.Outro__text-column___1Uya_{padding:40px}.Outro__headline___uIsid{font-size:36px;line-height:1.1em;margin:40px 0}.Outro__headline___uIsid:first-letter{text-transform:uppercase}.Outro__body-copy___3fW8a{margin:0}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/mini-game/modals/outro/Outro.scss"],"names":[],"mappings":"AAAA,4BAAa,iBAAiB,CAAC,uBAA2D,YAAY,aAAa,uBAAuB,mBAAmB,4BAA4B,4BAA4B,CAAC,sBAAO,WAAW,WAAW,CAAC,4BAAa,YAAY,CAAC,yBAAkE,eAAe,kBAAkB,aAAa,CAAC,sCAAuB,wBAAwB,CAAC,0BAAqE,QAAQ,CAAC","file":"Outro.scss","sourcesContent":[".event-outro{text-align:center}.header{composes:red from '../../../../common/Colour.scss';height:30px;display:flex;justify-content:center;align-items:center;border-top-left-radius:10px;border-top-right-radius:10px}.image{width:70px;height:auto}.text-column{padding:40px}.headline{composes:bold-font from '../../../../common/Fonts.scss';font-size:36px;line-height:1.1em;margin:40px 0}.headline:first-letter{text-transform:uppercase}.body-copy{composes:medium-font from '../../../../common/Fonts.scss';margin:0}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"event-outro": "Outro__event-outro___AVjvB",
	"eventOutro": "Outro__event-outro___AVjvB",
	"header": "Outro__header___1E52_ " + __webpack_require__(1).locals["red"] + "",
	"image": "Outro__image___2ZBJU",
	"text-column": "Outro__text-column___1Uya_",
	"textColumn": "Outro__text-column___1Uya_",
	"headline": "Outro__headline___uIsid " + __webpack_require__(0).locals["bold-font"] + "",
	"body-copy": "Outro__body-copy___3fW8a " + __webpack_require__(0).locals["medium-font"] + "",
	"bodyCopy": "Outro__body-copy___3fW8a " + __webpack_require__(0).locals["medium-font"] + ""
};

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(214)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("./BatteryIndicator.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.BatteryIndicator);
        global.BatteryIndicator = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./BatteryIndicator.scss": {
            "battery": "BatteryIndicator__battery___3ARxj",
            "battery-fill": "BatteryIndicator__battery-fill___mRZ4d",
            "energy-icon": "BatteryIndicator__energy-icon___3aea9"
        }
    };

    var BatteryIndicator = function (_super) {
        tslib_1.__extends(BatteryIndicator, _super);
        function BatteryIndicator(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            return _this;
        }
        BatteryIndicator.prototype.render = function () {
            var energy = this.props.energy;
            var battery_fill_width = energy / 100 / 0.01 + '%';
            return React.createElement(
                "div",
                {
                    className: (0, _getClassName3.default)('battery', _styleModuleImportMap)
                },
                React.createElement("div", { style: { width: battery_fill_width }, className: (0, _getClassName3.default)('battery-fill', _styleModuleImportMap)
                }),
                React.createElement("div", {
                    className: (0, _getClassName3.default)('energy-icon', _styleModuleImportMap)
                })
            );
        };
        return BatteryIndicator;
    }(React.Component);
    exports.default = BatteryIndicator;
});

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(215);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./BatteryIndicator.scss", function() {
			var newContent = require("!!../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./BatteryIndicator.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports


// module
exports.push([module.i, ".BatteryIndicator__battery___3ARxj{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:50%;padding-bottom:20%}.BatteryIndicator__battery___3ARxj:before{background:url(img/mini-game/battery@3x.png) 50% no-repeat;background-size:contain;content:\"\";position:absolute;top:-10%;bottom:-13%;left:-6%;right:-10%}.BatteryIndicator__battery-fill___mRZ4d{background:url(img/mini-game/battery-energy@3x.png) no-repeat 0;background-size:auto 67%;position:absolute;top:0;left:0;height:100%;width:100%}.BatteryIndicator__energy-icon___3aea9{background:url(img/mini-game/energy-icon@3x.png) no-repeat 50%;background-size:contain;position:absolute;top:50%;left:50%;width:30%;height:50%;transform:translate(-50%,-50%)}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/mini-game/BatteryIndicator.scss"],"names":[],"mappings":"AAAA,mCAAS,kBAAkB,QAAQ,SAAS,+BAAgC,UAAU,kBAAkB,CAAC,0CAAgB,2DAA8D,wBAAwB,WAAW,kBAAkB,SAAS,YAAY,SAAS,UAAU,CAAC,wCAAc,gEAA0E,yBAAyB,kBAAkB,MAAM,OAAO,YAAY,UAAU,CAAC,uCAAa,+DAAkE,wBAAwB,kBAAkB,QAAQ,SAAS,UAAU,WAAW,8BAA+B,CAAC","file":"BatteryIndicator.scss","sourcesContent":[".battery{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);width:50%;padding-bottom:20%}.battery:before{background:url(img/mini-game/battery@3x.png) center no-repeat;background-size:contain;content:'';position:absolute;top:-10%;bottom:-13%;left:-6%;right:-10%}.battery-fill{background:url(img/mini-game/battery-energy@3x.png) no-repeat left center;background-size:auto 67%;position:absolute;top:0;left:0;height:100%;width:100%}.energy-icon{background:url(img/mini-game/energy-icon@3x.png) no-repeat center;background-size:contain;position:absolute;top:50%;left:50%;width:30%;height:50%;transform:translate(-50%, -50%)}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"battery": "BatteryIndicator__battery___3ARxj",
	"battery-fill": "BatteryIndicator__battery-fill___mRZ4d",
	"batteryFill": "BatteryIndicator__battery-fill___mRZ4d",
	"energy-icon": "BatteryIndicator__energy-icon___3aea9",
	"energyIcon": "BatteryIndicator__energy-icon___3aea9"
};

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports
exports.i(__webpack_require__(1), undefined);
exports.i(__webpack_require__(0), undefined);

// module
exports.push([module.i, ".Question__question-content___16wOD{text-align:center}.Question__header___3Diwg{height:30px;display:flex;justify-content:center;align-items:center;border-top-left-radius:10px;border-top-right-radius:10px;background:url(\"img/game/modals/warning-stripes@2x.png\");background-size:cover}.Question__label___3RXBf{font-size:1.2em}.Question__image___1l98D{position:relative;width:70px;height:auto}.Question__source-image___bjtf-{width:100%}.Question__warning-icon___11KA5{position:absolute;top:40%;left:50%;transform:translate(-50%,-50%);width:50%}.Question__question-and-answer___3P-g_{position:relative;width:100%;min-width:600px;overflow:hidden;transition:height .5s ease-in-out}.Question__question-content___16wOD{box-sizing:border-box;border:10px solid #e94e0f;border-radius:10px}.Question__answer-content___1cc90 .Question__question-slide___1-hML{transform:translate(-100%);opacity:0}.Question__answer-content___1cc90 .Question__answer-slide___2sgdt{transform:translate(0);opacity:1}.Question__answer-slide___2sgdt,.Question__question-slide___1-hML{position:absolute;padding:40px;transition:transform .5s ease-in-out}.Question__answer-slide___2sgdt{transform:translate(100%);opacity:0;width:100%;max-width:600px;box-sizing:border-box}.Question__warning___2mz9c{border-bottom:1px solid grey;padding:20px 40px}.Question__warning-attention___3p3L3{text-transform:uppercase;font-weight:700}.Question__headline___1B2M8{font-size:36px;line-height:1.1em;margin:40px 0}.Question__headline___1B2M8:first-letter{text-transform:uppercase}.Question__body-copy___2elJd{margin:0}.Question__options___1IRKh{display:flex;flex-direction:row;justify-content:center;min-width:800px}.Question__option___3m8J_{display:flex;align-items:center;justify-content:center;flex:1;background-color:#246cb1;color:#fff;padding:30px 20px;margin:10px;cursor:pointer;box-sizing:border-box;border:5px solid #fff;transition:all .2s ease-out;border-radius:5px;font-size:1.25em;box-shadow:0 3px 5px rgba(0,0,0,.15);min-width:120px;max-width:250px}.Question__option___3m8J_:hover{background-color:#4892da}.Question__option___3m8J_:first-letter{text-transform:uppercase}.Question__option___3m8J_:first-of-type{background-color:#ed9a2c}.Question__option___3m8J_:first-of-type:hover{background-color:#f3bc72}.Question__option___3m8J_:last-of-type{background-color:#de4e24}.Question__option___3m8J_:last-of-type:hover{background-color:#e88466}.Question__response___AIMbY{margin-top:20px}.Question__answer-footer___b9kWU{display:flex;justify-content:center;padding-top:40px}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game/modals/event-question/Question.scss"],"names":[],"mappings":"AAAA,oCAAkB,iBAAiB,CAAC,0BAA8D,YAAY,aAAa,uBAAuB,mBAAmB,4BAA4B,6BAA6B,yDAAyD,qBAAqB,CAAC,yBAA+D,eAAe,CAAC,yBAAO,kBAAkB,WAAW,WAAW,CAAC,gCAAc,UAAU,CAAC,gCAAc,kBAAkB,QAAQ,SAAS,+BAAgC,SAAS,CAAC,uCAAqB,kBAAkB,WAAW,gBAAgB,gBAAgB,iCAAkC,CAAC,oCAAkB,sBAAsB,0BAA0B,kBAAkB,CAAC,AAA0C,oEAAgC,2BAA8B,SAAS,CAAC,kEAA8B,uBAA0B,SAAS,CAAC,kEAA8B,kBAAkB,aAAa,oCAAqC,CAAC,gCAAc,0BAA6B,UAAU,WAAW,gBAAgB,qBAAqB,CAAC,2BAAS,6BAA6B,iBAAiB,CAAC,qCAAmB,yBAAyB,eAAgB,CAAC,4BAAkE,eAAe,kBAAkB,aAAa,CAAC,yCAAuB,wBAAwB,CAAC,6BAAqE,QAAQ,CAAC,2BAAS,aAAa,mBAAmB,uBAAuB,eAAe,CAAC,0BAAgE,aAAa,mBAAmB,uBAAuB,OAAO,yBAAyB,WAAY,kBAAkB,YAAY,eAAe,sBAAsB,sBAAuB,4BAA6B,kBAAkB,iBAAiB,qCAAsC,gBAAgB,eAAe,CAAC,gCAAc,wBAAwB,CAAC,uCAAqB,wBAAwB,CAAC,wCAAsB,wBAAwB,CAAC,8CAA4B,wBAAwB,CAAC,uCAAqB,wBAAwB,CAAC,6CAA2B,wBAAwB,CAAC,4BAAU,eAAe,CAAC,iCAAe,aAAa,uBAAuB,gBAAgB,CAAC","file":"Question.scss","sourcesContent":[".question-content{text-align:center}.header{composes:yellow from '../../../../common/Colour.scss';height:30px;display:flex;justify-content:center;align-items:center;border-top-left-radius:10px;border-top-right-radius:10px;background:url(\"img/game/modals/warning-stripes@2x.png\");background-size:cover}.label{composes:bold-font from '../../../../common/Fonts.scss';font-size:1.2em}.image{position:relative;width:70px;height:auto}.source-image{width:100%}.warning-icon{position:absolute;top:40%;left:50%;transform:translate(-50%, -50%);width:50%}.question-and-answer{position:relative;width:100%;min-width:600px;overflow:hidden;transition:height 0.5s ease-in-out}.question-content{box-sizing:border-box;border:10px solid #E94E0F;border-radius:10px}.answer-content{composes:question-content}.answer-content .question-slide{transform:translate(-100%, 0);opacity:0}.answer-content .answer-slide{transform:translate(0, 0);opacity:1}.question-slide,.answer-slide{position:absolute;padding:40px;transition:transform 0.5s ease-in-out}.answer-slide{transform:translate(100%, 0);opacity:0;width:100%;max-width:600px;box-sizing:border-box}.warning{border-bottom:1px solid grey;padding:20px 40px}.warning-attention{text-transform:uppercase;font-weight:bold}.headline{composes:bold-font from '../../../../common/Fonts.scss';font-size:36px;line-height:1.1em;margin:40px 0}.headline:first-letter{text-transform:uppercase}.body-copy{composes:medium-font from '../../../../common/Fonts.scss';margin:0}.options{display:flex;flex-direction:row;justify-content:center;min-width:800px}.option{composes:bold-font from '../../../../common/Fonts.scss';display:flex;align-items:center;justify-content:center;flex:1;background-color:#246cb1;color:white;padding:30px 20px;margin:10px;cursor:pointer;box-sizing:border-box;border:5px solid white;transition:all 0.2s ease-out;border-radius:5px;font-size:1.25em;box-shadow:0 3px 5px rgba(0,0,0,0.15);min-width:120px;max-width:250px}.option:hover{background-color:#4892da}.option:first-letter{text-transform:uppercase}.option:first-of-type{background-color:#ed9a2c}.option:first-of-type:hover{background-color:#f3bc72}.option:last-of-type{background-color:#de4e24}.option:last-of-type:hover{background-color:#e88466}.response{margin-top:20px}.answer-footer{display:flex;justify-content:center;padding-top:40px}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"question-content": "Question__question-content___16wOD",
	"questionContent": "Question__question-content___16wOD",
	"header": "Question__header___3Diwg " + __webpack_require__(1).locals["yellow"] + "",
	"label": "Question__label___3RXBf " + __webpack_require__(0).locals["bold-font"] + "",
	"image": "Question__image___1l98D",
	"source-image": "Question__source-image___bjtf-",
	"sourceImage": "Question__source-image___bjtf-",
	"warning-icon": "Question__warning-icon___11KA5",
	"warningIcon": "Question__warning-icon___11KA5",
	"question-and-answer": "Question__question-and-answer___3P-g_",
	"questionAndAnswer": "Question__question-and-answer___3P-g_",
	"answer-content": "Question__answer-content___1cc90 Question__question-content___16wOD",
	"answerContent": "Question__answer-content___1cc90 Question__question-content___16wOD",
	"question-slide": "Question__question-slide___1-hML",
	"questionSlide": "Question__question-slide___1-hML",
	"answer-slide": "Question__answer-slide___2sgdt",
	"answerSlide": "Question__answer-slide___2sgdt",
	"warning": "Question__warning___2mz9c",
	"warning-attention": "Question__warning-attention___3p3L3",
	"warningAttention": "Question__warning-attention___3p3L3",
	"headline": "Question__headline___1B2M8 " + __webpack_require__(0).locals["bold-font"] + "",
	"body-copy": "Question__body-copy___2elJd " + __webpack_require__(0).locals["medium-font"] + "",
	"bodyCopy": "Question__body-copy___2elJd " + __webpack_require__(0).locals["medium-font"] + "",
	"options": "Question__options___1IRKh",
	"option": "Question__option___3m8J_ " + __webpack_require__(0).locals["bold-font"] + "",
	"response": "Question__response___AIMbY",
	"answer-footer": "Question__answer-footer___b9kWU",
	"answerFooter": "Question__answer-footer___b9kWU"
};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(218);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./MiniGame.scss", function() {
			var newContent = require("!!../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./MiniGame.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports
exports.i(__webpack_require__(0), undefined);

// module
exports.push([module.i, ".MiniGame__mini-game___1pWRT{position:absolute;top:0;left:0;width:100%;height:100%;background-image:url(\"img/mini-game/background.png\");background-size:cover;background-repeat:no-repeat}.MiniGame__timer___2A5mn{position:absolute;top:60px;left:50%;transform:translate(-50%);color:#000;font-size:36px;text-align:center}.MiniGame__timer___2A5mn p{margin:10px}.MiniGame__instructions___2g-O5{position:absolute;bottom:80px;left:50%;transform:translate(-50%);color:#000;font-size:36px;text-align:center}.MiniGame__instructions___2g-O5 p{margin:10px}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/mini-game/MiniGame.scss"],"names":[],"mappings":"AAAA,6BAAW,kBAAkB,MAAM,OAAO,WAAW,YAAY,qDAAqD,sBAAsB,2BAA2B,CAAC,yBAAyD,kBAAkB,SAAS,SAAS,0BAA6B,WAAY,eAAe,iBAAiB,CAAC,2BAAS,WAAW,CAAC,gCAAgE,kBAAkB,YAAY,SAAS,0BAA6B,WAAY,eAAe,iBAAiB,CAAC,kCAAgB,WAAW,CAAC","file":"MiniGame.scss","sourcesContent":[".mini-game{position:absolute;top:0;left:0;width:100%;height:100%;background-image:url(\"img/mini-game/background.png\");background-size:cover;background-repeat:no-repeat}.timer{composes:bold-font from '../../common/Fonts.scss';position:absolute;top:60px;left:50%;transform:translate(-50%, 0);color:black;font-size:36px;text-align:center}.timer p{margin:10px}.instructions{composes:bold-font from '../../common/Fonts.scss';position:absolute;bottom:80px;left:50%;transform:translate(-50%, 0);color:black;font-size:36px;text-align:center}.instructions p{margin:10px}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"mini-game": "MiniGame__mini-game___1pWRT",
	"miniGame": "MiniGame__mini-game___1pWRT",
	"timer": "MiniGame__timer___2A5mn " + __webpack_require__(0).locals["bold-font"] + "",
	"instructions": "MiniGame__instructions___2g-O5 " + __webpack_require__(0).locals["bold-font"] + ""
};

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(220);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../node_modules/sass-loader/lib/loader.js!./ModalComponent.scss", function() {
			var newContent = require("!!../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../node_modules/sass-loader/lib/loader.js!./ModalComponent.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports


// module
exports.push([module.i, ".ModalComponent__container___3ykxU{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.9)}.ModalComponent__container-enter___22_Hx{transition:opacity .25s ease-out;opacity:0}.ModalComponent__container-enter-active___uZAcv{opacity:1}.ModalComponent__container-exit___2bK0f{transition:opacity .25s ease-in-out;opacity:1}.ModalComponent__container-exit-active___2QYCA{opacity:0}.ModalComponent__transparent-container___okiIx .ModalComponent__content___2YsFZ{background-color:transparent}.ModalComponent__modal___2daI6{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);max-width:1000px}.ModalComponent__modal-enter___1GLrC{transform:translate(-50%,-48%);transition:all .25s ease-out;opacity:0}.ModalComponent__modal-enter-active___3e3s4{opacity:1;transform:translate(-50%,-50%)}.ModalComponent__modal-exit___1PGNY{transition:all .25s ease-out;opacity:1}.ModalComponent__modal-exit-active___1YVrv{opacity:0}.ModalComponent__content___2YsFZ{background-color:#fff;border-radius:10px}.ModalComponent__footer___2Zm3Y{display:flex;justify-content:center;margin-top:30px}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game/modals/ModalComponent.scss"],"names":[],"mappings":"AAAA,mCAAW,eAAe,MAAM,OAAO,WAAW,YAAY,+BAAgC,CAAC,yCAAiB,iCAAkC,SAAS,CAAC,gDAAwB,SAAS,CAAC,wCAAgB,oCAAqC,SAAS,CAAC,+CAAuB,SAAS,CAAC,AAA0C,gFAAgC,4BAA4B,CAAC,+BAAO,eAAe,QAAQ,SAAS,+BAAgC,gBAAgB,CAAC,qCAAa,+BAAgC,6BAA8B,SAAS,CAAC,4CAAoB,UAAU,8BAA+B,CAAC,oCAAY,6BAA8B,SAAS,CAAC,2CAAmB,SAAS,CAAC,iCAAS,sBAAuB,kBAAkB,CAAC,gCAAQ,aAAa,uBAAuB,eAAe,CAAC","file":"ModalComponent.scss","sourcesContent":[".container{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,0.9)}.container-enter{transition:opacity 0.25s ease-out;opacity:0}.container-enter-active{opacity:1}.container-exit{transition:opacity 0.25s ease-in-out;opacity:1}.container-exit-active{opacity:0}.transparent-container{composes:container}.transparent-container .content{background-color:transparent}.modal{position:fixed;top:50%;left:50%;transform:translate(-50%, -50%);max-width:1000px}.modal-enter{transform:translate(-50%, -48%);transition:all 0.25s ease-out;opacity:0}.modal-enter-active{opacity:1;transform:translate(-50%, -50%)}.modal-exit{transition:all 0.25s ease-out;opacity:1}.modal-exit-active{opacity:0}.content{background-color:white;border-radius:10px}.footer{display:flex;justify-content:center;margin-top:30px}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "ModalComponent__container___3ykxU",
	"container-enter": "ModalComponent__container-enter___22_Hx",
	"containerEnter": "ModalComponent__container-enter___22_Hx",
	"container-enter-active": "ModalComponent__container-enter-active___uZAcv",
	"containerEnterActive": "ModalComponent__container-enter-active___uZAcv",
	"container-exit": "ModalComponent__container-exit___2bK0f",
	"containerExit": "ModalComponent__container-exit___2bK0f",
	"container-exit-active": "ModalComponent__container-exit-active___2QYCA",
	"containerExitActive": "ModalComponent__container-exit-active___2QYCA",
	"transparent-container": "ModalComponent__transparent-container___okiIx ModalComponent__container___3ykxU",
	"transparentContainer": "ModalComponent__transparent-container___okiIx ModalComponent__container___3ykxU",
	"content": "ModalComponent__content___2YsFZ",
	"modal": "ModalComponent__modal___2daI6",
	"modal-enter": "ModalComponent__modal-enter___1GLrC",
	"modalEnter": "ModalComponent__modal-enter___1GLrC",
	"modal-enter-active": "ModalComponent__modal-enter-active___3e3s4",
	"modalEnterActive": "ModalComponent__modal-enter-active___3e3s4",
	"modal-exit": "ModalComponent__modal-exit___1PGNY",
	"modalExit": "ModalComponent__modal-exit___1PGNY",
	"modal-exit-active": "ModalComponent__modal-exit-active___1YVrv",
	"modalExitActive": "ModalComponent__modal-exit-active___1YVrv",
	"footer": "ModalComponent__footer___2Zm3Y"
};

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(8), __webpack_require__(9), __webpack_require__(26), __webpack_require__(15), __webpack_require__(222)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("lodash"), require("react-redux"), require("../screenComponent"), require("../../../store/actions/screens"), require("./Leaderboard.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.lodash, global.reactRedux, global.screenComponent, global.screens, global.Leaderboard);
        global.Leaderboard = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _lodash, _reactRedux, _screenComponent, _screens) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./Leaderboard.scss": {
            "leaderboard": "Leaderboard__leaderboard___3qNGF",
            "back-button": "Leaderboard__back-button___1svDq",
            "content": "Leaderboard__content___233Gi",
            "title": "Leaderboard__title___31YHL Fonts__bold-font___3iFek",
            "table": "Leaderboard__table___2FBfp Fonts__bold-font___3iFek",
            "header-row": "Leaderboard__header-row___ZTdr7",
            "score-row": "Leaderboard__score-row___3_yB4",
            "gold-medal": "Leaderboard__gold-medal___3LNB0",
            "silver-medal": "Leaderboard__silver-medal___Xjs2p",
            "bronze-medal": "Leaderboard__bronze-medal___v2Xe1"
        }
    };

    var Leaderboard = function (_super) {
        tslib_1.__extends(Leaderboard, _super);
        function Leaderboard(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.getTableContents = function () {
                return _.times(50, function (i) {
                    var name = 'Name';
                    var score = _.random(500, 10000);
                    return React.createElement(
                        "tr",
                        { key: i, className: (0, _getClassName3.default)('score-row', _styleModuleImportMap)
                        },
                        React.createElement(
                            "td",
                            null,
                            _this.getMedal(i)
                        ),
                        React.createElement(
                            "td",
                            null,
                            i
                        ),
                        React.createElement(
                            "td",
                            null,
                            name
                        ),
                        React.createElement(
                            "td",
                            null,
                            score
                        )
                    );
                });
            };
            _this.getMedal = function (position) {
                switch (position) {
                    case 0:
                        return React.createElement(
                            "div",
                            {
                                className: (0, _getClassName3.default)('gold-medal', _styleModuleImportMap)
                            },
                            "gold"
                        );
                    case 1:
                        return React.createElement(
                            "div",
                            {
                                className: (0, _getClassName3.default)('silver-medal', _styleModuleImportMap)
                            },
                            "silver"
                        );
                    case 2:
                        return React.createElement(
                            "div",
                            {
                                className: (0, _getClassName3.default)('bronze-medal', _styleModuleImportMap)
                            },
                            "bronze"
                        );
                }
            };
            return _this;
        }
        Leaderboard.prototype.render = function () {
            if (!this.props.active) return null;
            return React.createElement(
                "div",
                {
                    className: (0, _getClassName3.default)('leaderboard', _styleModuleImportMap)
                },
                React.createElement(
                    "button",
                    { onClick: this.props.showMainMenu, className: (0, _getClassName3.default)('back-button', _styleModuleImportMap)
                    },
                    "back"
                ),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('content', _styleModuleImportMap)
                    },
                    React.createElement(
                        "h2",
                        {
                            className: (0, _getClassName3.default)('title', _styleModuleImportMap)
                        },
                        "leaderboard"
                    ),
                    React.createElement(
                        "table",
                        {
                            className: (0, _getClassName3.default)('table', _styleModuleImportMap)
                        },
                        React.createElement(
                            "tbody",
                            null,
                            React.createElement(
                                "tr",
                                {
                                    className: (0, _getClassName3.default)('header-row', _styleModuleImportMap)
                                },
                                React.createElement(
                                    "th",
                                    null,
                                    "medal"
                                ),
                                React.createElement(
                                    "th",
                                    null,
                                    "position"
                                ),
                                React.createElement(
                                    "th",
                                    null,
                                    "name"
                                ),
                                React.createElement(
                                    "th",
                                    null,
                                    "score"
                                )
                            ),
                            this.getTableContents()
                        )
                    )
                )
            );
        };
        return Leaderboard;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state) {
        return {};
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {
            showMainMenu: function showMainMenu() {
                return dispatch((0, _screens.showMainMenu)());
            }
        };
    };
    exports.default = (0, _screenComponent.screenComponent)()((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Leaderboard));
});

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(223);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./Leaderboard.scss", function() {
			var newContent = require("!!../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./Leaderboard.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports
exports.i(__webpack_require__(0), undefined);

// module
exports.push([module.i, ".Leaderboard__leaderboard___3qNGF{position:absolute;top:0;left:0;width:100%;height:100%;overflow:hidden}.Leaderboard__back-button___1svDq{position:absolute;top:20px;left:20px}.Leaderboard__content___233Gi{display:flex;flex-direction:column;align-items:center;width:100%;height:100%;overflow-y:auto;margin:auto;color:#fff}.Leaderboard__title___31YHL{margin:30px auto;padding:20px;font-size:64px;text-transform:capitalize;border-bottom:3px solid #fff}.Leaderboard__table___2FBfp{max-width:800px;border-collapse:collapse}.Leaderboard__header-row___ZTdr7{font-size:24px;text-transform:uppercase}.Leaderboard__header-row___ZTdr7>*{padding:10px 30px;text-align:left}.Leaderboard__score-row___3_yB4{font-size:32px;border-top:1px solid hsla(0,0%,100%,.5)}.Leaderboard__score-row___3_yB4>*{padding:10px 30px}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/leaderboard/Leaderboard.scss"],"names":[],"mappings":"AAAA,kCAAa,kBAAkB,MAAM,OAAO,WAAW,YAAY,eAAe,CAAC,kCAAa,kBAAkB,SAAS,SAAS,CAAC,8BAAS,aAAa,sBAAsB,mBAAmB,WAAW,YAAY,gBAAgB,YAAY,UAAW,CAAC,4BAAyD,iBAAiB,aAAa,eAAe,0BAA0B,4BAA6B,CAAC,4BAAyD,gBAAgB,wBAAwB,CAAC,iCAAY,eAAe,wBAAwB,CAAC,mCAAc,kBAAkB,eAAe,CAAC,gCAAW,eAAe,uCAA0C,CAAC,kCAAa,iBAAiB,CAAC","file":"Leaderboard.scss","sourcesContent":[".leaderboard{position:absolute;top:0;left:0;width:100%;height:100%;overflow:hidden}.back-button{position:absolute;top:20px;left:20px}.content{display:flex;flex-direction:column;align-items:center;width:100%;height:100%;overflow-y:auto;margin:auto;color:white}.title{composes:bold-font from '../../common/Fonts.scss';margin:30px auto;padding:20px;font-size:64px;text-transform:capitalize;border-bottom:3px solid white}.table{composes:bold-font from '../../common/Fonts.scss';max-width:800px;border-collapse:collapse}.header-row{font-size:24px;text-transform:uppercase}.header-row>*{padding:10px 30px;text-align:left}.score-row{font-size:32px;border-top:1px solid rgba(255,255,255,0.5)}.score-row>*{padding:10px 30px}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"leaderboard": "Leaderboard__leaderboard___3qNGF",
	"back-button": "Leaderboard__back-button___1svDq",
	"backButton": "Leaderboard__back-button___1svDq",
	"content": "Leaderboard__content___233Gi",
	"title": "Leaderboard__title___31YHL " + __webpack_require__(0).locals["bold-font"] + "",
	"table": "Leaderboard__table___2FBfp " + __webpack_require__(0).locals["bold-font"] + "",
	"header-row": "Leaderboard__header-row___ZTdr7",
	"headerRow": "Leaderboard__header-row___ZTdr7",
	"score-row": "Leaderboard__score-row___3_yB4",
	"scoreRow": "Leaderboard__score-row___3_yB4"
};

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(26), __webpack_require__(15), __webpack_require__(92), __webpack_require__(34), __webpack_require__(225)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("react-redux"), require("../screenComponent"), require("../../../store/actions/screens"), require("../../common/slideshow/SlideShow"), require("../../../store/actions/game"), require("./HowToPlay.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.reactRedux, global.screenComponent, global.screens, global.SlideShow, global.game, global.HowToPlay);
        global.HowToPlay = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _reactRedux, _screenComponent, _screens, _SlideShow, _game) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./HowToPlay.scss": {
            "back-button": "HowToPlay__back-button___ap_ix",
            "slide": "HowToPlay__slide___FX_CN"
        }
    };

    var HowToPlay = function (_super) {
        tslib_1.__extends(HowToPlay, _super);
        function HowToPlay(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            return _this;
        }
        HowToPlay.prototype.render = function () {
            var _a = this.props,
                showMainMenu = _a.showMainMenu,
                showGameIntro = _a.showGameIntro;
            if (!this.props.active) return null;
            return React.createElement(
                _SlideShow.SlideShow,
                { onCancel: showMainMenu, onComplete: showGameIntro },
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('slide', _styleModuleImportMap)
                    },
                    "slide one"
                ),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('slide', _styleModuleImportMap)
                    },
                    "slide two"
                ),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('slide', _styleModuleImportMap)
                    },
                    "slide three"
                ),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('slide', _styleModuleImportMap)
                    },
                    "slide four"
                )
            );
        };
        return HowToPlay;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state) {
        return {};
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {
            showGameIntro: function showGameIntro() {
                return dispatch((0, _game.showGameIntro)());
            },
            showMainMenu: function showMainMenu() {
                return dispatch((0, _screens.showMainMenu)());
            }
        };
    };
    exports.default = (0, _screenComponent.screenComponent)()((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(HowToPlay));
});

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(226);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./HowToPlay.scss", function() {
			var newContent = require("!!../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./HowToPlay.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports


// module
exports.push([module.i, ".HowToPlay__back-button___ap_ix{position:absolute;top:20px;left:20px}.HowToPlay__slide___FX_CN{position:absolute;width:100%;height:100%}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/how-to-play/HowToPlay.scss"],"names":[],"mappings":"AAAA,gCAAa,kBAAkB,SAAS,SAAS,CAAC,0BAAO,kBAAkB,WAAW,WAAW,CAAC","file":"HowToPlay.scss","sourcesContent":[".back-button{position:absolute;top:20px;left:20px}.slide{position:absolute;width:100%;height:100%}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"back-button": "HowToPlay__back-button___ap_ix",
	"backButton": "HowToPlay__back-button___ap_ix",
	"slide": "HowToPlay__slide___FX_CN"
};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(228);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./PowerMapGame.scss", function() {
			var newContent = require("!!../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./PowerMapGame.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports


// module
exports.push([module.i, "#power-map,body,html{width:100%;height:100%;margin:0;padding:0}#power-map{font-family:frutiger-medium}.PowerMapGame__power-map-game___6OQgx{position:absolute;width:100%;height:100%;top:0;left:0;background-image:url(\"img/game/map.jpg\");background-size:cover;background-position:50%;overflow:hidden}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/PowerMapGame.scss"],"names":[],"mappings":"AAAoD,qBAA1C,WAAW,YAAY,SAAS,SAAS,CAA4F,AAA3F,WAA6D,2BAA6B,CAAC,sCAAgB,kBAAkB,WAAW,YAAY,MAAM,OAAO,yCAAyC,sBAAsB,wBAA2B,eAAe,CAAC","file":"PowerMapGame.scss","sourcesContent":["html,body{width:100%;height:100%;margin:0;padding:0}:global #power-map{width:100%;height:100%;margin:0;padding:0;font-family:'frutiger-medium'}.power-map-game{position:absolute;width:100%;height:100%;top:0;left:0;background-image:url(\"img/game/map.jpg\");background-size:cover;background-position:center;overflow:hidden}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"power-map-game": "PowerMapGame__power-map-game___6OQgx",
	"powerMapGame": "PowerMapGame__power-map-game___6OQgx"
};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
            if (true) {
                        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(230), __webpack_require__(17), __webpack_require__(26), __webpack_require__(240), __webpack_require__(248), __webpack_require__(253), __webpack_require__(257), __webpack_require__(258), __webpack_require__(101), __webpack_require__(15), __webpack_require__(16), __webpack_require__(298), __webpack_require__(261), __webpack_require__(33), __webpack_require__(86), __webpack_require__(264), __webpack_require__(280), __webpack_require__(25), __webpack_require__(283), __webpack_require__(98), __webpack_require__(81), __webpack_require__(42), __webpack_require__(97), __webpack_require__(288), __webpack_require__(289), __webpack_require__(293), __webpack_require__(39), __webpack_require__(296)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
            } else if (typeof exports !== "undefined") {
                        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("react-redux"), require("./map/GameplayMap"), require("../../../store/reducers/modal"), require("../screenComponent"), require("./power-sources/PowerSources"), require("./modals/power-source-details/PowerSourceDetails"), require("./modals/hint/Hint"), require("./modals/event-question/OutageQuestion"), require("./modals/outage/Outage"), require("./modals/ModalComponent"), require("../../../store/actions/screens"), require("../../../store/reducers/screen"), require("./modals/game-over/GameOver"), require("./modals/timer-start/TimerStart"), require("../../../store/actions/timer"), require("../../../store/reducers/interaction"), require("./game-ui/GameUi"), require("./power-sources/DraggablePowerSource"), require("../../../store/actions/questions/questions"), require("./modals/year-info/YearInfo"), require("./modals/event-question/YearEndQuestion"), require("../../../store/actions/mini-game/miniGame"), require("../../../store/reducers/mini-game/miniGame"), require("./map/Clouds"), require("./hints-button/QuitButton"), require("./timer/GameCalendar"), require("./modals/year-end/YearEnd"), require("../../../store/reducers/calendar/isYearAlreadyComplete"), require("./Game.scss"));
            } else {
                        var mod = {
                                    exports: {}
                        };
                        factory(mod.exports, global.getClassName, global.tslib, global.react, global.reactRedux, global.GameplayMap, global.modal, global.screenComponent, global.PowerSources, global.PowerSourceDetails, global.Hint, global.OutageQuestion, global.Outage, global.ModalComponent, global.screens, global.screen, global.GameOver, global.TimerStart, global.timer, global.interaction, global.GameUi, global.DraggablePowerSource, global.questions, global.YearInfo, global.YearEndQuestion, global.miniGame, global.miniGame, global.Clouds, global.QuitButton, global.GameCalendar, global.YearEnd, global.isYearAlreadyComplete, global.Game);
                        global.Game = mod.exports;
            }
})(this, function (exports, _getClassName2, _tslib, _react, _reactRedux, _GameplayMap, _modal, _screenComponent, _PowerSources, _PowerSourceDetails, _Hint, _OutageQuestion, _Outage, _ModalComponent, _screens, _screen, _GameOver, _TimerStart, _timer, _interaction, _GameUi, _DraggablePowerSource, _questions, _YearInfo, _YearEndQuestion, _miniGame, _miniGame2, _Clouds, _QuitButton, _GameCalendar, _YearEnd, _isYearAlreadyComplete) {
            "use strict";

            Object.defineProperty(exports, "__esModule", {
                        value: true
            });

            var _getClassName3 = _interopRequireDefault(_getClassName2);

            var tslib_1 = _interopRequireWildcard(_tslib);

            var React = _interopRequireWildcard(_react);

            var _GameplayMap2 = _interopRequireDefault(_GameplayMap);

            var _PowerSources2 = _interopRequireDefault(_PowerSources);

            var _PowerSourceDetails2 = _interopRequireDefault(_PowerSourceDetails);

            var _Hint2 = _interopRequireDefault(_Hint);

            var _OutageQuestion2 = _interopRequireDefault(_OutageQuestion);

            var _Outage2 = _interopRequireDefault(_Outage);

            var _ModalComponent2 = _interopRequireDefault(_ModalComponent);

            var _GameOver2 = _interopRequireDefault(_GameOver);

            var _TimerStart2 = _interopRequireDefault(_TimerStart);

            var _GameUi2 = _interopRequireDefault(_GameUi);

            var _DraggablePowerSource2 = _interopRequireDefault(_DraggablePowerSource);

            var _YearInfo2 = _interopRequireDefault(_YearInfo);

            var _YearEndQuestion2 = _interopRequireDefault(_YearEndQuestion);

            var _Clouds2 = _interopRequireDefault(_Clouds);

            var _QuitButton2 = _interopRequireDefault(_QuitButton);

            var _GameCalendar2 = _interopRequireDefault(_GameCalendar);

            var _YearEnd2 = _interopRequireDefault(_YearEnd);

            function _interopRequireWildcard(obj) {
                        if (obj && obj.__esModule) {
                                    return obj;
                        } else {
                                    var newObj = {};

                                    if (obj != null) {
                                                for (var key in obj) {
                                                            if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                                                }
                                    }

                                    newObj.default = obj;
                                    return newObj;
                        }
            }

            function _interopRequireDefault(obj) {
                        return obj && obj.__esModule ? obj : {
                                    default: obj
                        };
            }

            var _styleModuleImportMap = {
                        "./Game.scss": {
                                    "game": "Game__game___2rvjh",
                                    "dragging": "Game__dragging___159fM Game__game___2rvjh",
                                    "output-ui": "Game__output-ui___3UhjP",
                                    "outputs": "Game__outputs___B7gsY",
                                    "energy-mix": "Game__energy-mix___2yJ8c",
                                    "top-right-ui": "Game__top-right-ui___1fq5s",
                                    "edf-logo": "Game__edf-logo___3h3TY"
                        }
            };

            var Game = function (_super) {
                        tslib_1.__extends(Game, _super);
                        function Game(props) {
                                    var _this = _super.call(this, props) || this;
                                    _this.props = props;
                                    _this.startMiniGame = function () {
                                                var has_mini_game = _this.props.has_mini_game;
                                                if (!has_mini_game) return;
                                                _this.props.showEventGame();
                                    };
                                    return _this;
                        }
                        Game.prototype.render = function () {
                                    var _a = this.props,
                                        active = _a.active,
                                        is_dragging = _a.is_dragging,
                                        showQuestion = _a.showQuestion;
                                    if (!active) return null;
                                    return React.createElement(
                                                "div",
                                                {
                                                            className: (0, _getClassName3.default)(!is_dragging ? 'game' : 'dragging', _styleModuleImportMap)
                                                },
                                                React.createElement(_GameplayMap2.default, null),
                                                React.createElement(_Clouds2.default, null),
                                                React.createElement(_PowerSources2.default, null),
                                                React.createElement(_DraggablePowerSource2.default, null),
                                                React.createElement(_GameUi2.default, null),
                                                React.createElement(
                                                            "div",
                                                            {
                                                                        className: (0, _getClassName3.default)('top-right-ui', _styleModuleImportMap)
                                                            },
                                                            React.createElement(_QuitButton2.default, null),
                                                            React.createElement(_GameCalendar2.default, null)
                                                ),
                                                React.createElement(
                                                            _ModalComponent2.default,
                                                            { modal_id: _modal.MODALS.TIMER_START, onClose: this.props.startTimer },
                                                            React.createElement(_TimerStart2.default, null)
                                                ),
                                                React.createElement(
                                                            _ModalComponent2.default,
                                                            { modal_id: _modal.MODALS.HINT, close_button_type: 'none' },
                                                            React.createElement(_Hint2.default, null)
                                                ),
                                                React.createElement(
                                                            _ModalComponent2.default,
                                                            { modal_id: _modal.MODALS.OUTAGE, onClose: showQuestion },
                                                            React.createElement(_Outage2.default, null)
                                                ),
                                                React.createElement(
                                                            _ModalComponent2.default,
                                                            { modal_id: _modal.MODALS.YEAR, close_button_type: this.props.is_already_complete ? 'none' : 'slideshow-complete', close_button_text: "let's go!", onClose: this.startMiniGame },
                                                            React.createElement(_YearInfo2.default, null)
                                                ),
                                                React.createElement(
                                                            _ModalComponent2.default,
                                                            { modal_id: _modal.MODALS.YEAR_END_STATUS, close_button_type: 'ok', onClose: this.props.showYearEndQuestion },
                                                            React.createElement(_YearEnd2.default, null)
                                                ),
                                                React.createElement(
                                                            _ModalComponent2.default,
                                                            { modal_id: _modal.MODALS.OUTAGE_QUESTION, close_button_type: 'none' },
                                                            React.createElement(_OutageQuestion2.default, null)
                                                ),
                                                React.createElement(
                                                            _ModalComponent2.default,
                                                            { modal_id: _modal.MODALS.YEAR_END_QUESTION, close_button_type: 'none' },
                                                            React.createElement(_YearEndQuestion2.default, null)
                                                ),
                                                React.createElement(
                                                            _ModalComponent2.default,
                                                            { modal_id: _modal.MODALS.POWER_SOURCE_DETAILS, close_button_type: 'none' },
                                                            React.createElement(_PowerSourceDetails2.default, null)
                                                ),
                                                React.createElement(
                                                            _ModalComponent2.default,
                                                            { modal_id: _modal.MODALS.GAME_OVER, close_button_type: 'none' },
                                                            React.createElement(_GameOver2.default, null)
                                                )
                                    );
                        };
                        return Game;
            }(React.Component);
            var mapStateToProps = function mapStateToProps(state) {
                        return {
                                    is_dragging: (0, _interaction.isDragging)(state),
                                    has_mini_game: (0, _miniGame2.hasMiniGameData)(state),
                                    is_already_complete: (0, _isYearAlreadyComplete.isYearAlreadyComplete)(state)
                        };
            };
            var mapDispatchToProps = function mapDispatchToProps(dispatch) {
                        return {
                                    startTimer: function startTimer() {
                                                return dispatch((0, _timer.startTimer)());
                                    },
                                    activateMiniGame: function activateMiniGame() {
                                                return dispatch((0, _miniGame.activateMiniGame)());
                                    },
                                    showEventGame: function showEventGame() {
                                                return dispatch((0, _screens.setScreen)(_screen.SCREENS.MINI_GAME));
                                    },
                                    showQuestion: function showQuestion() {
                                                return dispatch((0, _questions.showNextOutageQuestion)('low-energy-mix'));
                                    },
                                    showMainMenu: function showMainMenu() {
                                                return dispatch((0, _screens.showMainMenu)());
                                    },
                                    showYearEndQuestion: function showYearEndQuestion() {
                                                return dispatch((0, _questions.showNextYearEndQuestion)());
                                    }
                        };
            };
            exports.default = (0, _screenComponent.screenComponent)()((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Game));
});

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(8), __webpack_require__(9), __webpack_require__(10), __webpack_require__(231), __webpack_require__(234), __webpack_require__(235), __webpack_require__(236), __webpack_require__(237), __webpack_require__(238)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("lodash"), require("react-redux"), require("../../../../data/data"), require("./MapLocation"), require("../../../../store/actions/interaction"), require("../../../../store/actions/mapOffset"), require("../../../../store/actions/mapBounds"), require("../../../../store/reducers/map/mapState"), require("./GameplayMap.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.lodash, global.reactRedux, global.data, global.MapLocation, global.interaction, global.mapOffset, global.mapBounds, global.mapState, global.GameplayMap);
        global.GameplayMap = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _lodash, _reactRedux, _data, _MapLocation, _interaction, _mapOffset, _mapBounds, _mapState) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    var _ = _interopRequireWildcard(_lodash);

    var _MapLocation2 = _interopRequireDefault(_MapLocation);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./GameplayMap.scss": {
            "gameplay-map": "GameplayMap__gameplay-map___3qMvx",
            "normal": "GameplayMap__normal___3JTfX GameplayMap__gameplay-map___3qMvx",
            "snow": "GameplayMap__snow___1ZuAd GameplayMap__gameplay-map___3qMvx"
        }
    };

    var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }

        return target;
    };

    var GameplayMap = function (_super) {
        tslib_1.__extends(GameplayMap, _super);
        function GameplayMap(props, state) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.state = state;
            _this.onMouseDown = function (mouse_event) {
                document.addEventListener('mousemove', _this.onMouseMove);
                document.addEventListener('mouseup', _this.onMouseUp);
                _this.px = mouse_event.pageX;
                _this.py = mouse_event.pageY;
                _this.props.startDragging();
            };
            _this.onMouseMove = function (mouse_event) {
                var setMapOffset = _this.props.setMapOffset;
                var dx = _this.px - mouse_event.pageX;
                var dy = _this.py - mouse_event.pageY;
                var _a = _this.state,
                    nx = _a.x,
                    ny = _a.y;
                var x = _.clamp(nx - dx, window.innerWidth - _this.width, 0);
                var y = _.clamp(ny - dy, window.innerHeight - _this.height, 0);
                _this.px = mouse_event.pageX;
                _this.py = mouse_event.pageY;
                _this.setState({ x: x, y: y });
                setMapOffset(x, y);
            };
            _this.onMouseUp = function (mouse_event) {
                document.removeEventListener('mousemove', _this.onMouseMove);
                document.removeEventListener('mouseup', _this.onMouseUp);
                _this.props.stopDragging();
            };
            _this.getMapLocations = function () {
                var locations = (0, _data.getPowerSourceLocationsData)();
                return _.map(locations, function (location, i) {
                    return React.createElement(_MapLocation2.default, _extends({}, location, { location_id: i, key: i }));
                });
            };
            _this.measureMap = function (el) {
                if (!el) return;
                var bounds = el.getBoundingClientRect();
                _this.width = bounds.width;
                _this.height = bounds.height;
                var setMapBounds = _this.props.setMapBounds;
                setMapBounds(_this.width, _this.height);
            };
            _this.state = { x: -1730, y: -2890 };
            return _this;
        }
        GameplayMap.prototype.componentDidMount = function () {};
        GameplayMap.prototype.render = function () {
            var weather_state = this.props.weather_state;
            var _a = this.state,
                x = _a.x,
                y = _a.y;
            return React.createElement(
                "div",
                { style: { top: y, left: x }, onMouseDown: this.onMouseDown, ref: this.measureMap, className: (0, _getClassName3.default)(weather_state, _styleModuleImportMap)
                },
                this.getMapLocations()
            );
        };
        return GameplayMap;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state) {
        return {
            weather_state: (0, _mapState.getMapWweatherState)(state)
        };
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {
            startDragging: function startDragging() {
                return dispatch((0, _interaction.startDragging)());
            },
            stopDragging: function stopDragging() {
                return dispatch((0, _interaction.stopDragging)());
            },
            setMapBounds: function setMapBounds(width, height) {
                return dispatch((0, _mapBounds.setMapBounds)(width, height));
            },
            setMapOffset: function setMapOffset(ox, oy) {
                return dispatch((0, _mapOffset.setMapOffset)(ox, oy));
            }
        };
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GameplayMap);
});

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(13), __webpack_require__(54), __webpack_require__(55), __webpack_require__(38), __webpack_require__(37), __webpack_require__(25), __webpack_require__(30), __webpack_require__(83), __webpack_require__(28), __webpack_require__(12), __webpack_require__(31), __webpack_require__(232)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("react-redux"), require("../../../../store/reducers/powerSources"), require("../../../../store/actions/locations"), require("../../../../store/reducers/highlightLocation"), require("../../../../store/reducers/draggingPowerSource"), require("../../../../store/reducers/location"), require("../../../../store/actions/questions/questions"), require("../../../../store/reducers/power-sources/damage"), require("../../../../store/actions/power-sources/damage"), require("../../../../store/reducers/power-sources/deprecate"), require("../../../../store/reducers/year"), require("../../../../store/actions/powerSources"), require("./MapLocation.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.reactRedux, global.powerSources, global.locations, global.highlightLocation, global.draggingPowerSource, global.location, global.questions, global.damage, global.damage, global.deprecate, global.year, global.powerSources, global.MapLocation);
        global.MapLocation = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _reactRedux, _powerSources, _locations, _highlightLocation, _draggingPowerSource, _location, _questions, _damage, _damage2, _deprecate, _year, _powerSources2) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./MapLocation.scss": {
            "map-location": "MapLocation__map-location___2Q2NL",
            "tooltip": "MapLocation__tooltip___29z48 Fonts__bold-font___3iFek",
            "image": "MapLocation__image___1H8NX",
            "delete-button": "MapLocation__delete-button___1YqUr",
            "empty": "MapLocation__empty___2jwGh MapLocation__map-location___2Q2NL",
            "populated": "MapLocation__populated___1_dNh MapLocation__map-location___2Q2NL",
            "location-icon": "MapLocation__location-icon___18Tev",
            "invalid-icon": "MapLocation__invalid-icon___3j2pT",
            "warning-icon": "MapLocation__warning-icon___-l-sw",
            "bounce": "MapLocation__bounce___1Eb9F",
            "boost-icon": "MapLocation__boost-icon___1Oz2L MapLocation__warning-icon___-l-sw",
            "deprecated-icon": "MapLocation__deprecated-icon___1FHnQ",
            "icon-deprecated": "MapLocation__icon-deprecated___1KFGx MapLocation__deprecated-icon___1FHnQ",
            "icon-damaged": "MapLocation__icon-damaged___cKPwd MapLocation__warning-icon___-l-sw",
            "icon-boost": "MapLocation__icon-boost___ZiiXA MapLocation__warning-icon___-l-sw",
            "icon-enabled": "MapLocation__icon-enabled___3-3SN",
            "hidden-delete-button": "MapLocation__hidden-delete-button___1IYjl"
        }
    };

    var MapLocation = function (_super) {
        tslib_1.__extends(MapLocation, _super);
        function MapLocation(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.onClick = function (event) {
                if (event.target.classList.contains('delete')) return;
                var _a = _this.props,
                    is_damaged = _a.is_damaged,
                    repairDamageAtLocation = _a.repairDamageAtLocation,
                    power_source = _a.power_source,
                    setSelectedLocation = _a.setSelectedLocation,
                    location_id = _a.location_id;
                if (is_damaged) return repairDamageAtLocation(location_id);
                if (power_source) setSelectedLocation(location_id);
            };
            _this.getBackgroundImage = function () {
                var power_source = _this.props.power_source;
                if (!power_source) return null;
                var id = power_source.id;
                var icon;
                var type = _this.props.type;
                switch (id) {
                    case 'wind-sea':
                        {
                            icon = id;
                            break;
                        }
                    default:
                        {
                            icon = id;
                            break;
                        }
                }
                return "url(./img/game/map-power-sources/" + icon + "@2x.png)";
            };
            _this.getTooltipText = function () {
                var _a = _this.props,
                    power_source = _a.power_source,
                    is_valid = _a.is_valid,
                    type = _a.type,
                    dragging_power_source = _a.dragging_power_source,
                    is_damaged = _a.is_damaged,
                    is_deprecated = _a.is_deprecated,
                    year = _a.year;
                if (year.year === 2020 || year.year === 2024) {
                    return null;
                }
                if (!_this.canDelete() && power_source && power_source.id !== 'other' && !is_damaged && !is_deprecated) {
                    return "<span style='text-transform: none;'>Oops!<br/>You can’t remove this power source from your map,<br/>as it needs to be in your 2032 energy mix.<br/>(*Clue alert!*).</span>";
                }
                if (!is_valid) return dragging_power_source['requirement-reason'];
                if (power_source) return power_source.label;
                return type;
            };
            _this.getIconStyleName = function () {
                var _a = _this.props,
                    year_data = _a.year,
                    is_damaged = _a.is_damaged,
                    is_deprecated = _a.is_deprecated;
                var year = year_data.year;
                if (is_deprecated) return 'icon-deprecated';
                if (is_damaged) return year !== 2024 ? 'icon-damaged' : 'icon-boost';
                return 'icon-enabled';
            };
            _this.canDelete = function () {
                var _a = _this.props,
                    power_source = _a.power_source,
                    year = _a.year,
                    is_last = _a.is_last;
                var removable = (power_source || {}).removable;
                return power_source && removable !== false && !is_last && !(year.year === 2020 || year.year === 2024);
            };
            return _this;
        }
        MapLocation.prototype.render = function () {
            var _a = this.props,
                position = _a.position,
                power_source = _a.power_source,
                is_damaged = _a.is_damaged,
                location_id = _a.location_id,
                is_valid = _a.is_valid,
                removePowerSourceAtLocation = _a.removePowerSourceAtLocation,
                is_last = _a.is_last;
            var removable = (power_source || {}).removable;
            return React.createElement(
                "div",
                { style: {
                        top: position[1] + "%",
                        left: position[0] + "%"
                    }, onClick: this.onClick, className: (0, _getClassName3.default)(!power_source ? 'empty' : 'populated', _styleModuleImportMap)
                },
                React.createElement("div", { style: {
                        backgroundImage: this.getBackgroundImage()
                    }, className: (0, _getClassName3.default)(is_valid ? 'location-icon' : 'invalid-icon', _styleModuleImportMap)
                }),
                React.createElement("div", {
                    className: (0, _getClassName3.default)(this.getIconStyleName(), _styleModuleImportMap)
                }),
                this.getTooltipText() && React.createElement("span", { dangerouslySetInnerHTML: { __html: this.getTooltipText() }, className: (0, _getClassName3.default)('tooltip', _styleModuleImportMap)
                }),
                this.canDelete() && React.createElement(
                    "span",
                    { onClick: function onClick() {
                            return removePowerSourceAtLocation(location_id);
                        }, className: ('delete' ? 'delete' + " " : "") + (0, _getClassName3.default)('delete-button', _styleModuleImportMap)
                    },
                    React.createElement("img", { className: 'delete', src: 'img/game/map-location/cross.png' })
                )
            );
        };
        return MapLocation;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state, props) {
        return {
            power_source: (0, _powerSources.getPowerSourceAtLocation)(state, props),
            is_damaged: (0, _damage.isPowerSourceDamaged)(state, props),
            is_deprecated: (0, _deprecate.isPowerSourceDeprecated)(state, props),
            is_highlight: (0, _highlightLocation.isLocationHighlighted)(state, props),
            is_valid: (0, _location.isLocationValidForDraggingPowerSource)(state, props),
            is_last: (0, _powerSources.isPowerSourceLastOfType)(state, props),
            dragging_power_source: (0, _draggingPowerSource.getDraggingPowerSource)(state),
            year: (0, _year.getYearData)(state)
        };
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {
            setSelectedLocation: function setSelectedLocation(location_id) {
                return dispatch((0, _locations.setSelectedLocation)(location_id));
            },
            repairDamageAtLocation: function repairDamageAtLocation(location_id) {
                return dispatch((0, _damage2.repairDamageAtLocation)(location_id));
            },
            showQuestion: function showQuestion() {
                return dispatch((0, _questions.showNextOutageQuestion)());
            },
            removePowerSourceAtLocation: function removePowerSourceAtLocation(location_id) {
                return dispatch((0, _powerSources2.removePowerSourceAtLocation)(location_id));
            }
        };
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MapLocation);
});

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(233);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../node_modules/sass-loader/lib/loader.js!./MapLocation.scss", function() {
			var newContent = require("!!../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../node_modules/sass-loader/lib/loader.js!./MapLocation.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports
exports.i(__webpack_require__(0), undefined);

// module
exports.push([module.i, ".MapLocation__map-location___2Q2NL{position:absolute;display:flex;justify-content:center;align-items:center;width:50px;height:50px;white-space:nowrap;cursor:pointer;background-size:contain;transform:translate(-50%,-50%);transition:all .2s ease-out;text-transform:capitalize}.MapLocation__map-location___2Q2NL .MapLocation__tooltip___29z48{white-space:nowrap;text-align:center}.MapLocation__map-location___2Q2NL:hover .MapLocation__image___1H8NX{bottom:5px}.MapLocation__map-location___2Q2NL:hover .MapLocation__tooltip___29z48{opacity:1;top:100%}.MapLocation__map-location___2Q2NL:hover .MapLocation__delete-button___1YqUr{bottom:80%;opacity:1}.MapLocation__empty___2jwGh:hover{width:70px;height:70px;background-color:hsla(0,0%,100%,.5);border-radius:50px;box-shadow:0 0 30px #fff}.MapLocation__populated___1_dNh{width:110px;height:110px}.MapLocation__location-icon___18Tev{background:url(\"./img/game/map-location/hotspot@2x.png\") no-repeat 50%;width:100%;height:100%;background-size:contain}.MapLocation__invalid-icon___3j2pT{background:url(\"./img/game/map-location/invalid-hotspot@2x.png\") no-repeat 50%;width:100%;height:100%;background-size:contain}@keyframes MapLocation__bounce___1Eb9F{0%{transform:translate(-50%)}25%{transform:translate(-50%,-15px)}50%{transform:translate(-50%)}75%{transform:translate(-50%,-15px)}to{transform:translate(-50%)}}.MapLocation__warning-icon___-l-sw{position:absolute;width:60px;height:60px;top:-60px;left:50%;background:url(\"./img/game/power-sources/source-warning@3x.png\") no-repeat 50%;background-size:contain;transform:translate(-50%,-50%);opacity:0;transition:all .2s ease-in-out;animation:MapLocation__bounce___1Eb9F 2s infinite}.MapLocation__boost-icon___1Oz2L{background:url(\"./img/game/power-sources/source-boost@3x.png\") no-repeat 50%}.MapLocation__deprecated-icon___1FHnQ{position:absolute;width:120px;height:80px;top:50px;left:50%;background:url(\"./img/game/power-sources/source-closed.png\") no-repeat 50%;background-size:contain;transform:translate(-50%,-50%);opacity:0}.MapLocation__icon-deprecated___1KFGx{opacity:1}.MapLocation__icon-damaged___cKPwd{top:-40px;opacity:1}.MapLocation__icon-boost___ZiiXA{background:url(\"./img/game/power-sources/source-boost@3x.png\") no-repeat 50%;opacity:1}.MapLocation__tooltip___29z48{position:absolute;top:90%;left:50%;transform:translate(-50%);background:rgba(0,0,0,.8);padding:10px 20px;border-radius:50px;color:#fff;opacity:0;transition:all .2s ease-in-out;pointer-events:none;user-select:none}.MapLocation__tooltip___29z48:first-letter{text-transform:uppercase}.MapLocation__delete-button___1YqUr{position:absolute;bottom:70%;left:50%;transform:translate(-50%);background:transparent;padding:10px 20px;border-radius:50px;color:#fff;opacity:0;transition:all .2s ease-in-out;user-select:none}.MapLocation__hidden-delete-button___1IYjl{display:none}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game/map/MapLocation.scss"],"names":[],"mappings":"AAAA,mCAAc,kBAAkB,aAAa,uBAAuB,mBAAmB,WAAW,YAAY,mBAAmB,eAAe,wBAAwB,+BAAgC,4BAA6B,yBAAyB,CAAC,iEAAuB,mBAAmB,iBAAiB,CAAC,qEAA2B,UAAU,CAAC,uEAA6B,UAAU,QAAQ,CAAC,6EAAmC,WAAW,SAAS,CAAC,AAA6B,kCAAa,WAAW,YAAY,oCAAuC,mBAAmB,wBAAyB,CAAC,gCAAiC,YAAY,YAAY,CAAC,oCAAe,uEAA0E,WAAW,YAAY,uBAAuB,CAAC,mCAAc,+EAAkF,WAAW,YAAY,uBAAuB,CAAC,uCAAkB,GAAG,yBAA4B,CAAC,IAAI,+BAAgC,CAAC,IAAI,yBAA4B,CAAC,IAAI,+BAAgC,CAAC,GAAK,yBAA4B,CAAC,CAAC,mCAAc,kBAAkB,WAAW,YAAY,UAAU,SAAS,+EAAkF,wBAAwB,+BAAgC,UAAU,+BAAgC,iDAA4B,CAAC,iCAAkC,4EAA+E,CAAC,sCAAiB,kBAAkB,YAAY,YAAY,SAAS,SAAS,2EAA8E,wBAAwB,+BAAgC,SAAS,CAAC,sCAA0C,SAAS,CAAC,mCAAoC,UAAU,SAAS,CAAC,iCAAkC,6EAAgF,SAAS,CAAC,8BAA8D,kBAAkB,QAAQ,SAAS,0BAA6B,0BAA2B,kBAAkB,mBAAmB,WAAY,UAAU,+BAAgC,oBAAoB,gBAAgB,CAAC,2CAAsB,wBAAwB,CAAC,oCAAe,kBAAkB,WAAW,SAAS,0BAA6B,uBAAuB,kBAAkB,mBAAmB,WAAY,UAAU,+BAAgC,gBAAgB,CAAC,2CAAsB,YAAY,CAAC","file":"MapLocation.scss","sourcesContent":[".map-location{position:absolute;display:flex;justify-content:center;align-items:center;width:50px;height:50px;white-space:nowrap;cursor:pointer;background-size:contain;transform:translate(-50%, -50%);transition:all 0.2s ease-out;text-transform:capitalize}.map-location .tooltip{white-space:nowrap;text-align:center}.map-location:hover .image{bottom:5px}.map-location:hover .tooltip{opacity:1;top:100%}.map-location:hover .delete-button{bottom:80%;opacity:1}.empty{composes:map-location}.empty:hover{width:70px;height:70px;background-color:rgba(255,255,255,0.5);border-radius:50px;box-shadow:white 0 0 30px}.populated{composes:map-location;width:110px;height:110px}.location-icon{background:url(\"./img/game/map-location/hotspot@2x.png\") no-repeat center;width:100%;height:100%;background-size:contain}.invalid-icon{background:url(\"./img/game/map-location/invalid-hotspot@2x.png\") no-repeat center;width:100%;height:100%;background-size:contain}@keyframes bounce{0%{transform:translate(-50%, 0)}25%{transform:translate(-50%, -15px)}50%{transform:translate(-50%, 0)}75%{transform:translate(-50%, -15px)}100%{transform:translate(-50%, 0)}}.warning-icon{position:absolute;width:60px;height:60px;top:-60px;left:50%;background:url(\"./img/game/power-sources/source-warning@3x.png\") no-repeat center;background-size:contain;transform:translate(-50%, -50%);opacity:0;transition:all 0.2s ease-in-out;animation:bounce 2s infinite}.boost-icon{composes:warning-icon;background:url(\"./img/game/power-sources/source-boost@3x.png\") no-repeat center}.deprecated-icon{position:absolute;width:120px;height:80px;top:50px;left:50%;background:url(\"./img/game/power-sources/source-closed.png\") no-repeat center;background-size:contain;transform:translate(-50%, -50%);opacity:0}.icon-deprecated{composes:deprecated-icon;opacity:1}.icon-damaged{composes:warning-icon;top:-40px;opacity:1}.icon-boost{composes:warning-icon;background:url(\"./img/game/power-sources/source-boost@3x.png\") no-repeat center;opacity:1}.tooltip{composes:bold-font from '../../../common/Fonts.scss';position:absolute;top:90%;left:50%;transform:translate(-50%, 0);background:rgba(0,0,0,0.8);padding:10px 20px;border-radius:50px;color:white;opacity:0;transition:all 0.2s ease-in-out;pointer-events:none;user-select:none}.tooltip:first-letter{text-transform:uppercase}.delete-button{position:absolute;bottom:70%;left:50%;transform:translate(-50%, 0);background:transparent;padding:10px 20px;border-radius:50px;color:white;opacity:0;transition:all 0.2s ease-in-out;user-select:none}.hidden-delete-button{display:none}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"map-location": "MapLocation__map-location___2Q2NL",
	"mapLocation": "MapLocation__map-location___2Q2NL",
	"tooltip": "MapLocation__tooltip___29z48 " + __webpack_require__(0).locals["bold-font"] + "",
	"image": "MapLocation__image___1H8NX",
	"delete-button": "MapLocation__delete-button___1YqUr",
	"deleteButton": "MapLocation__delete-button___1YqUr",
	"empty": "MapLocation__empty___2jwGh MapLocation__map-location___2Q2NL",
	"populated": "MapLocation__populated___1_dNh MapLocation__map-location___2Q2NL",
	"location-icon": "MapLocation__location-icon___18Tev",
	"locationIcon": "MapLocation__location-icon___18Tev",
	"invalid-icon": "MapLocation__invalid-icon___3j2pT",
	"invalidIcon": "MapLocation__invalid-icon___3j2pT",
	"warning-icon": "MapLocation__warning-icon___-l-sw",
	"warningIcon": "MapLocation__warning-icon___-l-sw",
	"bounce": "MapLocation__bounce___1Eb9F",
	"boost-icon": "MapLocation__boost-icon___1Oz2L MapLocation__warning-icon___-l-sw",
	"boostIcon": "MapLocation__boost-icon___1Oz2L MapLocation__warning-icon___-l-sw",
	"deprecated-icon": "MapLocation__deprecated-icon___1FHnQ",
	"deprecatedIcon": "MapLocation__deprecated-icon___1FHnQ",
	"icon-deprecated": "MapLocation__icon-deprecated___1KFGx MapLocation__deprecated-icon___1FHnQ",
	"iconDeprecated": "MapLocation__icon-deprecated___1KFGx MapLocation__deprecated-icon___1FHnQ",
	"icon-damaged": "MapLocation__icon-damaged___cKPwd MapLocation__warning-icon___-l-sw",
	"iconDamaged": "MapLocation__icon-damaged___cKPwd MapLocation__warning-icon___-l-sw",
	"icon-boost": "MapLocation__icon-boost___ZiiXA MapLocation__warning-icon___-l-sw",
	"iconBoost": "MapLocation__icon-boost___ZiiXA MapLocation__warning-icon___-l-sw",
	"hidden-delete-button": "MapLocation__hidden-delete-button___1IYjl",
	"hiddenDeleteButton": "MapLocation__hidden-delete-button___1IYjl"
};

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("./action"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.interaction = mod.exports;
    }
})(this, function (exports, _action) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.startDragging = startDragging;
    exports.stopDragging = stopDragging;
    function startDragging() {
        return { type: _action.START_DRAGGING, payload: {} };
    }
    function stopDragging() {
        return { type: _action.STOP_DRAGGING, payload: {} };
    }
});

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("./action"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.mapOffset = mod.exports;
    }
})(this, function (exports, _action) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.setMapOffset = setMapOffset;
    function setMapOffset(ox, oy) {
        return { type: _action.SET_MAP_OFFSET, payload: { ox: ox, oy: oy } };
    }
});

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("./action"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.mapBounds = mod.exports;
    }
})(this, function (exports, _action) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.setMapBounds = setMapBounds;
    function setMapBounds(width, height) {
        return { type: _action.SET_MAP_BOUNDS, payload: { width: width, height: height } };
    }
});

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(11), __webpack_require__(12)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('reselect'), require('../year'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.reselect, global.year);
        global.mapState = mod.exports;
    }
})(this, function (exports, _reselect, _year) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getMapWweatherState = undefined;
    var getMapWweatherState = exports.getMapWweatherState = (0, _reselect.createSelector)([_year.getYearData], function (year_data) {
        return year_data['map-state'] === 'snow' ? 'snow' : 'normal';
    });
});

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(239);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../node_modules/sass-loader/lib/loader.js!./GameplayMap.scss", function() {
			var newContent = require("!!../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../node_modules/sass-loader/lib/loader.js!./GameplayMap.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports


// module
exports.push([module.i, ".GameplayMap__gameplay-map___3qMvx{position:absolute;width:3992px;height:5670px;background-repeat:no-repeat;background-color:#398ee8;cursor:move}.GameplayMap__gameplay-map___3qMvx,.GameplayMap__normal___3JTfX{background-image:url(\"img/game/map.jpg\")}.GameplayMap__snow___1ZuAd{background-image:url(\"img/game/map-snow.jpg\")}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game/map/GameplayMap.scss"],"names":[],"mappings":"AAAA,mCAAc,kBAAkB,aAAa,cAAc,AAAyC,4BAA4B,yBAAyB,WAAW,CAAC,gEAA1G,wCAAyC,CAAwI,2BAA4B,6CAA6C,CAAC","file":"GameplayMap.scss","sourcesContent":[".gameplay-map{position:absolute;width:3992px;height:5670px;background-image:url(\"img/game/map.jpg\");background-repeat:no-repeat;background-color:#398ee8;cursor:move}.normal{composes:gameplay-map;background-image:url(\"img/game/map.jpg\")}.snow{composes:gameplay-map;background-image:url(\"img/game/map-snow.jpg\")}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"gameplay-map": "GameplayMap__gameplay-map___3qMvx",
	"gameplayMap": "GameplayMap__gameplay-map___3qMvx",
	"normal": "GameplayMap__normal___3JTfX GameplayMap__gameplay-map___3qMvx",
	"snow": "GameplayMap__snow___1ZuAd GameplayMap__gameplay-map___3qMvx"
};

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(8), __webpack_require__(10), __webpack_require__(102), __webpack_require__(246)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("react-redux"), require("lodash"), require("../../../../data/data"), require("./PowerSource"), require("./PowerSources.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.reactRedux, global.lodash, global.data, global.PowerSource, global.PowerSources);
        global.PowerSources = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _reactRedux, _lodash, _data, _PowerSource) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    var _ = _interopRequireWildcard(_lodash);

    var _PowerSource2 = _interopRequireDefault(_PowerSource);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./PowerSources.scss": {
            "power-sources": "PowerSources__power-sources___32KI-"
        }
    };

    var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }

        return target;
    };

    var PowerSources = function (_super) {
        tslib_1.__extends(PowerSources, _super);
        function PowerSources(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.getPowerSources = function () {
                var power_sources = (0, _data.getPowerSourcesData)();
                return _.map(power_sources, function (power_source, i) {
                    return React.createElement(_PowerSource2.default, _extends({}, power_source, { key: i }));
                });
            };
            return _this;
        }
        PowerSources.prototype.render = function () {
            return React.createElement(
                "div",
                {
                    className: (0, _getClassName3.default)('power-sources', _styleModuleImportMap)
                },
                this.getPowerSources()
            );
        };
        return PowerSources;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state) {
        return {};
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {};
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PowerSources);
});

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(242)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("./Counter.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.Counter);
        global.Counter = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./Counter.scss": {
            "counter": "Counter__counter___3_AWI Fonts__bold-font___3iFek",
            "left-align": "Counter__left-align___2v4s5 Counter__counter___3_AWI Fonts__bold-font___3iFek",
            "right-align": "Counter__right-align___2G6IE Counter__counter___3_AWI Fonts__bold-font___3iFek"
        }
    };

    var Counter = function (_super) {
        tslib_1.__extends(Counter, _super);
        function Counter(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            return _this;
        }
        Counter.prototype.render = function () {
            var _a = this.props,
                count = _a.count,
                _b = _a.align,
                align = _b === void 0 ? 'left' : _b;
            if (!count) return null;
            return React.createElement(
                "span",
                {
                    className: (0, _getClassName3.default)(align + "-align", _styleModuleImportMap)
                },
                count
            );
        };
        return Counter;
    }(React.Component);
    exports.default = Counter;
});

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(243);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./Counter.scss", function() {
			var newContent = require("!!../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./Counter.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports
exports.i(__webpack_require__(0), undefined);

// module
exports.push([module.i, ".Counter__counter___3_AWI{position:absolute;bottom:-5px;background-color:#e94e0f;padding:5px;border-radius:50px;min-width:20px;height:20px;text-align:center;line-height:1.25em;color:#fff}.Counter__left-align___2v4s5{left:-5px}.Counter__right-align___2G6IE{right:-5px}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/common/counter/Counter.scss"],"names":[],"mappings":"AAAA,0BAAiD,kBAAkB,YAAY,yBAAyB,YAAY,mBAAmB,eAAe,YAAY,kBAAkB,mBAAmB,UAAW,CAAC,6BAA6B,SAAS,CAAC,8BAA8B,UAAU,CAAC","file":"Counter.scss","sourcesContent":[".counter{composes:bold-font from '../Fonts.scss';position:absolute;bottom:-5px;background-color:#e94e0f;padding:5px;border-radius:50px;min-width:20px;height:20px;text-align:center;line-height:1.25em;color:white}.left-align{composes:counter;left:-5px}.right-align{composes:counter;right:-5px}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"counter": "Counter__counter___3_AWI " + __webpack_require__(0).locals["bold-font"] + "",
	"left-align": "Counter__left-align___2v4s5 Counter__counter___3_AWI " + __webpack_require__(0).locals["bold-font"] + "",
	"leftAlign": "Counter__left-align___2v4s5 Counter__counter___3_AWI " + __webpack_require__(0).locals["bold-font"] + "",
	"right-align": "Counter__right-align___2G6IE Counter__counter___3_AWI " + __webpack_require__(0).locals["bold-font"] + "",
	"rightAlign": "Counter__right-align___2G6IE Counter__counter___3_AWI " + __webpack_require__(0).locals["bold-font"] + ""
};

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(245);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../node_modules/sass-loader/lib/loader.js!./PowerSource.scss", function() {
			var newContent = require("!!../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../node_modules/sass-loader/lib/loader.js!./PowerSource.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports
exports.i(__webpack_require__(0), undefined);

// module
exports.push([module.i, ".PowerSource__power-source___3W25s{position:relative;display:flex;width:70px;height:70px;margin-right:10px;cursor:pointer}.PowerSource__power-source___3W25s:hover .PowerSource__image___1cX1N{bottom:5px}.PowerSource__power-source___3W25s:hover .PowerSource__tooltip___fMBVk{opacity:1;top:100%;white-space:nowrap}.PowerSource__closed___2hMea{pointer-events:none}.PowerSource__maxed-out___qtRVh{cursor:not-allowed}.PowerSource__image___1cX1N{position:absolute;bottom:0;width:70px;height:auto;align-self:flex-end;transition:all .2s ease-out}.PowerSource__tooltip___fMBVk{position:absolute;top:90%;left:50%;transform:translate(-50%);background:rgba(0,0,0,.8);padding:10px 20px;border-radius:50px;color:#fff;opacity:0;transition:all .2s ease-in-out}.PowerSource__tooltip___fMBVk:first-letter{text-transform:uppercase}.PowerSource__deprecated-icon___W-SOx{position:absolute;width:80px;height:80px;top:30px;left:50%;background:url(img/game/power-sources/source-closed.png) no-repeat 50%;background-size:contain;transform:translate(-50%,-50%)}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game/power-sources/PowerSource.scss"],"names":[],"mappings":"AAAA,mCAAc,kBAAkB,aAAa,WAAW,YAAY,kBAAkB,cAAc,CAAC,qEAA2B,UAAU,CAAC,uEAA6B,UAAU,SAAS,kBAAkB,CAAC,6BAA8B,mBAAmB,CAAC,gCAAiC,kBAAkB,CAAC,4BAAO,kBAAkB,SAAS,WAAW,YAAY,oBAAoB,2BAA4B,CAAC,8BAA8D,kBAAkB,QAAQ,SAAS,0BAA6B,0BAA2B,kBAAkB,mBAAmB,WAAY,UAAU,8BAA+B,CAAC,2CAAsB,wBAAwB,CAAC,sCAAiB,kBAAkB,WAAW,YAAY,SAAS,SAAS,uEAA0E,wBAAwB,8BAA+B,CAAC","file":"PowerSource.scss","sourcesContent":[".power-source{position:relative;display:flex;width:70px;height:70px;margin-right:10px;cursor:pointer}.power-source:hover .image{bottom:5px}.power-source:hover .tooltip{opacity:1;top:100%;white-space:nowrap}.closed{composes:power-source;pointer-events:none}.maxed-out{composes:power-source;cursor:not-allowed}.image{position:absolute;bottom:0;width:70px;height:auto;align-self:flex-end;transition:all 0.2s ease-out}.tooltip{composes:bold-font from '../../../common/Fonts.scss';position:absolute;top:90%;left:50%;transform:translate(-50%, 0);background:rgba(0,0,0,0.8);padding:10px 20px;border-radius:50px;color:white;opacity:0;transition:all 0.2s ease-in-out}.tooltip:first-letter{text-transform:uppercase}.deprecated-icon{position:absolute;width:80px;height:80px;top:30px;left:50%;background:url(img/game/power-sources/source-closed.png) no-repeat center;background-size:contain;transform:translate(-50%, -50%)}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"power-source": "PowerSource__power-source___3W25s",
	"powerSource": "PowerSource__power-source___3W25s",
	"image": "PowerSource__image___1cX1N",
	"tooltip": "PowerSource__tooltip___fMBVk " + __webpack_require__(0).locals["bold-font"] + "",
	"closed": "PowerSource__closed___2hMea PowerSource__power-source___3W25s",
	"maxed-out": "PowerSource__maxed-out___qtRVh PowerSource__power-source___3W25s",
	"maxedOut": "PowerSource__maxed-out___qtRVh PowerSource__power-source___3W25s",
	"deprecated-icon": "PowerSource__deprecated-icon___W-SOx",
	"deprecatedIcon": "PowerSource__deprecated-icon___W-SOx"
};

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(247);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../node_modules/sass-loader/lib/loader.js!./PowerSources.scss", function() {
			var newContent = require("!!../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../node_modules/sass-loader/lib/loader.js!./PowerSources.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports


// module
exports.push([module.i, ".PowerSources__power-sources___32KI-{position:absolute;top:50px;left:50px;display:flex;user-select:none}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game/power-sources/PowerSources.scss"],"names":[],"mappings":"AAAA,qCAAe,kBAAkB,SAAS,UAAU,aAAa,gBAAgB,CAAC","file":"PowerSources.scss","sourcesContent":[".power-sources{position:absolute;top:50px;left:50px;display:flex;user-select:none}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"power-sources": "PowerSources__power-sources___32KI-",
	"powerSources": "PowerSources__power-sources___32KI-"
};

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(8), __webpack_require__(13), __webpack_require__(10), __webpack_require__(37), __webpack_require__(31), __webpack_require__(25), __webpack_require__(88), __webpack_require__(19), __webpack_require__(51), __webpack_require__(30), __webpack_require__(58), __webpack_require__(251)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("react-redux"), require("lodash"), require("../../../../../store/reducers/powerSources"), require("../../../../../data/data"), require("../../../../../store/reducers/location"), require("../../../../../store/actions/powerSources"), require("../../../../../store/actions/questions/questions"), require("../../../../../store/reducers/season"), require("../../../../common/ui/button/Button"), require("../../../../../store/reducers/outputs/costPerMw"), require("../../../../../store/reducers/power-sources/damage"), require("../CloseButton"), require("./PowerSourceDetails.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.reactRedux, global.lodash, global.powerSources, global.data, global.location, global.powerSources, global.questions, global.season, global.Button, global.costPerMw, global.damage, global.CloseButton, global.PowerSourceDetails);
        global.PowerSourceDetails = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _reactRedux, _lodash, _powerSources, _data, _location, _powerSources2, _questions, _season, _Button, _costPerMw, _damage, _CloseButton) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    var _ = _interopRequireWildcard(_lodash);

    var _Button2 = _interopRequireDefault(_Button);

    var _CloseButton2 = _interopRequireDefault(_CloseButton);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./PowerSourceDetails.scss": {
            "power-source-details": "PowerSourceDetails__power-source-details___2gknM",
            "content": "PowerSourceDetails__content___D4E1_",
            "image-and-stats": "PowerSourceDetails__image-and-stats___1zMH6",
            "image": "PowerSourceDetails__image___3fZ2C",
            "stats": "PowerSourceDetails__stats___2Quii",
            "stats-title": "PowerSourceDetails__stats-title___2h7tR Fonts__bold-font___3iFek",
            "ui": "PowerSourceDetails__ui___30GCS",
            "title-container": "PowerSourceDetails__title-container___2KKuY",
            "text": "PowerSourceDetails__text___3Yu7n",
            "headline": "PowerSourceDetails__headline___1LMSR Fonts__bold-font___3iFek",
            "sub-headline": "PowerSourceDetails__sub-headline___25AAL Fonts__bold-font___3iFek",
            "body-copy": "PowerSourceDetails__body-copy___3TP24 Fonts__medium-font___3yYd3",
            "fix-outage-button": "PowerSourceDetails__fix-outage-button___2kkyV",
            "fix-outage-button-disabled": "PowerSourceDetails__fix-outage-button-disabled___14lQn"
        }
    };

    var PowerSourceDetails = function (_super) {
        tslib_1.__extends(PowerSourceDetails, _super);
        function PowerSourceDetails(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.removePowerSource = function () {
                _this.props.removePowerSourceAtLocation(_this.props.selected_location);
            };
            _this.getEnergyOutput = function () {
                var power_source = _this.props.power_source;
                var energy_output = power_source["energy-output"];
                var max = _.max(_.map((0, _data.getAllPowerSourcesData)(), 'energy-output'));
                return energy_output / max / 0.01 + '%';
            };
            _this.getCostPerMw = function () {
                var power_source = _this.props.power_source;
                var cost_per_mw = power_source["cost-per-mw"];
                var max = _.max(_.map((0, _data.getAllPowerSourcesData)(), 'cost-per-mw'));
                return cost_per_mw / max / 0.01 + '%';
            };
            _this.getEnvironmentalImpact = function () {
                var power_source = _this.props.power_source;
                var environmental_impact = power_source["environmental-impact"];
                var max = _.max(_.map((0, _data.getAllPowerSourcesData)(), 'environmental-impact'));
                return environmental_impact / max / 0.01 + '%';
            };
            return _this;
        }
        PowerSourceDetails.prototype.render = function () {
            var _a = this.props,
                power_source = _a.power_source,
                is_damaged = _a.is_damaged,
                removePowerSourceAtLocation = _a.removePowerSourceAtLocation,
                selected_location = _a.selected_location,
                counts = _a.counts;
            if (!power_source) return null;
            var removable = power_source.removable;
            var id = power_source.id,
                label = power_source.label,
                description = power_source.description,
                cost_per_mw = power_source["cost-per-mw"],
                energy_output = power_source["energy-output"],
                environmental_impact = power_source["environmental-impact"];
            return React.createElement(
                "span",
                null,
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('content', _styleModuleImportMap)
                    },
                    React.createElement(_CloseButton2.default, { onClose: this.props.onClose }),
                    React.createElement(
                        "div",
                        {
                            className: (0, _getClassName3.default)("image-and-stats", _styleModuleImportMap)
                        },
                        React.createElement("div", { style: { backgroundImage: "url(img/game/power-sources/info/" + id + ".jpg)" }, className: (0, _getClassName3.default)("image", _styleModuleImportMap)
                        }),
                        React.createElement(
                            "div",
                            {
                                className: (0, _getClassName3.default)('title-container', _styleModuleImportMap)
                            },
                            React.createElement(
                                "h4",
                                {
                                    className: (0, _getClassName3.default)('headline', _styleModuleImportMap)
                                },
                                label
                            ),
                            React.createElement(
                                "h3",
                                {
                                    className: (0, _getClassName3.default)('sub-headline', _styleModuleImportMap)
                                },
                                "power station"
                            )
                        )
                    ),
                    React.createElement(
                        "div",
                        {
                            className: (0, _getClassName3.default)('text', _styleModuleImportMap)
                        },
                        React.createElement("p", { dangerouslySetInnerHTML: { __html: description }, className: (0, _getClassName3.default)('body-copy', _styleModuleImportMap)
                        }),
                        removable !== false && counts[power_source.id] > 1 && React.createElement(
                            "div",
                            {
                                className: (0, _getClassName3.default)('ui', _styleModuleImportMap)
                            },
                            React.createElement(
                                _Button2.default,
                                { type: 'remove-power-source', onClick: function onClick() {
                                        return removePowerSourceAtLocation(selected_location);
                                    } },
                                "remove"
                            )
                        )
                    )
                )
            );
        };
        return PowerSourceDetails;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state, props) {
        return {
            power_source: (0, _powerSources.getPowerSourceAtSelectedLocation)(state),
            selected_location: (0, _location.getSelectedLocation)(state),
            is_damaged: (0, _damage.isPowerSourceDamaged)(state, props),
            season_index: (0, _season.getSeasonIndex)(state),
            target_cost_per_mw: (0, _costPerMw.getTargetCostPerMw)(state),
            counts: (0, _powerSources.countPowerSourcesByType)(state)
        };
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {
            removePowerSourceAtLocation: function removePowerSourceAtLocation(location_id) {
                return dispatch((0, _powerSources2.removePowerSourceAtLocation)(location_id));
            },
            showQuestion: function showQuestion() {
                return dispatch((0, _questions.showNextOutageQuestion)());
            }
        };
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PowerSourceDetails);
});

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(250);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../node_modules/sass-loader/lib/loader.js!./CloseButton.scss", function() {
			var newContent = require("!!../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../node_modules/sass-loader/lib/loader.js!./CloseButton.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports


// module
exports.push([module.i, ".CloseButton__close-button___aYlNU{position:absolute;top:0;right:0;width:48px;height:48px;display:flex;align-items:center;justify-content:center;background-color:#fff;border:none;padding:0;font-size:32px;cursor:pointer;border-radius:10px;transition:all .1s ease-out;margin:8px}.CloseButton__close-button___aYlNU:hover{font-size:36px;opacity:.8}.CloseButton__close-button___aYlNU:active,.CloseButton__close-button___aYlNU:focus{outline:none}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game/modals/CloseButton.scss"],"names":[],"mappings":"AAAA,mCAAc,kBAAkB,MAAM,QAAQ,WAAW,YAAY,aAAa,mBAAmB,uBAAuB,sBAAuB,YAAY,UAAU,eAAe,eAAe,mBAAmB,4BAA6B,UAAU,CAAC,yCAAoB,eAAe,UAAW,CAAC,mFAAyC,YAAY,CAAC","file":"CloseButton.scss","sourcesContent":[".close-button{position:absolute;top:0;right:0;width:48px;height:48px;display:flex;align-items:center;justify-content:center;background-color:white;border:none;padding:0;font-size:32px;cursor:pointer;border-radius:10px;transition:all 0.1s ease-out;margin:8px}.close-button:hover{font-size:36px;opacity:0.8}.close-button:active,.close-button:focus{outline:none}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"close-button": "CloseButton__close-button___aYlNU",
	"closeButton": "CloseButton__close-button___aYlNU"
};

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(252);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../node_modules/sass-loader/lib/loader.js!./PowerSourceDetails.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../node_modules/sass-loader/lib/loader.js!./PowerSourceDetails.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports
exports.i(__webpack_require__(0), undefined);

// module
exports.push([module.i, ".PowerSourceDetails__content___D4E1_{display:flex;flex-direction:column;width:700px;max-height:90vh;overflow-y:auto}.PowerSourceDetails__image-and-stats___1zMH6{display:flex;flex:1;border-bottom:1px solid rgba(0,0,0,.1)}.PowerSourceDetails__image___3fZ2C{width:250px;height:150px;background-color:grey;background-repeat:no-repeat;background-size:cover;background-position:50%;border-top-left-radius:10px;overflow:hidden}.PowerSourceDetails__stats___2Quii{height:60%;padding:30px}.PowerSourceDetails__stats-title___2h7tR{font-size:28px;line-height:1.1em}.PowerSourceDetails__ui___30GCS{padding-top:10px;width:200px;margin:auto}.PowerSourceDetails__title-container___2KKuY{display:flex;flex-direction:column;padding:40px;justify-content:flex-end}.PowerSourceDetails__text___3Yu7n{padding:40px;box-sizing:border-box}.PowerSourceDetails__headline___1LMSR{font-size:36px;line-height:1.1em;margin:0;text-transform:capitalize}.PowerSourceDetails__headline___1LMSR:first-letter{text-transform:uppercase}.PowerSourceDetails__sub-headline___25AAL{font-size:28px;line-height:1.1em;margin:0}.PowerSourceDetails__body-copy___3TP24{margin-top:20px;white-space:pre-wrap}.PowerSourceDetails__fix-outage-button-disabled___14lQn{cursor:not-allowed;opacity:.5}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game/modals/power-source-details/PowerSourceDetails.scss"],"names":[],"mappings":"AAAA,qCAAS,aAAa,sBAAsB,YAAY,gBAAgB,eAAe,CAAC,6CAAiB,aAAa,OAAO,sCAAuC,CAAC,mCAAO,YAAY,aAAa,sBAAsB,4BAA4B,sBAAsB,wBAA2B,4BAA4B,eAAe,CAAC,mCAAO,WAAW,YAAY,CAAC,yCAAqE,eAAe,iBAAiB,CAAC,gCAAI,iBAAiB,YAAY,WAAW,CAAC,6CAAiB,aAAa,sBAAsB,aAAa,wBAAwB,CAAC,kCAAM,aAAa,qBAAqB,CAAC,sCAAkE,eAAe,kBAAkB,SAAS,yBAAyB,CAAC,mDAAuB,wBAAwB,CAAC,0CAAsE,eAAe,kBAAkB,QAAQ,CAAC,uCAAqE,gBAAgB,oBAAoB,CAAC,wDAA4B,mBAAmB,UAAW,CAAC","file":"PowerSourceDetails.scss","sourcesContent":[".content{display:flex;flex-direction:column;width:700px;max-height:90vh;overflow-y:auto}.image-and-stats{display:flex;flex:1;border-bottom:1px solid rgba(0,0,0,0.1)}.image{width:250px;height:150px;background-color:grey;background-repeat:no-repeat;background-size:cover;background-position:center;border-top-left-radius:10px;overflow:hidden}.stats{height:60%;padding:30px}.stats-title{composes:bold-font from '../../../../common/Fonts.scss';font-size:28px;line-height:1.1em}.ui{padding-top:10px;width:200px;margin:auto}.title-container{display:flex;flex-direction:column;padding:40px;justify-content:flex-end}.text{padding:40px;box-sizing:border-box}.headline{composes:bold-font from '../../../../common/Fonts.scss';font-size:36px;line-height:1.1em;margin:0;text-transform:capitalize}.headline:first-letter{text-transform:uppercase}.sub-headline{composes:bold-font from '../../../../common/Fonts.scss';font-size:28px;line-height:1.1em;margin:0}.body-copy{composes:medium-font from '../../../../common/Fonts.scss';margin-top:20px;white-space:pre-wrap}.fix-outage-button-disabled{cursor:not-allowed;opacity:0.5}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"content": "PowerSourceDetails__content___D4E1_",
	"image-and-stats": "PowerSourceDetails__image-and-stats___1zMH6",
	"imageAndStats": "PowerSourceDetails__image-and-stats___1zMH6",
	"image": "PowerSourceDetails__image___3fZ2C",
	"stats": "PowerSourceDetails__stats___2Quii",
	"stats-title": "PowerSourceDetails__stats-title___2h7tR " + __webpack_require__(0).locals["bold-font"] + "",
	"statsTitle": "PowerSourceDetails__stats-title___2h7tR " + __webpack_require__(0).locals["bold-font"] + "",
	"ui": "PowerSourceDetails__ui___30GCS",
	"title-container": "PowerSourceDetails__title-container___2KKuY",
	"titleContainer": "PowerSourceDetails__title-container___2KKuY",
	"text": "PowerSourceDetails__text___3Yu7n",
	"headline": "PowerSourceDetails__headline___1LMSR " + __webpack_require__(0).locals["bold-font"] + "",
	"sub-headline": "PowerSourceDetails__sub-headline___25AAL " + __webpack_require__(0).locals["bold-font"] + "",
	"subHeadline": "PowerSourceDetails__sub-headline___25AAL " + __webpack_require__(0).locals["bold-font"] + "",
	"body-copy": "PowerSourceDetails__body-copy___3TP24 " + __webpack_require__(0).locals["medium-font"] + "",
	"bodyCopy": "PowerSourceDetails__body-copy___3TP24 " + __webpack_require__(0).locals["medium-font"] + "",
	"fix-outage-button-disabled": "PowerSourceDetails__fix-outage-button-disabled___14lQn",
	"fixOutageButtonDisabled": "PowerSourceDetails__fix-outage-button-disabled___14lQn"
};

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(8), __webpack_require__(254), __webpack_require__(35), __webpack_require__(58), __webpack_require__(255)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("react-redux"), require("lodash"), require("../../../../../store/reducers/hint"), require("../../../../common/highlight-text/HighlightText"), require("../CloseButton"), require("./Hint.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.reactRedux, global.lodash, global.hint, global.HighlightText, global.CloseButton, global.Hint);
        global.Hint = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _reactRedux, _lodash, _hint, _HighlightText, _CloseButton) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    var _ = _interopRequireWildcard(_lodash);

    var _HighlightText2 = _interopRequireDefault(_HighlightText);

    var _CloseButton2 = _interopRequireDefault(_CloseButton);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./Hint.scss": {
            "hint-content": "Hint__hint-content___27Qj-",
            "text-column": "Hint__text-column___1-iOP",
            "headline": "Hint__headline___m11LT Fonts__bold-font___3iFek",
            "body-copy": "Hint__body-copy___hKR5t Fonts__medium-font___3yYd3",
            "image-column": "Hint__image-column___2cSRU",
            "image": "Hint__image___krdix",
            "hint-list": "Hint__hint-list___iEy6I",
            "hint-list-item": "Hint__hint-list-item___3eDhZ"
        }
    };

    var Hint = function (_super) {
        tslib_1.__extends(Hint, _super);
        function Hint(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.getHints = function () {
                var hint = _this.props.hint;
                var hints = hint.hints;
                return _.map(hints, function (hint, i) {
                    return React.createElement(
                        "li",
                        { key: i, className: (0, _getClassName3.default)('hint-list-item', _styleModuleImportMap)
                        },
                        React.createElement("i", { className: "fas fa-lightbulb" }),
                        React.createElement("span", { dangerouslySetInnerHTML: { __html: hint } })
                    );
                });
            };
            return _this;
        }
        Hint.prototype.render = function () {
            var hint = this.props.hint;
            if (!hint) return null;
            return React.createElement(
                "div",
                {
                    className: (0, _getClassName3.default)('hint-content', _styleModuleImportMap)
                },
                React.createElement(_CloseButton2.default, { onClose: this.props.onClose }),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('text-column', _styleModuleImportMap)
                    },
                    React.createElement(
                        _HighlightText2.default,
                        { type: 'blue' },
                        "hint"
                    ),
                    React.createElement(
                        "ul",
                        {
                            className: (0, _getClassName3.default)('hint-list', _styleModuleImportMap)
                        },
                        this.getHints()
                    )
                )
            );
        };
        return Hint;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state) {
        return {
            hint: (0, _hint.getHintData)(state)
        };
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {};
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Hint);
});

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(11), __webpack_require__(10), __webpack_require__(12)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("reselect"), require("../../data/data"), require("./year"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.reselect, global.data, global.year);
        global.hint = mod.exports;
    }
})(this, function (exports, _reselect, _data, _year) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getHintData = undefined;
    var getHintData = exports.getHintData = (0, _reselect.createSelector)([_year.getYearIndex], function (year_index) {
        var hints = (0, _data.getHints)();
        return hints[year_index];
    });
});

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(256);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../node_modules/sass-loader/lib/loader.js!./Hint.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../node_modules/sass-loader/lib/loader.js!./Hint.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports
exports.i(__webpack_require__(0), undefined);

// module
exports.push([module.i, ".Hint__hint-content___27Qj-{display:flex;flex-direction:row;align-items:stretch}.Hint__text-column___1-iOP{padding:40px}.Hint__headline___m11LT{font-size:24px;line-height:1.1em;margin:40px 0}.Hint__headline___m11LT:first-letter{text-transform:uppercase}.Hint__body-copy___hKR5t{margin:0}.Hint__image-column___2cSRU{position:relative;flex:1}.Hint__image___krdix{position:absolute;width:100%;height:100%;background-color:grey}.Hint__hint-list___iEy6I{margin:40px 0;padding:0}.Hint__hint-list-item___3eDhZ{margin:20px;list-style:none;display:flex;align-items:center}.Hint__hint-list-item___3eDhZ>:first-child{margin:20px 40px 20px 0}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game/modals/hint/Hint.scss"],"names":[],"mappings":"AAAA,4BAAc,aAAa,mBAAmB,mBAAmB,CAAC,2BAAa,YAAY,CAAC,wBAAkE,eAAe,kBAAkB,aAAa,CAAC,qCAAuB,wBAAwB,CAAC,yBAAqE,QAAQ,CAAC,4BAAc,kBAAkB,MAAM,CAAC,qBAAO,kBAAkB,WAAW,YAAY,qBAAqB,CAAC,yBAAW,cAAc,SAAS,CAAC,8BAAgB,YAAY,gBAAgB,aAAa,kBAAkB,CAAC,2CAA8B,uBAAuB,CAAC","file":"Hint.scss","sourcesContent":[".hint-content{display:flex;flex-direction:row;align-items:stretch}.text-column{padding:40px}.headline{composes:bold-font from '../../../../common/Fonts.scss';font-size:24px;line-height:1.1em;margin:40px 0}.headline:first-letter{text-transform:uppercase}.body-copy{composes:medium-font from '../../../../common/Fonts.scss';margin:0}.image-column{position:relative;flex:1}.image{position:absolute;width:100%;height:100%;background-color:grey}.hint-list{margin:40px 0;padding:0}.hint-list-item{margin:20px;list-style:none;display:flex;align-items:center}.hint-list-item>*:first-child{margin:20px 40px 20px 0}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"hint-content": "Hint__hint-content___27Qj-",
	"hintContent": "Hint__hint-content___27Qj-",
	"text-column": "Hint__text-column___1-iOP",
	"textColumn": "Hint__text-column___1-iOP",
	"headline": "Hint__headline___m11LT " + __webpack_require__(0).locals["bold-font"] + "",
	"body-copy": "Hint__body-copy___hKR5t " + __webpack_require__(0).locals["medium-font"] + "",
	"bodyCopy": "Hint__body-copy___hKR5t " + __webpack_require__(0).locals["medium-font"] + "",
	"image-column": "Hint__image-column___2cSRU",
	"imageColumn": "Hint__image-column___2cSRU",
	"image": "Hint__image___krdix",
	"hint-list": "Hint__hint-list___iEy6I",
	"hintList": "Hint__hint-list___iEy6I",
	"hint-list-item": "Hint__hint-list-item___3eDhZ",
	"hintListItem": "Hint__hint-list-item___3eDhZ"
};

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(8), __webpack_require__(85), __webpack_require__(99), __webpack_require__(56), __webpack_require__(18), __webpack_require__(103), __webpack_require__(35), __webpack_require__(100), __webpack_require__(19)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("react-redux"), require("lodash"), require("../../../../../store/reducers/questions/outageQuestion"), require("../../../../common/VoiceOver"), require("../../../../../store/actions/outages"), require("../../../../../store/actions/modals"), require("../../../../../store/reducers/outage"), require("../../../../common/highlight-text/HighlightText"), require("./Question.scss"), require("../../../../common/ui/button/Button"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.reactRedux, global.lodash, global.outageQuestion, global.VoiceOver, global.outages, global.modals, global.outage, global.HighlightText, global.Question, global.Button);
        global.OutageQuestion = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _reactRedux, _lodash, _outageQuestion, _VoiceOver, _outages, _modals, _outage, _HighlightText, _Question, _Button) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    var _ = _interopRequireWildcard(_lodash);

    var _HighlightText2 = _interopRequireDefault(_HighlightText);

    var styles = _interopRequireWildcard(_Question);

    var _Button2 = _interopRequireDefault(_Button);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "styles": {
            "question-content": "Question__question-content___16wOD",
            "header": "Question__header___3Diwg Colour__yellow___2xL7_",
            "label": "Question__label___3RXBf Fonts__bold-font___3iFek",
            "image": "Question__image___1l98D",
            "source-image": "Question__source-image___bjtf-",
            "warning-icon": "Question__warning-icon___11KA5",
            "question-and-answer": "Question__question-and-answer___3P-g_",
            "answer-content": "Question__answer-content___1cc90 Question__question-content___16wOD",
            "question-slide": "Question__question-slide___1-hML",
            "answer-slide": "Question__answer-slide___2sgdt",
            "warning": "Question__warning___2mz9c",
            "warning-text": "Question__warning-text___1U409",
            "warning-attention": "Question__warning-attention___3p3L3",
            "headline": "Question__headline___1B2M8 Fonts__bold-font___3iFek",
            "body-copy": "Question__body-copy___2elJd Fonts__medium-font___3yYd3",
            "options": "Question__options___1IRKh",
            "option": "Question__option___3m8J_ Fonts__bold-font___3iFek",
            "response": "Question__response___AIMbY",
            "answer-footer": "Question__answer-footer___b9kWU"
        }
    };

    var initial_state = {
        answer: null,
        answered: false,
        height: null
    };
    var OutageQuestion = function (_super) {
        tslib_1.__extends(OutageQuestion, _super);
        function OutageQuestion(props, state) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.state = state;
            _this.measureHeight = function (el, answered) {
                var _a = _this.state,
                    sanswered = _a.answered,
                    oheight = _a.height;
                if (sanswered !== answered) return;
                if (!el) return;
                var nheight = el.getBoundingClientRect().height;
                if (oheight !== nheight) _this.setState({ height: nheight });
            };
            _this.getOptions = function () {
                return _.map(_this.props.question.answers, function (answer, i) {
                    return React.createElement(
                        _VoiceOver.VoiceOver,
                        { vo: answer.vo, style_name: styles.option, onClick: function onClick() {
                                return _this.chooseAnswer(i);
                            }, key: i },
                        answer.text
                    );
                });
            };
            _this.chooseAnswer = function (answer) {
                _this.setState({ answer: answer, answered: true });
            };
            _this.clearOutage = function () {
                var _a = _this.props,
                    clearOutageID = _a.clearOutageID,
                    hideModal = _a.hideModal;
                clearOutageID();
                hideModal();
            };
            _this.state = initial_state;
            return _this;
        }
        OutageQuestion.prototype.render = function () {
            var _this = this;
            var _a = this.props,
                outage = _a.outage,
                question = _a.question,
                clearOutageID = _a.clearOutageID,
                hideModal = _a.hideModal;
            var _b = this.state,
                answer = _b.answer,
                answered = _b.answered,
                height = _b.height;
            if (!question) return null;
            var question_text = question.question,
                image = question.image,
                response = question.response;
            var affects = null;
            var is_correct = answer === this.props.question.answer;
            return React.createElement(
                "div",
                {
                    className: (0, _getClassName3.default)(!answered ? 'question-content' : 'answer-content', _styleModuleImportMap)
                },
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('header', _styleModuleImportMap)
                    },
                    React.createElement(
                        "div",
                        {
                            className: (0, _getClassName3.default)('image', _styleModuleImportMap)
                        },
                        React.createElement("img", { src: "./img/game/power-sources/" + affects + "@2x.png", className: (0, _getClassName3.default)('source-image', _styleModuleImportMap)
                        }),
                        React.createElement("img", { src: "./img/game/modals/warning-icon@2x.png", className: (0, _getClassName3.default)('warning-icon', _styleModuleImportMap)
                        })
                    )
                ),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('warning', _styleModuleImportMap)
                    },
                    React.createElement(
                        "p",
                        {
                            className: (0, _getClassName3.default)('warning-text', _styleModuleImportMap)
                        },
                        React.createElement(
                            "span",
                            {
                                className: (0, _getClassName3.default)('warning-attention', _styleModuleImportMap)
                            },
                            "attention action needed - "
                        ),
                        "Answer a questions to fix your power stations and bring them back online"
                    )
                ),
                React.createElement(
                    "div",
                    { style: { height: height }, className: (0, _getClassName3.default)('question-and-answer', _styleModuleImportMap)
                    },
                    React.createElement(
                        "div",
                        { ref: function ref(el) {
                                return _this.measureHeight(el, false);
                            }, className: (0, _getClassName3.default)('question-slide', _styleModuleImportMap)
                        },
                        React.createElement(
                            _HighlightText2.default,
                            { type: 'yellow' },
                            "question"
                        ),
                        React.createElement(
                            "h4",
                            {
                                className: (0, _getClassName3.default)('headline', _styleModuleImportMap)
                            },
                            question_text
                        ),
                        React.createElement(
                            "div",
                            {
                                className: (0, _getClassName3.default)('options', _styleModuleImportMap)
                            },
                            this.getOptions()
                        )
                    ),
                    React.createElement(
                        "div",
                        { ref: function ref(el) {
                                return _this.measureHeight(el, true);
                            }, className: (0, _getClassName3.default)('answer-slide', _styleModuleImportMap)
                        },
                        React.createElement(
                            _HighlightText2.default,
                            { type: 'yellow' },
                            is_correct ? 'well done!' : 'wrong answer!'
                        ),
                        React.createElement(
                            "h4",
                            {
                                className: (0, _getClassName3.default)('headline', _styleModuleImportMap)
                            },
                            question_text
                        ),
                        React.createElement(
                            "div",
                            {
                                className: (0, _getClassName3.default)('response', _styleModuleImportMap)
                            },
                            response
                        ),
                        React.createElement(
                            "div",
                            {
                                className: (0, _getClassName3.default)('answer-footer', _styleModuleImportMap)
                            },
                            is_correct && React.createElement(
                                _Button2.default,
                                { type: 'right-answer', onClick: this.clearOutage },
                                "good job!"
                            ),
                            !is_correct && React.createElement(
                                _Button2.default,
                                { type: 'wrong-answer', onClick: hideModal },
                                "oh no!"
                            )
                        )
                    )
                )
            );
        };
        return OutageQuestion;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state) {
        return {
            outage: (0, _outage.getOutageData)(state),
            question: (0, _outageQuestion.getOutageQuestionData)(state)
        };
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {
            clearOutageID: function clearOutageID() {
                return dispatch((0, _outages.clearOutageID)());
            },
            hideModal: function hideModal() {
                return dispatch((0, _modals.hideModal)());
            }
        };
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(OutageQuestion);
});

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(103), __webpack_require__(35), __webpack_require__(259)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("react-redux"), require("../../../../../store/reducers/outage"), require("../../../../common/highlight-text/HighlightText"), require("./Outage.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.reactRedux, global.outage, global.HighlightText, global.Outage);
        global.Outage = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _reactRedux, _outage, _HighlightText) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    var _HighlightText2 = _interopRequireDefault(_HighlightText);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./Outage.scss": {
            "outage-content": "Outage__outage-content___39_ZZ",
            "header": "Outage__header___2Dn1u Colour__yellow___2xL7_",
            "image": "Outage__image___11252",
            "source-image": "Outage__source-image___3t7KJ",
            "warning-icon": "Outage__warning-icon___WSYiG",
            "text-column": "Outage__text-column___30A_y",
            "headline": "Outage__headline___2-vGW Fonts__bold-font___3iFek",
            "body-copy": "Outage__body-copy___2emws Fonts__medium-font___3yYd3"
        }
    };

    var Outage = function (_super) {
        tslib_1.__extends(Outage, _super);
        function Outage(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            return _this;
        }
        Outage.prototype.render = function () {
            var outage = this.props.outage;
            var title = outage.title,
                affects = outage.affects,
                description = outage.description;
            return React.createElement(
                "div",
                {
                    className: (0, _getClassName3.default)('outage-content', _styleModuleImportMap)
                },
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('header', _styleModuleImportMap)
                    },
                    React.createElement(
                        "div",
                        {
                            className: (0, _getClassName3.default)('image', _styleModuleImportMap)
                        },
                        React.createElement("img", { src: "./img/game/power-sources/" + affects + "@2x.png", className: (0, _getClassName3.default)('source-image', _styleModuleImportMap)
                        })
                    )
                ),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('text-column', _styleModuleImportMap)
                    },
                    React.createElement(
                        _HighlightText2.default,
                        { type: 'yellow' },
                        "action needed"
                    ),
                    React.createElement(
                        "h4",
                        {
                            className: (0, _getClassName3.default)('headline', _styleModuleImportMap)
                        },
                        title
                    ),
                    React.createElement(
                        "p",
                        {
                            className: (0, _getClassName3.default)('body-copy', _styleModuleImportMap)
                        },
                        description
                    )
                )
            );
        };
        return Outage;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state) {
        return {
            outage: (0, _outage.getOutageData)(state)
        };
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {};
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Outage);
});

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(260);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../node_modules/sass-loader/lib/loader.js!./Outage.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../node_modules/sass-loader/lib/loader.js!./Outage.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports
exports.i(__webpack_require__(1), undefined);
exports.i(__webpack_require__(0), undefined);

// module
exports.push([module.i, ".Outage__outage-content___39_ZZ{text-align:center}.Outage__header___2Dn1u{height:30px;display:flex;justify-content:center;align-items:center;border-top-left-radius:10px;border-top-right-radius:10px;background:url(\"img/game/modals/warning-stripes@2x.png\");background-size:cover}.Outage__image___11252{position:relative;width:70px;height:auto}.Outage__source-image___3t7KJ{width:100%}.Outage__warning-icon___WSYiG{position:absolute;top:40%;left:50%;transform:translate(-50%,-50%);width:50%}.Outage__text-column___30A_y{padding:40px}.Outage__headline___2-vGW{font-size:36px;line-height:1.1em;margin:40px 0}.Outage__headline___2-vGW:first-letter{text-transform:uppercase}.Outage__body-copy___2emws{margin:0}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game/modals/outage/Outage.scss"],"names":[],"mappings":"AAAA,gCAAgB,iBAAiB,CAAC,wBAA8D,YAAY,aAAa,uBAAuB,mBAAmB,4BAA4B,6BAA6B,yDAAyD,qBAAqB,CAAC,uBAAO,kBAAkB,WAAW,WAAW,CAAC,8BAAc,UAAU,CAAC,8BAAc,kBAAkB,QAAQ,SAAS,+BAAgC,SAAS,CAAC,6BAAa,YAAY,CAAC,0BAAkE,eAAe,kBAAkB,aAAa,CAAC,uCAAuB,wBAAwB,CAAC,2BAAqE,QAAQ,CAAC","file":"Outage.scss","sourcesContent":[".outage-content{text-align:center}.header{composes:yellow from '../../../../common/Colour.scss';height:30px;display:flex;justify-content:center;align-items:center;border-top-left-radius:10px;border-top-right-radius:10px;background:url(\"img/game/modals/warning-stripes@2x.png\");background-size:cover}.image{position:relative;width:70px;height:auto}.source-image{width:100%}.warning-icon{position:absolute;top:40%;left:50%;transform:translate(-50%, -50%);width:50%}.text-column{padding:40px}.headline{composes:bold-font from '../../../../common/Fonts.scss';font-size:36px;line-height:1.1em;margin:40px 0}.headline:first-letter{text-transform:uppercase}.body-copy{composes:medium-font from '../../../../common/Fonts.scss';margin:0}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"outage-content": "Outage__outage-content___39_ZZ",
	"outageContent": "Outage__outage-content___39_ZZ",
	"header": "Outage__header___2Dn1u " + __webpack_require__(1).locals["yellow"] + "",
	"image": "Outage__image___11252",
	"source-image": "Outage__source-image___3t7KJ",
	"sourceImage": "Outage__source-image___3t7KJ",
	"warning-icon": "Outage__warning-icon___WSYiG",
	"warningIcon": "Outage__warning-icon___WSYiG",
	"text-column": "Outage__text-column___30A_y",
	"textColumn": "Outage__text-column___30A_y",
	"headline": "Outage__headline___2-vGW " + __webpack_require__(0).locals["bold-font"] + "",
	"body-copy": "Outage__body-copy___2emws " + __webpack_require__(0).locals["medium-font"] + "",
	"bodyCopy": "Outage__body-copy___2emws " + __webpack_require__(0).locals["medium-font"] + ""
};

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(262)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("tslib"), require("react"), require("react-redux"), require("./TimerStart.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.tslib, global.react, global.reactRedux, global.TimerStart);
        global.TimerStart = mod.exports;
    }
})(this, function (exports, _tslib, _react, _reactRedux) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    var TimerStart = function (_super) {
        tslib_1.__extends(TimerStart, _super);
        function TimerStart(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            return _this;
        }
        TimerStart.prototype.render = function () {
            return React.createElement(
                "span",
                null,
                React.createElement(
                    "h3",
                    null,
                    "timer is starting!"
                )
            );
        };
        return TimerStart;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state) {
        return {};
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {};
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TimerStart);
});

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(263);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../node_modules/sass-loader/lib/loader.js!./TimerStart.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../node_modules/sass-loader/lib/loader.js!./TimerStart.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"TimerStart.scss","sourceRoot":""}]);

// exports


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(8), __webpack_require__(53), __webpack_require__(279), __webpack_require__(265), __webpack_require__(268), __webpack_require__(274), __webpack_require__(12), __webpack_require__(18), __webpack_require__(17), __webpack_require__(277)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("react-redux"), require("lodash"), require("../../../../store/reducers/results"), require("../../../../store/actions/results"), require("./carbon-metre/CarbonMetre"), require("./outputs/EnergyOutput"), require("./carbon-metre/CarbonMetreHint"), require("../../../../store/reducers/year"), require("../../../../store/actions/modals"), require("../../../../store/reducers/modal"), require("./GameUi.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.reactRedux, global.lodash, global.results, global.results, global.CarbonMetre, global.EnergyOutput, global.CarbonMetreHint, global.year, global.modals, global.modal, global.GameUi);
        global.GameUi = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _reactRedux, _lodash, _results, _results2, _CarbonMetre, _EnergyOutput, _CarbonMetreHint, _year, _modals, _modal) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    var _ = _interopRequireWildcard(_lodash);

    var _CarbonMetre2 = _interopRequireDefault(_CarbonMetre);

    var _EnergyOutput2 = _interopRequireDefault(_EnergyOutput);

    var _CarbonMetreHint2 = _interopRequireDefault(_CarbonMetreHint);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./GameUi.scss": {
            "background": "GameUi__background___1mktj",
            "game-ui": "GameUi__game-ui___3SGiy",
            "scenario-reminder": "GameUi__scenario-reminder____mVaa Fonts__bold-font___3iFek",
            "reminder-text": "GameUi__reminder-text___1JWNi",
            "edf-logo": "GameUi__edf-logo___2D-mW",
            "second-row": "GameUi__second-row___3KRlo"
        }
    };

    var GameUi = function (_super) {
        tslib_1.__extends(GameUi, _super);
        function GameUi(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.togglePanel = function () {
                var _a = _this.props,
                    is_open = _a.is_open,
                    openResultsPanel = _a.openResultsPanel,
                    closeResultsPanel = _a.closeResultsPanel;
                is_open ? closeResultsPanel() : openResultsPanel();
            };
            _this.getContainerBottom = function () {
                var is_open = _this.props.is_open;
                if (!_this.summary_el || !_this.detail_el) return '0';
                if (is_open) return '10%';
                var summary_height = _this.summary_el.getBoundingClientRect().height;
                var detail_height = _this.detail_el.getBoundingClientRect().height;
                return detail_height * -1 + 'px';
            };
            _this.showPanel = function () {
                var _a = _this.props,
                    resetResultsPanel = _a.resetResultsPanel,
                    closeResultsPanel = _a.closeResultsPanel;
                resetResultsPanel();
                _.delay(closeResultsPanel, 1000);
            };
            return _this;
        }
        GameUi.prototype.componentDidUpdate = function (prev_props) {};
        GameUi.prototype.render = function () {
            var _a = this.props,
                is_open = _a.is_open,
                year = _a.year,
                showYearInfo = _a.showYearInfo;
            return React.createElement(
                React.Fragment,
                null,
                React.createElement("div", { style: { opacity: is_open ? 1 : 0 }, className: (0, _getClassName3.default)('background', _styleModuleImportMap)
                }),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('game-ui', _styleModuleImportMap)
                    },
                    React.createElement(
                        "div",
                        { onClick: showYearInfo, className: (0, _getClassName3.default)('scenario-reminder', _styleModuleImportMap)
                        },
                        React.createElement(
                            "div",
                            {
                                className: (0, _getClassName3.default)('edf-logo', _styleModuleImportMap)
                            },
                            React.createElement("img", { src: 'img/edf-logo.jpg' })
                        ),
                        React.createElement(
                            "div",
                            {
                                className: (0, _getClassName3.default)('reminder-text', _styleModuleImportMap)
                            },
                            year.reminder
                        )
                    ),
                    React.createElement(
                        "div",
                        null,
                        React.createElement(_CarbonMetre2.default, null)
                    ),
                    React.createElement(
                        "div",
                        {
                            className: (0, _getClassName3.default)('second-row', _styleModuleImportMap)
                        },
                        React.createElement(_EnergyOutput2.default, null),
                        React.createElement(_CarbonMetreHint2.default, null)
                    )
                )
            );
        };
        return GameUi;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state) {
        return {
            is_open: (0, _results.isResultsPanelOpen)(state),
            year: (0, _year.getYearData)(state)
        };
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {
            openResultsPanel: function openResultsPanel() {
                return dispatch((0, _results2.openResultsPanel)());
            },
            closeResultsPanel: function closeResultsPanel() {
                return dispatch((0, _results2.closeResultsPanel)());
            },
            resetResultsPanel: function resetResultsPanel() {
                return dispatch((0, _results2.resetResultsPanel)());
            },
            showYearInfo: function showYearInfo() {
                return dispatch((0, _modals.showModal)(_modal.MODALS.YEAR));
            }
        };
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GameUi);
});

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(32), __webpack_require__(13), __webpack_require__(104), __webpack_require__(266)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("react-redux"), require("../../../../../store/reducers/outputs/carbonOutput"), require("../../../../../store/reducers/powerSources"), require("chroma-js"), require("./CarbonMetre.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.reactRedux, global.carbonOutput, global.powerSources, global.chromaJs, global.CarbonMetre);
        global.CarbonMetre = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _reactRedux, _carbonOutput, _powerSources, _chromaJs) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./CarbonMetre.scss": {
            "carbon-metre": "CarbonMetre__carbon-metre___3rtcw",
            "metre-label": "CarbonMetre__metre-label___2Jdmw Fonts__calculator-font___2Vr8r",
            "metre": "CarbonMetre__metre___2KOE0",
            "end-label": "CarbonMetre__end-label___f85dD Fonts__calculator-font___2Vr8r",
            "metre-measure": "CarbonMetre__metre-measure___10YMb",
            "metre-value": "CarbonMetre__metre-value___C3Svs",
            "metre-value-indicator": "CarbonMetre__metre-value-indicator___Hi7BT Fonts__calculator-font___2Vr8r",
            "target-marker": "CarbonMetre__target-marker___1Ol7m"
        }
    };

    var CarbonMetre = function (_super) {
        tslib_1.__extends(CarbonMetre, _super);
        function CarbonMetre(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.getOutputColour = function () {
                var carbon_output_percentage = _this.props.carbon_output_percentage;
                var colour_scale = (0, _chromaJs.scale)(['#ff0000', '#fcb425', '#fff600', '#7bd125', '#6ee524', '#60ff11']);
                return colour_scale(carbon_output_percentage * 0.01).hex();
            };
            return _this;
        }
        CarbonMetre.prototype.render = function () {
            var carbon_output_percentage = this.props.carbon_output_percentage;
            var value_width = carbon_output_percentage + "%";
            var value_colour = this.getOutputColour();
            return React.createElement(
                "div",
                {
                    className: (0, _getClassName3.default)('carbon-metre', _styleModuleImportMap)
                },
                React.createElement(
                    "span",
                    {
                        className: (0, _getClassName3.default)('metre-label', _styleModuleImportMap)
                    },
                    "low carbon generation"
                ),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('metre', _styleModuleImportMap)
                    },
                    React.createElement(
                        "span",
                        {
                            className: (0, _getClassName3.default)('end-label', _styleModuleImportMap)
                        },
                        "0%"
                    ),
                    React.createElement(
                        "div",
                        {
                            className: (0, _getClassName3.default)('metre-measure', _styleModuleImportMap)
                        },
                        React.createElement("div", { style: { width: value_width, backgroundColor: value_colour }, className: (0, _getClassName3.default)('metre-value', _styleModuleImportMap)
                        }),
                        React.createElement(
                            "div",
                            { style: { left: value_width }, className: (0, _getClassName3.default)('metre-value-indicator', _styleModuleImportMap)
                            },
                            value_width
                        ),
                        React.createElement("div", {
                            className: (0, _getClassName3.default)('target-marker', _styleModuleImportMap)
                        })
                    ),
                    React.createElement(
                        "span",
                        {
                            className: (0, _getClassName3.default)('end-label', _styleModuleImportMap)
                        },
                        "100%"
                    )
                )
            );
        };
        return CarbonMetre;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state, props) {
        return {
            power_source_count: (0, _powerSources.countPowerSources)(state),
            carbon_output_percentage: (0, _carbonOutput.getCarbonOutputPercentage)(state),
            carbon_target: (0, _carbonOutput.getCarbonOutputTarget)(state)
        };
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {};
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CarbonMetre);
});

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(267);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../node_modules/sass-loader/lib/loader.js!./CarbonMetre.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../node_modules/sass-loader/lib/loader.js!./CarbonMetre.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports
exports.i(__webpack_require__(0), undefined);

// module
exports.push([module.i, ".CarbonMetre__carbon-metre___3rtcw{display:flex;background-color:#000;color:#fff;align-items:center;height:50px;border-radius:10px}.CarbonMetre__metre-label___2Jdmw{padding:10px 20px;font-size:32px;letter-spacing:2px;text-transform:uppercase}.CarbonMetre__metre___2KOE0{display:flex;align-items:center;flex:1;height:calc(100% - 10px);margin-right:5px;background-color:#fff;border-radius:5px;color:#000}.CarbonMetre__end-label___f85dD{padding:10px 20px;font-size:32px}.CarbonMetre__metre-measure___10YMb{position:relative;flex:1;height:100%;background-color:#a9a9a9}.CarbonMetre__metre-value___C3Svs{position:absolute;top:0;left:0;height:100%;width:40%;transition:all .75s ease-in-out}.CarbonMetre__metre-value-indicator___Hi7BT{position:absolute;bottom:100%;left:50%;transform:translate(-50%);background-color:#000;padding:10px;border-radius:10px;color:#fff;font-size:32px;transition:all .75s ease-in-out}.CarbonMetre__target-marker___1Ol7m{position:absolute;top:90%;left:85%;width:0;height:0;border-left:25px solid transparent;border-right:25px solid transparent;border-bottom:25px solid #246ab6}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game/game-ui/carbon-metre/CarbonMetre.scss"],"names":[],"mappings":"AAAA,mCAAc,aAAa,sBAAuB,WAAY,mBAAmB,YAAY,kBAAkB,CAAC,kCAA2E,kBAAkB,eAAe,mBAAmB,wBAAwB,CAAC,4BAAO,aAAa,mBAAmB,OAAO,yBAAyB,iBAAiB,sBAAuB,kBAAkB,UAAW,CAAC,gCAAyE,kBAAkB,cAAc,CAAC,oCAAe,kBAAkB,OAAO,YAAY,wBAAyB,CAAC,kCAAa,kBAAkB,MAAM,OAAO,YAAY,UAAU,+BAAgC,CAAC,4CAAqF,kBAAkB,YAAY,SAAS,0BAA6B,sBAAuB,aAAa,mBAAmB,WAAY,eAAe,+BAAgC,CAAC,oCAAe,kBAAkB,QAAQ,SAAS,QAAU,SAAW,mCAAmC,oCAAoC,gCAAgC,CAAC","file":"CarbonMetre.scss","sourcesContent":[".carbon-metre{display:flex;background-color:black;color:white;align-items:center;height:50px;border-radius:10px}.metre-label{composes:calculator-font from '../../../../common/Fonts.scss';padding:10px 20px;font-size:32px;letter-spacing:2px;text-transform:uppercase}.metre{display:flex;align-items:center;flex:1;height:calc(100% - 10px);margin-right:5px;background-color:white;border-radius:5px;color:black}.end-label{composes:calculator-font from '../../../../common/Fonts.scss';padding:10px 20px;font-size:32px}.metre-measure{position:relative;flex:1;height:100%;background-color:darkgrey}.metre-value{position:absolute;top:0;left:0;height:100%;width:40%;transition:all 750ms ease-in-out}.metre-value-indicator{composes:calculator-font from '../../../../common/Fonts.scss';position:absolute;bottom:100%;left:50%;transform:translate(-50%, 0);background-color:black;padding:10px;border-radius:10px;color:white;font-size:32px;transition:all 750ms ease-in-out}.target-marker{position:absolute;top:90%;left:85%;width:0px;height:0px;border-left:25px solid transparent;border-right:25px solid transparent;border-bottom:25px solid #246AB6}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"carbon-metre": "CarbonMetre__carbon-metre___3rtcw",
	"carbonMetre": "CarbonMetre__carbon-metre___3rtcw",
	"metre-label": "CarbonMetre__metre-label___2Jdmw " + __webpack_require__(0).locals["calculator-font"] + "",
	"metreLabel": "CarbonMetre__metre-label___2Jdmw " + __webpack_require__(0).locals["calculator-font"] + "",
	"metre": "CarbonMetre__metre___2KOE0",
	"end-label": "CarbonMetre__end-label___f85dD " + __webpack_require__(0).locals["calculator-font"] + "",
	"endLabel": "CarbonMetre__end-label___f85dD " + __webpack_require__(0).locals["calculator-font"] + "",
	"metre-measure": "CarbonMetre__metre-measure___10YMb",
	"metreMeasure": "CarbonMetre__metre-measure___10YMb",
	"metre-value": "CarbonMetre__metre-value___C3Svs",
	"metreValue": "CarbonMetre__metre-value___C3Svs",
	"metre-value-indicator": "CarbonMetre__metre-value-indicator___Hi7BT " + __webpack_require__(0).locals["calculator-font"] + "",
	"metreValueIndicator": "CarbonMetre__metre-value-indicator___Hi7BT " + __webpack_require__(0).locals["calculator-font"] + "",
	"target-marker": "CarbonMetre__target-marker___1Ol7m",
	"targetMarker": "CarbonMetre__target-marker___1Ol7m"
};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(104), __webpack_require__(29), __webpack_require__(269), __webpack_require__(52), __webpack_require__(272)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("react-redux"), require("chroma-js"), require("../../../../../store/reducers/outputs/energyOutput"), require("./output-tooltip/OutputTooltip"), require("../../../../../store/reducers/energy/energyDemand"), require("./EnergyOutput.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.reactRedux, global.chromaJs, global.energyOutput, global.OutputTooltip, global.energyDemand, global.EnergyOutput);
        global.EnergyOutput = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _reactRedux, _chromaJs, _energyOutput, _OutputTooltip, _energyDemand) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    var _OutputTooltip2 = _interopRequireDefault(_OutputTooltip);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./EnergyOutput.scss": {
            "numeric-metre": "EnergyOutput__numeric-metre___2nzKq",
            "green": "EnergyOutput__green___2NCaN",
            "grey": "EnergyOutput__grey___3mwa-",
            "readout": "EnergyOutput__readout___21pSA",
            "output-label": "EnergyOutput__output-label___1fv4T Fonts__bold-font___3iFek",
            "demand-output-label": "EnergyOutput__demand-output-label___3KlL8 EnergyOutput__output-label___1fv4T Fonts__bold-font___3iFek",
            "output-value": "EnergyOutput__output-value___30DTL Fonts__bold-font___3iFek",
            "output-units": "EnergyOutput__output-units___R-i4Q Fonts__medium-font___3yYd3",
            "output-divider": "EnergyOutput__output-divider___2JzId Fonts__light-font___3KKc6"
        }
    };

    var initial_state = { hover: false };
    var EnergyOutput = function (_super) {
        tslib_1.__extends(EnergyOutput, _super);
        function EnergyOutput(props, state) {
            if (state === void 0) {
                state = initial_state;
            }
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.state = state;
            _this.getOutputText = function () {
                var _a = _this.props.energy_output_ratio,
                    pc = _a === void 0 ? 0 : _a;
                var ratio = pc * 100;
                if (ratio < 5) return 'not enough power';
                if (ratio < 15) return 'too low';
                if (ratio < 25) return 'ok';
                if (ratio < 35) return 'good';
                if (ratio < 45) return 'great';
                if (ratio < 55) return 'excellent';
                if (ratio < 65) return 'great';
                if (ratio < 75) return 'good';
                if (ratio < 88) return 'too much';
                if (ratio < 95) return 'wasting power';
                return 'really wasteful';
            };
            _this.getOutputColour = function () {
                var _a = _this.props.energy_output_ratio,
                    pc = _a === void 0 ? 0 : _a;
                var colour_scale = (0, _chromaJs.scale)(['#ff0000', '#fff600', '#25cc00', '#fff600', '#ff0000']);
                return colour_scale(pc).hex();
            };
            _this.onMouseEnter = function () {
                var hover = _this.state.hover;
                if (hover) return;
                _this.setState({ hover: true });
            };
            _this.onMouseLeave = function () {
                var hover = _this.state.hover;
                if (!hover) return;
                _this.setState({ hover: false });
            };
            return _this;
        }
        EnergyOutput.prototype.render = function () {
            var _a = this.props,
                energy_output = _a.energy_output,
                energy_demand = _a.energy_demand;
            var hover = this.state.hover;
            var colour = this.getOutputColour();
            return React.createElement(
                "div",
                { onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave, className: (0, _getClassName3.default)('numeric-metre', _styleModuleImportMap)
                },
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('readout', _styleModuleImportMap)
                    },
                    React.createElement(
                        "div",
                        { style: { color: this.getOutputColour() }, className: (0, _getClassName3.default)('output-label green', _styleModuleImportMap)
                        },
                        "power output"
                    ),
                    React.createElement(
                        "div",
                        { style: { color: this.getOutputColour() }, className: (0, _getClassName3.default)('output-value green', _styleModuleImportMap)
                        },
                        energy_output,
                        " ",
                        React.createElement(
                            "span",
                            {
                                className: (0, _getClassName3.default)('output-units', _styleModuleImportMap)
                            },
                            "tera watts hrs"
                        )
                    ),
                    React.createElement(
                        "span",
                        {
                            className: (0, _getClassName3.default)('output-divider grey', _styleModuleImportMap)
                        },
                        "/"
                    ),
                    React.createElement(
                        "div",
                        {
                            className: (0, _getClassName3.default)('output-value grey', _styleModuleImportMap)
                        },
                        energy_demand,
                        " ",
                        React.createElement(
                            "span",
                            {
                                className: (0, _getClassName3.default)('output-units', _styleModuleImportMap)
                            },
                            "tera watts hrs"
                        )
                    ),
                    React.createElement(
                        "div",
                        {
                            className: (0, _getClassName3.default)('demand-output-label', _styleModuleImportMap)
                        },
                        "power needed"
                    )
                ),
                React.createElement(
                    _OutputTooltip2.default,
                    { visible: hover, title: 'Energy Output' },
                    "This is how much energy your power plants are producing. Try to get as close to the target as possible - too much or too little is bad!"
                )
            );
        };
        return EnergyOutput;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state) {
        return {
            energy_demand: (0, _energyDemand.getEnergyDemand)(state),
            energy_output: (0, _energyOutput.getEnergyOutput)(state),
            energy_output_ratio: (0, _energyOutput.getEnergyOutputRatio)(state)
        };
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {};
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EnergyOutput);
});

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(270)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("./OutputTooltip.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.OutputTooltip);
        global.OutputTooltip = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./OutputTooltip.scss": {
            "output-tooltip": "OutputTooltip__output-tooltip___3IVPe",
            "hidden": "OutputTooltip__hidden___1NWiw OutputTooltip__output-tooltip___3IVPe",
            "visible": "OutputTooltip__visible___3W6eP OutputTooltip__output-tooltip___3IVPe",
            "title": "OutputTooltip__title___25gv1",
            "text": "OutputTooltip__text___HN8u4"
        }
    };

    var OutputTooltip = function (_super) {
        tslib_1.__extends(OutputTooltip, _super);
        function OutputTooltip(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            return _this;
        }
        OutputTooltip.prototype.render = function () {
            var _a = this.props,
                children = _a.children,
                title = _a.title,
                visible = _a.visible;
            return React.createElement(
                "div",
                {
                    className: (0, _getClassName3.default)(visible ? 'visible' : 'hidden', _styleModuleImportMap)
                },
                React.createElement(
                    "h4",
                    {
                        className: (0, _getClassName3.default)('title', _styleModuleImportMap)
                    },
                    title
                ),
                React.createElement(
                    "p",
                    {
                        className: (0, _getClassName3.default)('text', _styleModuleImportMap)
                    },
                    children
                )
            );
        };
        return OutputTooltip;
    }(React.Component);
    exports.default = OutputTooltip;
});

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(271);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../../node_modules/sass-loader/lib/loader.js!./OutputTooltip.scss", function() {
			var newContent = require("!!../../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../../node_modules/sass-loader/lib/loader.js!./OutputTooltip.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports


// module
exports.push([module.i, ".OutputTooltip__output-tooltip___3IVPe{position:absolute;left:50%;transform:translate(-50%);min-width:90%;pointer-events:none;transition:all .2s ease-in-out;padding:20px;box-sizing:border-box;background-color:#fff;border-radius:10px;box-shadow:0 5px 10px rgba(0,0,0,.2)}.OutputTooltip__hidden___1NWiw{bottom:80%;opacity:0;visibility:hidden}.OutputTooltip__visible___3W6eP{bottom:90%;opacity:1}.OutputTooltip__title___25gv1{margin:0 0 10px}.OutputTooltip__text___HN8u4{margin:0}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game/game-ui/outputs/output-tooltip/OutputTooltip.scss"],"names":[],"mappings":"AAAA,uCAAgB,kBAAkB,SAAS,0BAA6B,cAAc,oBAAoB,+BAAgC,aAAa,sBAAsB,sBAAuB,mBAAmB,oCAAqC,CAAC,+BAAgC,WAAW,UAAU,iBAAiB,CAAC,gCAAiC,WAAW,SAAS,CAAC,8BAAO,eAAiB,CAAC,6BAAM,QAAQ,CAAC","file":"OutputTooltip.scss","sourcesContent":[".output-tooltip{position:absolute;left:50%;transform:translate(-50%, 0);min-width:90%;pointer-events:none;transition:all 0.2s ease-in-out;padding:20px;box-sizing:border-box;background-color:white;border-radius:10px;box-shadow:0 5px 10px rgba(0,0,0,0.2)}.hidden{composes:output-tooltip;bottom:80%;opacity:0;visibility:hidden}.visible{composes:output-tooltip;bottom:90%;opacity:1}.title{margin:0 0 10px 0}.text{margin:0}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"output-tooltip": "OutputTooltip__output-tooltip___3IVPe",
	"outputTooltip": "OutputTooltip__output-tooltip___3IVPe",
	"hidden": "OutputTooltip__hidden___1NWiw OutputTooltip__output-tooltip___3IVPe",
	"visible": "OutputTooltip__visible___3W6eP OutputTooltip__output-tooltip___3IVPe",
	"title": "OutputTooltip__title___25gv1",
	"text": "OutputTooltip__text___HN8u4"
};

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(273);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../node_modules/sass-loader/lib/loader.js!./EnergyOutput.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../node_modules/sass-loader/lib/loader.js!./EnergyOutput.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports
exports.i(__webpack_require__(0), undefined);

// module
exports.push([module.i, ".EnergyOutput__numeric-metre___2nzKq{position:relative;display:flex;flex:1;border-right:1px solid #cfcfcf;border-top:1px solid #cfcfcf;padding:2%;justify-content:center;align-items:center}.EnergyOutput__green___2NCaN{color:#396518;text-align:right}.EnergyOutput__grey___3mwa-{color:#aaa}.EnergyOutput__readout___21pSA{display:flex}.EnergyOutput__output-label___1fv4T{font-size:20px;line-height:.8em}.EnergyOutput__demand-output-label___3KlL8{color:#aaa;margin-left:10px}.EnergyOutput__output-value___30DTL{display:flex;flex-direction:column;font-size:48px;text-align:right;min-width:100px;line-height:.8em}.EnergyOutput__output-units___R-i4Q{text-transform:uppercase;font-size:12px;line-height:24px}.EnergyOutput__output-divider___2JzId{margin:0 0 0 15px;font-size:73px;line-height:.8}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game/game-ui/outputs/EnergyOutput.scss"],"names":[],"mappings":"AAAA,qCAAe,kBAAkB,aAAa,OAAO,+BAA+B,6BAA6B,WAAW,uBAAuB,kBAAkB,CAAC,6BAAO,cAAc,gBAAgB,CAAC,4BAAM,UAAa,CAAC,+BAAS,YAAY,CAAC,oCAAsE,eAAe,gBAAiB,CAAC,2CAA2C,WAAc,gBAAgB,CAAC,oCAAsE,aAAa,sBAAsB,eAAe,iBAAiB,gBAAgB,gBAAiB,CAAC,oCAAwE,yBAAyB,eAAe,gBAAgB,CAAC,sCAAyE,kBAAkB,eAAe,cAAe,CAAC","file":"EnergyOutput.scss","sourcesContent":[".numeric-metre{position:relative;display:flex;flex:1;border-right:1px solid #CFCFCF;border-top:1px solid #CFCFCF;padding:2%;justify-content:center;align-items:center}.green{color:#396518;text-align:right}.grey{color:#aaaaaa}.readout{display:flex}.output-label{composes:bold-font from '../../../../common/Fonts.scss';font-size:20px;line-height:0.8em}.demand-output-label{composes:output-label;color:#aaaaaa;margin-left:10px}.output-value{composes:bold-font from '../../../../common/Fonts.scss';display:flex;flex-direction:column;font-size:48px;text-align:right;min-width:100px;line-height:0.8em}.output-units{composes:medium-font from '../../../../common/Fonts.scss';text-transform:uppercase;font-size:12px;line-height:24px}.output-divider{composes:light-font from '../../../../common/Fonts.scss';margin:0 0 0 15px;font-size:73px;line-height:0.8}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"numeric-metre": "EnergyOutput__numeric-metre___2nzKq",
	"numericMetre": "EnergyOutput__numeric-metre___2nzKq",
	"green": "EnergyOutput__green___2NCaN",
	"grey": "EnergyOutput__grey___3mwa-",
	"readout": "EnergyOutput__readout___21pSA",
	"output-label": "EnergyOutput__output-label___1fv4T " + __webpack_require__(0).locals["bold-font"] + "",
	"outputLabel": "EnergyOutput__output-label___1fv4T " + __webpack_require__(0).locals["bold-font"] + "",
	"demand-output-label": "EnergyOutput__demand-output-label___3KlL8 EnergyOutput__output-label___1fv4T " + __webpack_require__(0).locals["bold-font"] + "",
	"demandOutputLabel": "EnergyOutput__demand-output-label___3KlL8 EnergyOutput__output-label___1fv4T " + __webpack_require__(0).locals["bold-font"] + "",
	"output-value": "EnergyOutput__output-value___30DTL " + __webpack_require__(0).locals["bold-font"] + "",
	"outputValue": "EnergyOutput__output-value___30DTL " + __webpack_require__(0).locals["bold-font"] + "",
	"output-units": "EnergyOutput__output-units___R-i4Q " + __webpack_require__(0).locals["medium-font"] + "",
	"outputUnits": "EnergyOutput__output-units___R-i4Q " + __webpack_require__(0).locals["medium-font"] + "",
	"output-divider": "EnergyOutput__output-divider___2JzId " + __webpack_require__(0).locals["light-font"] + "",
	"outputDivider": "EnergyOutput__output-divider___2JzId " + __webpack_require__(0).locals["light-font"] + ""
};

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(32), __webpack_require__(275)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("react-redux"), require("../../../../../store/reducers/outputs/carbonOutput"), require("./CarbonMetreHint.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.reactRedux, global.carbonOutput, global.CarbonMetreHint);
        global.CarbonMetreHint = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _reactRedux, _carbonOutput) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./CarbonMetreHint.scss": {
            "carbon-metre-hint": "CarbonMetreHint__carbon-metre-hint___1_tD9",
            "hint": "CarbonMetreHint__hint___H9rfq Colour__blue___3JCwq Fonts__bold-font___3iFek"
        }
    };

    var CarbonMetreHint = function (_super) {
        tslib_1.__extends(CarbonMetreHint, _super);
        function CarbonMetreHint(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            return _this;
        }
        CarbonMetreHint.prototype.render = function () {
            return React.createElement(
                "div",
                {
                    className: (0, _getClassName3.default)('carbon-metre-hint', _styleModuleImportMap)
                },
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('hint', _styleModuleImportMap)
                    },
                    React.createElement(
                        "p",
                        null,
                        "82% - 87% off your power should be generated from low-carbon sources by 2032"
                    )
                )
            );
        };
        return CarbonMetreHint;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state, props) {
        return {
            carbon_output: (0, _carbonOutput.getCarbonOutput)(state),
            carbon_target: (0, _carbonOutput.getCarbonOutputTarget)(state)
        };
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {};
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CarbonMetreHint);
});

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(276);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../node_modules/sass-loader/lib/loader.js!./CarbonMetreHint.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../node_modules/sass-loader/lib/loader.js!./CarbonMetreHint.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports
exports.i(__webpack_require__(1), undefined);
exports.i(__webpack_require__(0), undefined);

// module
exports.push([module.i, ".CarbonMetreHint__carbon-metre-hint___1_tD9{display:flex;align-items:center;width:50%;padding:10px 30px}.CarbonMetreHint__hint___H9rfq{color:#fff;padding:15px 30px;border-radius:10px;font-size:20px}.CarbonMetreHint__hint___H9rfq>*{margin:0}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game/game-ui/carbon-metre/CarbonMetreHint.scss"],"names":[],"mappings":"AAAA,4CAAmB,aAAa,mBAAmB,UAAU,iBAAiB,CAAC,+BAAkH,WAAY,kBAAkB,mBAAmB,cAAc,CAAC,iCAAQ,QAAQ,CAAC","file":"CarbonMetreHint.scss","sourcesContent":[".carbon-metre-hint{display:flex;align-items:center;width:50%;padding:10px 30px}.hint{composes:blue from '../../../../common/Colour.scss';composes:bold-font from '../../../../common/Fonts.scss';color:white;padding:15px 30px;border-radius:10px;font-size:20px}.hint>*{margin:0}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"carbon-metre-hint": "CarbonMetreHint__carbon-metre-hint___1_tD9",
	"carbonMetreHint": "CarbonMetreHint__carbon-metre-hint___1_tD9",
	"hint": "CarbonMetreHint__hint___H9rfq " + __webpack_require__(1).locals["blue"] + " " + __webpack_require__(0).locals["bold-font"] + ""
};

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(278);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../node_modules/sass-loader/lib/loader.js!./GameUi.scss", function() {
			var newContent = require("!!../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../node_modules/sass-loader/lib/loader.js!./GameUi.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports
exports.i(__webpack_require__(0), undefined);

// module
exports.push([module.i, ".GameUi__game-ui___3SGiy{position:absolute;bottom:0;left:50%;transform:translate(-50%);display:flex;flex-direction:column;width:80%;max-width:1000px;background-color:#fff;border-radius:10px;padding:10px;user-select:none}.GameUi__scenario-reminder____mVaa{display:flex;padding:20px;width:35%;min-width:450px;justify-content:flex-start;align-items:center;color:#000;font-size:1.2em;position:absolute;bottom:100%;left:10px;background-color:#fff;border-top-left-radius:10px;border-top-right-radius:10px}.GameUi__edf-logo___2D-mW{margin-right:20px}.GameUi__edf-logo___2D-mW img{width:40px}.GameUi__second-row___3KRlo{display:flex}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game/game-ui/GameUi.scss"],"names":[],"mappings":"AAAA,yBAAS,kBAAkB,SAAS,SAAS,0BAA6B,aAAa,sBAAsB,UAAU,iBAAiB,sBAAuB,mBAAmB,aAAa,gBAAgB,CAAC,mCAAwE,aAAa,aAAa,UAAU,gBAAgB,2BAA2B,mBAAmB,WAAY,gBAAgB,kBAAkB,YAAY,UAAU,sBAAuB,4BAA4B,4BAA4B,CAAC,0BAAU,iBAAiB,CAAC,8BAAc,UAAU,CAAC,4BAAY,YAAY,CAAC","file":"GameUi.scss","sourcesContent":[".game-ui{position:absolute;bottom:0;left:50%;transform:translate(-50%, 0);display:flex;flex-direction:column;width:80%;max-width:1000px;background-color:white;border-radius:10px;padding:10px;user-select:none}.scenario-reminder{composes:bold-font from '../../../common/Fonts.scss';display:flex;padding:20px;width:35%;min-width:450px;justify-content:flex-start;align-items:center;color:black;font-size:1.2em;position:absolute;bottom:100%;left:10px;background-color:white;border-top-left-radius:10px;border-top-right-radius:10px}.edf-logo{margin-right:20px}.edf-logo img{width:40px}.second-row{display:flex}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"game-ui": "GameUi__game-ui___3SGiy",
	"gameUi": "GameUi__game-ui___3SGiy",
	"scenario-reminder": "GameUi__scenario-reminder____mVaa " + __webpack_require__(0).locals["bold-font"] + "",
	"scenarioReminder": "GameUi__scenario-reminder____mVaa " + __webpack_require__(0).locals["bold-font"] + "",
	"edf-logo": "GameUi__edf-logo___2D-mW",
	"edfLogo": "GameUi__edf-logo___2D-mW",
	"second-row": "GameUi__second-row___3KRlo",
	"secondRow": "GameUi__second-row___3KRlo"
};

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("./action"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.action);
        global.results = mod.exports;
    }
})(this, function (exports, _action) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.openResultsPanel = openResultsPanel;
    exports.closeResultsPanel = closeResultsPanel;
    exports.resetResultsPanel = resetResultsPanel;
    function openResultsPanel() {
        return { type: _action.OPEN_RESULTS_PANEL, payload: {} };
    }
    function closeResultsPanel() {
        return { type: _action.CLOSE_RESULTS_PANEL, payload: {} };
    }
    function resetResultsPanel() {
        return { type: _action.RESET_RESULTS_PANEL, payload: {} };
    }
});

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(8), __webpack_require__(9), __webpack_require__(10), __webpack_require__(38), __webpack_require__(87), __webpack_require__(54), __webpack_require__(31), __webpack_require__(90), __webpack_require__(281)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("lodash"), require("react-redux"), require("../../../../data/data"), require("../../../../store/reducers/draggingPowerSource"), require("../../../../store/reducers/map/mapOffset"), require("../../../../store/actions/locations"), require("../../../../store/actions/powerSources"), require("../../../../store/reducers/map/mapBounds"), require("./DraggablePowerSource.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.lodash, global.reactRedux, global.data, global.draggingPowerSource, global.mapOffset, global.locations, global.powerSources, global.mapBounds, global.DraggablePowerSource);
        global.DraggablePowerSource = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _lodash, _reactRedux, _data, _draggingPowerSource, _mapOffset, _locations, _powerSources, _mapBounds) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./DraggablePowerSource.scss": {
            "draggable-power-source": "DraggablePowerSource__draggable-power-source___113dJ",
            "hidden": "DraggablePowerSource__hidden___2Ri3h DraggablePowerSource__draggable-power-source___113dJ",
            "dragging": "DraggablePowerSource__dragging___7fZFJ DraggablePowerSource__draggable-power-source___113dJ",
            "image": "DraggablePowerSource__image___1LM_L"
        }
    };

    var DraggablePowerSource = function (_super) {
        tslib_1.__extends(DraggablePowerSource, _super);
        function DraggablePowerSource(props, state) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.state = state;
            _this.setStartPosition = function (el) {
                var origin = _this.props.origin;
                var x = origin.x,
                    y = origin.y;
                _this.setState({ x: x, y: y });
            };
            _this.startDragging = function () {
                var dragging = _this.state.dragging;
                if (dragging) return;
                document.addEventListener('mousemove', _this.onDrag);
                document.addEventListener('mouseup', _this.stopDragging);
                _this.setState({ dragging: true, style_name: 'dragging' });
            };
            _this.stopDragging = function () {
                var placePowerSource = _this.props.placePowerSource;
                document.removeEventListener('mousemove', _this.onDrag);
                document.removeEventListener('mouseup', _this.stopDragging);
                placePowerSource();
                _this.setState({ dragging: false, style_name: 'hidden' });
            };
            _this.onDrag = function (event) {
                var _a = _this.props,
                    map_offset = _a.map_offset,
                    setHighlightLocation = _a.setHighlightLocation;
                var ox = map_offset.x,
                    oy = map_offset.y;
                var mx = event.pageX,
                    my = event.pageY;
                var x = mx - ox;
                var y = my - oy;
                var map_bounds = _this.props.map_bounds;
                var pcx = Math.round(x / map_bounds.width / 0.01);
                var pcy = Math.round(y / map_bounds.height / 0.01);
                var radius = 0.5;
                var locations = (0, _data.getPowerSourceLocationsData)();
                var location_id = _.findIndex(locations, function (location) {
                    var position = location.position;
                    var px = position[0],
                        py = position[1];
                    var x1 = px - radius;
                    var x2 = px + radius;
                    var y1 = py - radius;
                    var y2 = py + radius;
                    return pcx > x1 && pcx < x2 && pcy > y1 && pcy < y2;
                });
                setHighlightLocation(location_id);
                _this.setState({ x: mx, y: my });
            };
            _this.state = {
                dragging: false,
                style_name: 'hidden',
                x: 0, y: 0
            };
            return _this;
        }
        DraggablePowerSource.prototype.componentDidUpdate = function (prev_props, prev_state) {
            var npower_source = this.props.power_source;
            var opower_source = prev_props.power_source;
            var power_source = this.props.power_source;
            var ndragging = this.state.dragging;
            var odragging = prev_state.dragging;
            if (npower_source && !opower_source) return this.startDragging();
        };
        DraggablePowerSource.prototype.render = function () {
            var power_source = this.props.power_source;
            var _a = this.state,
                style_name = _a.style_name,
                x = _a.x,
                y = _a.y;
            if (!power_source) return null;
            var id = power_source.id;
            return React.createElement(
                "div",
                { style: { top: y, left: x }, ref: this.setStartPosition, className: (0, _getClassName3.default)(style_name, _styleModuleImportMap)
                },
                React.createElement("span", { style: { backgroundImage: "url(./img/game/map-power-sources/" + id + "@2x.png)" }, className: (0, _getClassName3.default)('image', _styleModuleImportMap)
                })
            );
        };
        return DraggablePowerSource;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state, props) {
        return {
            power_source: (0, _draggingPowerSource.getDraggingPowerSource)(state),
            origin: (0, _draggingPowerSource.getDraggingOrigin)(state),
            map_bounds: (0, _mapBounds.getMapBounds)(state),
            map_offset: (0, _mapOffset.getMapOffset)(state)
        };
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {
            setHighlightLocation: function setHighlightLocation(location_id) {
                return dispatch((0, _locations.setHighlightLocation)(location_id));
            },
            placePowerSource: function placePowerSource() {
                return dispatch((0, _powerSources.placePowerSource)());
            }
        };
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DraggablePowerSource);
});

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(282);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../node_modules/sass-loader/lib/loader.js!./DraggablePowerSource.scss", function() {
			var newContent = require("!!../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../node_modules/sass-loader/lib/loader.js!./DraggablePowerSource.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports


// module
exports.push([module.i, ".DraggablePowerSource__draggable-power-source___113dJ{display:flex;justify-content:center;align-items:center;position:absolute;width:0;height:0;background-color:hsla(0,0%,100%,.5);border-radius:50px;pointer-events:none;transform:translate(-50%,-50%);transition:width .2s ease-out,height .2s ease-out;top:500px;left:500px}.DraggablePowerSource__dragging___7fZFJ{width:80px;height:80px}.DraggablePowerSource__image___1LM_L{position:absolute;width:80px;height:80px;background:no-repeat 50%;background-size:contain}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game/power-sources/DraggablePowerSource.scss"],"names":[],"mappings":"AAAA,sDAAwB,aAAa,uBAAuB,mBAAmB,kBAAkB,QAAQ,SAAS,oCAAuC,mBAAmB,oBAAoB,+BAAgC,kDAAqD,UAAU,UAAU,CAAC,AAAwC,wCAA0C,WAAW,WAAW,CAAC,qCAAO,kBAAkB,WAAW,YAAY,yBAA4B,uBAAuB,CAAC","file":"DraggablePowerSource.scss","sourcesContent":[".draggable-power-source{display:flex;justify-content:center;align-items:center;position:absolute;width:0;height:0;background-color:rgba(255,255,255,0.5);border-radius:50px;pointer-events:none;transform:translate(-50%, -50%);transition:width 0.2s ease-out, height 0.2s ease-out;top:500px;left:500px}.hidden{composes:draggable-power-source}.dragging{composes:draggable-power-source;width:80px;height:80px}.image{position:absolute;width:80px;height:80px;background:no-repeat center;background-size:contain}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"draggable-power-source": "DraggablePowerSource__draggable-power-source___113dJ",
	"draggablePowerSource": "DraggablePowerSource__draggable-power-source___113dJ",
	"hidden": "DraggablePowerSource__hidden___2Ri3h DraggablePowerSource__draggable-power-source___113dJ",
	"dragging": "DraggablePowerSource__dragging___7fZFJ DraggablePowerSource__draggable-power-source___113dJ",
	"image": "DraggablePowerSource__image___1LM_L"
};

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(12), __webpack_require__(105), __webpack_require__(39), __webpack_require__(19), __webpack_require__(22), __webpack_require__(58), __webpack_require__(284)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("react-redux"), require("../../../../../store/reducers/year"), require("../../../../common/calendar/Calendar"), require("../../../../../store/reducers/calendar/isYearAlreadyComplete"), require("../../../../common/ui/button/Button"), require("../../../../../store/actions/calendar/year"), require("../CloseButton"), require("./YearInfo.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.reactRedux, global.year, global.Calendar, global.isYearAlreadyComplete, global.Button, global.year, global.CloseButton, global.YearInfo);
        global.YearInfo = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _reactRedux, _year, _Calendar, _isYearAlreadyComplete, _Button, _year2, _CloseButton) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    var _Calendar2 = _interopRequireDefault(_Calendar);

    var _Button2 = _interopRequireDefault(_Button);

    var _CloseButton2 = _interopRequireDefault(_CloseButton);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./YearInfo.scss": {
            "year-info": "YearInfo__year-info___3TnYT",
            "header": "YearInfo__header___3N66y Fonts__bold-font___3iFek",
            "content": "YearInfo__content___2J9aP",
            "year-label": "YearInfo__year-label___1zcH1 Fonts__bold-font___3iFek",
            "calendar": "YearInfo__calendar___3D6FU",
            "headline": "YearInfo__headline___1cigK Fonts__medium-font___3yYd3",
            "description": "YearInfo__description___1vzW2 Fonts__medium-font___3yYd3",
            "year-complete": "YearInfo__year-complete___1PwGB"
        }
    };

    var YearInfo = function (_super) {
        tslib_1.__extends(YearInfo, _super);
        function YearInfo(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            return _this;
        }
        YearInfo.prototype.render = function () {
            var _a = this.props,
                year_obj = _a.year,
                is_already_complete = _a.is_already_complete,
                endYear = _a.endYear;
            var year = year_obj.year,
                headline = year_obj.headline,
                description = year_obj.description;
            return React.createElement(
                "div",
                {
                    className: (0, _getClassName3.default)('year-info', _styleModuleImportMap)
                },
                React.createElement(_CloseButton2.default, { onClose: this.props.onClose }),
                React.createElement(
                    "span",
                    {
                        className: (0, _getClassName3.default)('header', _styleModuleImportMap)
                    },
                    "happy new year!"
                ),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('content', _styleModuleImportMap)
                    },
                    React.createElement(
                        "span",
                        {
                            className: (0, _getClassName3.default)('calendar', _styleModuleImportMap)
                        },
                        React.createElement(_Calendar2.default, { year: year, year_intro: true })
                    ),
                    headline && React.createElement("p", { dangerouslySetInnerHTML: { __html: headline }, className: (0, _getClassName3.default)('headline', _styleModuleImportMap)
                    }),
                    React.createElement("p", { dangerouslySetInnerHTML: { __html: description }, className: (0, _getClassName3.default)('description', _styleModuleImportMap)
                    }),
                    is_already_complete && React.createElement(
                        "div",
                        {
                            className: (0, _getClassName3.default)('year-complete', _styleModuleImportMap)
                        },
                        React.createElement(
                            "p",
                            null,
                            "Looks like you've already hit the targets for this year - good work!"
                        ),
                        React.createElement(
                            _Button2.default,
                            { type: 'skip-year', onClick: endYear },
                            "skip this year"
                        )
                    )
                )
            );
        };
        return YearInfo;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state) {
        return {
            year: (0, _year.getYearData)(state),
            is_already_complete: (0, _isYearAlreadyComplete.isYearAlreadyComplete)(state)
        };
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {
            endYear: function endYear() {
                return dispatch((0, _year2.endYear)());
            }
        };
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(YearInfo);
});

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(285);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../node_modules/sass-loader/lib/loader.js!./YearInfo.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../node_modules/sass-loader/lib/loader.js!./YearInfo.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports
exports.i(__webpack_require__(0), undefined);

// module
exports.push([module.i, ".YearInfo__year-info___3TnYT{padding:30px;max-height:60vh;overflow:auto}.YearInfo__header___3N66y{position:absolute;top:0;left:50%;transform:translate(-50%,-50%);padding:10px 20px;border-radius:5px;background-color:#e94e0f;font-size:24px;color:#fff;text-transform:uppercase;z-index:100}.YearInfo__content___2J9aP{display:flex;justify-content:center;align-items:center;flex-direction:column;padding:0 5%}.YearInfo__year-label___1zcH1{margin-top:20px;text-transform:uppercase}.YearInfo__calendar___3D6FU{margin:20px 0;font-size:80px}.YearInfo__headline___1cigK{margin:20px 0 0;color:#e94e0f;font-size:24px;line-height:1.2em;text-align:center;font-weight:700}.YearInfo__headline___1cigK b{font-family:frutiger-bold}.YearInfo__description___1vzW2{font-size:16px;white-space:pre-line;text-align:left}.YearInfo__year-complete___1PwGB{display:flex;font-weight:700;font-size:1.2em;align-items:center}.YearInfo__year-complete___1PwGB>p{padding:10px}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game/modals/year-info/YearInfo.scss"],"names":[],"mappings":"AAAA,6BAAW,aAAa,gBAAgB,aAAa,CAAC,0BAAgE,kBAAkB,MAAM,SAAS,+BAAgC,kBAAkB,kBAAkB,yBAAyB,eAAe,WAAY,yBAAyB,WAAW,CAAC,2BAAS,aAAa,uBAAuB,mBAAmB,sBAAsB,YAAY,CAAC,8BAAoE,gBAAgB,wBAAwB,CAAC,4BAAU,cAAc,cAAc,CAAC,4BAAoE,gBAAgB,cAAc,eAAe,kBAAkB,kBAAkB,eAAe,CAAC,8BAAY,yBAA2B,CAAC,+BAAuE,eAAe,qBAAqB,eAAe,CAAC,iCAAe,aAAa,gBAAiB,gBAAgB,kBAAkB,CAAC,mCAAiB,YAAY,CAAC","file":"YearInfo.scss","sourcesContent":[".year-info{padding:30px;max-height:60vh;overflow:auto}.header{composes:bold-font from '../../../../common/Fonts.scss';position:absolute;top:0;left:50%;transform:translate(-50%, -50%);padding:10px 20px;border-radius:5px;background-color:#E94E0F;font-size:24px;color:white;text-transform:uppercase;z-index:100}.content{display:flex;justify-content:center;align-items:center;flex-direction:column;padding:0 5%}.year-label{composes:bold-font from '../../../../common/Fonts.scss';margin-top:20px;text-transform:uppercase}.calendar{margin:20px 0;font-size:80px}.headline{composes:medium-font from '../../../../common/Fonts.scss';margin:20px 0 0;color:#E94E0F;font-size:24px;line-height:1.2em;text-align:center;font-weight:700}.headline b{font-family:'frutiger-bold'}.description{composes:medium-font from '../../../../common/Fonts.scss';font-size:16px;white-space:pre-line;text-align:left}.year-complete{display:flex;font-weight:bold;font-size:1.2em;align-items:center}.year-complete>p{padding:10px}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"year-info": "YearInfo__year-info___3TnYT",
	"yearInfo": "YearInfo__year-info___3TnYT",
	"header": "YearInfo__header___3N66y " + __webpack_require__(0).locals["bold-font"] + "",
	"content": "YearInfo__content___2J9aP",
	"year-label": "YearInfo__year-label___1zcH1 " + __webpack_require__(0).locals["bold-font"] + "",
	"yearLabel": "YearInfo__year-label___1zcH1 " + __webpack_require__(0).locals["bold-font"] + "",
	"calendar": "YearInfo__calendar___3D6FU",
	"headline": "YearInfo__headline___1cigK " + __webpack_require__(0).locals["medium-font"] + "",
	"description": "YearInfo__description___1vzW2 " + __webpack_require__(0).locals["medium-font"] + "",
	"year-complete": "YearInfo__year-complete___1PwGB",
	"yearComplete": "YearInfo__year-complete___1PwGB"
};

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(287);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./Calendar.scss", function() {
			var newContent = require("!!../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./Calendar.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports
exports.i(__webpack_require__(0), undefined);

// module
exports.push([module.i, ".Calendar__calendar___1EF9T{display:flex}.Calendar__digit___334S2{position:relative;font-size:1em;background-color:#fff;box-shadow:0 .04em .08em rgba(0,0,0,.4);padding:.25em;border-radius:.1em;margin:0 .05em;line-height:.8em}.Calendar__digit___334S2:after{content:\"\";position:absolute;top:50%;left:0;width:100%;border-bottom:1px solid rgba(0,0,0,.15)}.Calendar__digit___334S2:first-of-type{margin-left:0}.Calendar__digit___334S2:last-of-type{margin-right:0}.Calendar__year-intro-digit___1iSF9{margin:0 -.025em;border:10px solid #3ea341}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/common/calendar/Calendar.scss"],"names":[],"mappings":"AAAA,4BAAU,YAAY,CAAC,yBAA+C,kBAAkB,cAAc,sBAAuB,wCAA2C,cAAe,mBAAoB,eAAgB,gBAAiB,CAAC,+BAAa,WAAW,kBAAkB,QAAQ,OAAO,WAAW,uCAAwC,CAAC,uCAAqB,aAAa,CAAC,sCAAoB,cAAc,CAAC,oCAAiC,iBAAkB,yBAAyB,CAAC","file":"Calendar.scss","sourcesContent":[".calendar{display:flex}.digit{composes:bold-font from '../Fonts.scss';position:relative;font-size:1em;background-color:white;box-shadow:0 0.04em 0.08em rgba(0,0,0,0.4);padding:0.25em;border-radius:0.1em;margin:0 0.05em;line-height:0.8em}.digit:after{content:'';position:absolute;top:50%;left:0;width:100%;border-bottom:1px solid rgba(0,0,0,0.15)}.digit:first-of-type{margin-left:0}.digit:last-of-type{margin-right:0}.year-intro-digit{composes:digit;margin:0 -0.025em;border:10px solid #3ea341}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"calendar": "Calendar__calendar___1EF9T",
	"digit": "Calendar__digit___334S2 " + __webpack_require__(0).locals["bold-font"] + "",
	"year-intro-digit": "Calendar__year-intro-digit___1iSF9 Calendar__digit___334S2 " + __webpack_require__(0).locals["bold-font"] + "",
	"yearIntroDigit": "Calendar__year-intro-digit___1iSF9 Calendar__digit___334S2 " + __webpack_require__(0).locals["bold-font"] + ""
};

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(19), __webpack_require__(15), __webpack_require__(33)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("tslib"), require("react"), require("react-redux"), require("../../../common/ui/button/Button"), require("../../../../store/actions/screens"), require("../../../../store/actions/timer"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.tslib, global.react, global.reactRedux, global.Button, global.screens, global.timer);
        global.QuitButton = mod.exports;
    }
})(this, function (exports, _tslib, _react, _reactRedux, _Button, _screens, _timer) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    var _Button2 = _interopRequireDefault(_Button);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    var QuitButton = function (_super) {
        tslib_1.__extends(QuitButton, _super);
        function QuitButton(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.onQuit = function () {
                var _a = _this.props,
                    showMainMenu = _a.showMainMenu,
                    stopTimer = _a.stopTimer;
                showMainMenu();
                stopTimer();
            };
            return _this;
        }
        QuitButton.prototype.render = function () {
            return React.createElement(
                _Button2.default,
                { type: 'quit-game', onClick: this.onQuit },
                "quit"
            );
        };
        return QuitButton;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state) {
        return {};
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {
            showMainMenu: function showMainMenu() {
                return dispatch((0, _screens.showMainMenu)());
            },
            stopTimer: function stopTimer() {
                return dispatch((0, _timer.stopTimer)());
            }
        };
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(QuitButton);
});

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(8), __webpack_require__(9), __webpack_require__(22), __webpack_require__(76), __webpack_require__(33), __webpack_require__(290), __webpack_require__(12), __webpack_require__(105), __webpack_require__(291)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("lodash"), require("react-redux"), require("../../../../store/actions/calendar/year"), require("../../../../store/reducers/timer"), require("../../../../store/actions/timer"), require("./months"), require("../../../../store/reducers/year"), require("../../../common/calendar/Calendar"), require("./GameCalendar.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.lodash, global.reactRedux, global.year, global.timer, global.timer, global.months, global.year, global.Calendar, global.GameCalendar);
        global.GameCalendar = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _lodash, _reactRedux, _year, _timer, _timer2, _months, _year2, _Calendar) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    var _ = _interopRequireWildcard(_lodash);

    var _Calendar2 = _interopRequireDefault(_Calendar);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./GameCalendar.scss": {
            "container": "GameCalendar__container___2EOYR",
            "game-calendar": "GameCalendar__game-calendar___3n1Qq",
            "header": "GameCalendar__header___3EoBG Fonts__bold-font___3iFek",
            "year": "GameCalendar__year___1a6h1",
            "countdown": "GameCalendar__countdown___2X5bH Fonts__bold-font___3iFek",
            "bounceIn": "GameCalendar__bounceIn___1AKZp"
        }
    };

    var year_length = 120;
    var GameCalendar = function (_super) {
        tslib_1.__extends(GameCalendar, _super);
        function GameCalendar(props, state) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.state = state;
            _this.onUpdate = function (prev_props) {
                _this.toggleTimer();
            };
            _this.toggleTimer = function () {
                var timer_is_running = _this.props.timer_is_running;
                if (timer_is_running && _.isFinite(_this.timer)) return;
                if (timer_is_running) {
                    _this.timer = setInterval(_this.onTimerTick, 1000);
                } else {
                    clearInterval(_this.timer);
                    _this.timer = null;
                }
            };
            _this.onTimerTick = function () {
                var _a = _this.props,
                    time = _a.time,
                    tickTimer = _a.tickTimer,
                    duration = _a.duration;
                tickTimer();
                var index = Math.floor(time / duration * 12);
                var month = _months.MONTHS[index];
                _this.setState({ month: month });
                if (time < duration - 1) return;
                var endYear = _this.props.endYear;
                endYear();
            };
            _this.state = {
                month: _months.MONTHS[0]
            };
            return _this;
        }
        GameCalendar.prototype.componentDidMount = function () {
            this.onUpdate();
        };
        GameCalendar.prototype.componentDidUpdate = function (prev_props) {
            this.onUpdate(prev_props);
        };
        GameCalendar.prototype.componentWillUnmount = function () {
            clearInterval(this.timer);
        };
        GameCalendar.prototype.render = function () {
            var _a = this.props,
                year_obj = _a.year,
                endYear = _a.endYear,
                timer_is_running = _a.timer_is_running,
                time = _a.time,
                duration = _a.duration;
            var year = year_obj.year;
            var month = this.state.month;
            var remaining = duration - time;
            return React.createElement(
                "div",
                {
                    className: (0, _getClassName3.default)('container', _styleModuleImportMap)
                },
                React.createElement(
                    "div",
                    { onClick: endYear, className: (0, _getClassName3.default)('game-calendar', _styleModuleImportMap)
                    },
                    React.createElement(
                        "div",
                        {
                            className: (0, _getClassName3.default)('header', _styleModuleImportMap)
                        },
                        remaining,
                        " seconds"
                    ),
                    React.createElement(
                        "div",
                        {
                            className: (0, _getClassName3.default)('year', _styleModuleImportMap)
                        },
                        React.createElement(_Calendar2.default, { year: year })
                    )
                ),
                timer_is_running && remaining <= 10 && React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('countdown', _styleModuleImportMap)
                    },
                    remaining,
                    React.createElement(
                        "p",
                        null,
                        "seconds",
                        React.createElement("br", null),
                        "remaining"
                    )
                )
            );
        };
        return GameCalendar;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state) {
        return {
            year: (0, _year2.getYearData)(state),
            time: (0, _timer.getTime)(state),
            timer_is_running: (0, _timer.isTimerRunning)(state),
            duration: (0, _timer.getYearDuration)(state)
        };
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {
            tickTimer: function tickTimer() {
                return dispatch((0, _timer2.tickTimer)());
            },
            endYear: function endYear() {
                return dispatch((0, _year.endYear)());
            }
        };
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GameCalendar);
});

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports);
        global.months = mod.exports;
    }
})(this, function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var MONTHS = exports.MONTHS = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
});

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(292);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../node_modules/sass-loader/lib/loader.js!./GameCalendar.scss", function() {
			var newContent = require("!!../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../node_modules/sass-loader/lib/loader.js!./GameCalendar.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports
exports.i(__webpack_require__(0), undefined);

// module
exports.push([module.i, ".GameCalendar__container___2EOYR{user-select:none}.GameCalendar__game-calendar___3n1Qq{background-color:#fff;border-radius:5px;box-shadow:0 3px 6px rgba(0,0,0,.4);overflow:hidden;user-select:none}.GameCalendar__header___3EoBG{text-transform:uppercase;text-align:center;padding:10px;background-color:#e94e0f;color:#fff}.GameCalendar__year___1a6h1{padding:5px;font-size:32px}.GameCalendar__countdown___2X5bH{font-size:3em;margin:20px auto;text-align:center;color:#fff;filter:drop-shadow(0 0 3px rgba(0,0,0,.5));animation:GameCalendar__bounceIn___1AKZp 4s cubic-bezier(.175,.885,.32,1.275) 0s forwards;display:flex;justify-content:center}.GameCalendar__countdown___2X5bH p{margin:9px;font-size:16px;text-align:left}@keyframes GameCalendar__bounceIn___1AKZp{0%{opacity:0;margin-top:10px}20%{opacity:1;margin-top:0}80%{opacity:1;margin-top:0}to{opacity:0;margin-top:10px}}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game/timer/GameCalendar.scss"],"names":[],"mappings":"AAAA,iCAAW,gBAAgB,CAAC,qCAAe,sBAAuB,kBAAkB,oCAAqC,gBAAgB,gBAAgB,CAAC,8BAA6D,yBAAyB,kBAAkB,aAAa,yBAAyB,UAAW,CAAC,4BAAM,YAAY,cAAc,CAAC,iCAAgE,cAAc,iBAAiB,kBAAkB,WAAY,2CAAgD,0FAA0E,aAAa,sBAAsB,CAAC,mCAAa,WAAW,eAAe,eAAe,CAAC,0CAAoB,GAAG,UAAU,eAAe,CAAC,IAAI,UAAU,YAAY,CAAC,IAAI,UAAU,YAAY,CAAC,GAAK,UAAU,eAAe,CAAC,CAAC","file":"GameCalendar.scss","sourcesContent":[".container{user-select:none}.game-calendar{background-color:white;border-radius:5px;box-shadow:0 3px 6px rgba(0,0,0,0.4);overflow:hidden;user-select:none}.header{composes:bold-font from '../../../common/Fonts.scss';text-transform:uppercase;text-align:center;padding:10px;background-color:#E94E0F;color:white}.year{padding:5px;font-size:32px}.countdown{composes:bold-font from '../../../common/Fonts.scss';font-size:3em;margin:20px auto;text-align:center;color:white;filter:drop-shadow(0px 0px 3px rgba(0,0,0,0.5));animation:bounceIn 4s cubic-bezier(0.175, 0.885, 0.32, 1.275) 0s forwards;display:flex;justify-content:center}.countdown p{margin:9px;font-size:16px;text-align:left}@keyframes bounceIn{0%{opacity:0;margin-top:10px}20%{opacity:1;margin-top:0}80%{opacity:1;margin-top:0}100%{opacity:0;margin-top:10px}}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "GameCalendar__container___2EOYR",
	"game-calendar": "GameCalendar__game-calendar___3n1Qq",
	"gameCalendar": "GameCalendar__game-calendar___3n1Qq",
	"header": "GameCalendar__header___3EoBG " + __webpack_require__(0).locals["bold-font"] + "",
	"year": "GameCalendar__year___1a6h1",
	"countdown": "GameCalendar__countdown___2X5bH " + __webpack_require__(0).locals["bold-font"] + "",
	"bounceIn": "GameCalendar__bounceIn___1AKZp"
};

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(12), __webpack_require__(39), __webpack_require__(294)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("react-redux"), require("../../../../../store/reducers/year"), require("../../../../../store/reducers/calendar/isYearAlreadyComplete"), require("./YearEnd.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.reactRedux, global.year, global.isYearAlreadyComplete, global.YearEnd);
        global.YearEnd = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _reactRedux, _year, _isYearAlreadyComplete) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./YearEnd.scss": {
            "year-end": "YearEnd__year-end___1gvwK",
            "header": "YearEnd__header___hn5o- Colour__yellow___2xL7_",
            "image": "YearEnd__image___256Kn",
            "text-column": "YearEnd__text-column___sI0h-",
            "headline": "YearEnd__headline___3xiBv Fonts__bold-font___3iFek",
            "body-copy": "YearEnd__body-copy___2O-iS Fonts__medium-font___3yYd3"
        }
    };

    var YearEnd = function (_super) {
        tslib_1.__extends(YearEnd, _super);
        function YearEnd(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.getText = function () {
                var _a = _this.props,
                    year_obj = _a.year,
                    year_complete = _a.year_complete,
                    all_damage_repaired = _a.all_damage_repaired;
                var year_end = year_obj["year-end"],
                    year_end_success = year_obj["year-end-success"],
                    year_end_fail = year_obj["year-end-fail"];
                console.group('getText');
                console.log('year_end_success', year_end_success);
                console.log('all_damage_repaired', all_damage_repaired);
                console.log('year_complete', year_complete);
                console.groupEnd();
                if (year_end_success) {
                    return year_complete || all_damage_repaired ? year_end_success : year_end_fail;
                }
                return year_end;
            };
            return _this;
        }
        YearEnd.prototype.render = function () {
            return React.createElement(
                "div",
                {
                    className: (0, _getClassName3.default)('year-end', _styleModuleImportMap)
                },
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('text-column', _styleModuleImportMap)
                    },
                    React.createElement("p", { dangerouslySetInnerHTML: { __html: this.getText() }, className: (0, _getClassName3.default)('body-copy', _styleModuleImportMap)
                    })
                )
            );
        };
        return YearEnd;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state) {
        return {
            year: (0, _year.getYearData)(state),
            year_complete: (0, _isYearAlreadyComplete.isYearComplete)(state),
            all_damage_repaired: (0, _isYearAlreadyComplete.allDamagedStationsRepaired)(state)
        };
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {};
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(YearEnd);
});

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(295);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../node_modules/sass-loader/lib/loader.js!./YearEnd.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../node_modules/sass-loader/lib/loader.js!./YearEnd.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports
exports.i(__webpack_require__(1), undefined);
exports.i(__webpack_require__(0), undefined);

// module
exports.push([module.i, ".YearEnd__year-end___1gvwK{text-align:center}.YearEnd__header___hn5o-{height:30px;display:flex;justify-content:center;align-items:center;border-top-left-radius:10px;border-top-right-radius:10px}.YearEnd__image___256Kn{width:70px;height:auto}.YearEnd__text-column___sI0h-{padding:40px}.YearEnd__headline___3xiBv{font-size:36px;line-height:1.1em;margin:40px 0}.YearEnd__headline___3xiBv:first-letter{text-transform:uppercase}.YearEnd__body-copy___2O-iS{margin:0}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game/modals/year-end/YearEnd.scss"],"names":[],"mappings":"AAAA,2BAAU,iBAAiB,CAAC,yBAA8D,YAAY,aAAa,uBAAuB,mBAAmB,4BAA4B,4BAA4B,CAAC,wBAAO,WAAW,WAAW,CAAC,8BAAa,YAAY,CAAC,2BAAkE,eAAe,kBAAkB,aAAa,CAAC,wCAAuB,wBAAwB,CAAC,4BAAqE,QAAQ,CAAC","file":"YearEnd.scss","sourcesContent":[".year-end{text-align:center}.header{composes:yellow from '../../../../common/Colour.scss';height:30px;display:flex;justify-content:center;align-items:center;border-top-left-radius:10px;border-top-right-radius:10px}.image{width:70px;height:auto}.text-column{padding:40px}.headline{composes:bold-font from '../../../../common/Fonts.scss';font-size:36px;line-height:1.1em;margin:40px 0}.headline:first-letter{text-transform:uppercase}.body-copy{composes:medium-font from '../../../../common/Fonts.scss';margin:0}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"year-end": "YearEnd__year-end___1gvwK",
	"yearEnd": "YearEnd__year-end___1gvwK",
	"header": "YearEnd__header___hn5o- " + __webpack_require__(1).locals["yellow"] + "",
	"image": "YearEnd__image___256Kn",
	"text-column": "YearEnd__text-column___sI0h-",
	"textColumn": "YearEnd__text-column___sI0h-",
	"headline": "YearEnd__headline___3xiBv " + __webpack_require__(0).locals["bold-font"] + "",
	"body-copy": "YearEnd__body-copy___2O-iS " + __webpack_require__(0).locals["medium-font"] + "",
	"bodyCopy": "YearEnd__body-copy___2O-iS " + __webpack_require__(0).locals["medium-font"] + ""
};

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(297);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./Game.scss", function() {
			var newContent = require("!!../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./Game.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports


// module
exports.push([module.i, ".Game__game___2rvjh{width:100%;height:100%;overflow:hidden;position:relative}.Game__dragging___159fM{user-select:none}.Game__output-ui___3UhjP{position:absolute;bottom:0;left:50%;transform:translate(-50%);display:flex;width:80%;height:300px;background-color:#fff;border-radius:10px 10px 0 0;overflow:hidden;box-shadow:0 0 15px rgba(0,0,0,.5)}.Game__outputs___B7gsY{display:flex;flex-direction:column;flex:1}.Game__energy-mix___2yJ8c{display:flex;width:20%}.Game__top-right-ui___1fq5s{position:absolute;top:20px;right:20px;display:flex;align-items:flex-start}.Game__top-right-ui___1fq5s>*{margin-left:20px}.Game__top-right-ui___1fq5s .Game__edf-logo___3h3TY{margin-bottom:16px}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game/Game.scss"],"names":[],"mappings":"AAAA,oBAAM,WAAW,YAAY,gBAAgB,iBAAiB,CAAC,wBAAwB,gBAAgB,CAAC,yBAAW,kBAAkB,SAAS,SAAS,0BAA6B,aAAa,UAAU,aAAa,sBAAuB,4BAA4B,gBAAgB,kCAAmC,CAAC,uBAAS,aAAa,sBAAsB,MAAM,CAAC,0BAAY,aAAa,SAAS,CAAC,4BAAc,kBAAkB,SAAS,WAAW,aAAa,sBAAsB,CAAC,8BAAgB,gBAAgB,CAAC,oDAAwB,kBAAkB,CAAC","file":"Game.scss","sourcesContent":[".game{width:100%;height:100%;overflow:hidden;position:relative}.dragging{composes:game;user-select:none}.output-ui{position:absolute;bottom:0;left:50%;transform:translate(-50%, 0);display:flex;width:80%;height:300px;background-color:white;border-radius:10px 10px 0 0;overflow:hidden;box-shadow:0 0 15px rgba(0,0,0,0.5)}.outputs{display:flex;flex-direction:column;flex:1}.energy-mix{display:flex;width:20%}.top-right-ui{position:absolute;top:20px;right:20px;display:flex;align-items:flex-start}.top-right-ui>*{margin-left:20px}.top-right-ui .edf-logo{margin-bottom:16px}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"game": "Game__game___2rvjh",
	"dragging": "Game__dragging___159fM Game__game___2rvjh",
	"output-ui": "Game__output-ui___3UhjP",
	"outputUi": "Game__output-ui___3UhjP",
	"outputs": "Game__outputs___B7gsY",
	"energy-mix": "Game__energy-mix___2yJ8c",
	"energyMix": "Game__energy-mix___2yJ8c",
	"top-right-ui": "Game__top-right-ui___1fq5s",
	"topRightUi": "Game__top-right-ui___1fq5s",
	"edf-logo": "Game__edf-logo___3h3TY",
	"edfLogo": "Game__edf-logo___3h3TY"
};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(57), __webpack_require__(299), __webpack_require__(307), __webpack_require__(302), __webpack_require__(19), __webpack_require__(34), __webpack_require__(15), __webpack_require__(35), __webpack_require__(305)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("react-redux"), require("../../../../../store/reducers/score"), require("./summary/SummarySection"), require("./score/HintsSection"), require("./hints/QuestionsSection"), require("../../../../common/ui/button/Button"), require("../../../../../store/actions/game"), require("../../../../../store/actions/screens"), require("../../../../common/highlight-text/HighlightText"), require("./GameOver.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.reactRedux, global.score, global.SummarySection, global.HintsSection, global.QuestionsSection, global.Button, global.game, global.screens, global.HighlightText, global.GameOver);
        global.GameOver = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _reactRedux, _score, _SummarySection, _HintsSection, _QuestionsSection, _Button, _game, _screens, _HighlightText) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    var _SummarySection2 = _interopRequireDefault(_SummarySection);

    var _HintsSection2 = _interopRequireDefault(_HintsSection);

    var _QuestionsSection2 = _interopRequireDefault(_QuestionsSection);

    var _Button2 = _interopRequireDefault(_Button);

    var _HighlightText2 = _interopRequireDefault(_HighlightText);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./GameOver.scss": {
            "game-over": "GameOver__game-over___3otVX",
            "content": "GameOver__content___M2mz6",
            "score-and-hints": "GameOver__score-and-hints___3BHTI",
            "highlight": "GameOver__highlight___TOJoR",
            "floating-ui": "GameOver__floating-ui____YLvB"
        }
    };

    var GameOver = function (_super) {
        tslib_1.__extends(GameOver, _super);
        function GameOver(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            return _this;
        }
        GameOver.prototype.render = function () {
            var score = this.props.score;
            return React.createElement(
                "span",
                {
                    className: (0, _getClassName3.default)('game-over', _styleModuleImportMap)
                },
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('content', _styleModuleImportMap)
                    },
                    React.createElement(
                        "div",
                        {
                            className: (0, _getClassName3.default)('score-and-hints', _styleModuleImportMap)
                        },
                        React.createElement(
                            "span",
                            {
                                className: (0, _getClassName3.default)('highlight', _styleModuleImportMap)
                            },
                            React.createElement(
                                _HighlightText2.default,
                                { type: 'blue' },
                                "time's up!"
                            )
                        ),
                        React.createElement(_HintsSection2.default, null),
                        React.createElement(_QuestionsSection2.default, null)
                    ),
                    React.createElement(_SummarySection2.default, null)
                ),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('floating-ui', _styleModuleImportMap)
                    },
                    React.createElement(
                        _Button2.default,
                        { type: 'main-menu', onClick: this.props.showMainMenu },
                        "main menu"
                    ),
                    React.createElement(
                        _Button2.default,
                        { type: 'play-again', onClick: this.props.startGame },
                        "play again"
                    ),
                    React.createElement(
                        _Button2.default,
                        { type: 'more-info', onClick: null },
                        React.createElement(
                            "a",
                            { href: 'assets/certificate.pdf', download: "Power the UK Certificate.pdf" },
                            "Certificate"
                        )
                    )
                )
            );
        };
        return GameOver;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state) {
        return {
            score: (0, _score.getScore)(state)
        };
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {
            showMainMenu: function showMainMenu() {
                return dispatch((0, _screens.showMainMenu)());
            },
            startGame: function startGame() {
                return dispatch((0, _game.startGame)());
            }
        };
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GameOver);
});

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(8), __webpack_require__(9), __webpack_require__(10), __webpack_require__(13), __webpack_require__(34), __webpack_require__(32), __webpack_require__(102), __webpack_require__(300)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("lodash"), require("react-redux"), require("../../../../../../data/data"), require("../../../../../../store/reducers/powerSources"), require("../../../../../../store/actions/game"), require("../../../../../../store/reducers/outputs/carbonOutput"), require("../../../power-sources/PowerSource"), require("./SummarySection.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.lodash, global.reactRedux, global.data, global.powerSources, global.game, global.carbonOutput, global.PowerSource, global.SummarySection);
        global.SummarySection = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _lodash, _reactRedux, _data, _powerSources, _game, _carbonOutput, _PowerSource) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    var _ = _interopRequireWildcard(_lodash);

    var _PowerSource2 = _interopRequireDefault(_PowerSource);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./SummarySection.scss": {
            "summary-section": "SummarySection__summary-section___1RNU8",
            "result": "SummarySection__result___1aLlp",
            "low-carbon-summary": "SummarySection__low-carbon-summary___1sJim Fonts__calculator-font___2Vr8r",
            "carbon-label": "SummarySection__carbon-label___39Xtr",
            "carbon-percentage": "SummarySection__carbon-percentage___a5lwv",
            "power-sources": "SummarySection__power-sources___39XPK"
        }
    };

    var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }

        return target;
    };

    var SummarySection = function (_super) {
        tslib_1.__extends(SummarySection, _super);
        function SummarySection(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.getPowerSoures = function () {
                var power_source_counts = _this.props.power_source_counts;
                var power_sources = (0, _data.getPowerSourcesData)();
                return _.map(power_sources, function (power_source, i) {
                    return React.createElement(_PowerSource2.default, _extends({}, power_source, { key: i }));
                });
            };
            return _this;
        }
        SummarySection.prototype.render = function () {
            var _a = this.props,
                startGame = _a.startGame,
                carbon_pc = _a.carbon_pc;
            return React.createElement(
                "div",
                {
                    className: (0, _getClassName3.default)('summary-section', _styleModuleImportMap)
                },
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('low-carbon-summary', _styleModuleImportMap)
                    },
                    React.createElement(
                        "p",
                        {
                            className: (0, _getClassName3.default)('carbon-label', _styleModuleImportMap)
                        },
                        "low carbon generation"
                    ),
                    React.createElement(
                        "p",
                        {
                            className: (0, _getClassName3.default)('carbon-percentage', _styleModuleImportMap)
                        },
                        carbon_pc,
                        "%"
                    )
                ),
                React.createElement(
                    "div",
                    {
                        className: (0, _getClassName3.default)('power-sources', _styleModuleImportMap)
                    },
                    this.getPowerSoures()
                )
            );
        };
        return SummarySection;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state) {
        return {
            power_source_counts: (0, _powerSources.countPowerSourcesByType)(state),
            carbon_pc: (0, _carbonOutput.getCarbonOutputPercentage)(state)
        };
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {
            startGame: function startGame() {
                return dispatch((0, _game.startGame)());
            }
        };
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SummarySection);
});

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(301);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../../node_modules/sass-loader/lib/loader.js!./SummarySection.scss", function() {
			var newContent = require("!!../../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../../node_modules/sass-loader/lib/loader.js!./SummarySection.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports
exports.i(__webpack_require__(0), undefined);

// module
exports.push([module.i, ".SummarySection__summary-section___1RNU8{display:flex;flex-basis:260px;justify-content:flex-start;flex-direction:column;align-items:center;height:100%;width:260px;min-height:700px;box-sizing:border-box;z-index:100;pointer-events:none}.SummarySection__result___1aLlp{white-space:pre-line}.SummarySection__low-carbon-summary___1sJim{font-size:2em;font-weight:400;text-transform:uppercase;display:flex;flex-direction:column;justify-content:center;text-align:center}.SummarySection__carbon-label___39Xtr{margin:30px 0 0}.SummarySection__carbon-percentage___a5lwv{font-size:3em;margin:10px;line-height:.8em}.SummarySection__power-sources___39XPK{display:flex;flex-direction:column;flex:1;justify-content:space-evenly;max-height:800px}.SummarySection__power-sources___39XPK>:first-child{z-index:10}.SummarySection__power-sources___39XPK>:nth-child(2){z-index:6}.SummarySection__power-sources___39XPK>:nth-child(3){z-index:4}.SummarySection__power-sources___39XPK>:nth-child(4){z-index:2}.SummarySection__power-sources___39XPK>:nth-child(5){z-index:0}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game/modals/game-over/summary/SummarySection.scss"],"names":[],"mappings":"AAAA,yCAAiB,aAAa,iBAAiB,2BAA2B,sBAAsB,mBAAmB,YAAY,YAAY,iBAAiB,sBAAsB,YAAY,mBAAmB,CAAC,gCAAQ,oBAAoB,CAAC,4CAAqF,cAAc,gBAAmB,yBAAyB,aAAa,sBAAsB,uBAAuB,iBAAiB,CAAC,sCAAc,eAAiB,CAAC,2CAAmB,cAAc,YAAY,gBAAiB,CAAC,uCAAe,aAAa,sBAAsB,OAAO,6BAA6B,gBAAgB,CAAC,oDAA8B,UAAU,CAAC,qDAA8B,SAAS,CAAC,qDAA8B,SAAS,CAAC,qDAA8B,SAAS,CAAC,qDAA8B,SAAS,CAAC","file":"SummarySection.scss","sourcesContent":[".summary-section{display:flex;flex-basis:260px;justify-content:flex-start;flex-direction:column;align-items:center;height:100%;width:260px;min-height:700px;box-sizing:border-box;z-index:100;pointer-events:none}.result{white-space:pre-line}.low-carbon-summary{composes:calculator-font from '../../../../../common/Fonts.scss';font-size:2em;font-weight:normal;text-transform:uppercase;display:flex;flex-direction:column;justify-content:center;text-align:center}.carbon-label{margin:30px 0 0 0}.carbon-percentage{font-size:3em;margin:10px;line-height:0.8em}.power-sources{display:flex;flex-direction:column;flex:1;justify-content:space-evenly;max-height:800px}.power-sources>*:nth-child(1){z-index:10}.power-sources>*:nth-child(2){z-index:6}.power-sources>*:nth-child(3){z-index:4}.power-sources>*:nth-child(4){z-index:2}.power-sources>*:nth-child(5){z-index:0}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"summary-section": "SummarySection__summary-section___1RNU8",
	"summarySection": "SummarySection__summary-section___1RNU8",
	"result": "SummarySection__result___1aLlp",
	"low-carbon-summary": "SummarySection__low-carbon-summary___1sJim " + __webpack_require__(0).locals["calculator-font"] + "",
	"lowCarbonSummary": "SummarySection__low-carbon-summary___1sJim " + __webpack_require__(0).locals["calculator-font"] + "",
	"carbon-label": "SummarySection__carbon-label___39Xtr",
	"carbonLabel": "SummarySection__carbon-label___39Xtr",
	"carbon-percentage": "SummarySection__carbon-percentage___a5lwv",
	"carbonPercentage": "SummarySection__carbon-percentage___a5lwv",
	"power-sources": "SummarySection__power-sources___39XPK",
	"powerSources": "SummarySection__power-sources___39XPK"
};

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(8), __webpack_require__(91), __webpack_require__(10), __webpack_require__(303)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("react-redux"), require("lodash"), require("../../../../../../store/reducers/questions/correctAnswers"), require("../../../../../../data/data"), require("./ScoreSection.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.reactRedux, global.lodash, global.correctAnswers, global.data, global.ScoreSection);
        global.QuestionsSection = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _reactRedux, _lodash, _correctAnswers, _data) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./ScoreSection.scss": {
            "score-section": "ScoreSection__score-section___2n-Pv",
            "highlight": "ScoreSection__highlight___AcSGR",
            "result-text": "ScoreSection__result-text___Uf2RF Fonts__bold-font___3iFek",
            "copy": "ScoreSection__copy___3K6Cs",
            "correct-answer-count": "ScoreSection__correct-answer-count___1srOq Fonts__bold-font___3iFek",
            "score-subtitle": "ScoreSection__score-subtitle___18Gbl undefined"
        }
    };

    var QuestionSection = function (_super) {
        tslib_1.__extends(QuestionSection, _super);
        function QuestionSection(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.getResult = function () {
                var correct_answer_count = _this.props.correct_answer_count;
                var data = (0, _data.getQuestionResults)();
                return _.find(data, function (result) {
                    return correct_answer_count <= result.correct;
                });
            };
            return _this;
        }
        QuestionSection.prototype.render = function () {
            var _a = this.props.correct_answer_count,
                correct_answer_count = _a === void 0 ? 0 : _a;
            var result = this.getResult();
            var text = result.text.replace('$questions', correct_answer_count.toString());
            return React.createElement(
                "div",
                {
                    className: (0, _getClassName3.default)('score-section', _styleModuleImportMap)
                },
                React.createElement("div", { dangerouslySetInnerHTML: { __html: text }, className: (0, _getClassName3.default)('copy', _styleModuleImportMap)
                })
            );
        };
        return QuestionSection;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state) {
        return {
            correct_answer_count: (0, _correctAnswers.getCorrectAnswerCount)(state)
        };
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {};
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(QuestionSection);
});

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(304);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../../node_modules/sass-loader/lib/loader.js!./ScoreSection.scss", function() {
			var newContent = require("!!../../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../../node_modules/sass-loader/lib/loader.js!./ScoreSection.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports
exports.i(__webpack_require__(0), undefined);

// module
exports.push([module.i, ".ScoreSection__score-section___2n-Pv{padding:0 100px 100px;display:flex;justify-content:center;flex-direction:column;align-items:center;text-align:center}.ScoreSection__highlight___AcSGR{font-size:2em}.ScoreSection__result-text___Uf2RF{margin:20px;font-size:36px;color:#246ab6}.ScoreSection__copy___3K6Cs{white-space:pre-line}.ScoreSection__correct-answer-count___1srOq{font-size:64px;color:#246ab6;line-height:1em;padding:0;margin:0}.ScoreSection__score-subtitle___18Gbl{font-size:24px}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game/modals/game-over/hints/ScoreSection.scss"],"names":[],"mappings":"AAAA,qCAAe,sBAA4B,aAAa,uBAAuB,sBAAsB,mBAAmB,iBAAiB,CAAC,iCAAW,aAAa,CAAC,mCAAwE,YAAY,eAAe,aAAa,CAAC,4BAAM,oBAAoB,CAAC,4CAAiF,eAAe,cAAc,gBAAgB,UAAU,QAAQ,CAAC,sCAA2E,cAAc,CAAC","file":"ScoreSection.scss","sourcesContent":[".score-section{padding:0 100px 100px 100px;display:flex;justify-content:center;flex-direction:column;align-items:center;text-align:center}.highlight{font-size:2em}.result-text{composes:bold-font from '../../../../../common/Fonts.scss';margin:20px;font-size:36px;color:#246AB6}.copy{white-space:pre-line}.correct-answer-count{composes:bold-font from '../../../../../common/Fonts.scss';font-size:64px;color:#246AB6;line-height:1em;padding:0;margin:0}.score-subtitle{composes:bold-text from '../../../../../common/Fonts.scss';font-size:24px}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"score-section": "ScoreSection__score-section___2n-Pv",
	"scoreSection": "ScoreSection__score-section___2n-Pv",
	"highlight": "ScoreSection__highlight___AcSGR",
	"result-text": "ScoreSection__result-text___Uf2RF " + __webpack_require__(0).locals["bold-font"] + "",
	"resultText": "ScoreSection__result-text___Uf2RF " + __webpack_require__(0).locals["bold-font"] + "",
	"copy": "ScoreSection__copy___3K6Cs",
	"correct-answer-count": "ScoreSection__correct-answer-count___1srOq " + __webpack_require__(0).locals["bold-font"] + "",
	"correctAnswerCount": "ScoreSection__correct-answer-count___1srOq " + __webpack_require__(0).locals["bold-font"] + "",
	"score-subtitle": "ScoreSection__score-subtitle___18Gbl " + __webpack_require__(0).locals["bold-text"] + "",
	"scoreSubtitle": "ScoreSection__score-subtitle___18Gbl " + __webpack_require__(0).locals["bold-text"] + ""
};

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(306);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../node_modules/sass-loader/lib/loader.js!./GameOver.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../node_modules/sass-loader/lib/loader.js!./GameOver.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports


// module
exports.push([module.i, ".GameOver__game-over___3otVX{display:block;width:800px;max-height:90vh;overflow:auto}.GameOver__content___M2mz6{display:flex;flex-direction:row;position:relative;width:100%;height:100%;background-color:#fff;border-radius:10px;box-sizing:border-box}.GameOver__score-and-hints___3BHTI{flex:1;height:100%;border-right:1px solid grey}.GameOver__highlight___TOJoR{display:flex;justify-content:center;padding-top:2em;font-size:2em}.GameOver__floating-ui____YLvB{position:relative;width:100%;display:flex;padding:25px;background-color:#fff;justify-content:space-between;box-sizing:border-box}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game/modals/game-over/GameOver.scss"],"names":[],"mappings":"AAAA,6BAAW,cAAc,YAAY,gBAAgB,aAAa,CAAC,2BAAS,aAAa,mBAAmB,kBAAkB,WAAW,YAAY,sBAAuB,mBAAmB,qBAAqB,CAAC,mCAAiB,OAAO,YAAY,2BAA2B,CAAC,6BAAW,aAAa,uBAAuB,gBAAgB,aAAa,CAAC,+BAAa,kBAAkB,WAAW,aAAa,aAAa,sBAAuB,8BAA8B,qBAAqB,CAAC","file":"GameOver.scss","sourcesContent":[".game-over{display:block;width:800px;max-height:90vh;overflow:auto}.content{display:flex;flex-direction:row;position:relative;width:100%;height:100%;background-color:white;border-radius:10px;box-sizing:border-box}.score-and-hints{flex:1;height:100%;border-right:1px solid grey}.highlight{display:flex;justify-content:center;padding-top:2em;font-size:2em}.floating-ui{position:relative;width:100%;display:flex;padding:25px;background-color:white;justify-content:space-between;box-sizing:border-box}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"game-over": "GameOver__game-over___3otVX",
	"gameOver": "GameOver__game-over___3otVX",
	"content": "GameOver__content___M2mz6",
	"score-and-hints": "GameOver__score-and-hints___3BHTI",
	"scoreAndHints": "GameOver__score-and-hints___3BHTI",
	"highlight": "GameOver__highlight___TOJoR",
	"floating-ui": "GameOver__floating-ui____YLvB",
	"floatingUi": "GameOver__floating-ui____YLvB"
};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(4), __webpack_require__(3), __webpack_require__(9), __webpack_require__(8), __webpack_require__(29), __webpack_require__(32), __webpack_require__(10), __webpack_require__(308)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-plugin-react-css-modules/dist/browser/getClassName"), require("tslib"), require("react"), require("react-redux"), require("lodash"), require("../../../../../../store/reducers/outputs/energyOutput"), require("../../../../../../store/reducers/outputs/carbonOutput"), require("../../../../../../data/data"), require("./HintsSection.scss"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getClassName, global.tslib, global.react, global.reactRedux, global.lodash, global.energyOutput, global.carbonOutput, global.data, global.HintsSection);
        global.HintsSection = mod.exports;
    }
})(this, function (exports, _getClassName2, _tslib, _react, _reactRedux, _lodash, _energyOutput, _carbonOutput, _data) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _getClassName3 = _interopRequireDefault(_getClassName2);

    var tslib_1 = _interopRequireWildcard(_tslib);

    var React = _interopRequireWildcard(_react);

    var _ = _interopRequireWildcard(_lodash);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _styleModuleImportMap = {
        "./HintsSection.scss": {
            "hints-section": "HintsSection__hints-section___3lmnq",
            "title": "HintsSection__title___1PkPw undefined",
            "copy": "HintsSection__copy___2HWEk"
        }
    };

    var HintsSection = function (_super) {
        tslib_1.__extends(HintsSection, _super);
        function HintsSection(props) {
            var _this = _super.call(this, props) || this;
            _this.props = props;
            _this.getResult = function () {
                var _a = _this.props,
                    carbon = _a.carbon,
                    energy = _a.energy;
                var data = (0, _data.getGameOverResults)();
                return _.find(data, function (result) {
                    var carbon_match = carbon > result.carbon[0] && carbon < result.carbon[1];
                    var energy_match = energy > result.energy[0] && energy < result.energy[1];
                    return carbon_match && energy_match;
                });
            };
            return _this;
        }
        HintsSection.prototype.render = function () {
            var result = this.getResult();
            return React.createElement(
                "div",
                {
                    className: (0, _getClassName3.default)('hints-section', _styleModuleImportMap)
                },
                React.createElement("div", { dangerouslySetInnerHTML: { __html: result.text }, className: (0, _getClassName3.default)('copy', _styleModuleImportMap)
                })
            );
        };
        return HintsSection;
    }(React.Component);
    var mapStateToProps = function mapStateToProps(state) {
        return {
            energy: (0, _energyOutput.getEnergyOutput)(state),
            carbon: (0, _carbonOutput.getCarbonOutputPercentage)(state)
        };
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {};
    };
    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(HintsSection);
});

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(309);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../../node_modules/sass-loader/lib/loader.js!./HintsSection.scss", function() {
			var newContent = require("!!../../../../../../../../node_modules/typings-for-css-modules-loader/lib/index.js??ref--2-1!../../../../../../../../node_modules/sass-loader/lib/loader.js!./HintsSection.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(true);
// imports
exports.i(__webpack_require__(0), undefined);

// module
exports.push([module.i, ".HintsSection__hints-section___3lmnq{text-align:center;padding:70px}.HintsSection__title___1PkPw{font-size:18px}.HintsSection__copy___2HWEk{white-space:pre-line}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game/modals/game-over/score/HintsSection.scss"],"names":[],"mappings":"AAAA,qCAAe,kBAAkB,YAAY,CAAC,6BAAkE,cAAc,CAAC,4BAAM,oBAAoB,CAAC","file":"HintsSection.scss","sourcesContent":[".hints-section{text-align:center;padding:70px}.title{composes:bold-text from '../../../../../common/Fonts.scss';font-size:18px}.copy{white-space:pre-line}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"hints-section": "HintsSection__hints-section___3lmnq",
	"hintsSection": "HintsSection__hints-section___3lmnq",
	"title": "HintsSection__title___1PkPw " + __webpack_require__(0).locals["bold-text"] + "",
	"copy": "HintsSection__copy___2HWEk"
};

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// bin/power-map.js